var Tm = Object.defineProperty;
var Im = (e, n, t) => n in e ? Tm(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var be = (e, n, t) => (Im(e, typeof n != "symbol" ? n + "" : n, t), t);
import { jsx as L, jsxs as pe, Fragment as Bn } from "react/jsx-runtime";
import * as se from "react";
import K, { useRef as We, useContext as Er, useDebugValue as ud, createElement as Ec, useLayoutEffect as Pc, useEffect as ct, forwardRef as Wn, useState as lr, Children as ap, cloneElement as Mc, isValidElement as ba, Component as Rm, createRef as Wo, useMemo as jt, Fragment as rn, createContext as jn, useReducer as lp, useCallback as dd, useId as Am } from "react";
import * as Fm from "react-dom";
import Om, { createPortal as cp, findDOMNode as Lm } from "react-dom";
var Wt = function() {
  return Wt = Object.assign || function(n) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, Wt.apply(this, arguments);
};
function On(e, n, t) {
  if (t || arguments.length === 2)
    for (var r = 0, i = n.length, o; r < i; r++)
      (o || !(r in n)) && (o || (o = Array.prototype.slice.call(n, 0, r)), o[r] = n[r]);
  return e.concat(o || Array.prototype.slice.call(n));
}
function Nm(e) {
  var n = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return n[t] === void 0 && (n[t] = e(t)), n[t];
  };
}
var zm = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Vm = /* @__PURE__ */ Nm(
  function(e) {
    return zm.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Ss = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function up(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var st = "-ms-", Ms = "-moz-", Xe = "-webkit-", dp = "comm", wa = "rule", $c = "decl", Ym = "@import", fp = "@keyframes", Hm = "@layer", pp = Math.abs, Tc = String.fromCharCode, Yl = Object.assign;
function Bm(e, n) {
  return Et(e, 0) ^ 45 ? (((n << 2 ^ Et(e, 0)) << 2 ^ Et(e, 1)) << 2 ^ Et(e, 2)) << 2 ^ Et(e, 3) : 0;
}
function hp(e) {
  return e.trim();
}
function Xr(e, n) {
  return (e = n.exec(e)) ? e[0] : e;
}
function Ye(e, n, t) {
  return e.replace(n, t);
}
function Ro(e, n, t) {
  return e.indexOf(n, t);
}
function Et(e, n) {
  return e.charCodeAt(n) | 0;
}
function Vi(e, n, t) {
  return e.slice(n, t);
}
function Fr(e) {
  return e.length;
}
function gp(e) {
  return e.length;
}
function ks(e, n) {
  return n.push(e), e;
}
function Wm(e, n) {
  return e.map(n).join("");
}
function fd(e, n) {
  return e.filter(function(t) {
    return !Xr(t, n);
  });
}
var xa = 1, Yi = 1, mp = 0, vr = 0, bt = 0, Xi = "";
function Sa(e, n, t, r, i, o, a, c) {
  return { value: e, root: n, parent: t, type: r, props: i, children: o, line: xa, column: Yi, length: a, return: "", siblings: c };
}
function kn(e, n) {
  return Yl(Sa("", null, null, "", null, null, 0, e.siblings), e, { length: -e.length }, n);
}
function Ii(e) {
  for (; e.root; )
    e = kn(e.root, { children: [e] });
  ks(e, e.siblings);
}
function jm() {
  return bt;
}
function Gm() {
  return bt = vr > 0 ? Et(Xi, --vr) : 0, Yi--, bt === 10 && (Yi = 1, xa--), bt;
}
function kr() {
  return bt = vr < mp ? Et(Xi, vr++) : 0, Yi++, bt === 10 && (Yi = 1, xa++), bt;
}
function ci() {
  return Et(Xi, vr);
}
function Ao() {
  return vr;
}
function ka(e, n) {
  return Vi(Xi, e, n);
}
function Hl(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function qm(e) {
  return xa = Yi = 1, mp = Fr(Xi = e), vr = 0, [];
}
function Km(e) {
  return Xi = "", e;
}
function sl(e) {
  return hp(ka(vr - 1, Bl(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Um(e) {
  for (; (bt = ci()) && bt < 33; )
    kr();
  return Hl(e) > 2 || Hl(bt) > 3 ? "" : " ";
}
function Qm(e, n) {
  for (; --n && kr() && !(bt < 48 || bt > 102 || bt > 57 && bt < 65 || bt > 70 && bt < 97); )
    ;
  return ka(e, Ao() + (n < 6 && ci() == 32 && kr() == 32));
}
function Bl(e) {
  for (; kr(); )
    switch (bt) {
      case e:
        return vr;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Bl(bt);
        break;
      case 40:
        e === 41 && Bl(e);
        break;
      case 92:
        kr();
        break;
    }
  return vr;
}
function Xm(e, n) {
  for (; kr() && e + bt !== 57; )
    if (e + bt === 84 && ci() === 47)
      break;
  return "/*" + ka(n, vr - 1) + "*" + Tc(e === 47 ? e : kr());
}
function Zm(e) {
  for (; !Hl(ci()); )
    kr();
  return ka(e, vr);
}
function Jm(e) {
  return Km(Fo("", null, null, null, [""], e = qm(e), 0, [0], e));
}
function Fo(e, n, t, r, i, o, a, c, d) {
  for (var p = 0, m = 0, v = a, y = 0, _ = 0, S = 0, E = 1, Y = 1, N = 1, I = 0, Q = "", te = i, ie = o, ne = r, re = Q; Y; )
    switch (S = I, I = kr()) {
      case 40:
        if (S != 108 && Et(re, v - 1) == 58) {
          Ro(re += Ye(sl(I), "&", "&\f"), "&\f", pp(p ? c[p - 1] : 0)) != -1 && (N = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        re += sl(I);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        re += Um(S);
        break;
      case 92:
        re += Qm(Ao() - 1, 7);
        continue;
      case 47:
        switch (ci()) {
          case 42:
          case 47:
            ks(ev(Xm(kr(), Ao()), n, t, d), d);
            break;
          default:
            re += "/";
        }
        break;
      case 123 * E:
        c[p++] = Fr(re) * N;
      case 125 * E:
      case 59:
      case 0:
        switch (I) {
          case 0:
          case 125:
            Y = 0;
          case 59 + m:
            N == -1 && (re = Ye(re, /\f/g, "")), _ > 0 && Fr(re) - v && ks(_ > 32 ? hd(re + ";", r, t, v - 1, d) : hd(Ye(re, " ", "") + ";", r, t, v - 2, d), d);
            break;
          case 59:
            re += ";";
          default:
            if (ks(ne = pd(re, n, t, p, m, i, c, Q, te = [], ie = [], v, o), o), I === 123)
              if (m === 0)
                Fo(re, n, ne, ne, te, o, v, c, ie);
              else
                switch (y === 99 && Et(re, 3) === 110 ? 100 : y) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Fo(e, ne, ne, r && ks(pd(e, ne, ne, 0, 0, i, c, Q, i, te = [], v, ie), ie), i, ie, v, c, r ? te : ie);
                    break;
                  default:
                    Fo(re, ne, ne, ne, [""], ie, 0, c, ie);
                }
        }
        p = m = _ = 0, E = N = 1, Q = re = "", v = a;
        break;
      case 58:
        v = 1 + Fr(re), _ = S;
      default:
        if (E < 1) {
          if (I == 123)
            --E;
          else if (I == 125 && E++ == 0 && Gm() == 125)
            continue;
        }
        switch (re += Tc(I), I * E) {
          case 38:
            N = m > 0 ? 1 : (re += "\f", -1);
            break;
          case 44:
            c[p++] = (Fr(re) - 1) * N, N = 1;
            break;
          case 64:
            ci() === 45 && (re += sl(kr())), y = ci(), m = v = Fr(Q = re += Zm(Ao())), I++;
            break;
          case 45:
            S === 45 && Fr(re) == 2 && (E = 0);
        }
    }
  return o;
}
function pd(e, n, t, r, i, o, a, c, d, p, m, v) {
  for (var y = i - 1, _ = i === 0 ? o : [""], S = gp(_), E = 0, Y = 0, N = 0; E < r; ++E)
    for (var I = 0, Q = Vi(e, y + 1, y = pp(Y = a[E])), te = e; I < S; ++I)
      (te = hp(Y > 0 ? _[I] + " " + Q : Ye(Q, /&\f/g, _[I]))) && (d[N++] = te);
  return Sa(e, n, t, i === 0 ? wa : c, d, p, m, v);
}
function ev(e, n, t, r) {
  return Sa(e, n, t, dp, Tc(jm()), Vi(e, 2, -2), 0, r);
}
function hd(e, n, t, r, i) {
  return Sa(e, n, t, $c, Vi(e, 0, r), Vi(e, r + 1, -1), r, i);
}
function vp(e, n, t) {
  switch (Bm(e, n)) {
    case 5103:
      return Xe + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Xe + e + e;
    case 4789:
      return Ms + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Xe + e + Ms + e + st + e + e;
    case 5936:
      switch (Et(e, n + 11)) {
        case 114:
          return Xe + e + st + Ye(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Xe + e + st + Ye(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Xe + e + st + Ye(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
    case 6828:
    case 4268:
    case 2903:
      return Xe + e + st + e + e;
    case 6165:
      return Xe + e + st + "flex-" + e + e;
    case 5187:
      return Xe + e + Ye(e, /(\w+).+(:[^]+)/, Xe + "box-$1$2" + st + "flex-$1$2") + e;
    case 5443:
      return Xe + e + st + "flex-item-" + Ye(e, /flex-|-self/g, "") + (Xr(e, /flex-|baseline/) ? "" : st + "grid-row-" + Ye(e, /flex-|-self/g, "")) + e;
    case 4675:
      return Xe + e + st + "flex-line-pack" + Ye(e, /align-content|flex-|-self/g, "") + e;
    case 5548:
      return Xe + e + st + Ye(e, "shrink", "negative") + e;
    case 5292:
      return Xe + e + st + Ye(e, "basis", "preferred-size") + e;
    case 6060:
      return Xe + "box-" + Ye(e, "-grow", "") + Xe + e + st + Ye(e, "grow", "positive") + e;
    case 4554:
      return Xe + Ye(e, /([^-])(transform)/g, "$1" + Xe + "$2") + e;
    case 6187:
      return Ye(Ye(Ye(e, /(zoom-|grab)/, Xe + "$1"), /(image-set)/, Xe + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ye(e, /(image-set\([^]*)/, Xe + "$1$`$1");
    case 4968:
      return Ye(Ye(e, /(.+:)(flex-)?(.*)/, Xe + "box-pack:$3" + st + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Xe + e + e;
    case 4200:
      if (!Xr(e, /flex-|baseline/))
        return st + "grid-column-align" + Vi(e, n) + e;
      break;
    case 2592:
    case 3360:
      return st + Ye(e, "template-", "") + e;
    case 4384:
    case 3616:
      return t && t.some(function(r, i) {
        return n = i, Xr(r.props, /grid-\w+-end/);
      }) ? ~Ro(e + (t = t[n].value), "span", 0) ? e : st + Ye(e, "-start", "") + e + st + "grid-row-span:" + (~Ro(t, "span", 0) ? Xr(t, /\d+/) : +Xr(t, /\d+/) - +Xr(e, /\d+/)) + ";" : st + Ye(e, "-start", "") + e;
    case 4896:
    case 4128:
      return t && t.some(function(r) {
        return Xr(r.props, /grid-\w+-start/);
      }) ? e : st + Ye(Ye(e, "-end", "-span"), "span ", "") + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ye(e, /(.+)-inline(.+)/, Xe + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Fr(e) - 1 - n > 6)
        switch (Et(e, n + 1)) {
          case 109:
            if (Et(e, n + 4) !== 45)
              break;
          case 102:
            return Ye(e, /(.+:)(.+)-([^]+)/, "$1" + Xe + "$2-$3$1" + Ms + (Et(e, n + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Ro(e, "stretch", 0) ? vp(Ye(e, "stretch", "fill-available"), n, t) + e : e;
        }
      break;
    case 5152:
    case 5920:
      return Ye(e, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, i, o, a, c, d, p) {
        return st + i + ":" + o + p + (a ? st + i + "-span:" + (c ? d : +d - +o) + p : "") + e;
      });
    case 4949:
      if (Et(e, n + 6) === 121)
        return Ye(e, ":", ":" + Xe) + e;
      break;
    case 6444:
      switch (Et(e, Et(e, 14) === 45 ? 18 : 11)) {
        case 120:
          return Ye(e, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + Xe + (Et(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Xe + "$2$3$1" + st + "$2box$3") + e;
        case 100:
          return Ye(e, ":", ":" + st) + e;
      }
      break;
    case 5719:
    case 2647:
    case 2135:
    case 3927:
    case 2391:
      return Ye(e, "scroll-", "scroll-snap-") + e;
  }
  return e;
}
function jo(e, n) {
  for (var t = "", r = 0; r < e.length; r++)
    t += n(e[r], r, e, n) || "";
  return t;
}
function tv(e, n, t, r) {
  switch (e.type) {
    case Hm:
      if (e.children.length)
        break;
    case Ym:
    case $c:
      return e.return = e.return || e.value;
    case dp:
      return "";
    case fp:
      return e.return = e.value + "{" + jo(e.children, r) + "}";
    case wa:
      if (!Fr(e.value = e.props.join(",")))
        return "";
  }
  return Fr(t = jo(e.children, r)) ? e.return = e.value + "{" + t + "}" : "";
}
function rv(e) {
  var n = gp(e);
  return function(t, r, i, o) {
    for (var a = "", c = 0; c < n; c++)
      a += e[c](t, r, i, o) || "";
    return a;
  };
}
function nv(e) {
  return function(n) {
    n.root || (n = n.return) && e(n);
  };
}
function iv(e, n, t, r) {
  if (e.length > -1 && !e.return)
    switch (e.type) {
      case $c:
        e.return = vp(e.value, e.length, t);
        return;
      case fp:
        return jo([kn(e, { value: Ye(e.value, "@", "@" + Xe) })], r);
      case wa:
        if (e.length)
          return Wm(t = e.props, function(i) {
            switch (Xr(i, r = /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                Ii(kn(e, { props: [Ye(i, /:(read-\w+)/, ":" + Ms + "$1")] })), Ii(kn(e, { props: [i] })), Yl(e, { props: fd(t, r) });
                break;
              case "::placeholder":
                Ii(kn(e, { props: [Ye(i, /:(plac\w+)/, ":" + Xe + "input-$1")] })), Ii(kn(e, { props: [Ye(i, /:(plac\w+)/, ":" + Ms + "$1")] })), Ii(kn(e, { props: [Ye(i, /:(plac\w+)/, st + "input-$1")] })), Ii(kn(e, { props: [i] })), Yl(e, { props: fd(t, r) });
                break;
            }
            return "";
          });
    }
}
var sv = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, gi = typeof process < "u" && process.env !== void 0 && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", _p = "active", yp = "data-styled-version", Ca = "6.1.8", Ic = `/*!sc*/
`, Rc = typeof window < "u" && "HTMLElement" in window, ov = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env !== void 0 && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), av = {}, gd = /invalid hook call/i, po = /* @__PURE__ */ new Set(), bp = function(e, n) {
  if (process.env.NODE_ENV !== "production") {
    var t = n ? ' with the id of "'.concat(n, '"') : "", r = "The component ".concat(e).concat(t, ` has been created dynamically.
`) + `You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, i = console.error;
    try {
      var o = !0;
      console.error = function(a) {
        for (var c = [], d = 1; d < arguments.length; d++)
          c[d - 1] = arguments[d];
        gd.test(a) ? (o = !1, po.delete(r)) : i.apply(void 0, On([a], c, !1));
      }, We(), o && !po.has(r) && (console.warn(r), po.add(r));
    } catch (a) {
      gd.test(a.message) && po.delete(r);
    } finally {
      console.error = i;
    }
  }
}, Da = Object.freeze([]), Hi = Object.freeze({});
function wp(e, n, t) {
  return t === void 0 && (t = Hi), e.theme !== t.theme && e.theme || n || t.theme;
}
var Wl = /* @__PURE__ */ new Set(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "u", "ul", "use", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]), lv = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, cv = /(^-|-$)/g;
function md(e) {
  return e.replace(lv, "-").replace(cv, "");
}
var uv = /(a)(d)/gi, ho = 52, vd = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function jl(e) {
  var n, t = "";
  for (n = Math.abs(e); n > ho; n = n / ho | 0)
    t = vd(n % ho) + t;
  return (vd(n % ho) + t).replace(uv, "$1-$2");
}
var ol, xp = 5381, ii = function(e, n) {
  for (var t = n.length; t; )
    e = 33 * e ^ n.charCodeAt(--t);
  return e;
}, Sp = function(e) {
  return ii(xp, e);
};
function Ac(e) {
  return jl(Sp(e) >>> 0);
}
function kp(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function al(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var Cp = typeof Symbol == "function" && Symbol.for, Dp = Cp ? Symbol.for("react.memo") : 60115, dv = Cp ? Symbol.for("react.forward_ref") : 60112, fv = { childContextTypes: !0, contextType: !0, contextTypes: !0, defaultProps: !0, displayName: !0, getDefaultProps: !0, getDerivedStateFromError: !0, getDerivedStateFromProps: !0, mixins: !0, propTypes: !0, type: !0 }, pv = { name: !0, length: !0, prototype: !0, caller: !0, callee: !0, arguments: !0, arity: !0 }, Ep = { $$typeof: !0, compare: !0, defaultProps: !0, displayName: !0, propTypes: !0, type: !0 }, hv = ((ol = {})[dv] = { $$typeof: !0, render: !0, defaultProps: !0, displayName: !0, propTypes: !0 }, ol[Dp] = Ep, ol);
function _d(e) {
  return ("type" in (n = e) && n.type.$$typeof) === Dp ? Ep : "$$typeof" in e ? hv[e.$$typeof] : fv;
  var n;
}
var gv = Object.defineProperty, mv = Object.getOwnPropertyNames, yd = Object.getOwnPropertySymbols, vv = Object.getOwnPropertyDescriptor, _v = Object.getPrototypeOf, bd = Object.prototype;
function Pp(e, n, t) {
  if (typeof n != "string") {
    if (bd) {
      var r = _v(n);
      r && r !== bd && Pp(e, r, t);
    }
    var i = mv(n);
    yd && (i = i.concat(yd(n)));
    for (var o = _d(e), a = _d(n), c = 0; c < i.length; ++c) {
      var d = i[c];
      if (!(d in pv || t && t[d] || a && d in a || o && d in o)) {
        var p = vv(n, d);
        try {
          gv(e, d, p);
        } catch {
        }
      }
    }
  }
  return e;
}
function Bi(e) {
  return typeof e == "function";
}
function Fc(e) {
  return typeof e == "object" && "styledComponentId" in e;
}
function oi(e, n) {
  return e && n ? "".concat(e, " ").concat(n) : e || n || "";
}
function Go(e, n) {
  if (e.length === 0)
    return "";
  for (var t = e[0], r = 1; r < e.length; r++)
    t += n ? n + e[r] : e[r];
  return t;
}
function Wi(e) {
  return e !== null && typeof e == "object" && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function Gl(e, n, t) {
  if (t === void 0 && (t = !1), !t && !Wi(e) && !Array.isArray(e))
    return n;
  if (Array.isArray(n))
    for (var r = 0; r < n.length; r++)
      e[r] = Gl(e[r], n[r]);
  else if (Wi(n))
    for (var r in n)
      e[r] = Gl(e[r], n[r]);
  return e;
}
function Oc(e, n) {
  Object.defineProperty(e, "toString", { value: n });
}
var yv = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`, 18: "ThemeProvider: Please make sure your useTheme hook is within a `<ThemeProvider>`" } : {};
function bv() {
  for (var e = [], n = 0; n < arguments.length; n++)
    e[n] = arguments[n];
  for (var t = e[0], r = [], i = 1, o = e.length; i < o; i += 1)
    r.push(e[i]);
  return r.forEach(function(a) {
    t = t.replace(/%[a-z]/, a);
  }), t;
}
function Zi(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  return process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(e, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : "")) : new Error(bv.apply(void 0, On([yv[e]], n, !1)).trim());
}
var wv = function() {
  function e(n) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = n;
  }
  return e.prototype.indexOfGroup = function(n) {
    for (var t = 0, r = 0; r < n; r++)
      t += this.groupSizes[r];
    return t;
  }, e.prototype.insertRules = function(n, t) {
    if (n >= this.groupSizes.length) {
      for (var r = this.groupSizes, i = r.length, o = i; n >= o; )
        if ((o <<= 1) < 0)
          throw Zi(16, "".concat(n));
      this.groupSizes = new Uint32Array(o), this.groupSizes.set(r), this.length = o;
      for (var a = i; a < o; a++)
        this.groupSizes[a] = 0;
    }
    for (var c = this.indexOfGroup(n + 1), d = (a = 0, t.length); a < d; a++)
      this.tag.insertRule(c, t[a]) && (this.groupSizes[n]++, c++);
  }, e.prototype.clearGroup = function(n) {
    if (n < this.length) {
      var t = this.groupSizes[n], r = this.indexOfGroup(n), i = r + t;
      this.groupSizes[n] = 0;
      for (var o = r; o < i; o++)
        this.tag.deleteRule(r);
    }
  }, e.prototype.getGroup = function(n) {
    var t = "";
    if (n >= this.length || this.groupSizes[n] === 0)
      return t;
    for (var r = this.groupSizes[n], i = this.indexOfGroup(n), o = i + r, a = i; a < o; a++)
      t += "".concat(this.tag.getRule(a)).concat(Ic);
    return t;
  }, e;
}(), Oo = /* @__PURE__ */ new Map(), qo = /* @__PURE__ */ new Map(), Lo = 1, go = function(e) {
  if (Oo.has(e))
    return Oo.get(e);
  for (; qo.has(Lo); )
    Lo++;
  var n = Lo++;
  if (process.env.NODE_ENV !== "production" && ((0 | n) < 0 || n > 1073741824))
    throw Zi(16, "".concat(n));
  return Oo.set(e, n), qo.set(n, e), n;
}, xv = function(e, n) {
  Lo = n + 1, Oo.set(e, n), qo.set(n, e);
}, Sv = "style[".concat(gi, "][").concat(yp, '="').concat(Ca, '"]'), kv = new RegExp("^".concat(gi, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), Cv = function(e, n, t) {
  for (var r, i = t.split(","), o = 0, a = i.length; o < a; o++)
    (r = i[o]) && e.registerName(n, r);
}, Dv = function(e, n) {
  for (var t, r = ((t = n.textContent) !== null && t !== void 0 ? t : "").split(Ic), i = [], o = 0, a = r.length; o < a; o++) {
    var c = r[o].trim();
    if (c) {
      var d = c.match(kv);
      if (d) {
        var p = 0 | parseInt(d[1], 10), m = d[2];
        p !== 0 && (xv(m, p), Cv(e, m, d[3]), e.getTag().insertRules(p, i)), i.length = 0;
      } else
        i.push(c);
    }
  }
};
function Ev() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}
var Mp = function(e) {
  var n = document.head, t = e || n, r = document.createElement("style"), i = function(c) {
    var d = Array.from(c.querySelectorAll("style[".concat(gi, "]")));
    return d[d.length - 1];
  }(t), o = i !== void 0 ? i.nextSibling : null;
  r.setAttribute(gi, _p), r.setAttribute(yp, Ca);
  var a = Ev();
  return a && r.setAttribute("nonce", a), t.insertBefore(r, o), r;
}, Pv = function() {
  function e(n) {
    this.element = Mp(n), this.element.appendChild(document.createTextNode("")), this.sheet = function(t) {
      if (t.sheet)
        return t.sheet;
      for (var r = document.styleSheets, i = 0, o = r.length; i < o; i++) {
        var a = r[i];
        if (a.ownerNode === t)
          return a;
      }
      throw Zi(17);
    }(this.element), this.length = 0;
  }
  return e.prototype.insertRule = function(n, t) {
    try {
      return this.sheet.insertRule(t, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, e.prototype.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, e.prototype.getRule = function(n) {
    var t = this.sheet.cssRules[n];
    return t && t.cssText ? t.cssText : "";
  }, e;
}(), Mv = function() {
  function e(n) {
    this.element = Mp(n), this.nodes = this.element.childNodes, this.length = 0;
  }
  return e.prototype.insertRule = function(n, t) {
    if (n <= this.length && n >= 0) {
      var r = document.createTextNode(t);
      return this.element.insertBefore(r, this.nodes[n] || null), this.length++, !0;
    }
    return !1;
  }, e.prototype.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, e.prototype.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), $v = function() {
  function e(n) {
    this.rules = [], this.length = 0;
  }
  return e.prototype.insertRule = function(n, t) {
    return n <= this.length && (this.rules.splice(n, 0, t), this.length++, !0);
  }, e.prototype.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, e.prototype.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), wd = Rc, Tv = { isServer: !Rc, useCSSOMInjection: !ov }, Ko = function() {
  function e(n, t, r) {
    n === void 0 && (n = Hi), t === void 0 && (t = {});
    var i = this;
    this.options = Wt(Wt({}, Tv), n), this.gs = t, this.names = new Map(r), this.server = !!n.isServer, !this.server && Rc && wd && (wd = !1, function(o) {
      for (var a = document.querySelectorAll(Sv), c = 0, d = a.length; c < d; c++) {
        var p = a[c];
        p && p.getAttribute(gi) !== _p && (Dv(o, p), p.parentNode && p.parentNode.removeChild(p));
      }
    }(this)), Oc(this, function() {
      return function(o) {
        for (var a = o.getTag(), c = a.length, d = "", p = function(v) {
          var y = function(N) {
            return qo.get(N);
          }(v);
          if (y === void 0)
            return "continue";
          var _ = o.names.get(y), S = a.getGroup(v);
          if (_ === void 0 || S.length === 0)
            return "continue";
          var E = "".concat(gi, ".g").concat(v, '[id="').concat(y, '"]'), Y = "";
          _ !== void 0 && _.forEach(function(N) {
            N.length > 0 && (Y += "".concat(N, ","));
          }), d += "".concat(S).concat(E, '{content:"').concat(Y, '"}').concat(Ic);
        }, m = 0; m < c; m++)
          p(m);
        return d;
      }(i);
    });
  }
  return e.registerId = function(n) {
    return go(n);
  }, e.prototype.reconstructWithOptions = function(n, t) {
    return t === void 0 && (t = !0), new e(Wt(Wt({}, this.options), n), this.gs, t && this.names || void 0);
  }, e.prototype.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, e.prototype.getTag = function() {
    return this.tag || (this.tag = (n = function(t) {
      var r = t.useCSSOMInjection, i = t.target;
      return t.isServer ? new $v(i) : r ? new Pv(i) : new Mv(i);
    }(this.options), new wv(n)));
    var n;
  }, e.prototype.hasNameForId = function(n, t) {
    return this.names.has(n) && this.names.get(n).has(t);
  }, e.prototype.registerName = function(n, t) {
    if (go(n), this.names.has(n))
      this.names.get(n).add(t);
    else {
      var r = /* @__PURE__ */ new Set();
      r.add(t), this.names.set(n, r);
    }
  }, e.prototype.insertRules = function(n, t, r) {
    this.registerName(n, t), this.getTag().insertRules(go(n), r);
  }, e.prototype.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, e.prototype.clearRules = function(n) {
    this.getTag().clearGroup(go(n)), this.clearNames(n);
  }, e.prototype.clearTag = function() {
    this.tag = void 0;
  }, e;
}(), Iv = /&/g, Rv = /^\s*\/\/.*$/gm;
function $p(e, n) {
  return e.map(function(t) {
    return t.type === "rule" && (t.value = "".concat(n, " ").concat(t.value), t.value = t.value.replaceAll(",", ",".concat(n, " ")), t.props = t.props.map(function(r) {
      return "".concat(n, " ").concat(r);
    })), Array.isArray(t.children) && t.type !== "@keyframes" && (t.children = $p(t.children, n)), t;
  });
}
function Av(e) {
  var n, t, r, i = e === void 0 ? Hi : e, o = i.options, a = o === void 0 ? Hi : o, c = i.plugins, d = c === void 0 ? Da : c, p = function(y, _, S) {
    return S.startsWith(t) && S.endsWith(t) && S.replaceAll(t, "").length > 0 ? ".".concat(n) : y;
  }, m = d.slice();
  m.push(function(y) {
    y.type === wa && y.value.includes("&") && (y.props[0] = y.props[0].replace(Iv, t).replace(r, p));
  }), a.prefix && m.push(iv), m.push(tv);
  var v = function(y, _, S, E) {
    _ === void 0 && (_ = ""), S === void 0 && (S = ""), E === void 0 && (E = "&"), n = E, t = _, r = new RegExp("\\".concat(t, "\\b"), "g");
    var Y = y.replace(Rv, ""), N = Jm(S || _ ? "".concat(S, " ").concat(_, " { ").concat(Y, " }") : Y);
    a.namespace && (N = $p(N, a.namespace));
    var I = [];
    return jo(N, rv(m.concat(nv(function(Q) {
      return I.push(Q);
    })))), I;
  };
  return v.hash = d.length ? d.reduce(function(y, _) {
    return _.name || Zi(15), ii(y, _.name);
  }, xp).toString() : "", v;
}
var Fv = new Ko(), ql = Av(), Tp = K.createContext({ shouldForwardProp: void 0, styleSheet: Fv, stylis: ql });
Tp.Consumer;
K.createContext(void 0);
function Kl() {
  return Er(Tp);
}
var Ul = function() {
  function e(n, t) {
    var r = this;
    this.inject = function(i, o) {
      o === void 0 && (o = ql);
      var a = r.name + o.hash;
      i.hasNameForId(r.id, a) || i.insertRules(r.id, a, o(r.rules, a, "@keyframes"));
    }, this.name = n, this.id = "sc-keyframes-".concat(n), this.rules = t, Oc(this, function() {
      throw Zi(12, String(r.name));
    });
  }
  return e.prototype.getName = function(n) {
    return n === void 0 && (n = ql), this.name + n.hash;
  }, e;
}(), Ov = function(e) {
  return e >= "A" && e <= "Z";
};
function xd(e) {
  for (var n = "", t = 0; t < e.length; t++) {
    var r = e[t];
    if (t === 1 && r === "-" && e[0] === "-")
      return e;
    Ov(r) ? n += "-" + r.toLowerCase() : n += r;
  }
  return n.startsWith("ms-") ? "-" + n : n;
}
var Ip = function(e) {
  return e == null || e === !1 || e === "";
}, Rp = function(e) {
  var n, t, r = [];
  for (var i in e) {
    var o = e[i];
    e.hasOwnProperty(i) && !Ip(o) && (Array.isArray(o) && o.isCss || Bi(o) ? r.push("".concat(xd(i), ":"), o, ";") : Wi(o) ? r.push.apply(r, On(On(["".concat(i, " {")], Rp(o), !1), ["}"], !1)) : r.push("".concat(xd(i), ": ").concat((n = i, (t = o) == null || typeof t == "boolean" || t === "" ? "" : typeof t != "number" || t === 0 || n in sv || n.startsWith("--") ? String(t).trim() : "".concat(t, "px")), ";")));
  }
  return r;
};
function Tn(e, n, t, r) {
  if (Ip(e))
    return [];
  if (Fc(e))
    return [".".concat(e.styledComponentId)];
  if (Bi(e)) {
    if (!Bi(o = e) || o.prototype && o.prototype.isReactComponent || !n)
      return [e];
    var i = e(n);
    return process.env.NODE_ENV === "production" || typeof i != "object" || Array.isArray(i) || i instanceof Ul || Wi(i) || i === null || console.error("".concat(kp(e), " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.")), Tn(i, n, t, r);
  }
  var o;
  return e instanceof Ul ? t ? (e.inject(t, r), [e.getName(r)]) : [e] : Wi(e) ? Rp(e) : Array.isArray(e) ? Array.prototype.concat.apply(Da, e.map(function(a) {
    return Tn(a, n, t, r);
  })) : [e.toString()];
}
function Ap(e) {
  for (var n = 0; n < e.length; n += 1) {
    var t = e[n];
    if (Bi(t) && !Fc(t))
      return !1;
  }
  return !0;
}
var Lv = Sp(Ca), Nv = function() {
  function e(n, t, r) {
    this.rules = n, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (r === void 0 || r.isStatic) && Ap(n), this.componentId = t, this.baseHash = ii(Lv, t), this.baseStyle = r, Ko.registerId(t);
  }
  return e.prototype.generateAndInjectStyles = function(n, t, r) {
    var i = this.baseStyle ? this.baseStyle.generateAndInjectStyles(n, t, r) : "";
    if (this.isStatic && !r.hash)
      if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId))
        i = oi(i, this.staticRulesId);
      else {
        var o = Go(Tn(this.rules, n, t, r)), a = jl(ii(this.baseHash, o) >>> 0);
        if (!t.hasNameForId(this.componentId, a)) {
          var c = r(o, ".".concat(a), void 0, this.componentId);
          t.insertRules(this.componentId, a, c);
        }
        i = oi(i, a), this.staticRulesId = a;
      }
    else {
      for (var d = ii(this.baseHash, r.hash), p = "", m = 0; m < this.rules.length; m++) {
        var v = this.rules[m];
        if (typeof v == "string")
          p += v, process.env.NODE_ENV !== "production" && (d = ii(d, v));
        else if (v) {
          var y = Go(Tn(v, n, t, r));
          d = ii(d, y + m), p += y;
        }
      }
      if (p) {
        var _ = jl(d >>> 0);
        t.hasNameForId(this.componentId, _) || t.insertRules(this.componentId, _, r(p, ".".concat(_), void 0, this.componentId)), i = oi(i, _);
      }
    }
    return i;
  }, e;
}(), Lc = K.createContext(void 0);
Lc.Consumer;
var ll = {}, Sd = /* @__PURE__ */ new Set();
function zv(e, n, t) {
  var r = Fc(e), i = e, o = !al(e), a = n.attrs, c = a === void 0 ? Da : a, d = n.componentId, p = d === void 0 ? function(te, ie) {
    var ne = typeof te != "string" ? "sc" : md(te);
    ll[ne] = (ll[ne] || 0) + 1;
    var re = "".concat(ne, "-").concat(Ac(Ca + ne + ll[ne]));
    return ie ? "".concat(ie, "-").concat(re) : re;
  }(n.displayName, n.parentComponentId) : d, m = n.displayName, v = m === void 0 ? function(te) {
    return al(te) ? "styled.".concat(te) : "Styled(".concat(kp(te), ")");
  }(e) : m, y = n.displayName && n.componentId ? "".concat(md(n.displayName), "-").concat(n.componentId) : n.componentId || p, _ = r && i.attrs ? i.attrs.concat(c).filter(Boolean) : c, S = n.shouldForwardProp;
  if (r && i.shouldForwardProp) {
    var E = i.shouldForwardProp;
    if (n.shouldForwardProp) {
      var Y = n.shouldForwardProp;
      S = function(te, ie) {
        return E(te, ie) && Y(te, ie);
      };
    } else
      S = E;
  }
  var N = new Nv(t, y, r ? i.componentStyle : void 0);
  function I(te, ie) {
    return function(ne, re, ce) {
      var de = ne.attrs, ge = ne.componentStyle, $e = ne.defaultProps, Le = ne.foldedComponentIds, ze = ne.styledComponentId, ke = ne.target, fe = K.useContext(Lc), De = Kl(), _e = ne.shouldForwardProp || De.shouldForwardProp;
      process.env.NODE_ENV !== "production" && ud(ze);
      var ue = wp(re, fe, $e) || Hi, Ve = function(Ke, nt, ut) {
        for (var wt, Rt = Wt(Wt({}, nt), { className: void 0, theme: ut }), Mr = 0; Mr < Ke.length; Mr += 1) {
          var ve = Bi(wt = Ke[Mr]) ? wt(Rt) : wt;
          for (var dt in ve)
            Rt[dt] = dt === "className" ? oi(Rt[dt], ve[dt]) : dt === "style" ? Wt(Wt({}, Rt[dt]), ve[dt]) : ve[dt];
        }
        return nt.className && (Rt.className = oi(Rt.className, nt.className)), Rt;
      }(de, re, ue), Ne = Ve.as || ke, Re = {};
      for (var Ee in Ve)
        Ve[Ee] === void 0 || Ee[0] === "$" || Ee === "as" || Ee === "theme" && Ve.theme === ue || (Ee === "forwardedAs" ? Re.as = Ve.forwardedAs : _e && !_e(Ee, Ne) || (Re[Ee] = Ve[Ee], _e || process.env.NODE_ENV !== "development" || Vm(Ee) || Sd.has(Ee) || !Wl.has(Ne) || (Sd.add(Ee), console.warn('styled-components: it looks like an unknown prop "'.concat(Ee, '" is being sent through to the DOM, which will likely trigger a React console error. If you would like automatic filtering of unknown props, you can opt-into that behavior via `<StyleSheetManager shouldForwardProp={...}>` (connect an API like `@emotion/is-prop-valid`) or consider using transient props (`$` prefix for automatic filtering.)')))));
      var Be = function(Ke, nt) {
        var ut = Kl(), wt = Ke.generateAndInjectStyles(nt, ut.styleSheet, ut.stylis);
        return process.env.NODE_ENV !== "production" && ud(wt), wt;
      }(ge, Ve);
      process.env.NODE_ENV !== "production" && ne.warnTooManyClasses && ne.warnTooManyClasses(Be);
      var je = oi(Le, ze);
      return Be && (je += " " + Be), Ve.className && (je += " " + Ve.className), Re[al(Ne) && !Wl.has(Ne) ? "class" : "className"] = je, Re.ref = ce, Ec(Ne, Re);
    }(Q, te, ie);
  }
  I.displayName = v;
  var Q = K.forwardRef(I);
  return Q.attrs = _, Q.componentStyle = N, Q.displayName = v, Q.shouldForwardProp = S, Q.foldedComponentIds = r ? oi(i.foldedComponentIds, i.styledComponentId) : "", Q.styledComponentId = y, Q.target = r ? i.target : e, Object.defineProperty(Q, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(te) {
    this._foldedDefaultProps = r ? function(ie) {
      for (var ne = [], re = 1; re < arguments.length; re++)
        ne[re - 1] = arguments[re];
      for (var ce = 0, de = ne; ce < de.length; ce++)
        Gl(ie, de[ce], !0);
      return ie;
    }({}, i.defaultProps, te) : te;
  } }), process.env.NODE_ENV !== "production" && (bp(v, y), Q.warnTooManyClasses = /* @__PURE__ */ function(te, ie) {
    var ne = {}, re = !1;
    return function(ce) {
      if (!re && (ne[ce] = !0, Object.keys(ne).length >= 200)) {
        var de = ie ? ' with the id of "'.concat(ie, '"') : "";
        console.warn("Over ".concat(200, " classes were generated for component ").concat(te).concat(de, `.
`) + `Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), re = !0, ne = {};
      }
    };
  }(v, y)), Oc(Q, function() {
    return ".".concat(Q.styledComponentId);
  }), o && Pp(Q, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0 }), Q;
}
function kd(e, n) {
  for (var t = [e[0]], r = 0, i = n.length; r < i; r += 1)
    t.push(n[r], e[r + 1]);
  return t;
}
var Cd = function(e) {
  return Object.assign(e, { isCss: !0 });
};
function le(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  if (Bi(e) || Wi(e))
    return Cd(Tn(kd(Da, On([e], n, !0))));
  var r = e;
  return n.length === 0 && r.length === 1 && typeof r[0] == "string" ? Tn(r) : Cd(Tn(kd(r, n)));
}
function Ql(e, n, t) {
  if (t === void 0 && (t = Hi), !n)
    throw Zi(1, n);
  var r = function(i) {
    for (var o = [], a = 1; a < arguments.length; a++)
      o[a - 1] = arguments[a];
    return e(n, t, le.apply(void 0, On([i], o, !1)));
  };
  return r.attrs = function(i) {
    return Ql(e, n, Wt(Wt({}, t), { attrs: Array.prototype.concat(t.attrs, i).filter(Boolean) }));
  }, r.withConfig = function(i) {
    return Ql(e, n, Wt(Wt({}, t), i));
  }, r;
}
var Fp = function(e) {
  return Ql(zv, e);
}, W = Fp;
Wl.forEach(function(e) {
  W[e] = Fp(e);
});
var Vv = function() {
  function e(n, t) {
    this.rules = n, this.componentId = t, this.isStatic = Ap(n), Ko.registerId(this.componentId + 1);
  }
  return e.prototype.createStyles = function(n, t, r, i) {
    var o = i(Go(Tn(this.rules, t, r, i)), ""), a = this.componentId + n;
    r.insertRules(a, a, o);
  }, e.prototype.removeStyles = function(n, t) {
    t.clearRules(this.componentId + n);
  }, e.prototype.renderStyles = function(n, t, r, i) {
    n > 2 && Ko.registerId(this.componentId + n), this.removeStyles(n, r), this.createStyles(n, t, r, i);
  }, e;
}();
function Yv(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  var r = le.apply(void 0, On([e], n, !1)), i = "sc-global-".concat(Ac(JSON.stringify(r))), o = new Vv(r, i);
  process.env.NODE_ENV !== "production" && bp(i);
  var a = function(d) {
    var p = Kl(), m = K.useContext(Lc), v = K.useRef(p.styleSheet.allocateGSInstance(i)).current;
    return process.env.NODE_ENV !== "production" && K.Children.count(d.children) && console.warn("The global style component ".concat(i, " was given child JSX. createGlobalStyle does not render children.")), process.env.NODE_ENV !== "production" && r.some(function(y) {
      return typeof y == "string" && y.indexOf("@import") !== -1;
    }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), p.styleSheet.server && c(v, d, p.styleSheet, m, p.stylis), K.useLayoutEffect(function() {
      if (!p.styleSheet.server)
        return c(v, d, p.styleSheet, m, p.stylis), function() {
          return o.removeStyles(v, p.styleSheet);
        };
    }, [v, d, p.styleSheet, m, p.stylis]), null;
  };
  function c(d, p, m, v, y) {
    if (o.isStatic)
      o.renderStyles(d, av, m, y);
    else {
      var _ = Wt(Wt({}, p), { theme: wp(p, v, a.defaultProps) });
      o.renderStyles(d, _, m, y);
    }
  }
  return K.memo(a);
}
function Br(e) {
  for (var n = [], t = 1; t < arguments.length; t++)
    n[t - 1] = arguments[t];
  process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
  var r = Go(le.apply(void 0, On([e], n, !1))), i = Ac(r);
  return new Ul(i, r);
}
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
var mo = "__sc-".concat(gi, "__");
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window[mo] || (window[mo] = 0), window[mo] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window[mo] += 1);
const Hv = W.span`
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  border: 0;
  opacity: 0;
`;
function ln({ children: e }) {
  return /* @__PURE__ */ L(Hv, { children: e });
}
const Bv = "#0967d2", Wv = "#142334", jv = "#ffd000", Gv = "#0ce8d6", qv = "#7949d1", Kv = "#bca4e8", Uv = "#ef4e4e", Qv = "#f48585", Xv = "#ffd000", Zv = "#ffe366", Jv = "#12a537", e0 = "#3ebd93", t0 = "#42608a", r0 = "#839ec4", n0 = "#e76119", i0 = "#f2a67e", s0 = "#7949d1", o0 = "#bca4e8", a0 = "#0ce8d6", l0 = "#81f8ef", c0 = "#ffffff", u0 = "#142334", d0 = "#f5f7fa", f0 = "#192d43", p0 = "#ebeff5", h0 = "#1f3751", g0 = "rgba(31, 55, 81, 0.75)", m0 = "#142334", v0 = "#ffffff", _0 = "#4d5a68", y0 = "#c3c8cc", b0 = "#8191a2", w0 = "#a0a7af", x0 = "#0967d2", S0 = "#6fabf1", k0 = "#1f3751", C0 = "#ffffff", D0 = "#ebeff5", E0 = "#2a415a", P0 = "#ef4e4e", M0 = "#f48585", $0 = "#12a537", T0 = "#3ebd93", I0 = "#e5f1ff", R0 = "rgba(255, 255, 255, 0.1)", A0 = "#ffffff", F0 = "#142334", O0 = "#ffffff", L0 = "#142334", N0 = "#4d5a68", z0 = "#c3c8cc", V0 = "#ffffff", Y0 = "#142334", H0 = "#ffffff", B0 = "#142334", W0 = "#0967d2", j0 = "#6fabf1", G0 = "#142334", q0 = "#ffffff", K0 = "#4d5a68", U0 = "#c3c8cc", Q0 = "rgba(20, 35, 52, 0.12)", X0 = "rgba(255, 255, 255, 0.15)", Z0 = "rgba(20, 35, 52, 0.2)", J0 = "rgba(255, 255, 255, 0.22)", e_ = "#0967d2", t_ = "#6fabf1", r_ = "rgba(20, 35, 52, 0.13)", n_ = "rgba(6, 10, 16, 0.5)", i_ = "rgba(20, 35, 52, 0.13)", s_ = "rgba(6, 10, 16, 0.6)", o_ = "rgba(20, 35, 52, 0.2)", a_ = "rgba(6, 10, 16, 0.7)", l_ = "#31a03c", c_ = "#4191ed", u_ = "#a227c5", d_ = "#354b62", f_ = "#ffd000", p_ = "#e76119", h_ = "#c73732", g_ = "#828c95", m_ = "#4d5a68", v_ = "#a227c5", __ = "#e76119", y_ = "#31a03c", b_ = "#4191ed", w_ = "#c73732", x_ = "#d28e09", S_ = "#354b62", k_ = "#413ecf", C_ = "#d63baa", D_ = "#745138", E_ = "#ffd000", P_ = 2, M_ = 4, $_ = 8, T_ = 16, I_ = 24, R_ = 32, A_ = 48, F_ = 1, O_ = 2, L_ = 4, N_ = 8, z_ = 2, V_ = 4, Y_ = 8, H_ = 16, B_ = 24, W_ = 1e3, j_ = 10, G_ = 12, q_ = 14, K_ = 16, U_ = 20, Q_ = 24, X_ = 32, Z_ = 42, J_ = 16, ey = 24, ty = 32, ry = 40, ny = 3, iy = 1, sy = 6, oy = 2, ay = 12, ly = 4, cy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  color_background_1_de: u0,
  color_background_1_le: c0,
  color_background_2_de: f0,
  color_background_2_le: d0,
  color_background_3_de: h0,
  color_background_3_le: p0,
  color_background_backdrop: g0,
  color_border_default_de: X0,
  color_border_default_le: Q0,
  color_border_input_active_de: t_,
  color_border_input_active_le: e_,
  color_border_input_inactive_de: J0,
  color_border_input_inactive_le: Z0,
  color_brand_accent: jv,
  color_brand_add_on_de: Kv,
  color_brand_add_on_le: qv,
  color_brand_primary: Bv,
  color_brand_secondary: Wv,
  color_brand_upgrade: Gv,
  color_button_background_destroy_de: M0,
  color_button_background_destroy_le: P0,
  color_button_background_primary_de: S0,
  color_button_background_primary_le: x0,
  color_button_background_secondary_de: C0,
  color_button_background_secondary_le: k0,
  color_button_background_subtle_de: E0,
  color_button_background_subtle_le: D0,
  color_button_background_success_de: T0,
  color_button_background_success_le: $0,
  color_button_background_tint_de: R0,
  color_button_background_tint_le: I0,
  color_button_text_destroy_de: Y0,
  color_button_text_destroy_le: V0,
  color_button_text_primary_de: F0,
  color_button_text_primary_le: A0,
  color_button_text_secondary_de: L0,
  color_button_text_secondary_le: O0,
  color_button_text_subtle_de: z0,
  color_button_text_subtle_le: N0,
  color_button_text_success_de: B0,
  color_button_text_success_le: H0,
  color_collab_blue: b_,
  color_collab_brown: D_,
  color_collab_green: y_,
  color_collab_magenta: C_,
  color_collab_navy: S_,
  color_collab_orange: __,
  color_collab_owner: E_,
  color_collab_plum: k_,
  color_collab_purple: v_,
  color_collab_red: w_,
  color_collab_yellow: x_,
  color_depth_1_de: n_,
  color_depth_1_le: r_,
  color_depth_2_de: s_,
  color_depth_2_le: i_,
  color_depth_3_de: a_,
  color_depth_3_le: o_,
  color_label_blue: c_,
  color_label_dark_gray: m_,
  color_label_green: l_,
  color_label_light_gray: g_,
  color_label_navy: d_,
  color_label_orange: p_,
  color_label_purple: u_,
  color_label_red: h_,
  color_label_yellow: f_,
  color_link_primary_de: j0,
  color_link_primary_le: W0,
  color_link_secondary_de: q0,
  color_link_secondary_le: G0,
  color_link_subtle_de: U0,
  color_link_subtle_le: K0,
  color_text_default_de: v0,
  color_text_default_le: m0,
  color_text_nonessential_de: w0,
  color_text_nonessential_le: b0,
  color_text_subtle_de: y0,
  color_text_subtle_le: _0,
  color_utility_add_on_de: o0,
  color_utility_add_on_le: s0,
  color_utility_assigned_de: i0,
  color_utility_assigned_le: n0,
  color_utility_caution_de: Zv,
  color_utility_caution_le: Xv,
  color_utility_destroy_de: Qv,
  color_utility_destroy_le: Uv,
  color_utility_info_de: r0,
  color_utility_info_le: t0,
  color_utility_success_de: e0,
  color_utility_success_le: Jv,
  color_utility_upgrade_de: l0,
  color_utility_upgrade_le: a0,
  size_avatar_l: ry,
  size_avatar_m: ty,
  size_avatar_s: ey,
  size_avatar_xs: J_,
  size_border_radius_l: Y_,
  size_border_radius_m: V_,
  size_border_radius_pill: W_,
  size_border_radius_s: z_,
  size_border_radius_xl: H_,
  size_border_radius_xxl: B_,
  size_border_width_l: L_,
  size_border_width_m: O_,
  size_border_width_s: F_,
  size_border_width_xl: N_,
  size_depth_1_blur: ny,
  size_depth_1_y: iy,
  size_depth_2_blur: sy,
  size_depth_2_y: oy,
  size_depth_3_blur: ay,
  size_depth_3_y: ly,
  size_spacing_l: I_,
  size_spacing_m: T_,
  size_spacing_s: $_,
  size_spacing_xl: R_,
  size_spacing_xs: M_,
  size_spacing_xxl: A_,
  size_spacing_xxs: P_,
  size_text_l: U_,
  size_text_m: K_,
  size_text_s: q_,
  size_text_xl: Q_,
  size_text_xs: G_,
  size_text_xxl: X_,
  size_text_xxs: j_,
  size_text_xxxl: Z_
}, Symbol.toStringTag, { value: "Module" })), pt = {
  ...cy
}, Lt = `font-family: system-ui, -apple-system, BlinkMacSystemFont,
'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;`, dr = `font-family: 'Averta', system-ui, -apple-system, BlinkMacSystemFont,
'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;`, ui = le`
  outline-width: var(--cc_size_border_width_m);
  outline-style: solid;
`, _r = le`
  opacity: 0.5;
  cursor: not-allowed;
`, Pt = (e) => {
  const n = e === "error";
  return e === "success" && !n ? {
    accentColor: "var(--cc_color_utility_success)",
    icon: "check-circle-outline",
    focusStyles: le`
        ${ui}
        outline-color: var(--cc_color_utility_success);
      `
  } : n ? {
    accentColor: "var(--cc_color_utility_destroy)",
    icon: "alert-circle-outline",
    focusStyles: le`
        ${ui}
        outline-color: var(--cc_color_utility_destroy);
      `
  } : {
    accentColor: "var(--cc_color_utility_info)",
    icon: "information-outline",
    focusStyles: le`
        ${ui}
        outline-color: var(--cc_color_border_input_active);
      `
  };
}, fr = le`
  margin: -1px;
  padding: 0;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip: rect(0, 0, 0, 0);
  position: absolute;
`, Pr = (e) => {
  const n = ["xxl", "xl", "l", "m", "s", "xs", "xxs"], t = e.split(" "), r = [];
  return t.forEach((i) => {
    n.includes(i) ? r.push(`var(--cc_size_spacing_${i})`) : i === "auto" ? r.push("auto") : r.push("0");
  }), r.join(" ");
}, Uo = {
  large: pt.size_avatar_l,
  medium: pt.size_avatar_m,
  small: pt.size_avatar_s,
  xsmall: pt.size_avatar_xs
}, mt = {
  bounce: "cubic-bezier(0.17, 0.67, 0.48, 1.76)",
  easeIn: "cubic-bezier(0.55, 0.055, 0.675, 0.19)",
  easeOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  duration: {
    fast: "200ms",
    medium: "300ms",
    slow: "500ms"
  }
}, Nc = ({
  offset: e = pt.size_spacing_s,
  placement: n
}) => {
  const t = `translate3d(${e}px, 0, 0)`, r = `translate3d(-${e}px, 0, 0)`, i = `translate3d(0, ${e}px, 0)`, o = `translate3d(0, -${e}px, 0)`;
  switch (n) {
    case "top":
    case "top-start":
    case "top-end":
      return i;
    case "right":
    case "right-start":
    case "right-end":
      return r;
    case "bottom":
    case "bottom-start":
    case "bottom-end":
      return o;
    case "left":
    case "left-start":
    case "left-end":
      return t;
    default:
      return "translate3d(0, 0, 0)";
  }
}, Cs = {
  caution: "caution",
  success: "success",
  destroy: "destroy",
  secondary: "secondary"
}, Dd = {
  [Cs.caution]: "var(--cc_color_utility_caution)",
  [Cs.success]: "var(--cc_color_utility_success)",
  [Cs.destroy]: "var(--cc_color_utility_destroy)",
  [Cs.secondary]: "var(--cc_color_button_background_secondary)"
}, zc = (e) => e ? Dd[e] : Dd[Cs.secondary], Ri = {
  xxxl: {
    size: "var(--cc_size_text_xxxl)",
    family: "heading",
    weight: 800,
    lineHeight: 1.1
  },
  xxl: {
    size: "var(--cc_size_text_xxl)",
    family: "heading",
    weight: 800,
    lineHeight: 1.1
  },
  xl: {
    size: "var(--cc_size_text_xl)",
    family: "heading",
    weight: 700,
    lineHeight: 1.1
  },
  l: {
    size: "var(--cc_size_text_l)",
    family: "system",
    weight: 700,
    lineHeight: 1.2
  },
  m: {
    size: "var(--cc_size_text_m)",
    family: "system",
    lineHeight: 1.4
  },
  s: {
    size: "var(--cc_size_text_s)",
    family: "system",
    lineHeight: 1.4
  },
  xs: {
    size: "var(--cc_size_text_xs)",
    family: "system",
    lineHeight: 1.4
  },
  xxs: {
    size: "var(--cc_size_text_xxs)",
    family: "system",
    lineHeight: 1.4
  }
}, uy = W.span`
  /* unset all global typography styles */
  all: unset;

  /* default is block */
  display: ${(e) => e.$display};

  /* Component can inherit font color for one-offs */
  color: ${(e) => e.$color === "inherit" ? "inherit" : `var(--cc_color_text_${e.$color})`};

  /* Use either Averta (heading) or system font stack default */
  ${(e) => e.$family && e.$family === "heading" || Ri[e.size].family === "heading" ? dr : Lt}

  /* Add 1px to font size if heading font family, due to Averta lookin' too small */
  font-size: ${(e) => e.$family === "heading" ? `calc(${Ri[e.size].size} + 1px)` : Ri[e.size].size};
  line-height: ${(e) => Ri[e.size].lineHeight};

  /* if ccMargin is specified in props, convert spacing tokens to CSS variables */
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}

  /* if user specifies weight in props OR there is a weight default for the font size, set it in CSS */
  ${(e) => e.$weight || Ri[e.size].weight ? le`
          font-weight: ${e.$weight || Ri[e.size].weight};
        ` : null}
`;
function Nt({
  as: e,
  forwardedAs: n,
  children: t,
  color: r = "default",
  size: i = "s",
  family: o,
  ccMargin: a,
  weight: c,
  display: d = "block",
  className: p,
  style: m,
  ...v
}) {
  return /* @__PURE__ */ L(
    uy,
    {
      as: e,
      forwardedAs: n,
      size: i,
      $family: o,
      $ccMargin: a,
      $color: r,
      $weight: c,
      $display: d,
      className: p,
      style: m,
      ...v,
      children: t
    }
  );
}
const Gn = ({ disabled: e = !1, readOnly: n = !1 }) => `
      all: initial;
      box-sizing: border-box;
      font-family: inherit;
      max-width: 100%;
      overflow: visible;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      background: none;
      position: relative;
      appearance: none;
      text-decoration: none;
      touch-action: manipulation;
      cursor: pointer;
      user-select: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
  
      &:focus-visible {
        ${ui}
        outline-color: var(--cc_color_border_input_active);
        outline-offset: var(--cc_size_spacing_xxs);
      }
      
      ${e || n ? le`
              pointer-events: none;
            ` : ""}
      ${e ? _r : ""}
    `, Ea = {
  small: "var(--cc_size_avatar_m)",
  medium: "var(--cc_size_avatar_l)",
  large: "48px"
}, Pa = {
  // bump up by 1 because Averta renders smaller than system font
  small: "calc(var(--cc_size_text_xs) + 1px)",
  medium: "calc(var(--cc_size_text_s) + 1px)",
  large: "calc(var(--cc_size_text_m) + 1px)"
}, Op = {
  small: "calc(var(--cc_size_spacing_xs) * 0.75)",
  medium: "calc(var(--cc_size_spacing_s) * 0.75)",
  large: "calc(var(--cc_size_spacing_m) * 0.75)"
}, Lp = {
  small: "0 calc(var(--cc_size_spacing_s) * 1.25)",
  medium: "0 var(--cc_size_spacing_m)",
  large: "0 var(--cc_size_spacing_l)"
}, Ed = "var(--cc_size_spacing_s)", Np = W.button`
  ${Gn}
  position: absolute;
  inset: 0;
  aspect-ratio: 1 / 1;
  transition: background-color ${mt.duration.fast};
  border-radius: var(--cc_size_border_radius_l);
  &:hover {
    background-color: var(--cc_color_background_1_alpha_10);
  }
`, Pd = {
  small: 130,
  medium: 148,
  large: 500,
  auto: "auto"
}, dy = W.div`
  ${(e) => e.$size && Pd[e.$size] !== "auto" ? le`
          width: ${Pd[e.$size]}px;
        ` : null}
`, fy = W.div`
  position: relative;
  aspect-ratio: 1 / 1;

  @media (hover: hover) {
    .cc-asset-thumb-content-show-on-hover {
      transition: opacity ${mt.duration.fast};
      opacity: 0;
    }
  }

  /* if device supports hover, hide "cc-asset-thumb-content-show-on-hover" content until component is hovered or anything is focus-visible inside container */
  &:hover,
  &:has(*:focus-visible) {
    @media (hover: hover) {
      .cc-asset-thumb-content-show-on-hover {
        opacity: 1;
      }
    }
  }
`, py = Br`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.025);
  }
  100% {
    transform: scale(1);
  }
`, hy = W.span`
  display: block;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: var(--cc_size_border_radius_l);
  transition: transform 0.2s;
  &:has(~ ${Np}:active) {
    transform: scale(0.97);
  }

  ${(e) => e.$isSelected ? le`
          animation-name: ${py};
          animation-duration: ${mt.duration.medium};
          animation-timing-function: ${mt.easeOut};
        ` : ""}
`, gy = W.img`
  all: initial;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: var(--cc_size_border_radius_l);
  ${(e) => e.$shouldBlurImage ? le`
          filter: blur(16px);
        ` : null}
`, my = W.div`
  position: absolute;
  inset: 0;
  border-radius: var(--cc_size_border_radius_l);
  background: var(--cc_color_background_backdrop);
  opacity: 0.75;
`, vy = W.span`
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  border-radius: 0 0 var(--cc_size_border_radius_l)
    var(--cc_size_border_radius_l);
  height: 50%;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0) 0%,
    var(--cc_color_background_backdrop) 100%
  );
  text-shadow: 0 0 8px rgba(0, 0, 0, 0.35);
`, vo = W.span`
  position: absolute;
  inset-inline-${(e) => e.$inlineVal}: ${Ed};
  inset-block-${(e) => e.$blockVal}: ${Ed};
`, _y = W(Nt)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`, yy = W.i`
  font-size: var(--cc_size_text_xxxl);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  /* non-themed photo overlay icon, okay to hardcode color */
  color: rgba(255, 255, 255, 0.8);
`, by = (e) => typeof e == "string" ? /* @__PURE__ */ L(
  _y,
  {
    forwardedAs: "span",
    color: "subtle",
    size: "xs",
    ccMargin: "s none none",
    children: e
  }
) : e;
function JT({
  contentAfter: e,
  contentTopLeft: n,
  contentTopRight: t,
  contentBottomLeft: r,
  contentBottomRight: i,
  image: o,
  isSelected: a = !1,
  isVideo: c = !1,
  buttonAction: d,
  shouldBlurImage: p = !1,
  size: m = "auto",
  ...v
}) {
  const { accessibilityLabel: y, ..._ } = d || {};
  return /* @__PURE__ */ pe(dy, { ...v, $size: m, children: [
    /* @__PURE__ */ pe(fy, { children: [
      /* @__PURE__ */ pe(hy, { $isSelected: a, children: [
        /* @__PURE__ */ L(
          gy,
          {
            src: o.src,
            alt: o.alt ? o.alt : "",
            $shouldBlurImage: p
          }
        ),
        a ? /* @__PURE__ */ L(my, { "data-testid": "selected-asset-overlay" }) : null,
        r || i ? /* @__PURE__ */ L(vy, {}) : null,
        c ? /* @__PURE__ */ pe(Bn, { children: [
          /* @__PURE__ */ L(yy, { className: "mdi mdi-play-circle-outline" }),
          /* @__PURE__ */ L(ln, { children: "Video" })
        ] }) : null
      ] }),
      d ? /* @__PURE__ */ L(Np, { type: "button", ..._, children: /* @__PURE__ */ L(ln, { children: d.accessibilityLabel }) }) : null,
      n ? /* @__PURE__ */ L(
        vo,
        {
          $blockVal: "start",
          $inlineVal: "start",
          className: n.shouldShowOnHover ? "cc-asset-thumb-content-show-on-hover" : "",
          children: n.content
        }
      ) : null,
      t ? /* @__PURE__ */ L(
        vo,
        {
          $blockVal: "start",
          $inlineVal: "end",
          className: t.shouldShowOnHover ? "cc-asset-thumb-content-show-on-hover" : "",
          children: t.content
        }
      ) : null,
      r ? /* @__PURE__ */ L(vo, { $blockVal: "end", $inlineVal: "start", children: r }) : null,
      i ? /* @__PURE__ */ L(vo, { $blockVal: "end", $inlineVal: "end", children: i }) : null
    ] }),
    e ? by(e) : null
  ] });
}
function cn(e) {
  return zp(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function nr(e) {
  var n;
  return (e == null || (n = e.ownerDocument) == null ? void 0 : n.defaultView) || window;
}
function dn(e) {
  var n;
  return (n = (zp(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : n.documentElement;
}
function zp(e) {
  return e instanceof Node || e instanceof nr(e).Node;
}
function at(e) {
  return e instanceof Element || e instanceof nr(e).Element;
}
function Gt(e) {
  return e instanceof HTMLElement || e instanceof nr(e).HTMLElement;
}
function Xl(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof nr(e).ShadowRoot;
}
function js(e) {
  const {
    overflow: n,
    overflowX: t,
    overflowY: r,
    display: i
  } = cr(e);
  return /auto|scroll|overlay|hidden|clip/.test(n + r + t) && !["inline", "contents"].includes(i);
}
function wy(e) {
  return ["table", "td", "th"].includes(cn(e));
}
function Vc(e) {
  const n = Yc(), t = cr(e);
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !n && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !n && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function xy(e) {
  let n = mi(e);
  for (; Gt(n) && !ji(n); ) {
    if (Vc(n))
      return n;
    n = mi(n);
  }
  return null;
}
function Yc() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ji(e) {
  return ["html", "body", "#document"].includes(cn(e));
}
function cr(e) {
  return nr(e).getComputedStyle(e);
}
function Ma(e) {
  return at(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function mi(e) {
  if (cn(e) === "html")
    return e;
  const n = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Xl(e) && e.host || // Fallback.
    dn(e)
  );
  return Xl(n) ? n.host : n;
}
function Vp(e) {
  const n = mi(e);
  return ji(n) ? e.ownerDocument ? e.ownerDocument.body : e.body : Gt(n) && js(n) ? n : Vp(n);
}
function In(e, n, t) {
  var r;
  n === void 0 && (n = []), t === void 0 && (t = !0);
  const i = Vp(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = nr(i);
  return o ? n.concat(a, a.visualViewport || [], js(i) ? i : [], a.frameElement && t ? In(a.frameElement) : []) : n.concat(i, In(i, [], t));
}
function Dn(e) {
  let n = e.activeElement;
  for (; ((t = n) == null || (t = t.shadowRoot) == null ? void 0 : t.activeElement) != null; ) {
    var t;
    n = n.shadowRoot.activeElement;
  }
  return n;
}
function Bt(e, n) {
  if (!e || !n)
    return !1;
  const t = n.getRootNode == null ? void 0 : n.getRootNode();
  if (e.contains(n))
    return !0;
  if (t && Xl(t)) {
    let r = n;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Hc() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function Yp() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((n) => {
    let {
      brand: t,
      version: r
    } = n;
    return t + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function Sy(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : Zl() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function Hp(e) {
  return Cy() ? !1 : !Zl() && e.width === 0 && e.height === 0 || Zl() && e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "touch";
}
function Bp() {
  return /apple/i.test(navigator.vendor);
}
function Zl() {
  const e = /android/i;
  return e.test(Hc()) || e.test(Yp());
}
function ky() {
  return Hc().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function Cy() {
  return Yp().includes("jsdom/");
}
function Qo(e, n) {
  const t = ["mouse", "pen"];
  return n || t.push("", void 0), t.includes(e);
}
function Dy(e) {
  return "nativeEvent" in e;
}
function Ey(e) {
  return e.matches("html,body");
}
function tr(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function cl(e, n) {
  if (n == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(n);
  const t = e;
  return t.target != null && n.contains(t.target);
}
function si(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const Py = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Bc(e) {
  return Gt(e) && e.matches(Py);
}
function ul(e) {
  e.preventDefault(), e.stopPropagation();
}
function My(e) {
  return e ? e.getAttribute("role") === "combobox" && Bc(e) : !1;
}
const Gi = Math.min, di = Math.max, Xo = Math.round, _o = Math.floor, Ln = (e) => ({
  x: e,
  y: e
}), $y = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ty = {
  start: "end",
  end: "start"
};
function Jl(e, n, t) {
  return di(e, Gi(n, t));
}
function vi(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function Nn(e) {
  return e.split("-")[0];
}
function Gs(e) {
  return e.split("-")[1];
}
function Wc(e) {
  return e === "x" ? "y" : "x";
}
function jc(e) {
  return e === "y" ? "height" : "width";
}
function qs(e) {
  return ["top", "bottom"].includes(Nn(e)) ? "y" : "x";
}
function Gc(e) {
  return Wc(qs(e));
}
function Iy(e, n, t) {
  t === void 0 && (t = !1);
  const r = Gs(e), i = Gc(e), o = jc(i);
  let a = i === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return n.reference[o] > n.floating[o] && (a = Zo(a)), [a, Zo(a)];
}
function Ry(e) {
  const n = Zo(e);
  return [ec(e), n, ec(n)];
}
function ec(e) {
  return e.replace(/start|end/g, (n) => Ty[n]);
}
function Ay(e, n, t) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? n ? i : r : n ? r : i;
    case "left":
    case "right":
      return n ? o : a;
    default:
      return [];
  }
}
function Fy(e, n, t, r) {
  const i = Gs(e);
  let o = Ay(Nn(e), t === "start", r);
  return i && (o = o.map((a) => a + "-" + i), n && (o = o.concat(o.map(ec)))), o;
}
function Zo(e) {
  return e.replace(/left|right|bottom|top/g, (n) => $y[n]);
}
function Oy(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Wp(e) {
  return typeof e != "number" ? Oy(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Jo(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Md(e, n, t) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = qs(n), a = Gc(n), c = jc(a), d = Nn(n), p = o === "y", m = r.x + r.width / 2 - i.width / 2, v = r.y + r.height / 2 - i.height / 2, y = r[c] / 2 - i[c] / 2;
  let _;
  switch (d) {
    case "top":
      _ = {
        x: m,
        y: r.y - i.height
      };
      break;
    case "bottom":
      _ = {
        x: m,
        y: r.y + r.height
      };
      break;
    case "right":
      _ = {
        x: r.x + r.width,
        y: v
      };
      break;
    case "left":
      _ = {
        x: r.x - i.width,
        y: v
      };
      break;
    default:
      _ = {
        x: r.x,
        y: r.y
      };
  }
  switch (Gs(n)) {
    case "start":
      _[a] -= y * (t && p ? -1 : 1);
      break;
    case "end":
      _[a] += y * (t && p ? -1 : 1);
      break;
  }
  return _;
}
const Ly = async (e, n, t) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = t, c = o.filter(Boolean), d = await (a.isRTL == null ? void 0 : a.isRTL(n));
  let p = await a.getElementRects({
    reference: e,
    floating: n,
    strategy: i
  }), {
    x: m,
    y: v
  } = Md(p, r, d), y = r, _ = {}, S = 0;
  for (let E = 0; E < c.length; E++) {
    const {
      name: Y,
      fn: N
    } = c[E], {
      x: I,
      y: Q,
      data: te,
      reset: ie
    } = await N({
      x: m,
      y: v,
      initialPlacement: r,
      placement: y,
      strategy: i,
      middlewareData: _,
      rects: p,
      platform: a,
      elements: {
        reference: e,
        floating: n
      }
    });
    m = I ?? m, v = Q ?? v, _ = {
      ..._,
      [Y]: {
        ..._[Y],
        ...te
      }
    }, ie && S <= 50 && (S++, typeof ie == "object" && (ie.placement && (y = ie.placement), ie.rects && (p = ie.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: n,
      strategy: i
    }) : ie.rects), {
      x: m,
      y: v
    } = Md(p, y, d)), E = -1);
  }
  return {
    x: m,
    y: v,
    placement: y,
    strategy: i,
    middlewareData: _
  };
};
async function jp(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: c,
    strategy: d
  } = e, {
    boundary: p = "clippingAncestors",
    rootBoundary: m = "viewport",
    elementContext: v = "floating",
    altBoundary: y = !1,
    padding: _ = 0
  } = vi(n, e), S = Wp(_), Y = c[y ? v === "floating" ? "reference" : "floating" : v], N = Jo(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(Y))) == null || t ? Y : Y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(c.floating)),
    boundary: p,
    rootBoundary: m,
    strategy: d
  })), I = v === "floating" ? {
    ...a.floating,
    x: r,
    y: i
  } : a.reference, Q = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c.floating)), te = await (o.isElement == null ? void 0 : o.isElement(Q)) ? await (o.getScale == null ? void 0 : o.getScale(Q)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, ie = Jo(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: I,
    offsetParent: Q,
    strategy: d
  }) : I);
  return {
    top: (N.top - ie.top + S.top) / te.y,
    bottom: (ie.bottom - N.bottom + S.bottom) / te.y,
    left: (N.left - ie.left + S.left) / te.x,
    right: (ie.right - N.right + S.right) / te.x
  };
}
const Ny = (e) => ({
  name: "arrow",
  options: e,
  async fn(n) {
    const {
      x: t,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: c,
      middlewareData: d
    } = n, {
      element: p,
      padding: m = 0
    } = vi(e, n) || {};
    if (p == null)
      return {};
    const v = Wp(m), y = {
      x: t,
      y: r
    }, _ = Gc(i), S = jc(_), E = await a.getDimensions(p), Y = _ === "y", N = Y ? "top" : "left", I = Y ? "bottom" : "right", Q = Y ? "clientHeight" : "clientWidth", te = o.reference[S] + o.reference[_] - y[_] - o.floating[S], ie = y[_] - o.reference[_], ne = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(p));
    let re = ne ? ne[Q] : 0;
    (!re || !await (a.isElement == null ? void 0 : a.isElement(ne))) && (re = c.floating[Q] || o.floating[S]);
    const ce = te / 2 - ie / 2, de = re / 2 - E[S] / 2 - 1, ge = Gi(v[N], de), $e = Gi(v[I], de), Le = ge, ze = re - E[S] - $e, ke = re / 2 - E[S] / 2 + ce, fe = Jl(Le, ke, ze), De = !d.arrow && Gs(i) != null && ke !== fe && o.reference[S] / 2 - (ke < Le ? ge : $e) - E[S] / 2 < 0, _e = De ? ke < Le ? ke - Le : ke - ze : 0;
    return {
      [_]: y[_] + _e,
      data: {
        [_]: fe,
        centerOffset: ke - fe - _e,
        ...De && {
          alignmentOffset: _e
        }
      },
      reset: De
    };
  }
}), zy = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(n) {
      var t, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: c,
        platform: d,
        elements: p
      } = n, {
        mainAxis: m = !0,
        crossAxis: v = !0,
        fallbackPlacements: y,
        fallbackStrategy: _ = "bestFit",
        fallbackAxisSideDirection: S = "none",
        flipAlignment: E = !0,
        ...Y
      } = vi(e, n);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const N = Nn(i), I = Nn(c) === c, Q = await (d.isRTL == null ? void 0 : d.isRTL(p.floating)), te = y || (I || !E ? [Zo(c)] : Ry(c));
      !y && S !== "none" && te.push(...Fy(c, E, S, Q));
      const ie = [c, ...te], ne = await jp(n, Y), re = [];
      let ce = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (m && re.push(ne[N]), v) {
        const Le = Iy(i, a, Q);
        re.push(ne[Le[0]], ne[Le[1]]);
      }
      if (ce = [...ce, {
        placement: i,
        overflows: re
      }], !re.every((Le) => Le <= 0)) {
        var de, ge;
        const Le = (((de = o.flip) == null ? void 0 : de.index) || 0) + 1, ze = ie[Le];
        if (ze)
          return {
            data: {
              index: Le,
              overflows: ce
            },
            reset: {
              placement: ze
            }
          };
        let ke = (ge = ce.filter((fe) => fe.overflows[0] <= 0).sort((fe, De) => fe.overflows[1] - De.overflows[1])[0]) == null ? void 0 : ge.placement;
        if (!ke)
          switch (_) {
            case "bestFit": {
              var $e;
              const fe = ($e = ce.map((De) => [De.placement, De.overflows.filter((_e) => _e > 0).reduce((_e, ue) => _e + ue, 0)]).sort((De, _e) => De[1] - _e[1])[0]) == null ? void 0 : $e[0];
              fe && (ke = fe);
              break;
            }
            case "initialPlacement":
              ke = c;
              break;
          }
        if (i !== ke)
          return {
            reset: {
              placement: ke
            }
          };
      }
      return {};
    }
  };
};
async function Vy(e, n) {
  const {
    placement: t,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Nn(t), c = Gs(t), d = qs(t) === "y", p = ["left", "top"].includes(a) ? -1 : 1, m = o && d ? -1 : 1, v = vi(n, e);
  let {
    mainAxis: y,
    crossAxis: _,
    alignmentAxis: S
  } = typeof v == "number" ? {
    mainAxis: v,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...v
  };
  return c && typeof S == "number" && (_ = c === "end" ? S * -1 : S), d ? {
    x: _ * m,
    y: y * p
  } : {
    x: y * p,
    y: _ * m
  };
}
const $a = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(n) {
      var t, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: c
      } = n, d = await Vy(n, e);
      return a === ((t = c.offset) == null ? void 0 : t.placement) && (r = c.arrow) != null && r.alignmentOffset ? {} : {
        x: i + d.x,
        y: o + d.y,
        data: {
          ...d,
          placement: a
        }
      };
    }
  };
}, Yy = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(n) {
      const {
        x: t,
        y: r,
        placement: i
      } = n, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: c = {
          fn: (Y) => {
            let {
              x: N,
              y: I
            } = Y;
            return {
              x: N,
              y: I
            };
          }
        },
        ...d
      } = vi(e, n), p = {
        x: t,
        y: r
      }, m = await jp(n, d), v = qs(Nn(i)), y = Wc(v);
      let _ = p[y], S = p[v];
      if (o) {
        const Y = y === "y" ? "top" : "left", N = y === "y" ? "bottom" : "right", I = _ + m[Y], Q = _ - m[N];
        _ = Jl(I, _, Q);
      }
      if (a) {
        const Y = v === "y" ? "top" : "left", N = v === "y" ? "bottom" : "right", I = S + m[Y], Q = S - m[N];
        S = Jl(I, S, Q);
      }
      const E = c.fn({
        ...n,
        [y]: _,
        [v]: S
      });
      return {
        ...E,
        data: {
          x: E.x - t,
          y: E.y - r
        }
      };
    }
  };
}, Hy = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(n) {
      const {
        x: t,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = n, {
        offset: c = 0,
        mainAxis: d = !0,
        crossAxis: p = !0
      } = vi(e, n), m = {
        x: t,
        y: r
      }, v = qs(i), y = Wc(v);
      let _ = m[y], S = m[v];
      const E = vi(c, n), Y = typeof E == "number" ? {
        mainAxis: E,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...E
      };
      if (d) {
        const Q = y === "y" ? "height" : "width", te = o.reference[y] - o.floating[Q] + Y.mainAxis, ie = o.reference[y] + o.reference[Q] - Y.mainAxis;
        _ < te ? _ = te : _ > ie && (_ = ie);
      }
      if (p) {
        var N, I;
        const Q = y === "y" ? "width" : "height", te = ["top", "left"].includes(Nn(i)), ie = o.reference[v] - o.floating[Q] + (te && ((N = a.offset) == null ? void 0 : N[v]) || 0) + (te ? 0 : Y.crossAxis), ne = o.reference[v] + o.reference[Q] + (te ? 0 : ((I = a.offset) == null ? void 0 : I[v]) || 0) - (te ? Y.crossAxis : 0);
        S < ie ? S = ie : S > ne && (S = ne);
      }
      return {
        [y]: _,
        [v]: S
      };
    }
  };
};
function Gp(e) {
  const n = cr(e);
  let t = parseFloat(n.width) || 0, r = parseFloat(n.height) || 0;
  const i = Gt(e), o = i ? e.offsetWidth : t, a = i ? e.offsetHeight : r, c = Xo(t) !== o || Xo(r) !== a;
  return c && (t = o, r = a), {
    width: t,
    height: r,
    $: c
  };
}
function qc(e) {
  return at(e) ? e : e.contextElement;
}
function Ni(e) {
  const n = qc(e);
  if (!Gt(n))
    return Ln(1);
  const t = n.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = Gp(n);
  let a = (o ? Xo(t.width) : t.width) / r, c = (o ? Xo(t.height) : t.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: a,
    y: c
  };
}
const By = /* @__PURE__ */ Ln(0);
function qp(e) {
  const n = nr(e);
  return !Yc() || !n.visualViewport ? By : {
    x: n.visualViewport.offsetLeft,
    y: n.visualViewport.offsetTop
  };
}
function Wy(e, n, t) {
  return n === void 0 && (n = !1), !t || n && t !== nr(e) ? !1 : n;
}
function _i(e, n, t, r) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const i = e.getBoundingClientRect(), o = qc(e);
  let a = Ln(1);
  n && (r ? at(r) && (a = Ni(r)) : a = Ni(e));
  const c = Wy(o, t, r) ? qp(o) : Ln(0);
  let d = (i.left + c.x) / a.x, p = (i.top + c.y) / a.y, m = i.width / a.x, v = i.height / a.y;
  if (o) {
    const y = nr(o), _ = r && at(r) ? nr(r) : r;
    let S = y, E = S.frameElement;
    for (; E && r && _ !== S; ) {
      const Y = Ni(E), N = E.getBoundingClientRect(), I = cr(E), Q = N.left + (E.clientLeft + parseFloat(I.paddingLeft)) * Y.x, te = N.top + (E.clientTop + parseFloat(I.paddingTop)) * Y.y;
      d *= Y.x, p *= Y.y, m *= Y.x, v *= Y.y, d += Q, p += te, S = nr(E), E = S.frameElement;
    }
  }
  return Jo({
    width: m,
    height: v,
    x: d,
    y: p
  });
}
const jy = [":popover-open", ":modal"];
function Kp(e) {
  return jy.some((n) => {
    try {
      return e.matches(n);
    } catch {
      return !1;
    }
  });
}
function Gy(e) {
  let {
    elements: n,
    rect: t,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = dn(r), c = n ? Kp(n.floating) : !1;
  if (r === a || c && o)
    return t;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, p = Ln(1);
  const m = Ln(0), v = Gt(r);
  if ((v || !v && !o) && ((cn(r) !== "body" || js(a)) && (d = Ma(r)), Gt(r))) {
    const y = _i(r);
    p = Ni(r), m.x = y.x + r.clientLeft, m.y = y.y + r.clientTop;
  }
  return {
    width: t.width * p.x,
    height: t.height * p.y,
    x: t.x * p.x - d.scrollLeft * p.x + m.x,
    y: t.y * p.y - d.scrollTop * p.y + m.y
  };
}
function qy(e) {
  return Array.from(e.getClientRects());
}
function Up(e) {
  return _i(dn(e)).left + Ma(e).scrollLeft;
}
function Ky(e) {
  const n = dn(e), t = Ma(e), r = e.ownerDocument.body, i = di(n.scrollWidth, n.clientWidth, r.scrollWidth, r.clientWidth), o = di(n.scrollHeight, n.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -t.scrollLeft + Up(e);
  const c = -t.scrollTop;
  return cr(r).direction === "rtl" && (a += di(n.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: c
  };
}
function Uy(e, n) {
  const t = nr(e), r = dn(e), i = t.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, c = 0, d = 0;
  if (i) {
    o = i.width, a = i.height;
    const p = Yc();
    (!p || p && n === "fixed") && (c = i.offsetLeft, d = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: c,
    y: d
  };
}
function Qy(e, n) {
  const t = _i(e, !0, n === "fixed"), r = t.top + e.clientTop, i = t.left + e.clientLeft, o = Gt(e) ? Ni(e) : Ln(1), a = e.clientWidth * o.x, c = e.clientHeight * o.y, d = i * o.x, p = r * o.y;
  return {
    width: a,
    height: c,
    x: d,
    y: p
  };
}
function $d(e, n, t) {
  let r;
  if (n === "viewport")
    r = Uy(e, t);
  else if (n === "document")
    r = Ky(dn(e));
  else if (at(n))
    r = Qy(n, t);
  else {
    const i = qp(e);
    r = {
      ...n,
      x: n.x - i.x,
      y: n.y - i.y
    };
  }
  return Jo(r);
}
function Qp(e, n) {
  const t = mi(e);
  return t === n || !at(t) || ji(t) ? !1 : cr(t).position === "fixed" || Qp(t, n);
}
function Xy(e, n) {
  const t = n.get(e);
  if (t)
    return t;
  let r = In(e, [], !1).filter((c) => at(c) && cn(c) !== "body"), i = null;
  const o = cr(e).position === "fixed";
  let a = o ? mi(e) : e;
  for (; at(a) && !ji(a); ) {
    const c = cr(a), d = Vc(a);
    !d && c.position === "fixed" && (i = null), (o ? !d && !i : !d && c.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || js(a) && !d && Qp(e, a)) ? r = r.filter((m) => m !== a) : i = c, a = mi(a);
  }
  return n.set(e, r), r;
}
function Zy(e) {
  let {
    element: n,
    boundary: t,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...t === "clippingAncestors" ? Xy(n, this._c) : [].concat(t), r], c = a[0], d = a.reduce((p, m) => {
    const v = $d(n, m, i);
    return p.top = di(v.top, p.top), p.right = Gi(v.right, p.right), p.bottom = Gi(v.bottom, p.bottom), p.left = di(v.left, p.left), p;
  }, $d(n, c, i));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function Jy(e) {
  const {
    width: n,
    height: t
  } = Gp(e);
  return {
    width: n,
    height: t
  };
}
function eb(e, n, t) {
  const r = Gt(n), i = dn(n), o = t === "fixed", a = _i(e, !0, o, n);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Ln(0);
  if (r || !r && !o)
    if ((cn(n) !== "body" || js(i)) && (c = Ma(n)), r) {
      const v = _i(n, !0, o, n);
      d.x = v.x + n.clientLeft, d.y = v.y + n.clientTop;
    } else
      i && (d.x = Up(i));
  const p = a.left + c.scrollLeft - d.x, m = a.top + c.scrollTop - d.y;
  return {
    x: p,
    y: m,
    width: a.width,
    height: a.height
  };
}
function Td(e, n) {
  return !Gt(e) || cr(e).position === "fixed" ? null : n ? n(e) : e.offsetParent;
}
function Xp(e, n) {
  const t = nr(e);
  if (!Gt(e) || Kp(e))
    return t;
  let r = Td(e, n);
  for (; r && wy(r) && cr(r).position === "static"; )
    r = Td(r, n);
  return r && (cn(r) === "html" || cn(r) === "body" && cr(r).position === "static" && !Vc(r)) ? t : r || xy(e) || t;
}
const tb = async function(e) {
  const n = this.getOffsetParent || Xp, t = this.getDimensions;
  return {
    reference: eb(e.reference, await n(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await t(e.floating)
    }
  };
};
function rb(e) {
  return cr(e).direction === "rtl";
}
const Zp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Gy,
  getDocumentElement: dn,
  getClippingRect: Zy,
  getOffsetParent: Xp,
  getElementRects: tb,
  getClientRects: qy,
  getDimensions: Jy,
  getScale: Ni,
  isElement: at,
  isRTL: rb
};
function nb(e, n) {
  let t = null, r;
  const i = dn(e);
  function o() {
    var c;
    clearTimeout(r), (c = t) == null || c.disconnect(), t = null;
  }
  function a(c, d) {
    c === void 0 && (c = !1), d === void 0 && (d = 1), o();
    const {
      left: p,
      top: m,
      width: v,
      height: y
    } = e.getBoundingClientRect();
    if (c || n(), !v || !y)
      return;
    const _ = _o(m), S = _o(i.clientWidth - (p + v)), E = _o(i.clientHeight - (m + y)), Y = _o(p), I = {
      rootMargin: -_ + "px " + -S + "px " + -E + "px " + -Y + "px",
      threshold: di(0, Gi(1, d)) || 1
    };
    let Q = !0;
    function te(ie) {
      const ne = ie[0].intersectionRatio;
      if (ne !== d) {
        if (!Q)
          return a();
        ne ? a(!1, ne) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 100);
      }
      Q = !1;
    }
    try {
      t = new IntersectionObserver(te, {
        ...I,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(te, I);
    }
    t.observe(e);
  }
  return a(!0), o;
}
function Ta(e, n, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = r, p = qc(e), m = i || o ? [...p ? In(p) : [], ...In(n)] : [];
  m.forEach((N) => {
    i && N.addEventListener("scroll", t, {
      passive: !0
    }), o && N.addEventListener("resize", t);
  });
  const v = p && c ? nb(p, t) : null;
  let y = -1, _ = null;
  a && (_ = new ResizeObserver((N) => {
    let [I] = N;
    I && I.target === p && _ && (_.unobserve(n), cancelAnimationFrame(y), y = requestAnimationFrame(() => {
      var Q;
      (Q = _) == null || Q.observe(n);
    })), t();
  }), p && !d && _.observe(p), _.observe(n));
  let S, E = d ? _i(e) : null;
  d && Y();
  function Y() {
    const N = _i(e);
    E && (N.x !== E.x || N.y !== E.y || N.width !== E.width || N.height !== E.height) && t(), E = N, S = requestAnimationFrame(Y);
  }
  return t(), () => {
    var N;
    m.forEach((I) => {
      i && I.removeEventListener("scroll", t), o && I.removeEventListener("resize", t);
    }), v == null || v(), (N = _) == null || N.disconnect(), _ = null, d && cancelAnimationFrame(S);
  };
}
const Kc = Yy, Ia = zy, Id = Ny, ib = Hy, sb = (e, n, t) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Zp,
    ...t
  }, o = {
    ...i.platform,
    _c: r
  };
  return Ly(e, n, {
    ...i,
    platform: o
  });
}, Jp = (e) => {
  function n(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(t) : e;
      return r && n(r) ? r.current != null ? Id({
        element: r.current,
        padding: i
      }).fn(t) : {} : r ? Id({
        element: r,
        padding: i
      }).fn(t) : {};
    }
  };
};
var No = typeof document < "u" ? Pc : ct;
function ea(e, n) {
  if (e === n)
    return !0;
  if (typeof e != typeof n)
    return !1;
  if (typeof e == "function" && e.toString() === n.toString())
    return !0;
  let t, r, i;
  if (e && n && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== n.length)
        return !1;
      for (r = t; r-- !== 0; )
        if (!ea(e[r], n[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), t = i.length, t !== Object.keys(n).length)
      return !1;
    for (r = t; r-- !== 0; )
      if (!{}.hasOwnProperty.call(n, i[r]))
        return !1;
    for (r = t; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !ea(e[o], n[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}
function eh(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Rd(e, n) {
  const t = eh(e);
  return Math.round(n * t) / t;
}
function Ad(e) {
  const n = se.useRef(e);
  return No(() => {
    n.current = e;
  }), n;
}
function ob(e) {
  e === void 0 && (e = {});
  const {
    placement: n = "bottom",
    strategy: t = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: c = !0,
    whileElementsMounted: d,
    open: p
  } = e, [m, v] = se.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: n,
    middlewareData: {},
    isPositioned: !1
  }), [y, _] = se.useState(r);
  ea(y, r) || _(r);
  const [S, E] = se.useState(null), [Y, N] = se.useState(null), I = se.useCallback((_e) => {
    _e !== ne.current && (ne.current = _e, E(_e));
  }, []), Q = se.useCallback((_e) => {
    _e !== re.current && (re.current = _e, N(_e));
  }, []), te = o || S, ie = a || Y, ne = se.useRef(null), re = se.useRef(null), ce = se.useRef(m), de = d != null, ge = Ad(d), $e = Ad(i), Le = se.useCallback(() => {
    if (!ne.current || !re.current)
      return;
    const _e = {
      placement: n,
      strategy: t,
      middleware: y
    };
    $e.current && (_e.platform = $e.current), sb(ne.current, re.current, _e).then((ue) => {
      const Ve = {
        ...ue,
        isPositioned: !0
      };
      ze.current && !ea(ce.current, Ve) && (ce.current = Ve, Fm.flushSync(() => {
        v(Ve);
      }));
    });
  }, [y, n, t, $e]);
  No(() => {
    p === !1 && ce.current.isPositioned && (ce.current.isPositioned = !1, v((_e) => ({
      ..._e,
      isPositioned: !1
    })));
  }, [p]);
  const ze = se.useRef(!1);
  No(() => (ze.current = !0, () => {
    ze.current = !1;
  }), []), No(() => {
    if (te && (ne.current = te), ie && (re.current = ie), te && ie) {
      if (ge.current)
        return ge.current(te, ie, Le);
      Le();
    }
  }, [te, ie, Le, ge, de]);
  const ke = se.useMemo(() => ({
    reference: ne,
    floating: re,
    setReference: I,
    setFloating: Q
  }), [I, Q]), fe = se.useMemo(() => ({
    reference: te,
    floating: ie
  }), [te, ie]), De = se.useMemo(() => {
    const _e = {
      position: t,
      left: 0,
      top: 0
    };
    if (!fe.floating)
      return _e;
    const ue = Rd(fe.floating, m.x), Ve = Rd(fe.floating, m.y);
    return c ? {
      ..._e,
      transform: "translate(" + ue + "px, " + Ve + "px)",
      ...eh(fe.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: ue,
      top: Ve
    };
  }, [t, c, fe.floating, m.x, m.y]);
  return se.useMemo(() => ({
    ...m,
    update: Le,
    refs: ke,
    elements: fe,
    floatingStyles: De
  }), [m, Le, ke, fe, De]);
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ab = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], tc = /* @__PURE__ */ ab.join(","), th = typeof Element > "u", Os = th ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, ta = !th && Element.prototype.getRootNode ? function(e) {
  var n;
  return e == null || (n = e.getRootNode) === null || n === void 0 ? void 0 : n.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, ra = function e(n, t) {
  var r;
  t === void 0 && (t = !0);
  var i = n == null || (r = n.getAttribute) === null || r === void 0 ? void 0 : r.call(n, "inert"), o = i === "" || i === "true", a = o || t && n && e(n.parentNode);
  return a;
}, lb = function(n) {
  var t, r = n == null || (t = n.getAttribute) === null || t === void 0 ? void 0 : t.call(n, "contenteditable");
  return r === "" || r === "true";
}, cb = function(n, t, r) {
  if (ra(n))
    return [];
  var i = Array.prototype.slice.apply(n.querySelectorAll(tc));
  return t && Os.call(n, tc) && i.unshift(n), i = i.filter(r), i;
}, ub = function e(n, t, r) {
  for (var i = [], o = Array.from(n); o.length; ) {
    var a = o.shift();
    if (!ra(a, !1))
      if (a.tagName === "SLOT") {
        var c = a.assignedElements(), d = c.length ? c : a.children, p = e(d, !0, r);
        r.flatten ? i.push.apply(i, p) : i.push({
          scopeParent: a,
          candidates: p
        });
      } else {
        var m = Os.call(a, tc);
        m && r.filter(a) && (t || !n.includes(a)) && i.push(a);
        var v = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), y = !ra(v, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (v && y) {
          var _ = e(v === !0 ? a.children : v.children, !0, r);
          r.flatten ? i.push.apply(i, _) : i.push({
            scopeParent: a,
            candidates: _
          });
        } else
          o.unshift.apply(o, a.children);
      }
  }
  return i;
}, rh = function(n) {
  return !isNaN(parseInt(n.getAttribute("tabindex"), 10));
}, nh = function(n) {
  if (!n)
    throw new Error("No node provided");
  return n.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(n.tagName) || lb(n)) && !rh(n) ? 0 : n.tabIndex;
}, db = function(n, t) {
  var r = nh(n);
  return r < 0 && t && !rh(n) ? 0 : r;
}, fb = function(n, t) {
  return n.tabIndex === t.tabIndex ? n.documentOrder - t.documentOrder : n.tabIndex - t.tabIndex;
}, ih = function(n) {
  return n.tagName === "INPUT";
}, pb = function(n) {
  return ih(n) && n.type === "hidden";
}, hb = function(n) {
  var t = n.tagName === "DETAILS" && Array.prototype.slice.apply(n.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return t;
}, gb = function(n, t) {
  for (var r = 0; r < n.length; r++)
    if (n[r].checked && n[r].form === t)
      return n[r];
}, mb = function(n) {
  if (!n.name)
    return !0;
  var t = n.form || ta(n), r = function(c) {
    return t.querySelectorAll('input[type="radio"][name="' + c + '"]');
  }, i;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    i = r(window.CSS.escape(n.name));
  else
    try {
      i = r(n.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var o = gb(i, n.form);
  return !o || o === n;
}, vb = function(n) {
  return ih(n) && n.type === "radio";
}, _b = function(n) {
  return vb(n) && !mb(n);
}, yb = function(n) {
  var t, r = n && ta(n), i = (t = r) === null || t === void 0 ? void 0 : t.host, o = !1;
  if (r && r !== n) {
    var a, c, d;
    for (o = !!((a = i) !== null && a !== void 0 && (c = a.ownerDocument) !== null && c !== void 0 && c.contains(i) || n != null && (d = n.ownerDocument) !== null && d !== void 0 && d.contains(n)); !o && i; ) {
      var p, m, v;
      r = ta(i), i = (p = r) === null || p === void 0 ? void 0 : p.host, o = !!((m = i) !== null && m !== void 0 && (v = m.ownerDocument) !== null && v !== void 0 && v.contains(i));
    }
  }
  return o;
}, Fd = function(n) {
  var t = n.getBoundingClientRect(), r = t.width, i = t.height;
  return r === 0 && i === 0;
}, bb = function(n, t) {
  var r = t.displayCheck, i = t.getShadowRoot;
  if (getComputedStyle(n).visibility === "hidden")
    return !0;
  var o = Os.call(n, "details>summary:first-of-type"), a = o ? n.parentElement : n;
  if (Os.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof i == "function") {
      for (var c = n; n; ) {
        var d = n.parentElement, p = ta(n);
        if (d && !d.shadowRoot && i(d) === !0)
          return Fd(n);
        n.assignedSlot ? n = n.assignedSlot : !d && p !== n.ownerDocument ? n = p.host : n = d;
      }
      n = c;
    }
    if (yb(n))
      return !n.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Fd(n);
  return !1;
}, wb = function(n) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(n.tagName))
    for (var t = n.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var r = 0; r < t.children.length; r++) {
          var i = t.children.item(r);
          if (i.tagName === "LEGEND")
            return Os.call(t, "fieldset[disabled] *") ? !0 : !i.contains(n);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, xb = function(n, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  ra(t) || pb(t) || bb(t, n) || // For a details element with a summary, the summary element gets the focus
  hb(t) || wb(t));
}, Od = function(n, t) {
  return !(_b(t) || nh(t) < 0 || !xb(n, t));
}, Sb = function(n) {
  var t = parseInt(n.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, kb = function e(n) {
  var t = [], r = [];
  return n.forEach(function(i, o) {
    var a = !!i.scopeParent, c = a ? i.scopeParent : i, d = db(c, a), p = a ? e(i.candidates) : c;
    d === 0 ? a ? t.push.apply(t, p) : t.push(c) : r.push({
      documentOrder: o,
      tabIndex: d,
      item: i,
      isScope: a,
      content: p
    });
  }), r.sort(fb).reduce(function(i, o) {
    return o.isScope ? i.push.apply(i, o.content) : i.push(o.content), i;
  }, []).concat(t);
}, Uc = function(n, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = ub([n], t.includeContainer, {
    filter: Od.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: Sb
  }) : r = cb(n, t.includeContainer, Od.bind(null, t)), kb(r);
};
const Cb = se.useInsertionEffect, Db = Cb || ((e) => e());
function Oi(e) {
  const n = se.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return Db(() => {
    n.current = e;
  }), se.useCallback(function() {
    for (var t = arguments.length, r = new Array(t), i = 0; i < t; i++)
      r[i] = arguments[i];
    return n.current == null ? void 0 : n.current(...r);
  }, []);
}
let Ld = 0;
function ti(e, n) {
  n === void 0 && (n = {});
  const {
    preventScroll: t = !1,
    cancelPrevious: r = !0,
    sync: i = !1
  } = n;
  r && cancelAnimationFrame(Ld);
  const o = () => e == null ? void 0 : e.focus({
    preventScroll: t
  });
  i ? o() : Ld = requestAnimationFrame(o);
}
var rr = typeof document < "u" ? Pc : ct;
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, qi.apply(this, arguments);
}
let dl = !1, Eb = 0;
const Nd = () => "floating-ui-" + Eb++;
function Pb() {
  const [e, n] = se.useState(() => dl ? Nd() : void 0);
  return rr(() => {
    e == null && n(Nd());
  }, []), se.useEffect(() => {
    dl || (dl = !0);
  }, []), e;
}
const Mb = se.useId, Ks = Mb || Pb, sh = /* @__PURE__ */ se.forwardRef(function(n, t) {
  let {
    context: {
      placement: r,
      elements: {
        floating: i
      },
      middlewareData: {
        arrow: o
      }
    },
    width: a = 14,
    height: c = 7,
    tipRadius: d = 0,
    strokeWidth: p = 0,
    staticOffset: m,
    stroke: v,
    d: y,
    style: {
      transform: _,
      ...S
    } = {},
    ...E
  } = n;
  process.env.NODE_ENV !== "production" && (t || console.warn("Floating UI: The `ref` prop is required for the `FloatingArrow`", "component."));
  const Y = Ks();
  if (!i)
    return null;
  p *= 2;
  const N = p / 2, I = a / 2 * (d / -8 + 1), Q = c / 2 * d / 4, [te, ie] = r.split("-"), ne = Zp.isRTL(i), re = !!y, ce = te === "top" || te === "bottom", de = m && ie === "end" ? "bottom" : "top";
  let ge = m && ie === "end" ? "right" : "left";
  m && ne && (ge = ie === "end" ? "left" : "right");
  const $e = (o == null ? void 0 : o.x) != null ? m || o.x : "", Le = (o == null ? void 0 : o.y) != null ? m || o.y : "", ze = y || // biome-ignore lint/style/useTemplate: readability
  "M0,0" + (" H" + a) + (" L" + (a - I) + "," + (c - Q)) + (" Q" + a / 2 + "," + c + " " + I + "," + (c - Q)) + " Z", ke = {
    top: re ? "rotate(180deg)" : "",
    left: re ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: re ? "" : "rotate(180deg)",
    right: re ? "rotate(-90deg)" : "rotate(90deg)"
  }[te];
  return /* @__PURE__ */ se.createElement("svg", qi({}, E, {
    "aria-hidden": !0,
    ref: t,
    width: re ? a : a + p,
    height: a,
    viewBox: "0 0 " + a + " " + (c > a ? c : a),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [ge]: $e,
      [de]: Le,
      [te]: ce || re ? "100%" : "calc(100% - " + p / 2 + "px)",
      transform: "" + ke + (_ ?? ""),
      ...S
    }
  }), p > 0 && /* @__PURE__ */ se.createElement("path", {
    clipPath: "url(#" + Y + ")",
    fill: "none",
    stroke: v,
    strokeWidth: p + (y ? 0 : 1),
    d: ze
  }), /* @__PURE__ */ se.createElement("path", {
    stroke: p && !y ? E.fill : "none",
    d: ze
  }), /* @__PURE__ */ se.createElement("clipPath", {
    id: Y
  }, /* @__PURE__ */ se.createElement("rect", {
    x: -N,
    y: N * (re ? -1 : 1),
    width: a + p,
    height: a
  })));
});
function $b() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(n, t) {
      var r;
      (r = e.get(n)) == null || r.forEach((i) => i(t));
    },
    on(n, t) {
      e.set(n, [...e.get(n) || [], t]);
    },
    off(n, t) {
      var r;
      e.set(n, ((r = e.get(n)) == null ? void 0 : r.filter((i) => i !== t)) || []);
    }
  };
}
const Tb = /* @__PURE__ */ se.createContext(null), Ib = /* @__PURE__ */ se.createContext(null), Qc = () => {
  var e;
  return ((e = se.useContext(Tb)) == null ? void 0 : e.id) || null;
}, Ra = () => se.useContext(Ib);
function yi(e) {
  return "data-floating-ui-" + e;
}
function $s(e) {
  const n = We(e);
  return rr(() => {
    n.current = e;
  }), n;
}
const zd = /* @__PURE__ */ yi("safe-polygon");
function fl(e, n, t) {
  return t && !Qo(t) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[n];
}
function Rb(e, n) {
  n === void 0 && (n = {});
  const {
    open: t,
    onOpenChange: r,
    dataRef: i,
    events: o,
    elements: {
      domReference: a,
      floating: c
    },
    refs: d
  } = e, {
    enabled: p = !0,
    delay: m = 0,
    handleClose: v = null,
    mouseOnly: y = !1,
    restMs: _ = 0,
    move: S = !0
  } = n, E = Ra(), Y = Qc(), N = $s(v), I = $s(m), Q = se.useRef(), te = se.useRef(), ie = se.useRef(), ne = se.useRef(), re = se.useRef(!0), ce = se.useRef(!1), de = se.useRef(() => {
  }), ge = se.useCallback(() => {
    var ke;
    const fe = (ke = i.current.openEvent) == null ? void 0 : ke.type;
    return (fe == null ? void 0 : fe.includes("mouse")) && fe !== "mousedown";
  }, [i]);
  se.useEffect(() => {
    if (!p)
      return;
    function ke(fe) {
      let {
        open: De
      } = fe;
      De || (clearTimeout(te.current), clearTimeout(ne.current), re.current = !0);
    }
    return o.on("openchange", ke), () => {
      o.off("openchange", ke);
    };
  }, [p, o]), se.useEffect(() => {
    if (!p || !N.current || !t)
      return;
    function ke(De) {
      ge() && r(!1, De, "hover");
    }
    const fe = tr(c).documentElement;
    return fe.addEventListener("mouseleave", ke), () => {
      fe.removeEventListener("mouseleave", ke);
    };
  }, [c, t, r, p, N, ge]);
  const $e = se.useCallback(function(ke, fe, De) {
    fe === void 0 && (fe = !0), De === void 0 && (De = "hover");
    const _e = fl(I.current, "close", Q.current);
    _e && !ie.current ? (clearTimeout(te.current), te.current = setTimeout(() => r(!1, ke, De), _e)) : fe && (clearTimeout(te.current), r(!1, ke, De));
  }, [I, r]), Le = se.useCallback(() => {
    de.current(), ie.current = void 0;
  }, []), ze = se.useCallback(() => {
    if (ce.current) {
      const ke = tr(d.floating.current).body;
      ke.style.pointerEvents = "", ke.removeAttribute(zd), ce.current = !1;
    }
  }, [d]);
  return se.useEffect(() => {
    if (!p)
      return;
    function ke() {
      return i.current.openEvent ? ["click", "mousedown"].includes(i.current.openEvent.type) : !1;
    }
    function fe(ue) {
      if (clearTimeout(te.current), re.current = !1, y && !Qo(Q.current) || _ > 0 && fl(I.current, "open") === 0)
        return;
      const Ve = fl(I.current, "open", Q.current);
      Ve ? te.current = setTimeout(() => {
        r(!0, ue, "hover");
      }, Ve) : r(!0, ue, "hover");
    }
    function De(ue) {
      if (ke())
        return;
      de.current();
      const Ve = tr(c);
      if (clearTimeout(ne.current), N.current) {
        t || clearTimeout(te.current), ie.current = N.current({
          ...e,
          tree: E,
          x: ue.clientX,
          y: ue.clientY,
          onClose() {
            ze(), Le(), $e(ue, !0, "safe-polygon");
          }
        });
        const Re = ie.current;
        Ve.addEventListener("mousemove", Re), de.current = () => {
          Ve.removeEventListener("mousemove", Re);
        };
        return;
      }
      (Q.current === "touch" ? !Bt(c, ue.relatedTarget) : !0) && $e(ue);
    }
    function _e(ue) {
      ke() || N.current == null || N.current({
        ...e,
        tree: E,
        x: ue.clientX,
        y: ue.clientY,
        onClose() {
          ze(), Le(), $e(ue);
        }
      })(ue);
    }
    if (at(a)) {
      const ue = a;
      return t && ue.addEventListener("mouseleave", _e), c == null || c.addEventListener("mouseleave", _e), S && ue.addEventListener("mousemove", fe, {
        once: !0
      }), ue.addEventListener("mouseenter", fe), ue.addEventListener("mouseleave", De), () => {
        t && ue.removeEventListener("mouseleave", _e), c == null || c.removeEventListener("mouseleave", _e), S && ue.removeEventListener("mousemove", fe), ue.removeEventListener("mouseenter", fe), ue.removeEventListener("mouseleave", De);
      };
    }
  }, [a, c, p, e, y, _, S, $e, Le, ze, r, t, E, I, N, i]), rr(() => {
    var ke;
    if (p && t && (ke = N.current) != null && ke.__options.blockPointerEvents && ge()) {
      const De = tr(c).body;
      if (De.setAttribute(zd, ""), De.style.pointerEvents = "none", ce.current = !0, at(a) && c) {
        var fe;
        const _e = a, ue = E == null || (fe = E.nodesRef.current.find((Ve) => Ve.id === Y)) == null || (fe = fe.context) == null ? void 0 : fe.elements.floating;
        return ue && (ue.style.pointerEvents = ""), _e.style.pointerEvents = "auto", c.style.pointerEvents = "auto", () => {
          _e.style.pointerEvents = "", c.style.pointerEvents = "";
        };
      }
    }
  }, [p, t, Y, c, a, E, N, ge]), rr(() => {
    t || (Q.current = void 0, Le(), ze());
  }, [t, Le, ze]), se.useEffect(() => () => {
    Le(), clearTimeout(te.current), clearTimeout(ne.current), ze();
  }, [p, a, Le, ze]), se.useMemo(() => {
    if (!p)
      return {};
    function ke(fe) {
      Q.current = fe.pointerType;
    }
    return {
      reference: {
        onPointerDown: ke,
        onPointerEnter: ke,
        onMouseMove(fe) {
          t || _ === 0 || (clearTimeout(ne.current), ne.current = setTimeout(() => {
            re.current || r(!0, fe.nativeEvent, "hover");
          }, _));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(te.current);
        },
        onMouseLeave(fe) {
          $e(fe.nativeEvent, !1);
        }
      }
    };
  }, [p, _, t, r, $e]);
}
function Ab(e, n) {
  var t;
  let r = [], i = (t = e.find((o) => o.id === n)) == null ? void 0 : t.parentId;
  for (; i; ) {
    const o = e.find((a) => a.id === i);
    i = o == null ? void 0 : o.parentId, o && (r = r.concat(o));
  }
  return r;
}
function Ts(e, n) {
  let t = e.filter((i) => {
    var o;
    return i.parentId === n && ((o = i.context) == null ? void 0 : o.open);
  }), r = t;
  for (; r.length; )
    r = e.filter((i) => {
      var o;
      return (o = r) == null ? void 0 : o.some((a) => {
        var c;
        return i.parentId === a.id && ((c = i.context) == null ? void 0 : c.open);
      });
    }), t = t.concat(r);
  return t;
}
let Ai = /* @__PURE__ */ new WeakMap(), yo = /* @__PURE__ */ new WeakSet(), bo = {}, pl = 0;
const Fb = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, oh = (e) => e && (e.host || oh(e.parentNode)), Ob = (e, n) => n.map((t) => {
  if (e.contains(t))
    return t;
  const r = oh(t);
  return e.contains(r) ? r : null;
}).filter((t) => t != null);
function Lb(e, n, t, r) {
  const i = "data-floating-ui-inert", o = r ? "inert" : t ? "aria-hidden" : null, a = Ob(n, e), c = /* @__PURE__ */ new Set(), d = new Set(a), p = [];
  bo[i] || (bo[i] = /* @__PURE__ */ new WeakMap());
  const m = bo[i];
  a.forEach(v), y(n), c.clear();
  function v(_) {
    !_ || c.has(_) || (c.add(_), _.parentNode && v(_.parentNode));
  }
  function y(_) {
    !_ || d.has(_) || Array.prototype.forEach.call(_.children, (S) => {
      if (c.has(S))
        y(S);
      else {
        const E = o ? S.getAttribute(o) : null, Y = E !== null && E !== "false", N = (Ai.get(S) || 0) + 1, I = (m.get(S) || 0) + 1;
        Ai.set(S, N), m.set(S, I), p.push(S), N === 1 && Y && yo.add(S), I === 1 && S.setAttribute(i, ""), !Y && o && S.setAttribute(o, "true");
      }
    });
  }
  return pl++, () => {
    p.forEach((_) => {
      const S = (Ai.get(_) || 0) - 1, E = (m.get(_) || 0) - 1;
      Ai.set(_, S), m.set(_, E), S || (!yo.has(_) && o && _.removeAttribute(o), yo.delete(_)), E || _.removeAttribute(i);
    }), pl--, pl || (Ai = /* @__PURE__ */ new WeakMap(), Ai = /* @__PURE__ */ new WeakMap(), yo = /* @__PURE__ */ new WeakSet(), bo = {});
  };
}
function Vd(e, n, t) {
  n === void 0 && (n = !1), t === void 0 && (t = !1);
  const r = tr(e[0]).body;
  return Lb(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, n, t);
}
const Xc = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function ah(e, n) {
  const t = Uc(e, Xc());
  n === "prev" && t.reverse();
  const r = t.indexOf(Dn(tr(e)));
  return t.slice(r + 1)[0];
}
function lh() {
  return ah(document.body, "next");
}
function ch() {
  return ah(document.body, "prev");
}
function Is(e, n) {
  const t = n || e.currentTarget, r = e.relatedTarget;
  return !r || !Bt(t, r);
}
function Nb(e) {
  Uc(e, Xc()).forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  });
}
function zb(e) {
  e.querySelectorAll("[data-tabindex]").forEach((t) => {
    const r = t.dataset.tabindex;
    delete t.dataset.tabindex, r ? t.setAttribute("tabindex", r) : t.removeAttribute("tabindex");
  });
}
const Zc = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let Vb;
function Yd(e) {
  e.key === "Tab" && (e.target, clearTimeout(Vb));
}
const na = /* @__PURE__ */ se.forwardRef(function(n, t) {
  const [r, i] = se.useState();
  rr(() => (Bp() && i("button"), document.addEventListener("keydown", Yd), () => {
    document.removeEventListener("keydown", Yd);
  }), []);
  const o = {
    ref: t,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [yi("focus-guard")]: "",
    style: Zc
  };
  return /* @__PURE__ */ se.createElement("span", qi({}, n, o));
}), uh = /* @__PURE__ */ se.createContext(null), Hd = /* @__PURE__ */ yi("portal");
function Yb(e) {
  let {
    id: n,
    root: t
  } = e === void 0 ? {} : e;
  const [r, i] = se.useState(null), o = Ks(), a = dh(), c = se.useRef(null);
  return rr(() => () => {
    r == null || r.remove(), queueMicrotask(() => {
      c.current = null;
    });
  }, [r]), rr(() => {
    if (c.current)
      return;
    const d = n ? document.getElementById(n) : null;
    if (!d)
      return;
    const p = document.createElement("div");
    p.id = o, p.setAttribute(Hd, ""), d.appendChild(p), c.current = p, i(p);
  }, [n, o]), rr(() => {
    if (c.current)
      return;
    let d = t || (a == null ? void 0 : a.portalNode);
    d && !at(d) && (d = d.current), d = d || document.body;
    let p = null;
    n && (p = document.createElement("div"), p.id = n, d.appendChild(p));
    const m = document.createElement("div");
    m.id = o, m.setAttribute(Hd, ""), d = p || d, d.appendChild(m), c.current = m, i(m);
  }, [n, t, o, a]), r;
}
function Aa(e) {
  let {
    children: n,
    id: t,
    root: r = null,
    preserveTabOrder: i = !0
  } = e;
  const o = Yb({
    id: t,
    root: r
  }), [a, c] = se.useState(null), d = se.useRef(null), p = se.useRef(null), m = se.useRef(null), v = se.useRef(null), y = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!a && // Guards are only for non-modal focus management.
    !a.modal && // Don't render if unmount is transitioning.
    a.open && i && !!(r || o)
  );
  return se.useEffect(() => {
    if (!o || !i || a != null && a.modal)
      return;
    function _(S) {
      o && Is(S) && (S.type === "focusin" ? zb : Nb)(o);
    }
    return o.addEventListener("focusin", _, !0), o.addEventListener("focusout", _, !0), () => {
      o.removeEventListener("focusin", _, !0), o.removeEventListener("focusout", _, !0);
    };
  }, [o, i, a == null ? void 0 : a.modal]), /* @__PURE__ */ se.createElement(uh.Provider, {
    value: se.useMemo(() => ({
      preserveTabOrder: i,
      beforeOutsideRef: d,
      afterOutsideRef: p,
      beforeInsideRef: m,
      afterInsideRef: v,
      portalNode: o,
      setFocusManagerState: c
    }), [i, o])
  }, y && o && /* @__PURE__ */ se.createElement(na, {
    "data-type": "outside",
    ref: d,
    onFocus: (_) => {
      if (Is(_, o)) {
        var S;
        (S = m.current) == null || S.focus();
      } else {
        const E = ch() || (a == null ? void 0 : a.refs.domReference.current);
        E == null || E.focus();
      }
    }
  }), y && o && /* @__PURE__ */ se.createElement("span", {
    "aria-owns": o.id,
    style: Zc
  }), o && /* @__PURE__ */ cp(n, o), y && o && /* @__PURE__ */ se.createElement(na, {
    "data-type": "outside",
    ref: p,
    onFocus: (_) => {
      if (Is(_, o)) {
        var S;
        (S = v.current) == null || S.focus();
      } else {
        const E = lh() || (a == null ? void 0 : a.refs.domReference.current);
        E == null || E.focus(), a != null && a.closeOnFocusOut && (a == null || a.onOpenChange(!1, _.nativeEvent));
      }
    }
  }));
}
const dh = () => se.useContext(uh), Bd = 20;
let ri = [];
function hl(e) {
  ri = ri.filter((n) => n.isConnected), e && cn(e) !== "body" && (ri.push(e), ri.length > Bd && (ri = ri.slice(-Bd)));
}
function Wd() {
  return ri.slice().reverse().find((e) => e.isConnected);
}
const Hb = /* @__PURE__ */ se.forwardRef(function(n, t) {
  return /* @__PURE__ */ se.createElement("button", qi({}, n, {
    type: "button",
    ref: t,
    tabIndex: -1,
    style: Zc
  }));
});
function fh(e) {
  const {
    context: n,
    children: t,
    disabled: r = !1,
    order: i = ["content"],
    guards: o = !0,
    initialFocus: a = 0,
    returnFocus: c = !0,
    modal: d = !0,
    visuallyHiddenDismiss: p = !1,
    closeOnFocusOut: m = !0
  } = e, {
    open: v,
    refs: y,
    nodeId: _,
    onOpenChange: S,
    events: E,
    dataRef: Y,
    elements: {
      domReference: N,
      floating: I
    }
  } = n, Q = typeof a == "number" && a < 0, te = My(N) && Q, ie = Fb() ? o : !0, ne = $s(i), re = $s(a), ce = $s(c), de = Ra(), ge = dh(), $e = se.useRef(null), Le = se.useRef(null), ze = se.useRef(!1), ke = se.useRef(!1), fe = ge != null, De = se.useCallback(function(Ne) {
    return Ne === void 0 && (Ne = I), Ne ? Uc(Ne, Xc()) : [];
  }, [I]), _e = se.useCallback((Ne) => {
    const Re = De(Ne);
    return ne.current.map((Ee) => N && Ee === "reference" ? N : I && Ee === "floating" ? I : Re).filter(Boolean).flat();
  }, [N, I, ne, De]);
  se.useEffect(() => {
    if (r || !d)
      return;
    function Ne(Ee) {
      if (Ee.key === "Tab") {
        Bt(I, Dn(tr(I))) && De().length === 0 && !te && ul(Ee);
        const Be = _e(), je = si(Ee);
        ne.current[0] === "reference" && je === N && (ul(Ee), Ee.shiftKey ? ti(Be[Be.length - 1]) : ti(Be[1])), ne.current[1] === "floating" && je === I && Ee.shiftKey && (ul(Ee), ti(Be[0]));
      }
    }
    const Re = tr(I);
    return Re.addEventListener("keydown", Ne), () => {
      Re.removeEventListener("keydown", Ne);
    };
  }, [r, N, I, d, ne, te, De, _e]), se.useEffect(() => {
    if (r || !m)
      return;
    function Ne() {
      ke.current = !0, setTimeout(() => {
        ke.current = !1;
      });
    }
    function Re(Ee) {
      const Be = Ee.relatedTarget;
      queueMicrotask(() => {
        const je = !(Bt(N, Be) || Bt(I, Be) || Bt(Be, I) || Bt(ge == null ? void 0 : ge.portalNode, Be) || Be != null && Be.hasAttribute(yi("focus-guard")) || de && (Ts(de.nodesRef.current, _).find((Ke) => {
          var nt, ut;
          return Bt((nt = Ke.context) == null ? void 0 : nt.elements.floating, Be) || Bt((ut = Ke.context) == null ? void 0 : ut.elements.domReference, Be);
        }) || Ab(de.nodesRef.current, _).find((Ke) => {
          var nt, ut;
          return ((nt = Ke.context) == null ? void 0 : nt.elements.floating) === Be || ((ut = Ke.context) == null ? void 0 : ut.elements.domReference) === Be;
        })));
        Be && je && !ke.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        Be !== Wd() && (ze.current = !0, S(!1, Ee));
      });
    }
    if (I && Gt(N))
      return N.addEventListener("focusout", Re), N.addEventListener("pointerdown", Ne), !d && I.addEventListener("focusout", Re), () => {
        N.removeEventListener("focusout", Re), N.removeEventListener("pointerdown", Ne), !d && I.removeEventListener("focusout", Re);
      };
  }, [r, N, I, d, _, de, ge, S, m]), se.useEffect(() => {
    var Ne;
    if (r)
      return;
    const Re = Array.from((ge == null || (Ne = ge.portalNode) == null ? void 0 : Ne.querySelectorAll("[" + yi("portal") + "]")) || []);
    if (I) {
      const Ee = [I, ...Re, $e.current, Le.current, ne.current.includes("reference") || te ? N : null].filter((je) => je != null), Be = d || te ? Vd(Ee, ie, !ie) : Vd(Ee);
      return () => {
        Be();
      };
    }
  }, [r, N, I, d, ne, ge, te, ie]), rr(() => {
    if (r || !I)
      return;
    const Ne = tr(I), Re = Dn(Ne);
    queueMicrotask(() => {
      const Ee = _e(I), Be = re.current, je = (typeof Be == "number" ? Ee[Be] : Be.current) || I, Ke = Bt(I, Re);
      !Q && !Ke && v && ti(je, {
        preventScroll: je === I
      });
    });
  }, [r, v, I, Q, _e, re]), rr(() => {
    if (r || !I)
      return;
    let Ne = !1;
    const Re = tr(I), Ee = Dn(Re), Be = Y.current;
    hl(Ee);
    function je(Ke) {
      let {
        reason: nt,
        event: ut,
        nested: wt
      } = Ke;
      nt === "escape-key" && y.domReference.current && hl(y.domReference.current), nt === "hover" && ut.type === "mouseleave" && (ze.current = !0), nt === "outside-press" && (wt ? (ze.current = !1, Ne = !0) : ze.current = !(Sy(ut) || Hp(ut)));
    }
    return E.on("openchange", je), () => {
      E.off("openchange", je);
      const Ke = Dn(Re), nt = Bt(I, Ke) || de && Ts(de.nodesRef.current, _).some((Rt) => {
        var Mr;
        return Bt((Mr = Rt.context) == null ? void 0 : Mr.elements.floating, Ke);
      });
      (nt || Be.openEvent && ["click", "mousedown"].includes(Be.openEvent.type)) && y.domReference.current && hl(y.domReference.current);
      const wt = Wd();
      ce.current && !ze.current && Gt(wt) && // If the focus moved somewhere else after mount, avoid returning focus
      // since it likely entered a different element which should be
      // respected: https://github.com/floating-ui/floating-ui/issues/2607
      (!(wt !== Ke && Ke !== Re.body) || nt) && ti(wt, {
        // When dismissing nested floating elements, by the time the rAF has
        // executed, the menus will all have been unmounted. When they try
        // to get focused, the calls get ignored — leaving the root
        // reference focused as desired.
        cancelPrevious: !1,
        preventScroll: Ne
      });
    };
  }, [r, I, ce, Y, y, E, de, _]), rr(() => {
    if (!(r || !ge))
      return ge.setFocusManagerState({
        modal: d,
        closeOnFocusOut: m,
        open: v,
        onOpenChange: S,
        refs: y
      }), () => {
        ge.setFocusManagerState(null);
      };
  }, [r, ge, d, v, S, y, m]), rr(() => {
    if (r || !I || typeof MutationObserver != "function" || Q)
      return;
    const Ne = () => {
      const Ee = I.getAttribute("tabindex");
      ne.current.includes("floating") || Dn(tr(I)) !== y.domReference.current && De().length === 0 ? Ee !== "0" && I.setAttribute("tabindex", "0") : Ee !== "-1" && I.setAttribute("tabindex", "-1");
    };
    Ne();
    const Re = new MutationObserver(Ne);
    return Re.observe(I, {
      childList: !0,
      subtree: !0,
      attributes: !0
    }), () => {
      Re.disconnect();
    };
  }, [r, I, y, ne, De, Q]);
  function ue(Ne) {
    return r || !p || !d ? null : /* @__PURE__ */ se.createElement(Hb, {
      ref: Ne === "start" ? $e : Le,
      onClick: (Re) => S(!1, Re.nativeEvent)
    }, typeof p == "string" ? p : "Dismiss");
  }
  const Ve = !r && ie && (fe || d);
  return /* @__PURE__ */ se.createElement(se.Fragment, null, Ve && /* @__PURE__ */ se.createElement(na, {
    "data-type": "inside",
    ref: ge == null ? void 0 : ge.beforeInsideRef,
    onFocus: (Ne) => {
      if (d) {
        const Ee = _e();
        ti(i[0] === "reference" ? Ee[0] : Ee[Ee.length - 1]);
      } else if (ge != null && ge.preserveTabOrder && ge.portalNode)
        if (ze.current = !1, Is(Ne, ge.portalNode)) {
          const Ee = lh() || N;
          Ee == null || Ee.focus();
        } else {
          var Re;
          (Re = ge.beforeOutsideRef.current) == null || Re.focus();
        }
    }
  }), !te && ue("start"), t, ue("end"), Ve && /* @__PURE__ */ se.createElement(na, {
    "data-type": "inside",
    ref: ge == null ? void 0 : ge.afterInsideRef,
    onFocus: (Ne) => {
      if (d)
        ti(_e()[0]);
      else if (ge != null && ge.preserveTabOrder && ge.portalNode)
        if (m && (ze.current = !0), Is(Ne, ge.portalNode)) {
          const Ee = ch() || N;
          Ee == null || Ee.focus();
        } else {
          var Re;
          (Re = ge.afterOutsideRef.current) == null || Re.focus();
        }
    }
  }));
}
const gl = /* @__PURE__ */ new Set(), Bb = /* @__PURE__ */ se.forwardRef(function(n, t) {
  let {
    lockScroll: r = !1,
    ...i
  } = n;
  const o = Ks();
  return rr(() => {
    if (!r)
      return;
    gl.add(o);
    const a = /iP(hone|ad|od)|iOS/.test(Hc()), c = document.body.style, p = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", m = window.innerWidth - document.documentElement.clientWidth, v = c.left ? parseFloat(c.left) : window.pageXOffset, y = c.top ? parseFloat(c.top) : window.pageYOffset;
    if (c.overflow = "hidden", m && (c[p] = m + "px"), a) {
      var _, S;
      const E = ((_ = window.visualViewport) == null ? void 0 : _.offsetLeft) || 0, Y = ((S = window.visualViewport) == null ? void 0 : S.offsetTop) || 0;
      Object.assign(c, {
        position: "fixed",
        top: -(y - Math.floor(Y)) + "px",
        left: -(v - Math.floor(E)) + "px",
        right: "0"
      });
    }
    return () => {
      gl.delete(o), gl.size === 0 && (Object.assign(c, {
        overflow: "",
        [p]: ""
      }), a && (Object.assign(c, {
        position: "",
        top: "",
        left: "",
        right: ""
      }), window.scrollTo(v, y)));
    };
  }, [o, r]), /* @__PURE__ */ se.createElement("div", qi({
    ref: t
  }, i, {
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...i.style
    }
  }));
});
function jd(e) {
  return Gt(e.target) && e.target.tagName === "BUTTON";
}
function Gd(e) {
  return Bc(e);
}
function ph(e, n) {
  n === void 0 && (n = {});
  const {
    open: t,
    onOpenChange: r,
    dataRef: i,
    elements: {
      domReference: o
    }
  } = e, {
    enabled: a = !0,
    event: c = "click",
    toggle: d = !0,
    ignoreMouse: p = !1,
    keyboardHandlers: m = !0
  } = n, v = se.useRef(), y = se.useRef(!1);
  return se.useMemo(() => a ? {
    reference: {
      onPointerDown(_) {
        v.current = _.pointerType;
      },
      onMouseDown(_) {
        _.button === 0 && (Qo(v.current, !0) && p || c !== "click" && (t && d && (!i.current.openEvent || i.current.openEvent.type === "mousedown") ? r(!1, _.nativeEvent, "click") : (_.preventDefault(), r(!0, _.nativeEvent, "click"))));
      },
      onClick(_) {
        if (c === "mousedown" && v.current) {
          v.current = void 0;
          return;
        }
        Qo(v.current, !0) && p || (t && d && (!i.current.openEvent || i.current.openEvent.type === "click") ? r(!1, _.nativeEvent, "click") : r(!0, _.nativeEvent, "click"));
      },
      onKeyDown(_) {
        v.current = void 0, !(_.defaultPrevented || !m || jd(_)) && (_.key === " " && !Gd(o) && (_.preventDefault(), y.current = !0), _.key === "Enter" && r(!(t && d), _.nativeEvent, "click"));
      },
      onKeyUp(_) {
        _.defaultPrevented || !m || jd(_) || Gd(o) || _.key === " " && y.current && (y.current = !1, r(!(t && d), _.nativeEvent, "click"));
      }
    }
  } : {}, [a, i, c, p, m, o, d, t, r]);
}
const Wb = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, jb = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, qd = (e) => {
  var n, t;
  return {
    escapeKey: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.escapeKey) != null ? n : !1,
    outsidePress: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.outsidePress) != null ? t : !0
  };
};
function Jc(e, n) {
  n === void 0 && (n = {});
  const {
    open: t,
    onOpenChange: r,
    nodeId: i,
    elements: {
      reference: o,
      domReference: a,
      floating: c
    },
    dataRef: d
  } = e, {
    enabled: p = !0,
    escapeKey: m = !0,
    outsidePress: v = !0,
    outsidePressEvent: y = "pointerdown",
    referencePress: _ = !1,
    referencePressEvent: S = "pointerdown",
    ancestorScroll: E = !1,
    bubbles: Y,
    capture: N
  } = n, I = Ra(), Q = Oi(typeof v == "function" ? v : () => !1), te = typeof v == "function" ? Q : v, ie = se.useRef(!1), ne = se.useRef(!1), {
    escapeKey: re,
    outsidePress: ce
  } = qd(Y), {
    escapeKey: de,
    outsidePress: ge
  } = qd(N), $e = Oi((fe) => {
    if (!t || !p || !m || fe.key !== "Escape")
      return;
    const De = I ? Ts(I.nodesRef.current, i) : [];
    if (!re && (fe.stopPropagation(), De.length > 0)) {
      let _e = !0;
      if (De.forEach((ue) => {
        var Ve;
        if ((Ve = ue.context) != null && Ve.open && !ue.context.dataRef.current.__escapeKeyBubbles) {
          _e = !1;
          return;
        }
      }), !_e)
        return;
    }
    r(!1, Dy(fe) ? fe.nativeEvent : fe, "escape-key");
  }), Le = Oi((fe) => {
    var De;
    const _e = () => {
      var ue;
      $e(fe), (ue = si(fe)) == null || ue.removeEventListener("keydown", _e);
    };
    (De = si(fe)) == null || De.addEventListener("keydown", _e);
  }), ze = Oi((fe) => {
    const De = ie.current;
    ie.current = !1;
    const _e = ne.current;
    if (ne.current = !1, y === "click" && _e || De || typeof te == "function" && !te(fe))
      return;
    const ue = si(fe), Ve = "[" + yi("inert") + "]", Ne = tr(c).querySelectorAll(Ve);
    let Re = at(ue) ? ue : null;
    for (; Re && !ji(Re); ) {
      const je = mi(Re);
      if (ji(je) || !at(je))
        break;
      Re = je;
    }
    if (Ne.length && at(ue) && !Ey(ue) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !Bt(ue, c) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(Ne).every((je) => !Bt(Re, je)))
      return;
    if (Gt(ue) && c) {
      const je = ue.clientWidth > 0 && ue.scrollWidth > ue.clientWidth, Ke = ue.clientHeight > 0 && ue.scrollHeight > ue.clientHeight;
      let nt = Ke && fe.offsetX > ue.clientWidth;
      if (Ke && cr(ue).direction === "rtl" && (nt = fe.offsetX <= ue.offsetWidth - ue.clientWidth), nt || je && fe.offsetY > ue.clientHeight)
        return;
    }
    const Ee = I && Ts(I.nodesRef.current, i).some((je) => {
      var Ke;
      return cl(fe, (Ke = je.context) == null ? void 0 : Ke.elements.floating);
    });
    if (cl(fe, c) || cl(fe, a) || Ee)
      return;
    const Be = I ? Ts(I.nodesRef.current, i) : [];
    if (Be.length > 0) {
      let je = !0;
      if (Be.forEach((Ke) => {
        var nt;
        if ((nt = Ke.context) != null && nt.open && !Ke.context.dataRef.current.__outsidePressBubbles) {
          je = !1;
          return;
        }
      }), !je)
        return;
    }
    r(!1, fe, "outside-press");
  }), ke = Oi((fe) => {
    var De;
    const _e = () => {
      var ue;
      ze(fe), (ue = si(fe)) == null || ue.removeEventListener(y, _e);
    };
    (De = si(fe)) == null || De.addEventListener(y, _e);
  });
  return se.useEffect(() => {
    if (!t || !p)
      return;
    d.current.__escapeKeyBubbles = re, d.current.__outsidePressBubbles = ce;
    function fe(ue) {
      r(!1, ue, "ancestor-scroll");
    }
    const De = tr(c);
    m && De.addEventListener("keydown", de ? Le : $e, de), te && De.addEventListener(y, ge ? ke : ze, ge);
    let _e = [];
    return E && (at(a) && (_e = In(a)), at(c) && (_e = _e.concat(In(c))), !at(o) && o && o.contextElement && (_e = _e.concat(In(o.contextElement)))), _e = _e.filter((ue) => {
      var Ve;
      return ue !== ((Ve = De.defaultView) == null ? void 0 : Ve.visualViewport);
    }), _e.forEach((ue) => {
      ue.addEventListener("scroll", fe, {
        passive: !0
      });
    }), () => {
      m && De.removeEventListener("keydown", de ? Le : $e, de), te && De.removeEventListener(y, ge ? ke : ze, ge), _e.forEach((ue) => {
        ue.removeEventListener("scroll", fe);
      });
    };
  }, [d, c, a, o, m, te, y, t, r, E, p, re, ce, $e, de, Le, ze, ge, ke]), se.useEffect(() => {
    ie.current = !1;
  }, [te, y]), se.useMemo(() => p ? {
    reference: {
      onKeyDown: $e,
      [Wb[S]]: (fe) => {
        _ && r(!1, fe.nativeEvent, "reference-press");
      }
    },
    floating: {
      onKeyDown: $e,
      onMouseDown() {
        ne.current = !0;
      },
      onMouseUp() {
        ne.current = !0;
      },
      [jb[y]]: () => {
        ie.current = !0;
      }
    }
  } : {}, [p, _, y, S, r, $e]);
}
let rc;
process.env.NODE_ENV !== "production" && (rc = /* @__PURE__ */ new Set());
function Us(e) {
  var n;
  e === void 0 && (e = {});
  const {
    open: t = !1,
    onOpenChange: r,
    nodeId: i
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var o;
    const ce = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((o = e.elements) != null && o.reference && !at(e.elements.reference)) {
      var a;
      if (!((a = rc) != null && a.has(ce))) {
        var c;
        (c = rc) == null || c.add(ce), console.error(ce);
      }
    }
  }
  const [d, p] = se.useState(null), m = ((n = e.elements) == null ? void 0 : n.reference) || d, v = ob(e), y = Ra(), _ = Qc() != null, S = Oi((ce, de, ge) => {
    ce && (Y.current.openEvent = de), N.emit("openchange", {
      open: ce,
      event: de,
      reason: ge,
      nested: _
    }), r == null || r(ce, de, ge);
  }), E = se.useRef(null), Y = se.useRef({}), N = se.useState(() => $b())[0], I = Ks(), Q = se.useCallback((ce) => {
    const de = at(ce) ? {
      getBoundingClientRect: () => ce.getBoundingClientRect(),
      contextElement: ce
    } : ce;
    v.refs.setReference(de);
  }, [v.refs]), te = se.useCallback((ce) => {
    (at(ce) || ce === null) && (E.current = ce, p(ce)), (at(v.refs.reference.current) || v.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    ce !== null && !at(ce)) && v.refs.setReference(ce);
  }, [v.refs]), ie = se.useMemo(() => ({
    ...v.refs,
    setReference: te,
    setPositionReference: Q,
    domReference: E
  }), [v.refs, te, Q]), ne = se.useMemo(() => ({
    ...v.elements,
    domReference: m
  }), [v.elements, m]), re = se.useMemo(() => ({
    ...v,
    refs: ie,
    elements: ne,
    dataRef: Y,
    nodeId: i,
    floatingId: I,
    events: N,
    open: t,
    onOpenChange: S
  }), [v, i, I, N, t, S, ie, ne]);
  return rr(() => {
    const ce = y == null ? void 0 : y.nodesRef.current.find((de) => de.id === i);
    ce && (ce.context = re);
  }), se.useMemo(() => ({
    ...v,
    context: re,
    refs: ie,
    elements: ne
  }), [v, ie, ne, re]);
}
function Gb(e, n) {
  n === void 0 && (n = {});
  const {
    open: t,
    onOpenChange: r,
    events: i,
    refs: o,
    elements: {
      domReference: a
    }
  } = e, {
    enabled: c = !0,
    visibleOnly: d = !0
  } = n, p = se.useRef(!1), m = se.useRef(), v = se.useRef(!0);
  return se.useEffect(() => {
    if (!c)
      return;
    const y = nr(a);
    function _() {
      !t && Gt(a) && a === Dn(tr(a)) && (p.current = !0);
    }
    function S() {
      v.current = !0;
    }
    return y.addEventListener("blur", _), y.addEventListener("keydown", S, !0), () => {
      y.removeEventListener("blur", _), y.removeEventListener("keydown", S, !0);
    };
  }, [a, t, c]), se.useEffect(() => {
    if (!c)
      return;
    function y(_) {
      let {
        reason: S
      } = _;
      (S === "reference-press" || S === "escape-key") && (p.current = !0);
    }
    return i.on("openchange", y), () => {
      i.off("openchange", y);
    };
  }, [i, c]), se.useEffect(() => () => {
    clearTimeout(m.current);
  }, []), se.useMemo(() => c ? {
    reference: {
      onPointerDown(y) {
        Hp(y.nativeEvent) || (v.current = !1);
      },
      onMouseLeave() {
        p.current = !1;
      },
      onFocus(y) {
        if (p.current)
          return;
        const _ = si(y.nativeEvent);
        if (d && at(_))
          try {
            if (Bp() && ky())
              throw Error();
            if (!_.matches(":focus-visible"))
              return;
          } catch {
            if (!v.current && !Bc(_))
              return;
          }
        r(!0, y.nativeEvent, "focus");
      },
      onBlur(y) {
        p.current = !1;
        const _ = y.relatedTarget, S = at(_) && _.hasAttribute(yi("focus-guard")) && _.getAttribute("data-type") === "outside";
        m.current = window.setTimeout(() => {
          const E = Dn(a ? a.ownerDocument : document);
          !_ && E === a || Bt(o.floating.current, E) || Bt(a, E) || S || r(!1, y.nativeEvent, "focus");
        });
      }
    }
  } : {}, [c, d, a, o, r]);
}
const Kd = "active", Ud = "selected";
function ml(e, n, t) {
  const r = /* @__PURE__ */ new Map(), i = t === "item";
  let o = e;
  if (i && e) {
    const {
      [Kd]: a,
      [Ud]: c,
      ...d
    } = e;
    o = d;
  }
  return {
    ...t === "floating" && {
      tabIndex: -1
    },
    ...o,
    ...n.map((a) => {
      const c = a ? a[t] : null;
      return typeof c == "function" ? e ? c(e) : null : c;
    }).concat(e).reduce((a, c) => (c && Object.entries(c).forEach((d) => {
      let [p, m] = d;
      if (!(i && [Kd, Ud].includes(p)))
        if (p.indexOf("on") === 0) {
          if (r.has(p) || r.set(p, []), typeof m == "function") {
            var v;
            (v = r.get(p)) == null || v.push(m), a[p] = function() {
              for (var y, _ = arguments.length, S = new Array(_), E = 0; E < _; E++)
                S[E] = arguments[E];
              return (y = r.get(p)) == null ? void 0 : y.map((Y) => Y(...S)).find((Y) => Y !== void 0);
            };
          }
        } else
          a[p] = m;
    }), a), {})
  };
}
function eu(e) {
  e === void 0 && (e = []);
  const n = e, t = se.useCallback((o) => ml(o, e, "reference"), n), r = se.useCallback((o) => ml(o, e, "floating"), n), i = se.useCallback(
    (o) => ml(o, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    e.map((o) => o == null ? void 0 : o.item)
  );
  return se.useMemo(() => ({
    getReferenceProps: t,
    getFloatingProps: r,
    getItemProps: i
  }), [t, r, i]);
}
const qb = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function tu(e, n) {
  var t;
  n === void 0 && (n = {});
  const {
    open: r,
    floatingId: i
  } = e, {
    enabled: o = !0,
    role: a = "dialog"
  } = n, c = (t = qb.get(a)) != null ? t : a, d = Ks(), m = Qc() != null;
  return se.useMemo(() => {
    if (!o)
      return {};
    const v = {
      id: i,
      ...c && {
        role: c
      }
    };
    return c === "tooltip" || a === "label" ? {
      reference: {
        ["aria-" + (a === "label" ? "labelledby" : "describedby")]: r ? i : void 0
      },
      floating: v
    } : {
      reference: {
        "aria-expanded": r ? "true" : "false",
        "aria-haspopup": c === "alertdialog" ? "dialog" : c,
        "aria-controls": r ? i : void 0,
        ...c === "listbox" && {
          role: "combobox"
        },
        ...c === "menu" && {
          id: d
        },
        ...c === "menu" && m && {
          role: "menuitem"
        },
        ...a === "select" && {
          "aria-autocomplete": "none"
        },
        ...a === "combobox" && {
          "aria-autocomplete": "list"
        }
      },
      floating: {
        ...v,
        ...c === "menu" && {
          "aria-labelledby": d
        }
      },
      item(y) {
        let {
          active: _,
          selected: S
        } = y;
        const E = {
          role: "option",
          ..._ && {
            id: i + "-option"
          }
        };
        switch (a) {
          case "select":
            return {
              ...E,
              "aria-selected": _ && S
            };
          case "combobox":
            return {
              ...E,
              ..._ && {
                "aria-selected": !0
              }
            };
        }
        return {};
      }
    };
  }, [o, a, c, r, i, d, m]);
}
const Kb = Br`
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`, Ub = W.span`
  display: block;
`, Qb = W.span`
  ${dr}
  font-size: var(--cc_size_text_xs);
  font-weight: 600;
  box-sizing: border-box;
  display: block;
  max-width: 200px;
  text-align: center;
  padding: var(--cc_size_spacing_s);
  border-radius: var(--cc_size_border_radius_l);
  box-shadow: 0 0 var(--cc_size_depth_2_blur) var(--cc_color_depth_2);
  background-color: var(--cc_color_button_background_secondary);
  color: var(--cc_color_button_text_secondary);

  /* animation */
  opacity: 0;
  transform: ${(e) => Nc({ placement: e.$placement, offset: pt.size_spacing_s })};
  animation: ${Kb} ${mt.duration.medium} forwards
    ${mt.easeOut};
`, Xb = W.span`
  display: inline-flex;
`, Zb = W(sh)`
  fill: var(--cc_color_button_background_secondary);
`, hh = Wn(
  ({
    children: e,
    title: n,
    mountNodeId: t,
    placement: r = "top",
    delay: i = 0
  }, o) => {
    const [a, c] = lr(!1), d = We(null), { refs: p, floatingStyles: m, context: v } = Us({
      open: a,
      onOpenChange: c,
      placement: r,
      whileElementsMounted: Ta,
      middleware: [
        $a(pt.size_spacing_s),
        Ia({
          fallbackAxisSideDirection: "start"
        }),
        Kc(),
        Jp({
          element: d
        })
      ]
    }), y = Rb(v, {
      move: !1,
      delay: { open: i, close: 0 }
    }), _ = Gb(v), S = Jc(v), E = tu(v, { role: "tooltip" }), { getReferenceProps: Y, getFloatingProps: N } = eu([
      y,
      _,
      S,
      E
    ]);
    return /* @__PURE__ */ pe(Bn, { children: [
      /* @__PURE__ */ L(Xb, { ref: p.setReference, children: ap.only(e) ? Mc(e, {
        ...Y(),
        ref: (I) => {
          typeof o == "function" ? o(I) : o && (o.current = I), p.setReference(I);
        }
      }) : null }),
      /* @__PURE__ */ L(Aa, { id: t || void 0, children: a && /* @__PURE__ */ L(
        Ub,
        {
          ref: p.setFloating,
          style: m,
          ...N(),
          children: /* @__PURE__ */ pe(Qb, { $placement: v.placement, children: [
            n,
            /* @__PURE__ */ L(
              Zb,
              {
                tipRadius: 2,
                height: 6,
                width: 12,
                ref: d,
                context: v
              }
            )
          ] })
        }
      ) })
    ] });
  }
), Jb = W.span`
  /* if rendering as a button or link, do a style reset and add slab focus styles */
  ${(e) => e.$href || e.onClick ? le`
          all: initial;
          cursor: pointer;
          text-decoration: none;
          user-select: none;
          transition: transform ${mt.duration.medium};
          &:active {
            transform: scale(0.99);
          }
          &:focus-visible {
            ${ui}
            outline-color: var(--cc_color_border_input_active);
            outline-offset: var(--cc_size_spacing_xxs);
          }
        ` : null}
  ${dr};
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  width: ${(e) => e.$avatarSize}px;
  height: ${(e) => e.$avatarSize}px;
  background-color: var(--cc_color_background_3);
  border-radius: 100%;
  color: var(--cc_color_text_subtle);
  font-weight: 600;
  user-select: none;

  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
  ${(e) => e.$design === "group" ? le`
          box-shadow: 0 0 0
            calc(
              var(--cc_size_spacing_xxs) +
                ${e.$avatarSize >= pt.size_avatar_m ? "1" : "0"}px
            )
            var(--cc_color_background_1);
        ` : null}
`, e1 = W.img`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  object-fit: cover;
  object-position: center;
`, Qd = W.span`
  font-size: ${(e) => e.$initialsTextSize}px;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  text-align: center;
`, t1 = W.i`
  // make icon slightly larger than initials
  font-size: ${(e) => e.$initialsTextSize + 4}px;
`, r1 = W.span`
  position: absolute;
  display: block;
  pointer-events: none;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-width: var(--cc_size_border_width_m);
  border-style: solid;
  border-color: ${(e) => e.$borderColor};
  border-radius: 100%;
`, n1 = ({
  onClick: e,
  href: n
}) => e ? "button" : n ? "a" : "span", ru = Wn(
  ({
    borderColor: e,
    ccMargin: n,
    design: t = "normal",
    href: r,
    fullName: i,
    iconName: o,
    imageSrc: a,
    initials: c,
    onClick: d,
    size: p = "medium",
    testId: m,
    tooltip: v = { shouldShow: !1, placement: "top" },
    ...y
  }, _) => {
    var Q, te;
    const S = typeof p == "number" ? p : Uo[p], E = Math.round(
      S / (S <= pt.size_avatar_s ? 2 : 2.5)
    ), Y = ((te = (Q = i.match(/(\b\S)?/g)) == null ? void 0 : Q.join("").match(/(^\S|\S$)?/g)) == null ? void 0 : te.join("")) ?? "", N = () => a ? /* @__PURE__ */ L(
      e1,
      {
        ref: _,
        src: a,
        alt: i
      }
    ) : o ? /* @__PURE__ */ L(Qd, { ref: _, $initialsTextSize: E, children: /* @__PURE__ */ L(
      t1,
      {
        $initialsTextSize: E,
        className: `mdi mdi-${o}`,
        "aria-hidden": "true"
      }
    ) }) : /* @__PURE__ */ L(
      Qd,
      {
        ref: _,
        $initialsTextSize: E,
        "aria-hidden": "true",
        children: c || Y
      }
    ), I = /* @__PURE__ */ pe(
      Jb,
      {
        as: n1({ onClick: d, href: r }),
        ref: _,
        $avatarSize: S,
        "data-testid": m,
        $ccMargin: n,
        $design: t,
        href: r,
        $href: r,
        onClick: d,
        ...y,
        children: [
          a ? null : /* @__PURE__ */ L(ln, { children: i }),
          N(),
          e ? /* @__PURE__ */ L(r1, { $borderColor: e }) : null
        ]
      }
    );
    return v.shouldShow ? /* @__PURE__ */ L(hh, { placement: v.placement, title: i, children: I }) : I;
  }
);
function i1(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var nu = i1, s1 = typeof Ss == "object" && Ss && Ss.Object === Object && Ss, o1 = s1, a1 = o1, l1 = typeof self == "object" && self && self.Object === Object && self, c1 = a1 || l1 || Function("return this")(), gh = c1, u1 = gh, d1 = function() {
  return u1.Date.now();
}, f1 = d1, p1 = /\s/;
function h1(e) {
  for (var n = e.length; n-- && p1.test(e.charAt(n)); )
    ;
  return n;
}
var g1 = h1, m1 = g1, v1 = /^\s+/;
function _1(e) {
  return e && e.slice(0, m1(e) + 1).replace(v1, "");
}
var y1 = _1, b1 = gh, w1 = b1.Symbol, mh = w1, Xd = mh, vh = Object.prototype, x1 = vh.hasOwnProperty, S1 = vh.toString, ms = Xd ? Xd.toStringTag : void 0;
function k1(e) {
  var n = x1.call(e, ms), t = e[ms];
  try {
    e[ms] = void 0;
    var r = !0;
  } catch {
  }
  var i = S1.call(e);
  return r && (n ? e[ms] = t : delete e[ms]), i;
}
var C1 = k1, D1 = Object.prototype, E1 = D1.toString;
function P1(e) {
  return E1.call(e);
}
var M1 = P1, Zd = mh, $1 = C1, T1 = M1, I1 = "[object Null]", R1 = "[object Undefined]", Jd = Zd ? Zd.toStringTag : void 0;
function A1(e) {
  return e == null ? e === void 0 ? R1 : I1 : Jd && Jd in Object(e) ? $1(e) : T1(e);
}
var F1 = A1;
function O1(e) {
  return e != null && typeof e == "object";
}
var L1 = O1, N1 = F1, z1 = L1, V1 = "[object Symbol]";
function Y1(e) {
  return typeof e == "symbol" || z1(e) && N1(e) == V1;
}
var H1 = Y1, B1 = y1, ef = nu, W1 = H1, tf = NaN, j1 = /^[-+]0x[0-9a-f]+$/i, G1 = /^0b[01]+$/i, q1 = /^0o[0-7]+$/i, K1 = parseInt;
function U1(e) {
  if (typeof e == "number")
    return e;
  if (W1(e))
    return tf;
  if (ef(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ef(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = B1(e);
  var t = G1.test(e);
  return t || q1.test(e) ? K1(e.slice(2), t ? 2 : 8) : j1.test(e) ? tf : +e;
}
var Q1 = U1, X1 = nu, vl = f1, rf = Q1, Z1 = "Expected a function", J1 = Math.max, ew = Math.min;
function tw(e, n, t) {
  var r, i, o, a, c, d, p = 0, m = !1, v = !1, y = !0;
  if (typeof e != "function")
    throw new TypeError(Z1);
  n = rf(n) || 0, X1(t) && (m = !!t.leading, v = "maxWait" in t, o = v ? J1(rf(t.maxWait) || 0, n) : o, y = "trailing" in t ? !!t.trailing : y);
  function _(ne) {
    var re = r, ce = i;
    return r = i = void 0, p = ne, a = e.apply(ce, re), a;
  }
  function S(ne) {
    return p = ne, c = setTimeout(N, n), m ? _(ne) : a;
  }
  function E(ne) {
    var re = ne - d, ce = ne - p, de = n - re;
    return v ? ew(de, o - ce) : de;
  }
  function Y(ne) {
    var re = ne - d, ce = ne - p;
    return d === void 0 || re >= n || re < 0 || v && ce >= o;
  }
  function N() {
    var ne = vl();
    if (Y(ne))
      return I(ne);
    c = setTimeout(N, E(ne));
  }
  function I(ne) {
    return c = void 0, y && r ? _(ne) : (r = i = void 0, a);
  }
  function Q() {
    c !== void 0 && clearTimeout(c), p = 0, r = d = i = c = void 0;
  }
  function te() {
    return c === void 0 ? a : I(vl());
  }
  function ie() {
    var ne = vl(), re = Y(ne);
    if (r = arguments, i = this, d = ne, re) {
      if (c === void 0)
        return S(d);
      if (v)
        return clearTimeout(c), c = setTimeout(N, n), _(d);
    }
    return c === void 0 && (c = setTimeout(N, n)), a;
  }
  return ie.cancel = Q, ie.flush = te, ie;
}
var rw = tw, nw = rw, iw = nu, sw = "Expected a function";
function ow(e, n, t) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(sw);
  return iw(t) && (r = "leading" in t ? !!t.leading : r, i = "trailing" in t ? !!t.trailing : i), nw(e, n, {
    leading: r,
    maxWait: n,
    trailing: i
  });
}
var aw = ow;
const lw = /* @__PURE__ */ up(aw), cw = W.ul`
  all: initial;
  display: flex;
  align-items: center;
  list-style-type: none;
  min-width: 1px;
`, uw = W.li`
  all: initial;
  position: relative;
  flex-shrink: 0;
  min-width: 1px;
  width: ${(e) => e.$avatarSize}px;
  height: ${(e) => e.$avatarSize}px;
`, dw = W.li`
  all: initial;
  flex-shrink: 0;
`;
function eI({
  avatars: e,
  renderListFooter: n,
  size: t = "medium",
  ...r
}) {
  const i = We(null), o = We(null), [a, c] = lr(e.length), d = typeof t == "number" ? t : Uo[t], p = d / 4;
  return ct(() => {
    const m = () => {
      var I;
      if (!i.current)
        return;
      const y = o.current ? (I = o.current) == null ? void 0 : I.getBoundingClientRect().width : 0, _ = i.current.getBoundingClientRect().width - Math.ceil(y), S = typeof t == "number" ? t : Uo[t], E = S / 4, Y = S - E, N = Math.floor(
        _ / (Y + E / e.length)
      );
      c(e.length - N);
    };
    m();
    const v = lw(m);
    return window.addEventListener("resize", v), () => {
      window.removeEventListener("resize", v);
    };
  }, [e, n, t, a]), /* @__PURE__ */ pe(cw, { ref: i, ...r, children: [
    e.slice(0, e.length - a).map((m, v) => /* @__PURE__ */ L(
      uw,
      {
        $avatarSize: d,
        style: {
          marginInlineStart: v > 0 ? `-${p}px` : "0"
        },
        children: /* @__PURE__ */ L(
          ru,
          {
            size: t,
            tooltip: { shouldShow: !0, placement: "top" },
            design: "group",
            ...m
          },
          v
        )
      },
      v
    )),
    n ? /* @__PURE__ */ L(dw, { ref: o, children: n(
      a > 0 ? e.slice(e.length - a, e.length) : []
    ) }) : null
  ] });
}
const xr = {
  add_on: "add_on",
  assigned: "assigned",
  caution: "caution",
  destroy: "destroy",
  info: "info",
  success: "success",
  upgrade: "upgrade"
}, Ls = {
  small: "small",
  medium: "medium"
}, fw = (e) => {
  switch (e) {
    case xr.info:
      return "var(--cc_color_background_2)";
    case xr.upgrade:
      return "var(--cc_color_brand_upgrade_alpha_20)";
    case xr.assigned:
      return "var(--cc_color_utility_assigned_alpha_20)";
    case xr.add_on:
      return "var(--cc_color_brand_add_on_alpha_20)";
    default:
      return `var(--cc_color_utility_${e}_alpha_20)`;
  }
}, pw = (e) => {
  switch (e) {
    case xr.info:
      return "var(--cc_color_border_default)";
    case xr.upgrade:
      return "var(--cc_color_brand_upgrade_alpha_60)";
    case xr.assigned:
      return "var(--cc_color_utility_assigned_alpha_60)";
    case xr.add_on:
      return "var(--cc_color_brand_add_on_alpha_60)";
    default:
      return `var(--cc_color_utility_${e}_alpha_60)`;
  }
}, hw = W.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--cc_size_spacing_xs);
  background-color: ${(e) => fw(e.color || xr.info)};
  border-radius: var(--cc_size_border_radius_pill);
  border: var(--cc_size_border_width_s) solid
    ${(e) => pw(e.color || xr.info)};
  padding: ${(e) => e.size === Ls.small ? "6px" : "var(--cc_size_spacing_s)"};
  height: ${(e) => e.size === Ls.small ? "var(--cc_size_avatar_xs)" : "var(--cc_size_avatar_s)"};
  line-height: 1.5;
`, gw = W.i`
  color: var(--cc_color_text_default);
  font-size: ${(e) => e.size === Ls.small ? "11px" : "14px"};
  line-height: 0;
`, mw = W.span`
  ${dr}
  color: var(--cc_color_text_default);
  font-weight: 600;
  font-size: ${(e) => e.size === Ls.small ? "9px" : "10px"};
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0.25px;

  &:empty {
    display: none;
  }
`;
function tI({
  children: e,
  color: n = xr.info,
  iconName: t,
  size: r = Ls.medium,
  testId: i,
  ...o
}) {
  return /* @__PURE__ */ pe(hw, { size: r, color: n, "data-testid": i, ...o, children: [
    t ? /* @__PURE__ */ L(
      gw,
      {
        size: r,
        "data-testid": `${t}-icon`,
        className: `mdi mdi-${t}`
      }
    ) : null,
    /* @__PURE__ */ L(mw, { size: r, children: e })
  ] });
}
const vw = ({
  component: e,
  isLoading: n = !1,
  size: t = "medium"
}) => {
  const r = `calc(${Pa[t || "medium"]} + 4px)`;
  return ba(e) && e.type === "svg" ? Mc(e, {
    style: {
      width: r,
      height: r,
      fill: "currentColor",
      flexShrink: 0,
      visibility: n ? "hidden" : "visible",
      display: "block"
    }
  }) : e;
}, _w = W.i`
  color: currentColor;
  flex-shrink: 0;
  font-size: ${(e) => `calc(${Pa[e.$size || "medium"]} + 4px)`};
  top: 0;
  line-height: 1;

  ${(e) => e.$isLoading ? le`
          visibility: hidden;
        ` : null}
`, yw = ({
  iconName: e,
  isLoading: n = !1,
  size: t = "medium"
}) => /* @__PURE__ */ L(
  _w,
  {
    className: `mdi mdi-${e}`,
    role: "presentation",
    $isLoading: n,
    $size: t,
    "data-testid": `${e}-icon`
  }
), ia = ({
  icon: e,
  isLoading: n,
  size: t
}) => e != null && e.component ? /* @__PURE__ */ L(
  vw,
  {
    size: t,
    isLoading: n,
    component: e.component
  }
) : e != null && e.name ? /* @__PURE__ */ L(yw, { size: t, isLoading: n, iconName: e.name }) : null, bw = W.span`
  position: relative;
  ${dr}
  color: currentColor;
  font-size: ${(e) => Pa[e.$size || "medium"]};
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(e) => e.$isLoading ? le`
          visibility: hidden;
        ` : null}
`, _h = ({
  children: e,
  isLoading: n = !1,
  size: t = "medium"
}) => /* @__PURE__ */ L(bw, { $isLoading: n, $size: t, children: e }), ww = Br`
  to {
    stroke-dashoffset: 200;
  }
`, xw = Br`
  to {
    transform: rotate(1turn);
  }
`, Sw = W.span`
  display: ${(e) => e.$isCentered ? "flex" : "inline-flex"};
  flex-direction: ${(e) => e.$layout === "vertical" ? "column" : "row"};
  ${(e) => e.$isCentered ? le`
          justify-content: center;
        ` : null}
  align-items: center;
  justify-content: center;
  gap: calc(var(--cc_size_spacing_s) * 1.25);

  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
`, kw = W.span`
  ${Lt}
  font-size: ${(e) => e.$size >= pt.size_avatar_l ? "var(--cc_size_text_s)" : "var(--cc_size_text_xs)"};
  color: var(--cc_color_text_nonessential);
`, Cw = W.span`
  display: block;
  position: relative;
  width: ${(e) => e.$size}px;
  height: ${(e) => e.$size}px;
`, Dw = W.svg`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  transform: rotate(0turn);
  animation-name: ${xw};
  animation-duration: 0.75s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
`, Ew = W.circle`
  stroke: ${(e) => e.$trackColor};
  fill: transparent;
  stroke-width: 28;
`, Pw = W.circle`
  stroke: ${(e) => e.$meterColor};
  stroke-width: 28;
  fill: transparent;
  stroke-dasharray: 540;
  stroke-dashoffset: 506;
  stroke-linecap: round;
  animation-name: ${ww};
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: linear;
`, iu = ({
  accessibilityLabel: e,
  ccMargin: n,
  "data-testid": t,
  isCentered: r = !1,
  label: i,
  layout: o = "horizontal",
  meterColor: a = "var(--cc_color_border_input_inactive)",
  size: c = "medium",
  trackColor: d = "var(--cc_color_background_3)",
  testId: p,
  ...m
}) => {
  const v = typeof c == "number" ? c : Uo[c];
  return /* @__PURE__ */ pe(Sw, { $layout: o, $ccMargin: n, $isCentered: r, children: [
    /* @__PURE__ */ L(
      Cw,
      {
        $size: v,
        "data-testid": t || p,
        role: "status",
        "aria-live": "polite",
        "aria-relevant": "additions removals",
        ...m,
        children: /* @__PURE__ */ pe(
          Dw,
          {
            viewBox: "0 0 200 200",
            focusable: "false",
            "data-svg-type": "spinner",
            children: [
              /* @__PURE__ */ L("title", { children: e }),
              /* @__PURE__ */ pe("g", { role: "presentation", children: [
                /* @__PURE__ */ L(Ew, { r: "86", cy: "100", cx: "100", $trackColor: d }),
                /* @__PURE__ */ L(Pw, { r: "86", cy: "100", cx: "100", $meterColor: a })
              ] })
            ]
          }
        )
      }
    ),
    i ? /* @__PURE__ */ L(kw, { $layout: o, $size: v, children: i }) : null
  ] });
}, Mw = W(iu)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
`, yh = ({
  size: e = "medium"
}) => /* @__PURE__ */ L(
  Mw,
  {
    accessibilityLabel: "Loading",
    size: e === "large" ? 20 : "xsmall",
    trackColor: "rgba(0, 0, 0, 0.2)",
    meterColor: "currentColor"
  }
), _l = {
  solid: "solid",
  outline: "outline",
  minimal: "minimal"
}, $w = (e) => `
    color: var(--cc_color_button_text_${e});
    background: var(--cc_color_button_background_${e});
    &:hover {
      background: var(--cc_color_button_background_${e}_darken_10);
    }
  `, Tw = (e, n) => e === "destroy" || e === "success" ? `
      background: transparent;
      color: var(--cc_color_utility_${e});
      &:hover {
        color: var(--cc_color_utility_${e}_darken_10);
        background: var(--cc_color_button_background_${e}_alpha_10);
      }
      ${n ? `
              border-color: var(--cc_color_button_background_${e});
              &:hover {
                border-color: var(--cc_color_button_background_${e}_darken_10);
              }
            ` : null}
    ` : `
      background: transparent;
      color: var(--cc_color_link_${e});
      &:hover {
        background: var(--cc_color_button_background_${e}_alpha_${e === "subtle" ? "70" : "10"});
        color: var(--cc_color_link_${e}_darken_15);
      }
      ${n ? `
              border-color: var(--cc_color_link_${e});
              &:hover {
                border-color: var(--cc_color_link_${e}_darken_10);
              }
            ` : null}
  `, Iw = W.button`
  ${(e) => Gn({ disabled: e.disabled })}
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${(e) => Op[e.$size]};
  border: var(--cc_size_border_width_m) solid transparent;
  border-radius: var(--cc_size_border_radius_l);
  transition: transform 0.25s, color 0.25s, background 0.25s;
  ${(e) => e.$design === _l.outline || e.$design === _l.minimal ? Tw(
  e.$color,
  e.$design === _l.outline
) : $w(e.$color)};
  height: ${(e) => Ea[e.$size]};
  padding: ${(e) => Lp[e.$size]};
  font-family: 'Averta', system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  font-size: ${(e) => Pa[e.$size]};
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}

  &:active {
    transform: scale(0.98);
  }
`, Ns = Wn(
  ({
    ccMargin: e,
    children: n,
    color: t = "subtle",
    design: r = "solid",
    href: i,
    icon: o = { position: "before", name: void 0, component: void 0 },
    loading: a = !1,
    size: c = "medium",
    type: d = "button",
    ...p
  }, m) => /* @__PURE__ */ pe(
    Iw,
    {
      ref: m,
      as: i ? "a" : "button",
      $color: t,
      href: i,
      disabled: p.disabled,
      $design: r,
      $size: c,
      type: i ? void 0 : d,
      $ccMargin: e,
      className: p.className,
      style: p.style,
      ...p,
      children: [
        (o == null ? void 0 : o.position) === "before" ? /* @__PURE__ */ L(ia, { icon: o, isLoading: a, size: c }) : null,
        /* @__PURE__ */ L(_h, { size: c, isLoading: a, children: n }),
        (o == null ? void 0 : o.position) === "after" ? /* @__PURE__ */ L(ia, { icon: o, isLoading: a, size: c }) : null,
        a ? /* @__PURE__ */ L(yh, { size: c }) : null
      ]
    }
  )
), Rw = {
  success: "var(--cc_color_utility_success)",
  caution: "var(--cc_color_utility_caution)",
  destroy: "var(--cc_color_utility_destroy)",
  info: "var(--cc_color_utility_info)"
}, Aw = W.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
`, Fw = W.div`
  text-align: center;
`, Ow = W.div`
  height: 128px;
  width: 128px;
  margin-block-end: var(--cc_size_spacing_xs);
`, Lw = W.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`, Nw = W.i`
  display: block;
  color: ${(e) => Rw[e.$iconColor]};
  font-size: 48px;
  line-height: 1;
  margin-block-end: var(--cc_size_spacing_xs);
`, zw = W.div`
  display: flex;
  flex-direction: column;
  gap: var(--cc_size_spacing_s);
  margin-block-start: var(--cc_size_spacing_m);
`, Vw = ({
  image: e,
  ccMargin: n,
  color: t = "info",
  iconName: r,
  message: i = "",
  primaryAction: o,
  secondaryAction: a,
  title: c,
  ...d
}) => {
  var p, m, v, y;
  return /* @__PURE__ */ pe(Aw, { $ccMargin: n, ...d, children: [
    e != null && e.src ? /* @__PURE__ */ L(Ow, { style: e.imageContainerStyle, children: /* @__PURE__ */ L(Lw, { src: e.src, alt: e.alt }) }) : null,
    r ? /* @__PURE__ */ L(
      Nw,
      {
        className: `mdi mdi-${r}`,
        $iconColor: t,
        "aria-hidden": "true"
      }
    ) : null,
    /* @__PURE__ */ pe(Fw, { children: [
      c ? /* @__PURE__ */ L(
        Nt,
        {
          as: "h3",
          family: "heading",
          size: "xl",
          weight: "800",
          ccMargin: "none none xs",
          children: c
        }
      ) : null,
      i ? /* @__PURE__ */ L(Nt, { as: "p", color: "subtle", children: i }) : null
    ] }),
    o || a ? /* @__PURE__ */ pe(zw, { children: [
      o ? /* @__PURE__ */ L(
        Ns,
        {
          ...o,
          "data-testid": o["data-testid"],
          color: t === "destroy" ? "destroy" : "primary",
          icon: {
            name: (p = o.icon) == null ? void 0 : p.name,
            position: (m = o.icon) == null ? void 0 : m.position
          },
          children: o.label
        }
      ) : null,
      a ? /* @__PURE__ */ L(
        Ns,
        {
          ...a,
          "data-testid": a["data-testid"],
          color: "subtle",
          icon: {
            name: (v = a.icon) == null ? void 0 : v.name,
            position: (y = a.icon) == null ? void 0 : y.position
          },
          children: a.label
        }
      ) : null
    ] }) : null
  ] });
}, Yw = W(Ns)`
  padding: 0 0.25ch; /* If you change this value, update TableColumnSortButton to match */
  border: none;
  height: auto;
  line-height: inherit;
  vertical-align: baseline;
  border-radius: var(--cc_size_border_radius_m);
`, Hw = Wn(({ ...e }, n) => /* @__PURE__ */ L(Yw, { design: "minimal", ...e, ref: n })), Bw = (e) => {
  switch (e) {
    case "active":
      return le`
        background-color: var(--cc_color_button_background_secondary);
        color: var(--cc_color_button_text_secondary);
        border-color: var(--cc_color_button_background_secondary);
      `;
    case "open":
      return le`
        background-color: transparent;
        color: var(--cc_color_link_secondary);
        border-color: var(--cc_color_button_background_secondary);
        box-shadow: inset 0 0 0 var(--cc_size_border_width_s)
          var(--cc_color_button_background_secondary);
      `;
    default:
      return le`
        background-color: transparent;
        color: var(--cc_color_link_subtle);
        border-color: var(--cc_color_border_input_inactive);
        &:hover {
          border-color: var(--cc_color_button_background_secondary);
        }
      `;
  }
}, Ww = W.button`
  ${(e) => Gn({ disabled: e.disabled })}
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  height: ${Ea.medium};
  border-width: var(--cc_size_border_width_s);
  border-style: solid;
  border-radius: var(--cc_size_border_radius_l);
  padding: ${Lp.medium};
  line-height: 1.2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${Op.medium};
  transition: transform ${mt.duration.fast},
    color ${mt.duration.fast}, border-color ${mt.duration.fast},
    background ${mt.duration.fast};
  &:active {
    transform: scale(0.98);
  }
  ${(e) => Bw(e.$status || "normal")}
`, jw = W.span`
  box-sizing: border-box;
  ${dr}
  padding: 0 var(--cc_size_spacing_xxs);
  font-size: var(--cc_size_text_xs);
  font-weight: 700;
  background-color: var(--cc_color_button_text_secondary);
  color: var(--cc_color_button_background_secondary);
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  min-width: var(--cc_size_avatar_xs);
  height: var(--cc_size_avatar_xs);
  border-radius: var(--cc_size_border_radius_pill);
`, rI = Wn(
  ({ count: e, icon: n, status: t = "normal", loading: r, ...i }, o) => {
    const a = t === "active" && e && e >= 1;
    return /* @__PURE__ */ pe(
      Ww,
      {
        type: i.type || "button",
        $status: t,
        ref: o,
        ...i,
        children: [
          (n == null ? void 0 : n.position) === "before" ? /* @__PURE__ */ L(ia, { icon: n, size: "medium", isLoading: r }) : null,
          /* @__PURE__ */ L(_h, { isLoading: r, size: "medium", children: i.children }),
          (n == null ? void 0 : n.position) === "after" && !a ? /* @__PURE__ */ L(ia, { icon: n, size: "medium", isLoading: r }) : null,
          r ? /* @__PURE__ */ L(yh, { size: "medium" }) : null,
          a ? /* @__PURE__ */ L(jw, { children: e }) : null
        ]
      }
    );
  }
), Gw = W(Ns)`
  padding: 0;
  gap: 0;
  width: ${(e) => Ea[e.size]};
  ${(e) => e.$shape === "circle" ? le`
          border-radius: 100%;
        ` : null}
`, qw = W.span`
  ${fr}
`, bh = Wn(
  ({
    accessibilityLabel: e,
    iconComponent: n,
    iconName: t,
    shape: r = "circle",
    size: i = "medium",
    design: o = "solid",
    ...a
  }, c) => /* @__PURE__ */ L(
    Gw,
    {
      ref: c,
      icon: { component: n, name: t, position: "before" },
      design: o,
      size: i,
      $shape: r,
      ...a,
      children: /* @__PURE__ */ L(qw, { children: e })
    }
  )
), nc = {
  small: "small",
  medium: "medium",
  large: "large"
}, nf = (e) => {
  switch (e) {
    case "small":
      return "23px";
    case "medium":
      return "25px";
    case "large":
      return "27px";
  }
}, Kw = W(bh)`
  width: ${({ size: e }) => nf(e || nc.medium)};
  height: ${({ size: e }) => nf(e || nc.medium)};
  border: none;
`, sa = Wn(({ ...e }, n) => /* @__PURE__ */ L(
  Kw,
  {
    ref: n,
    $size: e.size || nc.medium,
    design: "minimal",
    ...e
  }
)), Uw = W.div`
  position: relative;
  height: 100%;
`, Qw = W.div`
  display: flex;
  align-items: flex-start;
  gap: var(--cc_size_spacing_m);
  background: var(--cc_color_background_1);
  margin: 0;
  border: var(--cc_size_border_width_s) solid var(--cc_color_border_default);
  border-radius: var(--cc_size_border_radius_l);
  padding: var(--cc_size_spacing_m) var(--cc_size_spacing_xl)
    var(--cc_size_spacing_m) var(--cc_size_spacing_m);
  ${(e) => e.onClick || e.href ? le`
          width: 100%;
          cursor: pointer;
          text-align: start;
          text-decoration: none;
          user-select: none;
          transition: all ${mt.duration.medium};
          &:hover {
            border-color: var(--cc_color_button_background_secondary);
          }
          &:active {
            transform: scale(0.99);
          }
          &:focus-visible {
            ${ui}
            outline-color: var(--cc_color_border_input_active);
            outline-offset: var(--cc_size_spacing_xxs);
          }
        ` : null}
`, Xw = W.span`
  position: absolute;
  inset-inline-end: var(--cc_size_spacing_xs);
  inset-block-start: var(--cc_size_spacing_xs);
`, Zw = W.div`
  flex-shrink: 0;
`, Jw = W.div`
  flex: 1;
`, ex = ({
  onClick: e,
  href: n
}) => e ? "button" : n ? "a" : "div", tx = (e) => typeof e == "string" ? /* @__PURE__ */ L(Nt, { as: "h2", size: "m", family: "heading", weight: 700, color: "default", children: e }) : e;
function nI({
  containerStyle: e,
  contentAction: n,
  contentAfter: t,
  contentBefore: r,
  contentThumbnail: i,
  children: o,
  onClick: a,
  href: c,
  title: d,
  ...p
}) {
  const { className: m, style: v, ...y } = p;
  return /* @__PURE__ */ pe(Uw, { className: m, style: v, children: [
    /* @__PURE__ */ pe(
      Qw,
      {
        as: ex({ onClick: a, href: c }),
        onClick: a,
        href: c,
        style: e,
        type: a ? "button" : void 0,
        ...y,
        children: [
          i ? /* @__PURE__ */ L(Zw, { children: i }) : null,
          /* @__PURE__ */ pe(Jw, { children: [
            r || null,
            d ? tx(d) : null,
            o || null,
            t || null
          ] })
        ]
      }
    ),
    n ? /* @__PURE__ */ L(Xw, { children: n }) : null
  ] });
}
const wh = (e) => le`
  display: inline-flex;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-radius: var(--cc_size_border_radius_pill);
  background-color: var(--cc_color_background_1);
  border-color: var(--cc_color_border_default);
  color: var(--cc_color_text_subtle);
  line-height: 1.5;

  ${e === "small" ? le`
        height: 22px;
        font-weight: 400;
        font-size: var(--cc_size_text_xs);
      ` : le`
        height: 28px;
        font-weight: 500;
        font-size: var(--cc_size_text_s);
      `}
`, rx = W.span`
  display: inline-flex;
  align-items: center;
  gap: ${(e) => e.$size === "small" ? "var(--cc_size_spacing_xs)" : "calc(var(--cc_size_spacing_s) * 0.75)"};
  min-width: 0;
  padding: 0
    ${(e) => e.$size === "small" ? "calc(var(--cc_size_spacing_xs) * 1.5)" : "calc(var(--cc_size_spacing_s) * 1.125)"};
  ${(e) => e.$contentAfter ? "padding-right: 0;" : null}
`, sf = W.span`
  flex-shrink: 0;
  display: grid;
  place-items: center;
`, nx = W.i`
  flex-shrink: 0;
  color: inherit;
  line-height: 1;
  font-size: ${(e) => e.$size === "small" ? "var(--cc_size_text_s)" : "var(--cc_size_text_m)"};
`, ix = W.span`
  ${Lt}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
`;
function xh({ ...e }) {
  return /* @__PURE__ */ pe(rx, { $size: e.size, $contentAfter: e.contentAfter, children: [
    e.contentBefore ? /* @__PURE__ */ L(sf, { children: e.contentBefore }) : null,
    e.iconName ? /* @__PURE__ */ L(
      nx,
      {
        $size: e.size,
        className: `mdi mdi-${e.iconName}`
      }
    ) : null,
    e.children ? /* @__PURE__ */ L(ix, { children: e.children }) : null,
    e.contentAfter ? /* @__PURE__ */ L(sf, { children: e.contentAfter }) : null
  ] });
}
const sx = W.span`
  ${(e) => wh(e.$size)}
`, zo = "calc(var(--cc_size_spacing_m) * 1.125)", ox = W.button`
  ${Gn}
  cursor: pointer;
  display: grid;
  place-items: center;
  border-radius: 100%;
  width: ${zo};
  height: ${zo};
  line-height: ${zo};
  margin-inline-end: ${(e) => e.$size === "small" ? "var(--cc_size_spacing_xxs)" : "var(--cc_size_spacing_xs)"};
  &:hover {
    background: var(--cc_color_button_background_subtle_alpha_70);
  }
  &:disabled {
    ${_r}
  }
`, ax = W.i`
  color: var(--cc_color_link_subtle);
  font-size: var(--cc_size_text_m);
  width: ${zo};
`;
function iI({ closeAction: e, ...n }) {
  const { children: t, iconName: r, contentBefore: i, size: o = "medium", ...a } = n;
  return /* @__PURE__ */ L(sx, { $size: o, ...a, children: /* @__PURE__ */ L(
    xh,
    {
      size: o,
      contentBefore: i,
      contentAfter: e ? /* @__PURE__ */ pe(
        ox,
        {
          type: "button",
          "data-testid": e["data-testid"],
          $size: o,
          onClick: e.onClick,
          children: [
            /* @__PURE__ */ L(ln, { children: e.accessibilityLabel }),
            /* @__PURE__ */ L(
              ax,
              {
                $size: o,
                className: "mdi mdi-close",
                "aria-hidden": "true"
              }
            )
          ]
        }
      ) : null,
      iconName: n.iconName,
      children: n.children
    }
  ) });
}
const lx = W.button`
  ${Gn} // add reset and focus styles
  ${(e) => wh(e.$size)} // add generic chip styles
  ${(e) => e.$pressed ? le`
          background: var(--cc_color_button_background_secondary);
          color: var(--cc_color_button_text_secondary);
        ` : null}
  ${(e) => e.disabled ? _r : null}
`;
function sI({ pressed: e = !1, ...n }) {
  const {
    children: t,
    disabled: r = !1,
    iconName: i,
    contentBefore: o,
    contentAfter: a,
    size: c = "medium",
    ...d
  } = n;
  return /* @__PURE__ */ L(
    lx,
    {
      $size: c,
      type: "button",
      $pressed: e,
      "aria-pressed": e,
      disabled: r,
      ...d,
      children: /* @__PURE__ */ L(
        xh,
        {
          size: c,
          contentBefore: n.contentBefore,
          contentAfter: n.contentAfter,
          iconName: n.iconName,
          children: n.children
        }
      )
    }
  );
}
const cx = W.div`
  display: flex;
  gap: var(--cc_size_spacing_s);
  align-items: flex-start;
  ${(e) => e.$design === "self" ? le`
          flex-direction: row-reverse;
        ` : null}

  /* if ccMargin is specified in props, convert spacing tokens to CSS variables */
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
`, ux = W.blockquote`
  all: initial;
  display: block;
  min-width: 0;
`, of = W(Nt)`
  ${(e) => e.$design === "self" ? le`
          text-align: end;
        ` : null}
`, dx = (e) => {
  switch (e) {
    case "self":
      return "var(--cc_color_button_background_primary)";
    case "other":
      return "var(--cc_color_button_background_subtle)";
    case "guest":
      return "var(--cc_color_utility_assigned_alpha_20)";
  }
}, fx = W.p`
  all: initial;
  display: inline-block;
  background-color: ${(e) => dx(e.$design)};
  border-radius: calc(var(--cc_size_border_radius_l) * 1.25);
  padding: var(--cc_size_spacing_s) calc(var(--cc_size_spacing_s) * 1.25);
  font-size: calc(var(--cc_size_text_xs) * 1.125);
  text-align: start;
  line-height: 1.3;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  color: ${(e) => e.$design === "self" ? "var(--cc_color_button_text_primary)" : "var(--cc_color_button_text_subtle)"};
  ${Lt}
  ${(e) => e.$design === "self" ? le`
          border-start-end-radius: 0;
        ` : le`
          border-start-start-radius: 0;
        `}
`;
function oI({
  ccMargin: e,
  design: n = "other",
  children: t,
  userNameText: r,
  timeStampText: i,
  avatar: o,
  ...a
}) {
  return /* @__PURE__ */ pe(cx, { $design: n, $ccMargin: e, ...a, children: [
    /* @__PURE__ */ L(ru, { ...o, size: "medium" }),
    /* @__PURE__ */ pe(ux, { children: [
      r ? /* @__PURE__ */ L(
        of,
        {
          forwardedAs: "cite",
          size: "xs",
          color: "subtle",
          weight: "500",
          ccMargin: "none none xxs",
          $design: n,
          children: r
        }
      ) : null,
      /* @__PURE__ */ L(fx, { $design: n, children: t }),
      i ? /* @__PURE__ */ L(
        of,
        {
          forwardedAs: "time",
          size: "xs",
          color: "nonessential",
          ccMargin: "xxs none none",
          $design: n,
          children: i
        }
      ) : null
    ] })
  ] });
}
const Sh = Br`
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`, px = W.div`
  position: absolute;
  inset: 0;
  background: var(--cc_color_background_backdrop);

  /* animation */
  opacity: 0;
  transform: translate3d(0, 0, 0);
  animation-name: ${Sh};
  animation-duration: ${mt.duration.fast};
  animation-fill-mode: forwards;
  @media (prefers-reduced-motion) {
    animation: none;
    opacity: 1;
    transform: none;
  }
`, hx = (e) => {
  const n = e ? `var(--cc_size_spacing_${e})` : "0";
  return {
    top: le`
      left: ${n};
      right: ${n};
      top: ${n};
      bottom: auto;
    `,
    right: le`
      inset-inline-start: auto;
      inset-inline-end: ${n};
      inset-block-start: ${n};
      inset-block-end: ${n};
    `,
    bottom: le`
      left: ${n};
      right: ${n};
      top: auto;
      bottom: ${n};
    `,
    left: le`
      inset-inline-start: ${n};
      inset-inline-end: auto;
      inset-block-start: ${n};
      inset-block-end: ${n};
    `
  };
}, gx = W.div`
  all: initial;
  box-sizing: border-box;
  position: fixed;
  display: block;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  max-height: 100%;

  ${(e) => hx(e.$offset)[e.$placement || "right"]};
`, wo = "50%", mx = {
  top: le`
    transform: translate3d(0, -${wo}, 0);
  `,
  right: le`
    transform: translate3d(${wo}, 0, 0);
  `,
  bottom: le`
    transform: translate3d(0, ${wo}, 0);
  `,
  left: le`
    transform: translate3d(-${wo}, 0, 0);
  `
}, vx = W.div`
  all: initial;
  box-sizing: border-box;
  display: block;
  background-color: var(--cc_color_background_1);
  padding: var(--cc_size_spacing_l);
  min-height: 100%;
  max-height: 100%;
  overflow-y: auto;
  box-shadow: 0 0 var(--cc_size_depth_3_blur) var(--cc_color_depth_3);

  /* animation */
  ${(e) => mx[e.$placement || "right"]};
  opacity: 0;
  animation-name: ${Sh};
  animation-duration: ${mt.duration.medium};
  animation-fill-mode: forwards;
  animation-timing-function: ${mt.easeOut};
  animation-delay: 100ms; /* wait a little bit for the backdrop to fade in first */
`;
function aI({
  as: e,
  backDropStyle: n,
  children: t,
  containerStyle: r,
  isOpen: i,
  onOpenChange: o,
  mountNodeId: a,
  placement: c,
  offset: d,
  shouldShowBackdrop: p = !0,
  triggerButton: m,
  ...v
}) {
  const { refs: y, context: _ } = Us({
    open: i,
    onOpenChange: o
  }), { getReferenceProps: S, getFloatingProps: E } = eu([
    ph(_),
    tu(_, { role: "dialog" }),
    Jc(_, { enabled: p })
    // only close on click-off and ESC if backdrop
  ]), Y = m || void 0, N = /* @__PURE__ */ L(
    gx,
    {
      ref: y.setFloating,
      $placement: c,
      $offset: d,
      ...v,
      ...E(),
      children: /* @__PURE__ */ L(vx, { as: e, $placement: c, style: r, children: t })
    }
  ), I = p ? /* @__PURE__ */ pe(Bb, { lockScroll: !0, style: n, children: [
    /* @__PURE__ */ L(px, {}),
    /* @__PURE__ */ L(fh, { context: _, modal: !0, children: N })
  ] }) : N;
  return /* @__PURE__ */ pe(Bn, { children: [
    m && ba(Y) ? K.cloneElement(
      Y,
      {
        type: "button",
        ref: y.setReference,
        ...S()
      }
    ) : null,
    /* @__PURE__ */ L(Aa, { id: a || void 0, children: i ? I : null })
  ] });
}
const kh = W.span`
  ${(e) => e.$debug ? "outline: var(--cc_size_border_width_s) dashed var(--cc_color_utility_destroy);" : null}
`, _x = (e) => {
  const { minWidth: n, maxWidth: t } = e;
  return n && t ? `(min-width: ${n}px) and (max-width: ${t}px)` : n && !t ? `(min-width: ${n}px)` : t && !n ? `(max-width: ${t}px)` : "(min-width: 0)";
}, af = (e) => e === "auto" ? "auto" : e === "fill" ? "minmax(0, 1fr)" : typeof e == "number" ? `${e}px` : e, yx = (e, n) => {
  const t = [];
  return e ? (e.forEach((r) => {
    const i = r.split(" ").map((o) => o === "0" ? "." : `${n}-${o}`).join(" ");
    t.push(`"${i}"`);
  }), t.join(" ")) : null;
}, bx = W.div`
  display: grid;
  ${(e) => {
  var n;
  return (n = e.$breakpoints) == null ? void 0 : n.map((t) => {
    const { areas: r, colGap: i, colAlign: o, cols: a, rowAlign: c, rowGap: d, rows: p } = t, m = a == null ? void 0 : a.map((y) => af(y)).join(" "), v = p == null ? void 0 : p.map((y) => af(y)).join(" ");
    return le`
        @container ${_x(t)} {
          ${r ? null : le`
                > ${kh} {
                  grid-area: auto !important;
                }
              `}
          ${a ? `
                grid-template-columns: ${m};
              ` : null}
          ${p ? `
                  grid-template-rows: ${v};
                ` : null}
          ${i ? `column-gap: var(--cc_size_spacing_${i});` : null}
          ${d ? `row-gap: var(--cc_size_spacing_${d});` : null}
          ${o ? `align-items: ${o};` : null}
          ${c ? `justify-items: ${c};` : null}
          ${r ? `grid-template-areas: ${yx(r, e.id)};` : "grid-template-areas: unset;"}
        }
      `;
  });
}}
`;
function lI({
  children: e,
  debug: n = !1,
  id: t,
  breakpoints: r,
  gridContainerStyle: i,
  gridItemStyle: o,
  ...a
}) {
  const { style: c, ...d } = a;
  return /* @__PURE__ */ L("div", { style: { containerType: "inline-size", ...c }, ...d, children: /* @__PURE__ */ L(bx, { id: t, $breakpoints: r, style: i, children: ap.map(e, (p, m) => {
    const v = `${t}-${m + 1}`;
    return /* @__PURE__ */ L(
      kh,
      {
        id: `${v}-item`,
        $debug: n,
        style: {
          gridArea: v,
          ...o
        },
        children: p
      },
      v
    );
  }) }) });
}
const wx = W.hr`
  all: initial;
  display: block;
  border-block-start: var(--cc_size_border_width_s) solid
    var(--cc_color_border_default);

  /* if ccMargin, convert spacing tokens to CSS variables */
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
`;
function cI({ ccMargin: e, ...n }) {
  return /* @__PURE__ */ L(wx, { $ccMargin: e, ...n });
}
const xx = W.div`
  position: relative;
  z-index: 1;
  display: grid; /* kill extra space created by display: inline-flex children (radios, checkboxes) */
`, Ch = W.div`
  display: flex;
  align-items: center;
  gap: calc(var(--cc_size_spacing_xs) * 1.125);
  font-size: var(--cc_size_text_xs);
  font-weight: 400;
  color: ${(e) => Pt(e.$status).accentColor};
  line-height: 1.2;
`, Dh = W.i`
  font-size: 18px;
  flex-shrink: 0;
`, Eh = W.span`
  ${Lt}
`;
function qn({
  children: e,
  inputId: n,
  message: t,
  ...r
}) {
  const { status: i = "normal", ...o } = r;
  return /* @__PURE__ */ pe(xx, { ...o, children: [
    e,
    /* @__PURE__ */ L("div", { role: "region", "aria-live": i === "error" || i === "success" ? "assertive" : "off", children: t ? /* @__PURE__ */ pe(Ch, { $status: i, children: [
      /* @__PURE__ */ L(
        Dh,
        {
          className: `mdi mdi-${Pt(i).icon}`,
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ L(Eh, { id: `${n}-message`, children: t })
    ] }) : null })
  ] });
}
const oa = {
  default: {
    iconSize: "var(--cc_size_text_xs)",
    facadeSize: "var(--cc_size_spacing_m)",
    fontSize: "var(--cc_size_text_s)"
  },
  assetFeed: {
    iconSize: "var(--cc_size_text_m)",
    facadeSize: "var(--cc_size_spacing_l)",
    fontSize: "var(--cc_size_text_m)"
  }
}, Ph = W.span`
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: ${(e) => e.$design ? oa[e.$design].facadeSize : "var(--cc_size_spacing_m)"};
  height: ${(e) => e.$design ? oa[e.$design].facadeSize : "var(--cc_size_spacing_m)"};
  border-width: var(--cc_size_border_width_s);
  border-style: solid;
  border-radius: var(--cc_size_border_radius_m);
  background-color: var(--cc_color_background_1);
  transition: all 0.2s;
  ${(e) => e.$checked && !e.$indeterminate ? le`
          border-color: transparent;
          background-color: ${e.$status !== "normal" && !e.$disabled ? Pt(e.$status).accentColor : "var(--cc_color_button_background_secondary)"};
          color: var(--cc_color_button_text_secondary);
        ` : le`
          border-color: ${e.$status !== "normal" && !e.$disabled ? Pt(e.$status).accentColor : "var(--cc_color_border_input_inactive)"};
          color: var(--cc_color_link_secondary);
        `}
`, Mh = W.label`
  all: initial;
  box-sizing: border-box;
  display: inline-flex;
  align-items: flex-start;
  justify-self: start; /* prevent label from stretching when inside <Message /> */
  gap: ${(e) => e.$hideLabel ? "normal" : "var(--cc_size_spacing_s)"};
  ${(e) => e.$message ? "margin-block-end: var(--cc_size_spacing_xs);" : null}
  cursor: ${(e) => e.$disabled ? "not-allowed;" : "pointer"};
  ${(e) => e.$disabled ? _r : null}
  &:hover ${Ph} {
    ${(e) => e.$disabled ? null : le`
            border-color: ${e.$checked ? "var(--cc_color_link_subtle)" : "var(--cc_color_link_secondary)"};
          `}
  }
`, Sx = W.input`
  all: initial;
  ${fr}
  &:focus-visible ~ ${Mh} {
    ${(e) => Pt(e.$status).focusStyles}
    border-radius: var(--cc_size_border_radius_m);
    outline-offset: var(--cc_size_spacing_xxs);
  }
`, kx = W.span`
  ${Lt}
  flex: 1;
  min-width: 1px;
  color: var(--cc_color_link_secondary);
  transform: ${(e) => e.$design === "assetFeed" ? "translateY(1px)" : "translateY(-1px)"};
  user-select: none;
  ${(e) => e.$design === "assetFeed" ? dr : Lt}
  font-size: ${(e) => e.$design ? oa[e.$design].fontSize : "var(--cc_size_text_s)"};
`, Cx = W.i`
  font-size: ${(e) => e.$design ? oa[e.$design].iconSize : "var(--cc_size_text_xs)"};
  transition: transform 0.2s;
  ${(e) => e.$indeterminate || e.$checked ? le`
          opacity: 1;
          transform: scale(1);
        ` : le`
          opacity: 0;
          transform: scale(0.1);
        `}
`;
function Dx({
  design: e = "default",
  hideLabel: n = !1,
  label: t,
  indeterminate: r,
  onChange: i,
  testId: o,
  value: a,
  ...c
}) {
  const d = We(null), {
    status: p = "normal",
    disabled: m = !1,
    checked: v = !1,
    message: y,
    ..._
  } = c;
  return ct(() => {
    if (d.current) {
      if (r) {
        d.current.checked = !1, d.current.indeterminate = !0;
        return;
      }
      if (v) {
        d.current.checked = !0, d.current.indeterminate = !1;
        return;
      }
      d.current.checked = !1, d.current.indeterminate = !1;
    }
  }, [v, r]), /* @__PURE__ */ pe(
    qn,
    {
      inputId: c.id,
      message: c.message,
      status: p,
      className: c.className,
      style: c.style,
      children: [
        /* @__PURE__ */ L(
          Sx,
          {
            "aria-invalid": p === "error",
            "aria-describedby": y ? `${c.id}-message` : "",
            checked: v,
            "data-testid": o,
            disabled: m,
            ref: d,
            name: c.name || c.id,
            onChange: i,
            $status: p,
            type: "checkbox",
            value: a,
            ..._
          }
        ),
        /* @__PURE__ */ pe(
          Mh,
          {
            htmlFor: c.id,
            $hideLabel: n,
            $disabled: m,
            $checked: v,
            $message: c.message,
            children: [
              /* @__PURE__ */ L(
                Ph,
                {
                  "aria-hidden": "true",
                  $disabled: m,
                  $checked: v,
                  $indeterminate: r,
                  $status: p,
                  $design: e,
                  children: /* @__PURE__ */ L(
                    Cx,
                    {
                      $checked: v,
                      $indeterminate: r,
                      $design: e,
                      className: `mdi mdi-${r ? "minus-thick" : "check-bold"}`
                    }
                  )
                }
              ),
              n ? /* @__PURE__ */ L(ln, { children: t }) : /* @__PURE__ */ L(kx, { $design: e, children: t })
            ]
          }
        )
      ]
    }
  );
}
const Ji = ({
  ccMargin: e,
  children: n
}) => /* @__PURE__ */ L(
  Nt,
  {
    as: "span",
    weight: 600,
    family: "heading",
    color: "default",
    ccMargin: e,
    children: n
  }
), Ex = W.fieldset`
  all: initial;
  position: relative;
  display: block;
  ${(e) => e.$message ? le`
          margin-block-end: var(--cc_size_spacing_s);
        ` : null}
`, Px = W.legend`
  all: initial;
  display: block;
  float: left; /* Hack to make the legend appear inside the container */
  ${(e) => e.$hideLabel ? fr : null}
`, Mx = W.div`
  clear: left; /* Clear the float from the legend */
`, $x = ({
  label: e,
  children: n,
  hideLabel: t = !1,
  testId: r,
  ...i
}) => {
  const {
    status: o = "normal",
    message: a,
    disabled: c,
    style: d,
    className: p,
    ...m
  } = i;
  return /* @__PURE__ */ L(
    qn,
    {
      status: o,
      message: i.message,
      inputId: i.id,
      style: d,
      className: p,
      children: /* @__PURE__ */ pe(
        Ex,
        {
          "data-testid": r,
          "aria-disabled": i.disabled,
          "aria-invalid": o === "error",
          "aria-describedby": i.message ? `${i.id}-message` : "",
          $message: i.message,
          ...m,
          children: [
            /* @__PURE__ */ L(Px, { $hideLabel: t, children: e }),
            n ? /* @__PURE__ */ L(Mx, { children: n }) : null
          ]
        }
      )
    }
  );
}, Tx = W.div`
  margin-block-start: var(--cc_size_spacing_xxs);
  ${(e) => e.$layout === "inline" ? le`
          display: flex;
          flex-wrap: wrap;
          gap: var(--cc_size_spacing_m);
        ` : le`
          display: grid;
          row-gap: var(--cc_size_spacing_s);
          column-gap: var(--cc_size_spacing_l);
        `}
`;
function $h({ layout: e = "block", ...n }) {
  const { label: t, ...r } = n;
  return /* @__PURE__ */ L(
    $x,
    {
      label: /* @__PURE__ */ L(Ji, { ccMargin: "none none s", children: t }),
      ...r,
      children: /* @__PURE__ */ L(Tx, { $layout: e, children: n.children })
    }
  );
}
function uI({
  onChange: e,
  options: n,
  selectedValues: t,
  ...r
}) {
  return /* @__PURE__ */ L($h, { ...r, children: n.map((i) => /* @__PURE__ */ L(
    Dx,
    {
      id: i.value,
      name: r.id,
      onChange: e,
      checked: t.includes(i.value),
      disabled: i.disabled || r.disabled,
      status: i.status || r.status,
      ...i
    },
    i.value
  )) });
}
function Th(e) {
  var n, t, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (n = 0; n < i; n++)
        e[n] && (t = Th(e[n])) && (r && (r += " "), r += t);
    } else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function Ot() {
  for (var e, n, t = 0, r = "", i = arguments.length; t < i; t++)
    (e = arguments[t]) && (n = Th(e)) && (r && (r += " "), r += n);
  return r;
}
function bi(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function we(e) {
  const n = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && n === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || n === "[object Number]" || typeof e == "string" || n === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function zs(e) {
  if (!bi(e) && typeof e != "number")
    return !1;
  const n = we(e);
  return !isNaN(Number(n));
}
const Ix = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Rx = (e, n, t) => {
  let r;
  const i = Ix[e];
  return typeof i == "string" ? r = i : n === 1 ? r = i.one : r = i.other.replace("{{count}}", n.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function yl(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const Ax = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Fx = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ox = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Lx = {
  date: yl({
    formats: Ax,
    defaultWidth: "full"
  }),
  time: yl({
    formats: Fx,
    defaultWidth: "full"
  }),
  dateTime: yl({
    formats: Ox,
    defaultWidth: "full"
  })
}, Nx = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, zx = (e, n, t, r) => Nx[e];
function vs(e) {
  return (n, t) => {
    const r = t != null && t.context ? String(t.context) : "standalone";
    let i;
    if (r === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, c = t != null && t.width ? String(t.width) : a;
      i = e.formattingValues[c] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, c = t != null && t.width ? String(t.width) : e.defaultWidth;
      i = e.values[c] || e.values[a];
    }
    const o = e.argumentCallback ? e.argumentCallback(n) : n;
    return i[o];
  };
}
const Vx = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Yx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Hx = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Bx = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Wx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, jx = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Gx = (e, n) => {
  const t = Number(e), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, qx = {
  ordinalNumber: Gx,
  era: vs({
    values: Vx,
    defaultWidth: "wide"
  }),
  quarter: vs({
    values: Yx,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: vs({
    values: Hx,
    defaultWidth: "wide"
  }),
  day: vs({
    values: Bx,
    defaultWidth: "wide"
  }),
  dayPeriod: vs({
    values: Wx,
    defaultWidth: "wide",
    formattingValues: jx,
    defaultFormattingWidth: "wide"
  })
};
function _s(e) {
  return (n, t = {}) => {
    const r = t.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = n.match(i);
    if (!o)
      return null;
    const a = o[0], c = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(c) ? Ux(c, (v) => v.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Kx(c, (v) => v.test(a))
    );
    let p;
    p = e.valueCallback ? e.valueCallback(d) : d, p = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(p)
    ) : p;
    const m = n.slice(a.length);
    return { value: p, rest: m };
  };
}
function Kx(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Ux(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Qx(e) {
  return (n, t = {}) => {
    const r = n.match(e.matchPattern);
    if (!r)
      return null;
    const i = r[0], o = n.match(e.parsePattern);
    if (!o)
      return null;
    let a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = t.valueCallback ? t.valueCallback(a) : a;
    const c = n.slice(i.length);
    return { value: a, rest: c };
  };
}
const Xx = /^(\d+)(th|st|nd|rd)?/i, Zx = /\d+/i, Jx = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, eS = {
  any: [/^b/i, /^(a|c)/i]
}, tS = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, rS = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, nS = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, iS = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, sS = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, oS = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, aS = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, lS = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, cS = {
  ordinalNumber: Qx({
    matchPattern: Xx,
    parsePattern: Zx,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: _s({
    matchPatterns: Jx,
    defaultMatchWidth: "wide",
    parsePatterns: eS,
    defaultParseWidth: "any"
  }),
  quarter: _s({
    matchPatterns: tS,
    defaultMatchWidth: "wide",
    parsePatterns: rS,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: _s({
    matchPatterns: nS,
    defaultMatchWidth: "wide",
    parsePatterns: iS,
    defaultParseWidth: "any"
  }),
  day: _s({
    matchPatterns: sS,
    defaultMatchWidth: "wide",
    parsePatterns: oS,
    defaultParseWidth: "any"
  }),
  dayPeriod: _s({
    matchPatterns: aS,
    defaultMatchWidth: "any",
    parsePatterns: lS,
    defaultParseWidth: "any"
  })
}, Ih = {
  code: "en-US",
  formatDistance: Rx,
  formatLong: Lx,
  formatRelative: zx,
  localize: qx,
  match: cS,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
let uS = {};
function Si() {
  return uS;
}
const Rh = 6048e5, dS = 864e5, Fa = 6e4, Oa = 36e5, fS = 1e3;
function zr(e) {
  const n = we(e);
  return n.setHours(0, 0, 0, 0), n;
}
function aa(e) {
  const n = we(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Vs(e, n) {
  const t = zr(e), r = zr(n), i = +t - aa(t), o = +r - aa(r);
  return Math.round((i - o) / dS);
}
function et(e, n) {
  return e instanceof Date ? new e.constructor(n) : new Date(n);
}
function La(e) {
  const n = we(e), t = et(e, 0);
  return t.setFullYear(n.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function pS(e) {
  const n = we(e);
  return Vs(n, La(n)) + 1;
}
function un(e, n) {
  var c, d, p, m;
  const t = Si(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((m = (p = t.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = we(e), o = i.getDay(), a = (o < r ? 7 : 0) + o - r;
  return i.setDate(i.getDate() - a), i.setHours(0, 0, 0, 0), i;
}
function Ki(e) {
  return un(e, { weekStartsOn: 1 });
}
function Ah(e) {
  const n = we(e), t = n.getFullYear(), r = et(e, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Ki(r), o = et(e, 0);
  o.setFullYear(t, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Ki(o);
  return n.getTime() >= i.getTime() ? t + 1 : n.getTime() >= a.getTime() ? t : t - 1;
}
function hS(e) {
  const n = Ah(e), t = et(e, 0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), Ki(t);
}
function su(e) {
  const n = we(e), t = +Ki(n) - +hS(n);
  return Math.round(t / Rh) + 1;
}
function ou(e, n) {
  var m, v, y, _;
  const t = we(e), r = t.getFullYear(), i = Si(), o = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((v = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : v.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((_ = (y = i.locale) == null ? void 0 : y.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, a = et(e, 0);
  a.setFullYear(r + 1, 0, o), a.setHours(0, 0, 0, 0);
  const c = un(a, n), d = et(e, 0);
  d.setFullYear(r, 0, o), d.setHours(0, 0, 0, 0);
  const p = un(d, n);
  return t.getTime() >= c.getTime() ? r + 1 : t.getTime() >= p.getTime() ? r : r - 1;
}
function gS(e, n) {
  var c, d, p, m;
  const t = Si(), r = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((m = (p = t.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = ou(e, n), o = et(e, 0);
  return o.setFullYear(i, 0, r), o.setHours(0, 0, 0, 0), un(o, n);
}
function Fh(e, n) {
  const t = we(e), r = +un(t, n) - +gS(t, n);
  return Math.round(r / Rh) + 1;
}
function Je(e, n) {
  const t = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(n, "0");
  return t + r;
}
const Sn = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), r = t > 0 ? t : 1 - t;
    return Je(n === "yy" ? r % 100 : r, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : Je(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return Je(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return Je(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return Je(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return Je(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return Je(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, r = e.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return Je(i, n.length);
  }
}, Fi = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, lf = {
  // Era
  G: function(e, n, t) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const r = e.getFullYear(), i = r > 0 ? r : 1 - r;
      return t.ordinalNumber(i, { unit: "year" });
    }
    return Sn.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, r) {
    const i = ou(e, r), o = i > 0 ? i : 1 - i;
    if (n === "YY") {
      const a = o % 100;
      return Je(a, 2);
    }
    return n === "Yo" ? t.ordinalNumber(o, { unit: "year" }) : Je(o, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Ah(e);
    return Je(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return Je(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(r);
      case "QQ":
        return Je(r, 2);
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(r);
      case "qq":
        return Je(r, 2);
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Sn.M(e, n);
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const r = e.getMonth();
    switch (n) {
      case "L":
        return String(r + 1);
      case "LL":
        return Je(r + 1, 2);
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, r) {
    const i = Fh(e, r);
    return n === "wo" ? t.ordinalNumber(i, { unit: "week" }) : Je(i, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const r = su(e);
    return n === "Io" ? t.ordinalNumber(r, { unit: "week" }) : Je(r, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Sn.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const r = pS(e);
    return n === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : Je(r, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const r = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(o);
      case "ee":
        return Je(o, 2);
      case "eo":
        return t.ordinalNumber(o, { unit: "day" });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, r) {
    const i = e.getDay(), o = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(o);
      case "cc":
        return Je(o, n.length);
      case "co":
        return t.ordinalNumber(o, { unit: "day" });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const r = e.getDay(), i = r === 0 ? 7 : r;
    switch (n) {
      case "i":
        return String(i);
      case "ii":
        return Je(i, n.length);
      case "io":
        return t.ordinalNumber(i, { unit: "day" });
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const i = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const r = e.getHours();
    let i;
    switch (r === 12 ? i = Fi.noon : r === 0 ? i = Fi.midnight : i = r / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const r = e.getHours();
    let i;
    switch (r >= 17 ? i = Fi.evening : r >= 12 ? i = Fi.afternoon : r >= 4 ? i = Fi.morning : i = Fi.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Sn.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Sn.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const r = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : Je(r, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let r = e.getHours();
    return r === 0 && (r = 24), n === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : Je(r, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Sn.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Sn.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Sn.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (n) {
      case "X":
        return uf(r);
      case "XXXX":
      case "XX":
        return ni(r);
      case "XXXXX":
      case "XXX":
      default:
        return ni(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return uf(r);
      case "xxxx":
      case "xx":
        return ni(r);
      case "xxxxx":
      case "xxx":
      default:
        return ni(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + cf(r, ":");
      case "OOOO":
      default:
        return "GMT" + ni(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const r = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + cf(r, ":");
      case "zzzz":
      default:
        return "GMT" + ni(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Je(r, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    const r = e.getTime();
    return Je(r, n.length);
  }
};
function cf(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), o = r % 60;
  return o === 0 ? t + String(i) : t + String(i) + n + Je(o, 2);
}
function uf(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Je(Math.abs(e) / 60, 2) : ni(e, n);
}
function ni(e, n = "") {
  const t = e > 0 ? "-" : "+", r = Math.abs(e), i = Je(Math.trunc(r / 60), 2), o = Je(r % 60, 2);
  return t + i + n + o;
}
const df = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, Oh = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, mS = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], r = t[1], i = t[2];
  if (!i)
    return df(e, n);
  let o;
  switch (r) {
    case "P":
      o = n.dateTime({ width: "short" });
      break;
    case "PP":
      o = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      o = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      o = n.dateTime({ width: "full" });
      break;
  }
  return o.replace("{{date}}", df(r, n)).replace("{{time}}", Oh(i, n));
}, la = {
  p: Oh,
  P: mS
}, vS = /^D+$/, _S = /^Y+$/, yS = ["D", "DD", "YY", "YYYY"];
function Lh(e) {
  return vS.test(e);
}
function Nh(e) {
  return _S.test(e);
}
function ic(e, n, t) {
  const r = bS(e, n, t);
  if (console.warn(r), yS.includes(e))
    throw new RangeError(r);
}
function bS(e, n, t) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const wS = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, xS = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, SS = /^'([^]*?)'?$/, kS = /''/g, CS = /[a-zA-Z]/;
function ff(e, n, t) {
  var m, v, y, _, S, E, Y, N;
  const r = Si(), i = (t == null ? void 0 : t.locale) ?? r.locale ?? Ih, o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((v = (m = t == null ? void 0 : t.locale) == null ? void 0 : m.options) == null ? void 0 : v.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((_ = (y = r.locale) == null ? void 0 : y.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, a = (t == null ? void 0 : t.weekStartsOn) ?? ((E = (S = t == null ? void 0 : t.locale) == null ? void 0 : S.options) == null ? void 0 : E.weekStartsOn) ?? r.weekStartsOn ?? ((N = (Y = r.locale) == null ? void 0 : Y.options) == null ? void 0 : N.weekStartsOn) ?? 0, c = we(e);
  if (!zs(c))
    throw new RangeError("Invalid time value");
  let d = n.match(xS).map((I) => {
    const Q = I[0];
    if (Q === "p" || Q === "P") {
      const te = la[Q];
      return te(I, i.formatLong);
    }
    return I;
  }).join("").match(wS).map((I) => {
    if (I === "''")
      return { isToken: !1, value: "'" };
    const Q = I[0];
    if (Q === "'")
      return { isToken: !1, value: DS(I) };
    if (lf[Q])
      return { isToken: !0, value: I };
    if (Q.match(CS))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + Q + "`"
      );
    return { isToken: !1, value: I };
  });
  i.localize.preprocessor && (d = i.localize.preprocessor(c, d));
  const p = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: i
  };
  return d.map((I) => {
    if (!I.isToken)
      return I.value;
    const Q = I.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Nh(Q) || !(t != null && t.useAdditionalDayOfYearTokens) && Lh(Q)) && ic(Q, n, String(e));
    const te = lf[Q[0]];
    return te(c, Q, i.localize, p);
  }).join("");
}
function DS(e) {
  const n = e.match(SS);
  return n ? n[1].replace(kS, "'") : e;
}
function au(e, n) {
  const t = +we(e);
  return et(e, t + n);
}
function sc(e, n) {
  return au(e, n * Fa);
}
function ES(e, n) {
  return au(e, n * Oa);
}
function Kn(e, n) {
  const t = we(e);
  return isNaN(n) ? et(e, NaN) : (n && t.setDate(t.getDate() + n), t);
}
function ca(e, n) {
  const t = n * 7;
  return Kn(e, t);
}
function Dr(e, n) {
  const t = we(e);
  if (isNaN(n))
    return et(e, NaN);
  if (!n)
    return t;
  const r = t.getDate(), i = et(e, t.getTime());
  i.setMonth(t.getMonth() + n + 1, 0);
  const o = i.getDate();
  return r >= o ? i : (t.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), t);
}
function lu(e, n) {
  const t = n * 3;
  return Dr(e, t);
}
function nn(e, n) {
  return Dr(e, n * 12);
}
function PS(e, n) {
  return Kn(e, -n);
}
function pf(e, n) {
  return ca(e, -n);
}
function Ui(e, n) {
  return Dr(e, -n);
}
function zh(e, n) {
  return lu(e, -n);
}
function Qi(e, n) {
  return nn(e, -n);
}
function sn(e) {
  return we(e).getSeconds();
}
function Vr(e) {
  return we(e).getMinutes();
}
function Yr(e) {
  return we(e).getHours();
}
function MS(e) {
  return we(e).getDay();
}
function hf(e) {
  return we(e).getDate();
}
function Ut(e) {
  return we(e).getMonth();
}
function fi(e) {
  const n = we(e);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function He(e) {
  return we(e).getFullYear();
}
function oc(e) {
  return we(e).getTime();
}
function Vo(e, n) {
  const t = we(e);
  return t.setSeconds(n), t;
}
function Yo(e, n) {
  const t = we(e);
  return t.setMinutes(n), t;
}
function Ho(e, n) {
  const t = we(e);
  return t.setHours(n), t;
}
function $S(e) {
  const n = we(e), t = n.getFullYear(), r = n.getMonth(), i = et(e, 0);
  return i.setFullYear(t, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function Kt(e, n) {
  const t = we(e), r = t.getFullYear(), i = t.getDate(), o = et(e, 0);
  o.setFullYear(r, n, 15), o.setHours(0, 0, 0, 0);
  const a = $S(o);
  return t.setMonth(n, Math.min(i, a)), t;
}
function Li(e, n) {
  const t = we(e), r = Math.trunc(t.getMonth() / 3) + 1, i = n - r;
  return Kt(t, t.getMonth() + i * 3);
}
function Ar(e, n) {
  const t = we(e);
  return isNaN(+t) ? et(e, NaN) : (t.setFullYear(n), t);
}
function gf(e) {
  let n;
  return e.forEach((t) => {
    const r = we(t);
    (!n || n > r || isNaN(+r)) && (n = r);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function mf(e) {
  let n;
  return e.forEach(function(t) {
    const r = we(t);
    (n === void 0 || n < r || isNaN(Number(r))) && (n = r);
  }), n || /* @__PURE__ */ new Date(NaN);
}
function ua(e, n) {
  const t = we(e), r = we(n), i = t.getFullYear() - r.getFullYear(), o = t.getMonth() - r.getMonth();
  return i * 12 + o;
}
function da(e, n) {
  const t = we(e), r = we(n);
  return t.getFullYear() - r.getFullYear();
}
function fa(e, n) {
  const t = we(e), r = we(n), i = t.getFullYear() - r.getFullYear(), o = fi(t) - fi(r);
  return i * 4 + o;
}
function Vh(e) {
  const n = we(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function ac(e) {
  const n = we(e), t = n.getMonth(), r = t - t % 3;
  return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
}
function lc(e) {
  const n = we(e);
  return n.setHours(23, 59, 59, 999), n;
}
function TS(e, n) {
  var c, d, p, m;
  const t = Si(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((d = (c = n == null ? void 0 : n.locale) == null ? void 0 : c.options) == null ? void 0 : d.weekStartsOn) ?? t.weekStartsOn ?? ((m = (p = t.locale) == null ? void 0 : p.options) == null ? void 0 : m.weekStartsOn) ?? 0, i = we(e), o = i.getDay(), a = (o < r ? -7 : 0) + 6 - (o - r);
  return i.setDate(i.getDate() + a), i.setHours(23, 59, 59, 999), i;
}
function IS(e) {
  const n = we(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Yh(e) {
  const n = we(e), t = n.getFullYear();
  return n.setFullYear(t + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function RS(e, n) {
  const t = we(e), r = we(n);
  return +t == +r;
}
function AS(e, n) {
  const t = zr(e), r = zr(n);
  return +t == +r;
}
function FS(e, n) {
  const t = we(e), r = we(n);
  return t.getFullYear() === r.getFullYear() && t.getMonth() === r.getMonth();
}
function OS(e, n) {
  const t = we(e), r = we(n);
  return t.getFullYear() === r.getFullYear();
}
function LS(e, n) {
  const t = ac(e), r = ac(n);
  return +t == +r;
}
function zn(e, n) {
  const t = we(e), r = we(n);
  return t.getTime() > r.getTime();
}
function wi(e, n) {
  const t = we(e), r = we(n);
  return +t < +r;
}
function Ys(e, n) {
  const t = +we(e), [r, i] = [
    +we(n.start),
    +we(n.end)
  ].sort((o, a) => o - a);
  return t >= r && t <= i;
}
function NS() {
  return Object.assign({}, Si());
}
function zS(e, n) {
  const t = n instanceof Date ? et(n, 0) : new n(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const VS = 10;
class Hh {
  constructor() {
    be(this, "subPriority", 0);
  }
  validate(n, t) {
    return !0;
  }
}
class YS extends Hh {
  constructor(n, t, r, i, o) {
    super(), this.value = n, this.validateValue = t, this.setValue = r, this.priority = i, o && (this.subPriority = o);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, r) {
    return this.setValue(n, t, this.value, r);
  }
}
class HS extends Hh {
  constructor() {
    super(...arguments);
    be(this, "priority", VS);
    be(this, "subPriority", -1);
  }
  set(t, r) {
    return r.timestampIsSet ? t : et(t, zS(t, Date));
  }
}
class Qe {
  run(n, t, r, i) {
    const o = this.parse(n, t, r, i);
    return o ? {
      setter: new YS(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(n, t, r) {
    return !0;
  }
}
class BS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 140);
    be(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return i.era(t, { width: "abbreviated" }) || i.era(t, { width: "narrow" });
      case "GGGGG":
        return i.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return i.era(t, { width: "wide" }) || i.era(t, { width: "abbreviated" }) || i.era(t, { width: "narrow" });
    }
  }
  set(t, r, i) {
    return r.era = i, t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const vt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Lr = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function _t(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function ft(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Nr(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const r = t[1] === "+" ? 1 : -1, i = t[2] ? parseInt(t[2], 10) : 0, o = t[3] ? parseInt(t[3], 10) : 0, a = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: r * (i * Oa + o * Fa + a * fS),
    rest: n.slice(t[0].length)
  };
}
function Bh(e) {
  return ft(vt.anyDigitsSigned, e);
}
function ht(e, n) {
  switch (e) {
    case 1:
      return ft(vt.singleDigit, n);
    case 2:
      return ft(vt.twoDigits, n);
    case 3:
      return ft(vt.threeDigits, n);
    case 4:
      return ft(vt.fourDigits, n);
    default:
      return ft(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function pa(e, n) {
  switch (e) {
    case 1:
      return ft(vt.singleDigitSigned, n);
    case 2:
      return ft(vt.twoDigitsSigned, n);
    case 3:
      return ft(vt.threeDigitsSigned, n);
    case 4:
      return ft(vt.fourDigitsSigned, n);
    default:
      return ft(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function cu(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Wh(e, n) {
  const t = n > 0, r = t ? n : 1 - n;
  let i;
  if (r <= 50)
    i = e || 100;
  else {
    const o = r + 50, a = Math.trunc(o / 100) * 100, c = e >= o % 100;
    i = e + a - (c ? 100 : 0);
  }
  return t ? i : 1 - i;
}
function jh(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class WS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 130);
    be(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, i) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: r === "yy"
    });
    switch (r) {
      case "y":
        return _t(ht(4, t), o);
      case "yo":
        return _t(
          i.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return _t(ht(r.length, t), o);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, i) {
    const o = t.getFullYear();
    if (i.isTwoDigitYear) {
      const c = Wh(
        i.year,
        o
      );
      return t.setFullYear(c, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const a = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class jS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 130);
    be(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    const o = (a) => ({
      year: a,
      isTwoDigitYear: r === "YY"
    });
    switch (r) {
      case "Y":
        return _t(ht(4, t), o);
      case "Yo":
        return _t(
          i.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return _t(ht(r.length, t), o);
    }
  }
  validate(t, r) {
    return r.isTwoDigitYear || r.year > 0;
  }
  set(t, r, i, o) {
    const a = ou(t, o);
    if (i.isTwoDigitYear) {
      const d = Wh(
        i.year,
        a
      );
      return t.setFullYear(
        d,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), un(t, o);
    }
    const c = !("era" in r) || r.era === 1 ? i.year : 1 - i.year;
    return t.setFullYear(c, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), un(t, o);
  }
}
class GS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 130);
    be(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r) {
    return pa(r === "R" ? 4 : r.length, t);
  }
  set(t, r, i) {
    const o = et(t, 0);
    return o.setFullYear(i, 0, 4), o.setHours(0, 0, 0, 0), Ki(o);
  }
}
class qS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 130);
    be(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, r) {
    return pa(r === "u" ? 4 : r.length, t);
  }
  set(t, r, i) {
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class KS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 120);
    be(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "Q":
      case "QQ":
        return ht(r.length, t);
      case "Qo":
        return i.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return i.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return i.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return i.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || i.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, i) {
    return t.setMonth((i - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class US extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 120);
    be(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "q":
      case "qq":
        return ht(r.length, t);
      case "qo":
        return i.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return i.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return i.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return i.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || i.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 4;
  }
  set(t, r, i) {
    return t.setMonth((i - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class QS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    be(this, "priority", 110);
  }
  parse(t, r, i) {
    const o = (a) => a - 1;
    switch (r) {
      case "M":
        return _t(
          ft(vt.month, t),
          o
        );
      case "MM":
        return _t(ht(2, t), o);
      case "Mo":
        return _t(
          i.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return i.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return i.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return i.month(t, { width: "wide", context: "formatting" }) || i.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, i) {
    return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class XS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 110);
    be(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    const o = (a) => a - 1;
    switch (r) {
      case "L":
        return _t(
          ft(vt.month, t),
          o
        );
      case "LL":
        return _t(ht(2, t), o);
      case "Lo":
        return _t(
          i.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return i.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return i.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return i.month(t, { width: "wide", context: "standalone" }) || i.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, i) {
    return t.setMonth(i, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function ZS(e, n, t) {
  const r = we(e), i = Fh(r, t) - n;
  return r.setDate(r.getDate() - i * 7), r;
}
class JS extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 100);
    be(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "w":
        return ft(vt.week, t);
      case "wo":
        return i.ordinalNumber(t, { unit: "week" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, i, o) {
    return un(ZS(t, i, o), o);
  }
}
function ek(e, n) {
  const t = we(e), r = su(t) - n;
  return t.setDate(t.getDate() - r * 7), t;
}
class tk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 100);
    be(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "I":
        return ft(vt.week, t);
      case "Io":
        return i.ordinalNumber(t, { unit: "week" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 53;
  }
  set(t, r, i) {
    return Ki(ek(t, i));
  }
}
const rk = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], nk = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class ik extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 90);
    be(this, "subPriority", 1);
    be(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "d":
        return ft(vt.date, t);
      case "do":
        return i.ordinalNumber(t, { unit: "date" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    const i = t.getFullYear(), o = jh(i), a = t.getMonth();
    return o ? r >= 1 && r <= nk[a] : r >= 1 && r <= rk[a];
  }
  set(t, r, i) {
    return t.setDate(i), t.setHours(0, 0, 0, 0), t;
  }
}
class sk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 90);
    be(this, "subpriority", 1);
    be(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    switch (r) {
      case "D":
      case "DD":
        return ft(vt.dayOfYear, t);
      case "Do":
        return i.ordinalNumber(t, { unit: "date" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    const i = t.getFullYear();
    return jh(i) ? r >= 1 && r <= 366 : r >= 1 && r <= 365;
  }
  set(t, r, i) {
    return t.setMonth(0, i), t.setHours(0, 0, 0, 0), t;
  }
}
function uu(e, n, t) {
  var v, y, _, S;
  const r = Si(), i = (t == null ? void 0 : t.weekStartsOn) ?? ((y = (v = t == null ? void 0 : t.locale) == null ? void 0 : v.options) == null ? void 0 : y.weekStartsOn) ?? r.weekStartsOn ?? ((S = (_ = r.locale) == null ? void 0 : _.options) == null ? void 0 : S.weekStartsOn) ?? 0, o = we(e), a = o.getDay(), d = (n % 7 + 7) % 7, p = 7 - i, m = n < 0 || n > 6 ? n - (a + p) % 7 : (d + p) % 7 - (a + p) % 7;
  return Kn(o, m);
}
class ok extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 90);
    be(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return i.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return i.day(t, { width: "wide", context: "formatting" }) || i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, i, o) {
    return t = uu(t, i, o), t.setHours(0, 0, 0, 0), t;
  }
}
class ak extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 90);
    be(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i, o) {
    const a = (c) => {
      const d = Math.floor((c - 1) / 7) * 7;
      return (c + o.weekStartsOn + 6) % 7 + d;
    };
    switch (r) {
      case "e":
      case "ee":
        return _t(ht(r.length, t), a);
      case "eo":
        return _t(
          i.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "eee":
        return i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return i.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return i.day(t, { width: "wide", context: "formatting" }) || i.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.day(t, { width: "short", context: "formatting" }) || i.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, i, o) {
    return t = uu(t, i, o), t.setHours(0, 0, 0, 0), t;
  }
}
class lk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 90);
    be(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, r, i, o) {
    const a = (c) => {
      const d = Math.floor((c - 1) / 7) * 7;
      return (c + o.weekStartsOn + 6) % 7 + d;
    };
    switch (r) {
      case "c":
      case "cc":
        return _t(ht(r.length, t), a);
      case "co":
        return _t(
          i.ordinalNumber(t, {
            unit: "day"
          }),
          a
        );
      case "ccc":
        return i.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(t, { width: "short", context: "standalone" }) || i.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return i.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return i.day(t, { width: "short", context: "standalone" }) || i.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return i.day(t, { width: "wide", context: "standalone" }) || i.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || i.day(t, { width: "short", context: "standalone" }) || i.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 6;
  }
  set(t, r, i, o) {
    return t = uu(t, i, o), t.setHours(0, 0, 0, 0), t;
  }
}
function ck(e) {
  let t = we(e).getDay();
  return t === 0 && (t = 7), t;
}
function uk(e, n) {
  const t = we(e), r = ck(t), i = n - r;
  return Kn(t, i);
}
class dk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 90);
    be(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, r, i) {
    const o = (a) => a === 0 ? 7 : a;
    switch (r) {
      case "i":
      case "ii":
        return ht(r.length, t);
      case "io":
        return i.ordinalNumber(t, { unit: "day" });
      case "iii":
        return _t(
          i.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(t, {
            width: "short",
            context: "formatting"
          }) || i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return _t(
          i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return _t(
          i.day(t, {
            width: "short",
            context: "formatting"
          }) || i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return _t(
          i.day(t, {
            width: "wide",
            context: "formatting"
          }) || i.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(t, {
            width: "short",
            context: "formatting"
          }) || i.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 7;
  }
  set(t, r, i) {
    return t = uk(t, i), t.setHours(0, 0, 0, 0), t;
  }
}
class fk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 80);
    be(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "a":
      case "aa":
      case "aaa":
        return i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return i.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, i) {
    return t.setHours(cu(i), 0, 0, 0), t;
  }
}
class pk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 80);
    be(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "b":
      case "bb":
      case "bbb":
        return i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return i.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, i) {
    return t.setHours(cu(i), 0, 0, 0), t;
  }
}
class hk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 80);
    be(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "B":
      case "BB":
      case "BBB":
        return i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return i.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || i.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, r, i) {
    return t.setHours(cu(i), 0, 0, 0), t;
  }
}
class gk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 70);
    be(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "h":
        return ft(vt.hour12h, t);
      case "ho":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 12;
  }
  set(t, r, i) {
    const o = t.getHours() >= 12;
    return o && i < 12 ? t.setHours(i + 12, 0, 0, 0) : !o && i === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(i, 0, 0, 0), t;
  }
}
class mk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 70);
    be(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "H":
        return ft(vt.hour23h, t);
      case "Ho":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 23;
  }
  set(t, r, i) {
    return t.setHours(i, 0, 0, 0), t;
  }
}
class vk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 70);
    be(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "K":
        return ft(vt.hour11h, t);
      case "Ko":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 11;
  }
  set(t, r, i) {
    return t.getHours() >= 12 && i < 12 ? t.setHours(i + 12, 0, 0, 0) : t.setHours(i, 0, 0, 0), t;
  }
}
class _k extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 70);
    be(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "k":
        return ft(vt.hour24h, t);
      case "ko":
        return i.ordinalNumber(t, { unit: "hour" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 1 && r <= 24;
  }
  set(t, r, i) {
    const o = i <= 24 ? i % 24 : i;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class yk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 60);
    be(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "m":
        return ft(vt.minute, t);
      case "mo":
        return i.ordinalNumber(t, { unit: "minute" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, i) {
    return t.setMinutes(i, 0, 0), t;
  }
}
class bk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 50);
    be(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r, i) {
    switch (r) {
      case "s":
        return ft(vt.second, t);
      case "so":
        return i.ordinalNumber(t, { unit: "second" });
      default:
        return ht(r.length, t);
    }
  }
  validate(t, r) {
    return r >= 0 && r <= 59;
  }
  set(t, r, i) {
    return t.setSeconds(i, 0), t;
  }
}
class wk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 30);
    be(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, r) {
    const i = (o) => Math.trunc(o * Math.pow(10, -r.length + 3));
    return _t(ht(r.length, t), i);
  }
  set(t, r, i) {
    return t.setMilliseconds(i), t;
  }
}
class xk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 10);
    be(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, r) {
    switch (r) {
      case "X":
        return Nr(
          Lr.basicOptionalMinutes,
          t
        );
      case "XX":
        return Nr(Lr.basic, t);
      case "XXXX":
        return Nr(
          Lr.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Nr(
          Lr.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Nr(Lr.extended, t);
    }
  }
  set(t, r, i) {
    return r.timestampIsSet ? t : et(
      t,
      t.getTime() - aa(t) - i
    );
  }
}
class Sk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 10);
    be(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, r) {
    switch (r) {
      case "x":
        return Nr(
          Lr.basicOptionalMinutes,
          t
        );
      case "xx":
        return Nr(Lr.basic, t);
      case "xxxx":
        return Nr(
          Lr.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Nr(
          Lr.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Nr(Lr.extended, t);
    }
  }
  set(t, r, i) {
    return r.timestampIsSet ? t : et(
      t,
      t.getTime() - aa(t) - i
    );
  }
}
class kk extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 40);
    be(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Bh(t);
  }
  set(t, r, i) {
    return [et(t, i * 1e3), { timestampIsSet: !0 }];
  }
}
class Ck extends Qe {
  constructor() {
    super(...arguments);
    be(this, "priority", 20);
    be(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return Bh(t);
  }
  set(t, r, i) {
    return [et(t, i), { timestampIsSet: !0 }];
  }
}
const Dk = {
  G: new BS(),
  y: new WS(),
  Y: new jS(),
  R: new GS(),
  u: new qS(),
  Q: new KS(),
  q: new US(),
  M: new QS(),
  L: new XS(),
  w: new JS(),
  I: new tk(),
  d: new ik(),
  D: new sk(),
  E: new ok(),
  e: new ak(),
  c: new lk(),
  i: new dk(),
  a: new fk(),
  b: new pk(),
  B: new hk(),
  h: new gk(),
  H: new mk(),
  K: new vk(),
  k: new _k(),
  m: new yk(),
  s: new bk(),
  S: new wk(),
  X: new xk(),
  x: new Sk(),
  t: new kk(),
  T: new Ck()
}, Ek = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Pk = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Mk = /^'([^]*?)'?$/, $k = /''/g, Tk = /\S/, Ik = /[a-zA-Z]/;
function bl(e, n, t, r) {
  var E, Y, N, I, Q, te, ie, ne;
  const i = NS(), o = (r == null ? void 0 : r.locale) ?? i.locale ?? Ih, a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((Y = (E = r == null ? void 0 : r.locale) == null ? void 0 : E.options) == null ? void 0 : Y.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((I = (N = i.locale) == null ? void 0 : N.options) == null ? void 0 : I.firstWeekContainsDate) ?? 1, c = (r == null ? void 0 : r.weekStartsOn) ?? ((te = (Q = r == null ? void 0 : r.locale) == null ? void 0 : Q.options) == null ? void 0 : te.weekStartsOn) ?? i.weekStartsOn ?? ((ne = (ie = i.locale) == null ? void 0 : ie.options) == null ? void 0 : ne.weekStartsOn) ?? 0;
  if (n === "")
    return e === "" ? we(t) : et(t, NaN);
  const d = {
    firstWeekContainsDate: a,
    weekStartsOn: c,
    locale: o
  }, p = [new HS()], m = n.match(Pk).map((re) => {
    const ce = re[0];
    if (ce in la) {
      const de = la[ce];
      return de(re, o.formatLong);
    }
    return re;
  }).join("").match(Ek), v = [];
  for (let re of m) {
    !(r != null && r.useAdditionalWeekYearTokens) && Nh(re) && ic(re, n, e), !(r != null && r.useAdditionalDayOfYearTokens) && Lh(re) && ic(re, n, e);
    const ce = re[0], de = Dk[ce];
    if (de) {
      const { incompatibleTokens: ge } = de;
      if (Array.isArray(ge)) {
        const Le = v.find(
          (ze) => ge.includes(ze.token) || ze.token === ce
        );
        if (Le)
          throw new RangeError(
            `The format string mustn't contain \`${Le.fullToken}\` and \`${re}\` at the same time`
          );
      } else if (de.incompatibleTokens === "*" && v.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${re}\` and any other token at the same time`
        );
      v.push({ token: ce, fullToken: re });
      const $e = de.run(
        e,
        re,
        o.match,
        d
      );
      if (!$e)
        return et(t, NaN);
      p.push($e.setter), e = $e.rest;
    } else {
      if (ce.match(Ik))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + ce + "`"
        );
      if (re === "''" ? re = "'" : ce === "'" && (re = Rk(re)), e.indexOf(re) === 0)
        e = e.slice(re.length);
      else
        return et(t, NaN);
    }
  }
  if (e.length > 0 && Tk.test(e))
    return et(t, NaN);
  const y = p.map((re) => re.priority).sort((re, ce) => ce - re).filter((re, ce, de) => de.indexOf(re) === ce).map(
    (re) => p.filter((ce) => ce.priority === re).sort((ce, de) => de.subPriority - ce.subPriority)
  ).map((re) => re[0]);
  let _ = we(t);
  if (isNaN(_.getTime()))
    return et(t, NaN);
  const S = {};
  for (const re of y) {
    if (!re.validate(_, d))
      return et(t, NaN);
    const ce = re.set(_, S, d);
    Array.isArray(ce) ? (_ = ce[0], Object.assign(S, ce[1])) : _ = ce;
  }
  return et(t, _);
}
function Rk(e) {
  return e.match(Mk)[1].replace($k, "'");
}
function Ak(e, n) {
  const t = (n == null ? void 0 : n.additionalDigits) ?? 2, r = Nk(e);
  let i;
  if (r.date) {
    const d = zk(r.date, t);
    i = Vk(d.restDateString, d.year);
  }
  if (!i || isNaN(i.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = i.getTime();
  let a = 0, c;
  if (r.time && (a = Yk(r.time), isNaN(a)))
    return /* @__PURE__ */ new Date(NaN);
  if (r.timezone) {
    if (c = Hk(r.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const d = new Date(o + a), p = /* @__PURE__ */ new Date(0);
    return p.setFullYear(
      d.getUTCFullYear(),
      d.getUTCMonth(),
      d.getUTCDate()
    ), p.setHours(
      d.getUTCHours(),
      d.getUTCMinutes(),
      d.getUTCSeconds(),
      d.getUTCMilliseconds()
    ), p;
  }
  return new Date(o + a + c);
}
const xo = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Fk = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Ok = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Lk = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Nk(e) {
  const n = {}, t = e.split(xo.dateTimeDelimiter);
  let r;
  if (t.length > 2)
    return n;
  if (/:/.test(t[0]) ? r = t[0] : (n.date = t[0], r = t[1], xo.timeZoneDelimiter.test(n.date) && (n.date = e.split(xo.timeZoneDelimiter)[0], r = e.substr(
    n.date.length,
    e.length
  ))), r) {
    const i = xo.timezone.exec(r);
    i ? (n.time = r.replace(i[1], ""), n.timezone = i[1]) : n.time = r;
  }
  return n;
}
function zk(e, n) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"
  ), r = e.match(t);
  if (!r)
    return { year: NaN, restDateString: "" };
  const i = r[1] ? parseInt(r[1]) : null, o = r[2] ? parseInt(r[2]) : null;
  return {
    year: o === null ? i : o * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function Vk(e, n) {
  if (n === null)
    return /* @__PURE__ */ new Date(NaN);
  const t = e.match(Fk);
  if (!t)
    return /* @__PURE__ */ new Date(NaN);
  const r = !!t[4], i = ys(t[1]), o = ys(t[2]) - 1, a = ys(t[3]), c = ys(t[4]), d = ys(t[5]) - 1;
  if (r)
    return qk(n, c, d) ? Bk(n, c, d) : /* @__PURE__ */ new Date(NaN);
  {
    const p = /* @__PURE__ */ new Date(0);
    return !jk(n, o, a) || !Gk(n, i) ? /* @__PURE__ */ new Date(NaN) : (p.setUTCFullYear(n, o, Math.max(i, a)), p);
  }
}
function ys(e) {
  return e ? parseInt(e) : 1;
}
function Yk(e) {
  const n = e.match(Ok);
  if (!n)
    return NaN;
  const t = wl(n[1]), r = wl(n[2]), i = wl(n[3]);
  return Kk(t, r, i) ? t * Oa + r * Fa + i * 1e3 : NaN;
}
function wl(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Hk(e) {
  if (e === "Z")
    return 0;
  const n = e.match(Lk);
  if (!n)
    return 0;
  const t = n[1] === "+" ? -1 : 1, r = parseInt(n[2]), i = n[3] && parseInt(n[3]) || 0;
  return Uk(r, i) ? t * (r * Oa + i * Fa) : NaN;
}
function Bk(e, n, t) {
  const r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  const i = r.getUTCDay() || 7, o = (n - 1) * 7 + t + 1 - i;
  return r.setUTCDate(r.getUTCDate() + o), r;
}
const Wk = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Gh(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function jk(e, n, t) {
  return n >= 0 && n <= 11 && t >= 1 && t <= (Wk[n] || (Gh(e) ? 29 : 28));
}
function Gk(e, n) {
  return n >= 1 && n <= (Gh(e) ? 366 : 365);
}
function qk(e, n, t) {
  return n >= 1 && n <= 53 && t >= 0 && t <= 6;
}
function Kk(e, n, t) {
  return e === 24 ? n === 0 && t === 0 : t >= 0 && t < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function Uk(e, n) {
  return n >= 0 && n <= 59;
}
function Qk(e, n) {
  return au(e, n * 1e3);
}
function Xk(e, n) {
  let t = we(e);
  return isNaN(+t) ? et(e, NaN) : (n.year != null && t.setFullYear(n.year), n.month != null && (t = Kt(t, n.month)), n.date != null && t.setDate(n.date), n.hours != null && t.setHours(n.hours), n.minutes != null && t.setMinutes(n.minutes), n.seconds != null && t.setSeconds(n.seconds), n.milliseconds != null && t.setMilliseconds(n.milliseconds), t);
}
function Zk(e, n) {
  e.prototype = Object.create(n.prototype), e.prototype.constructor = e, cc(e, n);
}
function cc(e, n) {
  return cc = Object.setPrototypeOf || function(r, i) {
    return r.__proto__ = i, r;
  }, cc(e, n);
}
function Jk(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(n.indexOf(i) >= 0) && (t[i] = e[i]);
  return t;
}
function vf(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function eC(e, n, t) {
  return e === n ? !0 : e.correspondingElement ? e.correspondingElement.classList.contains(t) : e.classList.contains(t);
}
function tC(e, n, t) {
  if (e === n)
    return !0;
  for (; e.parentNode || e.host; ) {
    if (e.parentNode && eC(e, n, t))
      return !0;
    e = e.parentNode || e.host;
  }
  return e;
}
function rC(e) {
  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
}
var nC = function() {
  if (!(typeof window > "u" || typeof window.addEventListener != "function")) {
    var n = !1, t = Object.defineProperty({}, "passive", {
      get: function() {
        n = !0;
      }
    }), r = function() {
    };
    return window.addEventListener("testPassiveEventSupport", r, t), window.removeEventListener("testPassiveEventSupport", r, t), n;
  }
};
function iC(e) {
  return e === void 0 && (e = 0), function() {
    return ++e;
  };
}
var sC = iC(), uc, So = {}, xl = {}, oC = ["touchstart", "touchmove"], aC = "ignore-react-onclickoutside";
function _f(e, n) {
  var t = {}, r = oC.indexOf(n) !== -1;
  return r && uc && (t.passive = !e.props.preventDefault), t;
}
function Na(e, n) {
  var t, r, i = e.displayName || e.name || "Component";
  return r = t = /* @__PURE__ */ function(o) {
    Zk(a, o);
    function a(d) {
      var p;
      return p = o.call(this, d) || this, p.__outsideClickHandler = function(m) {
        if (typeof p.__clickOutsideHandlerProp == "function") {
          p.__clickOutsideHandlerProp(m);
          return;
        }
        var v = p.getInstance();
        if (typeof v.props.handleClickOutside == "function") {
          v.props.handleClickOutside(m);
          return;
        }
        if (typeof v.handleClickOutside == "function") {
          v.handleClickOutside(m);
          return;
        }
        throw new Error("WrappedComponent: " + i + " lacks a handleClickOutside(event) function for processing outside click events.");
      }, p.__getComponentNode = function() {
        var m = p.getInstance();
        return n && typeof n.setClickOutsideRef == "function" ? n.setClickOutsideRef()(m) : typeof m.setClickOutsideRef == "function" ? m.setClickOutsideRef() : Lm(m);
      }, p.enableOnClickOutside = function() {
        if (!(typeof document > "u" || xl[p._uid])) {
          typeof uc > "u" && (uc = nC()), xl[p._uid] = !0;
          var m = p.props.eventTypes;
          m.forEach || (m = [m]), So[p._uid] = function(v) {
            if (p.componentNode !== null && !(p.initTimeStamp > v.timeStamp) && (p.props.preventDefault && v.preventDefault(), p.props.stopPropagation && v.stopPropagation(), !(p.props.excludeScrollbar && rC(v)))) {
              var y = v.composed && v.composedPath && v.composedPath().shift() || v.target;
              tC(y, p.componentNode, p.props.outsideClickIgnoreClass) === document && p.__outsideClickHandler(v);
            }
          }, m.forEach(function(v) {
            document.addEventListener(v, So[p._uid], _f(vf(p), v));
          });
        }
      }, p.disableOnClickOutside = function() {
        delete xl[p._uid];
        var m = So[p._uid];
        if (m && typeof document < "u") {
          var v = p.props.eventTypes;
          v.forEach || (v = [v]), v.forEach(function(y) {
            return document.removeEventListener(y, m, _f(vf(p), y));
          }), delete So[p._uid];
        }
      }, p.getRef = function(m) {
        return p.instanceRef = m;
      }, p._uid = sC(), p.initTimeStamp = performance.now(), p;
    }
    var c = a.prototype;
    return c.getInstance = function() {
      if (e.prototype && !e.prototype.isReactComponent)
        return this;
      var p = this.instanceRef;
      return p.getInstance ? p.getInstance() : p;
    }, c.componentDidMount = function() {
      if (!(typeof document > "u" || !document.createElement)) {
        var p = this.getInstance();
        if (n && typeof n.handleClickOutside == "function" && (this.__clickOutsideHandlerProp = n.handleClickOutside(p), typeof this.__clickOutsideHandlerProp != "function"))
          throw new Error("WrappedComponent: " + i + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        this.componentNode = this.__getComponentNode(), !this.props.disableOnClickOutside && this.enableOnClickOutside();
      }
    }, c.componentDidUpdate = function() {
      this.componentNode = this.__getComponentNode();
    }, c.componentWillUnmount = function() {
      this.disableOnClickOutside();
    }, c.render = function() {
      var p = this.props;
      p.excludeScrollbar;
      var m = Jk(p, ["excludeScrollbar"]);
      return e.prototype && e.prototype.isReactComponent ? m.ref = this.getRef : m.wrappedRef = this.getRef, m.disableOnClickOutside = this.disableOnClickOutside, m.enableOnClickOutside = this.enableOnClickOutside, Ec(e, m);
    }, a;
  }(Rm), t.displayName = "OnClickOutside(" + i + ")", t.defaultProps = {
    eventTypes: ["mousedown", "touchstart"],
    excludeScrollbar: n && n.excludeScrollbar || !1,
    outsideClickIgnoreClass: aC,
    preventDefault: !1,
    stopPropagation: !1
  }, t.getClass = function() {
    return e.getClass ? e.getClass() : e;
  }, r;
}
/*!
  react-datepicker v6.9.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
function Mt(e, n, t) {
  return n = ha(n), uC(e, qh() ? Reflect.construct(n, t || [], ha(e).constructor) : n.apply(e, t));
}
function qh() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qh = function() {
    return !!e;
  })();
}
function yf(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Jr(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? yf(Object(t), !0).forEach(function(r) {
      R(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : yf(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function lC(e, n) {
  if (typeof e != "object" || !e)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function Kh(e) {
  var n = lC(e, "string");
  return typeof n == "symbol" ? n : n + "";
}
function dc(e) {
  "@babel/helpers - typeof";
  return dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, dc(e);
}
function $t(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function bf(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Kh(r.key), r);
  }
}
function Tt(e, n, t) {
  return n && bf(e.prototype, n), t && bf(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function R(e, n, t) {
  return n = Kh(n), n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function Hs() {
  return Hs = Object.assign ? Object.assign.bind() : function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Hs.apply(this, arguments);
}
function It(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), n && fc(e, n);
}
function ha(e) {
  return ha = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ha(e);
}
function fc(e, n) {
  return fc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, fc(e, n);
}
function cC(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uC(e, n) {
  if (n && (typeof n == "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return cC(e);
}
function Vn(e) {
  return dC(e) || fC(e) || pC(e) || hC();
}
function dC(e) {
  if (Array.isArray(e))
    return pc(e);
}
function fC(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function pC(e, n) {
  if (e) {
    if (typeof e == "string")
      return pc(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return pc(e, n);
  }
}
function pc(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function hC() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Qs = 12, gC = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function rt(e) {
  var n = e ? typeof e == "string" || e instanceof String ? Ak(e) : we(e) : /* @__PURE__ */ new Date();
  return Cn(n) ? n : null;
}
function mC(e, n, t, r, i) {
  var o = null, a = on(t) || on(pi()), c = !0;
  return Array.isArray(n) ? (n.forEach(function(d) {
    var p = bl(e, d, /* @__PURE__ */ new Date(), {
      locale: a,
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
    r && (c = Cn(p, i) && e === lt(p, d, t)), Cn(p, i) && c && (o = p);
  }), o) : (o = bl(e, n, /* @__PURE__ */ new Date(), {
    locale: a,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), r ? c = Cn(o) && e === lt(o, n, t) : Cn(o) || (n = n.match(gC).map(function(d) {
    var p = d[0];
    if (p === "p" || p === "P") {
      var m = la[p];
      return a ? m(d, a.formatLong) : p;
    }
    return d;
  }).join(""), e.length > 0 && (o = bl(e, n.slice(0, e.length), /* @__PURE__ */ new Date(), {
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  })), Cn(o) || (o = new Date(e))), Cn(o) && c ? o : null);
}
function Cn(e, n) {
  return n = n || /* @__PURE__ */ new Date("1/1/1000"), zs(e) && !wi(e, n);
}
function lt(e, n, t) {
  if (t === "en")
    return ff(e, n, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var r = on(t);
  return t && !r && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !r && pi() && on(pi()) && (r = on(pi())), ff(e, n, {
    locale: r || null,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function mr(e, n) {
  var t = n.dateFormat, r = n.locale;
  return e && lt(e, Array.isArray(t) ? t[0] : t, r) || "";
}
function vC(e, n, t) {
  if (!e)
    return "";
  var r = mr(e, t), i = n ? mr(n, t) : "";
  return "".concat(r, " - ").concat(i);
}
function _C(e, n) {
  if (!(e != null && e.length))
    return "";
  var t = mr(e[0], n);
  if (e.length === 1)
    return t;
  if (e.length === 2) {
    var r = mr(e[1], n);
    return "".concat(t, ", ").concat(r);
  }
  var i = e.length - 1;
  return "".concat(t, " (+").concat(i, ")");
}
function Sl(e, n) {
  var t = n.hour, r = t === void 0 ? 0 : t, i = n.minute, o = i === void 0 ? 0 : i, a = n.second, c = a === void 0 ? 0 : a;
  return Ho(Yo(Vo(e, c), o), r);
}
function yC(e, n) {
  return n && on(n) || pi() && on(pi()), su(e);
}
function bC(e, n) {
  return lt(e, "ddd", n);
}
function wC(e) {
  return zr(e);
}
function Rn(e, n, t) {
  var r = on(n || pi());
  return un(e, {
    locale: r,
    weekStartsOn: t
  });
}
function An(e) {
  return Vh(e);
}
function Ds(e) {
  return La(e);
}
function wf(e) {
  return ac(e);
}
function xf() {
  return zr(rt());
}
function xC(e) {
  return TS(e);
}
function Or(e, n) {
  return e && n ? OS(e, n) : !e && !n;
}
function ar(e, n) {
  return e && n ? FS(e, n) : !e && !n;
}
function ga(e, n) {
  return e && n ? LS(e, n) : !e && !n;
}
function Ue(e, n) {
  return e && n ? AS(e, n) : !e && !n;
}
function ai(e, n) {
  return e && n ? RS(e, n) : !e && !n;
}
function Es(e, n, t) {
  var r, i = zr(n), o = lc(t);
  try {
    r = Ys(e, {
      start: i,
      end: o
    });
  } catch {
    r = !1;
  }
  return r;
}
function pi() {
  var e = typeof window < "u" ? window : globalThis;
  return e.__localeId__;
}
function on(e) {
  if (typeof e == "string") {
    var n = typeof window < "u" ? window : globalThis;
    return n.__localeData__ ? n.__localeData__[e] : null;
  } else
    return e;
}
function SC(e, n, t) {
  return n(lt(e, "EEEE", t));
}
function kC(e, n) {
  return lt(e, "EEEEEE", n);
}
function CC(e, n) {
  return lt(e, "EEE", n);
}
function du(e, n) {
  return lt(Kt(rt(), e), "LLLL", n);
}
function Uh(e, n) {
  return lt(Kt(rt(), e), "LLL", n);
}
function DC(e, n) {
  return lt(Li(rt(), e), "QQQ", n);
}
function za(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, i = n.excludeDates, o = n.excludeDateIntervals, a = n.includeDates, c = n.includeDateIntervals, d = n.filterDate;
  return Va(e, {
    minDate: t,
    maxDate: r
  }) || i && i.some(function(p) {
    return Ue(e, p.date ? p.date : p);
  }) || o && o.some(function(p) {
    var m = p.start, v = p.end;
    return Ys(e, {
      start: m,
      end: v
    });
  }) || a && !a.some(function(p) {
    return Ue(e, p);
  }) || c && !c.some(function(p) {
    var m = p.start, v = p.end;
    return Ys(e, {
      start: m,
      end: v
    });
  }) || d && !d(rt(e)) || !1;
}
function fu(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.excludeDates, r = n.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(i) {
    var o = i.start, a = i.end;
    return Ys(e, {
      start: o,
      end: a
    });
  }) : t && t.some(function(i) {
    return Ue(e, i.date ? i.date : i);
  }) || !1;
}
function Bo(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, i = n.excludeDates, o = n.includeDates, a = n.filterDate;
  return Va(e, {
    minDate: Vh(t),
    maxDate: IS(r)
  }) || i && i.some(function(c) {
    return ar(e, c);
  }) || o && !o.some(function(c) {
    return ar(e, c);
  }) || a && !a(rt(e)) || !1;
}
function ko(e, n, t, r) {
  var i = He(e), o = Ut(e), a = He(n), c = Ut(n), d = He(r);
  if (i === a && i === d)
    return o <= t && t <= c;
  if (i < a)
    return d === i && o <= t || d === a && c >= t || d < a && d > i;
}
function kl(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, i = n.excludeDates, o = n.includeDates, a = n.filterDate;
  return Va(e, {
    minDate: t,
    maxDate: r
  }) || i && i.some(function(c) {
    return ga(e, c);
  }) || o && !o.some(function(c) {
    return ga(e, c);
  }) || a && !a(rt(e)) || !1;
}
function Co(e, n, t) {
  if (!zs(n) || !zs(t))
    return !1;
  var r = He(n), i = He(t);
  return r <= e && i >= e;
}
function Qh(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate, i = n.excludeDates, o = n.includeDates, a = n.filterDate, c = new Date(e, 0, 1);
  return Va(c, {
    minDate: La(t),
    maxDate: Yh(r)
  }) || i && i.some(function(d) {
    return Or(c, d);
  }) || o && !o.some(function(d) {
    return Or(c, d);
  }) || a && !a(rt(c)) || !1;
}
function Do(e, n, t, r) {
  var i = He(e), o = fi(e), a = He(n), c = fi(n), d = He(r);
  if (i === a && i === d)
    return o <= t && t <= c;
  if (i < a)
    return d === i && o <= t || d === a && c >= t || d < a && d > i;
}
function Va(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.maxDate;
  return t && Vs(e, t) < 0 || r && Vs(e, r) > 0;
}
function Sf(e, n) {
  return n.some(function(t) {
    return Yr(t) === Yr(e) && Vr(t) === Vr(e) && sn(t) === sn(e);
  });
}
function kf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.excludeTimes, r = n.includeTimes, i = n.filterTime;
  return t && Sf(e, t) || r && !Sf(e, r) || i && !i(e) || !1;
}
function Cf(e, n) {
  var t = n.minTime, r = n.maxTime;
  if (!t || !r)
    throw new Error("Both minTime and maxTime props required");
  var i = rt();
  i = Ho(i, Yr(e)), i = Yo(i, Vr(e)), i = Vo(i, sn(e));
  var o = rt();
  o = Ho(o, Yr(t)), o = Yo(o, Vr(t)), o = Vo(o, sn(t));
  var a = rt();
  a = Ho(a, Yr(r)), a = Yo(a, Vr(r)), a = Vo(a, sn(r));
  var c;
  try {
    c = !Ys(i, {
      start: o,
      end: a
    });
  } catch {
    c = !1;
  }
  return c;
}
function Df(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.includeDates, i = Ui(e, 1);
  return t && ua(t, i) > 0 || r && r.every(function(o) {
    return ua(o, i) > 0;
  }) || !1;
}
function Ef(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.includeDates, i = Dr(e, 1);
  return t && ua(i, t) > 0 || r && r.every(function(o) {
    return ua(i, o) > 0;
  }) || !1;
}
function EC(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.includeDates, i = La(e), o = zh(i, 1);
  return t && fa(t, o) > 0 || r && r.every(function(a) {
    return fa(a, o) > 0;
  }) || !1;
}
function PC(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.includeDates, i = Yh(e), o = lu(i, 1);
  return t && fa(o, t) > 0 || r && r.every(function(a) {
    return fa(o, a) > 0;
  }) || !1;
}
function Pf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.includeDates, i = Qi(e, 1);
  return t && da(t, i) > 0 || r && r.every(function(o) {
    return da(o, i) > 0;
  }) || !1;
}
function MC(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.minDate, r = n.yearItemNumber, i = r === void 0 ? Qs : r, o = Ds(Qi(e, i)), a = Pn(o, i), c = a.endPeriod, d = t && He(t);
  return d && d > c || !1;
}
function Mf(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.includeDates, i = nn(e, 1);
  return t && da(i, t) > 0 || r && r.every(function(o) {
    return da(i, o) > 0;
  }) || !1;
}
function $C(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = n.maxDate, r = n.yearItemNumber, i = r === void 0 ? Qs : r, o = nn(e, i), a = Pn(o, i), c = a.startPeriod, d = t && He(t);
  return d && d < c || !1;
}
function Xh(e) {
  var n = e.minDate, t = e.includeDates;
  if (t && n) {
    var r = t.filter(function(i) {
      return Vs(i, n) >= 0;
    });
    return gf(r);
  } else
    return t ? gf(t) : n;
}
function Zh(e) {
  var n = e.maxDate, t = e.includeDates;
  if (t && n) {
    var r = t.filter(function(i) {
      return Vs(i, n) <= 0;
    });
    return mf(r);
  } else
    return t ? mf(t) : n;
}
function $f() {
  for (var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--highlighted", t = /* @__PURE__ */ new Map(), r = 0, i = e.length; r < i; r++) {
    var o = e[r];
    if (bi(o)) {
      var a = lt(o, "MM.dd.yyyy"), c = t.get(a) || [];
      c.includes(n) || (c.push(n), t.set(a, c));
    } else if (dc(o) === "object") {
      var d = Object.keys(o), p = d[0], m = o[d[0]];
      if (typeof p == "string" && m.constructor === Array)
        for (var v = 0, y = m.length; v < y; v++) {
          var _ = lt(m[v], "MM.dd.yyyy"), S = t.get(_) || [];
          S.includes(p) || (S.push(p), t.set(_, S));
        }
    }
  }
  return t;
}
function TC(e, n) {
  return e.length !== n.length ? !1 : e.every(function(t, r) {
    return t === n[r];
  });
}
function IC() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "react-datepicker__day--holidays", t = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    var i = r.date, o = r.holidayName;
    if (bi(i)) {
      var a = lt(i, "MM.dd.yyyy"), c = t.get(a) || {};
      if (!("className" in c && c.className === n && TC(c.holidayNames, [o]))) {
        c.className = n;
        var d = c.holidayNames;
        c.holidayNames = d ? [].concat(Vn(d), [o]) : [o], t.set(a, c);
      }
    }
  }), t;
}
function RC(e, n, t, r, i) {
  for (var o = i.length, a = [], c = 0; c < o; c++) {
    var d = e;
    d = ES(d, Yr(i[c])), d = sc(d, Vr(i[c])), d = Qk(d, sn(i[c]));
    var p = sc(e, (t + 1) * r);
    zn(d, n) && wi(d, p) && a.push(i[c]);
  }
  return a;
}
function Tf(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Pn(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Qs, t = Math.ceil(He(e) / n) * n, r = t - (n - 1);
  return {
    startPeriod: r,
    endPeriod: t
  };
}
function AC(e) {
  var n = new Date(e.getFullYear(), e.getMonth(), e.getDate()), t = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
  return Math.round((+t - +n) / 36e5);
}
function If(e) {
  var n = e.getSeconds(), t = e.getMilliseconds();
  return we(e.getTime() - n * 1e3 - t);
}
function FC(e, n) {
  return If(e).getTime() === If(n).getTime();
}
function Rf(e) {
  if (!bi(e))
    throw new Error("Invalid date");
  var n = new Date(e);
  return n.setHours(0, 0, 0, 0), n;
}
function Af(e, n) {
  if (!bi(e) || !bi(n))
    throw new Error("Invalid date received");
  var t = Rf(e), r = Rf(n);
  return wi(t, r);
}
function Jh(e) {
  var n = " ";
  return e.key === n;
}
function OC(e, n, t, r) {
  for (var i = [], o = 0; o < 2 * n + 1; o++) {
    var a = e + n - o, c = !0;
    t && (c = He(t) <= a), r && c && (c = He(r) >= a), c && i.push(a);
  }
  return i;
}
var LC = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    $t(this, n), r = Mt(this, n, [t]), R(r, "renderOptions", function() {
      var c = r.props.year, d = r.state.yearsList.map(function(v) {
        return /* @__PURE__ */ K.createElement("div", {
          className: c === v ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
          key: v,
          onClick: r.onChange.bind(r, v),
          "aria-selected": c === v ? "true" : void 0
        }, c === v ? /* @__PURE__ */ K.createElement("span", {
          className: "react-datepicker__year-option--selected"
        }, "✓") : "", v);
      }), p = r.props.minDate ? He(r.props.minDate) : null, m = r.props.maxDate ? He(r.props.maxDate) : null;
      return (!m || !r.state.yearsList.find(function(v) {
        return v === m;
      })) && d.unshift(/* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__year-option",
        key: "upcoming",
        onClick: r.incrementYears
      }, /* @__PURE__ */ K.createElement("a", {
        className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
      }))), (!p || !r.state.yearsList.find(function(v) {
        return v === p;
      })) && d.push(/* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__year-option",
        key: "previous",
        onClick: r.decrementYears
      }, /* @__PURE__ */ K.createElement("a", {
        className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
      }))), d;
    }), R(r, "onChange", function(c) {
      r.props.onChange(c);
    }), R(r, "handleClickOutside", function() {
      r.props.onCancel();
    }), R(r, "shiftYears", function(c) {
      var d = r.state.yearsList.map(function(p) {
        return p + c;
      });
      r.setState({
        yearsList: d
      });
    }), R(r, "incrementYears", function() {
      return r.shiftYears(1);
    }), R(r, "decrementYears", function() {
      return r.shiftYears(-1);
    });
    var i = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, a = i || (o ? 10 : 5);
    return r.state = {
      yearsList: OC(r.props.year, a, r.props.minDate, r.props.maxDate)
    }, r.dropdownRef = /* @__PURE__ */ Wo(), r;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      var r = this.dropdownRef.current;
      if (r) {
        var i = r.children ? Array.from(r.children) : null, o = i ? i.find(function(a) {
          return a.ariaSelected;
        }) : null;
        r.scrollTop = o ? o.offsetTop + (o.clientHeight - r.clientHeight) / 2 : (r.scrollHeight - r.clientHeight) / 2;
      }
    }
  }, {
    key: "render",
    value: function() {
      var r = Ot({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return /* @__PURE__ */ K.createElement("div", {
        className: r,
        ref: this.dropdownRef
      }, this.renderOptions());
    }
  }]);
}(K.Component), NC = Na(LC), zC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "state", {
      dropdownVisible: !1
    }), R(t, "renderSelectOptions", function() {
      for (var a = t.props.minDate ? He(t.props.minDate) : 1900, c = t.props.maxDate ? He(t.props.maxDate) : 2100, d = [], p = a; p <= c; p++)
        d.push(/* @__PURE__ */ K.createElement("option", {
          key: p,
          value: p
        }, p));
      return d;
    }), R(t, "onSelectChange", function(a) {
      t.onChange(a.target.value);
    }), R(t, "renderSelectMode", function() {
      return /* @__PURE__ */ K.createElement("select", {
        value: t.props.year,
        className: "react-datepicker__year-select",
        onChange: t.onSelectChange
      }, t.renderSelectOptions());
    }), R(t, "renderReadView", function(a) {
      return /* @__PURE__ */ K.createElement("div", {
        key: "read",
        style: {
          visibility: a ? "visible" : "hidden"
        },
        className: "react-datepicker__year-read-view",
        onClick: function(d) {
          return t.toggleDropdown(d);
        }
      }, /* @__PURE__ */ K.createElement("span", {
        className: "react-datepicker__year-read-view--down-arrow"
      }), /* @__PURE__ */ K.createElement("span", {
        className: "react-datepicker__year-read-view--selected-year"
      }, t.props.year));
    }), R(t, "renderDropdown", function() {
      return /* @__PURE__ */ K.createElement(NC, {
        key: "dropdown",
        year: t.props.year,
        onChange: t.onChange,
        onCancel: t.toggleDropdown,
        minDate: t.props.minDate,
        maxDate: t.props.maxDate,
        scrollableYearDropdown: t.props.scrollableYearDropdown,
        yearDropdownItemNumber: t.props.yearDropdownItemNumber
      });
    }), R(t, "renderScrollMode", function() {
      var a = t.state.dropdownVisible, c = [t.renderReadView(!a)];
      return a && c.unshift(t.renderDropdown()), c;
    }), R(t, "onChange", function(a) {
      t.toggleDropdown(), a !== t.props.year && t.props.onChange(a);
    }), R(t, "toggleDropdown", function(a) {
      t.setState({
        dropdownVisible: !t.state.dropdownVisible
      }, function() {
        t.props.adjustDateOnChange && t.handleYearChange(t.props.date, a);
      });
    }), R(t, "handleYearChange", function(a, c) {
      t.onSelect(a, c), t.setOpen();
    }), R(t, "onSelect", function(a, c) {
      t.props.onSelect && t.props.onSelect(a, c);
    }), R(t, "setOpen", function() {
      t.props.setOpen && t.props.setOpen(!0);
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode();
          break;
        case "select":
          r = this.renderSelectMode();
          break;
      }
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
      }, r);
    }
  }]);
}(K.Component), VC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "isSelectedMonth", function(a) {
      return t.props.month === a;
    }), R(t, "renderOptions", function() {
      return t.props.monthNames.map(function(a, c) {
        return /* @__PURE__ */ K.createElement("div", {
          className: t.isSelectedMonth(c) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
          key: a,
          onClick: t.onChange.bind(t, c),
          "aria-selected": t.isSelectedMonth(c) ? "true" : void 0
        }, t.isSelectedMonth(c) ? /* @__PURE__ */ K.createElement("span", {
          className: "react-datepicker__month-option--selected"
        }, "✓") : "", a);
      });
    }), R(t, "onChange", function(a) {
      return t.props.onChange(a);
    }), R(t, "handleClickOutside", function() {
      return t.props.onCancel();
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__month-dropdown"
      }, this.renderOptions());
    }
  }]);
}(K.Component), YC = Na(VC), HC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "state", {
      dropdownVisible: !1
    }), R(t, "renderSelectOptions", function(a) {
      return a.map(function(c, d) {
        return /* @__PURE__ */ K.createElement("option", {
          key: d,
          value: d
        }, c);
      });
    }), R(t, "renderSelectMode", function(a) {
      return /* @__PURE__ */ K.createElement("select", {
        value: t.props.month,
        className: "react-datepicker__month-select",
        onChange: function(d) {
          return t.onChange(d.target.value);
        }
      }, t.renderSelectOptions(a));
    }), R(t, "renderReadView", function(a, c) {
      return /* @__PURE__ */ K.createElement("div", {
        key: "read",
        style: {
          visibility: a ? "visible" : "hidden"
        },
        className: "react-datepicker__month-read-view",
        onClick: t.toggleDropdown
      }, /* @__PURE__ */ K.createElement("span", {
        className: "react-datepicker__month-read-view--down-arrow"
      }), /* @__PURE__ */ K.createElement("span", {
        className: "react-datepicker__month-read-view--selected-month"
      }, c[t.props.month]));
    }), R(t, "renderDropdown", function(a) {
      return /* @__PURE__ */ K.createElement(YC, {
        key: "dropdown",
        month: t.props.month,
        monthNames: a,
        onChange: t.onChange,
        onCancel: t.toggleDropdown
      });
    }), R(t, "renderScrollMode", function(a) {
      var c = t.state.dropdownVisible, d = [t.renderReadView(!c, a)];
      return c && d.unshift(t.renderDropdown(a)), d;
    }), R(t, "onChange", function(a) {
      t.toggleDropdown(), a !== t.props.month && t.props.onChange(a);
    }), R(t, "toggleDropdown", function() {
      return t.setState({
        dropdownVisible: !t.state.dropdownVisible
      });
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r = this, i = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(a) {
        return Uh(a, r.props.locale);
      } : function(a) {
        return du(a, r.props.locale);
      }), o;
      switch (this.props.dropdownMode) {
        case "scroll":
          o = this.renderScrollMode(i);
          break;
        case "select":
          o = this.renderSelectMode(i);
          break;
      }
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
      }, o);
    }
  }]);
}(K.Component);
function BC(e, n) {
  for (var t = [], r = An(e), i = An(n); !zn(r, i); )
    t.push(rt(r)), r = Dr(r, 1);
  return t;
}
var WC = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), R(r, "renderOptions", function() {
      return r.state.monthYearsList.map(function(i) {
        var o = oc(i), a = Or(r.props.date, i) && ar(r.props.date, i);
        return /* @__PURE__ */ K.createElement("div", {
          className: a ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
          key: o,
          onClick: r.onChange.bind(r, o),
          "aria-selected": a ? "true" : void 0
        }, a ? /* @__PURE__ */ K.createElement("span", {
          className: "react-datepicker__month-year-option--selected"
        }, "✓") : "", lt(i, r.props.dateFormat, r.props.locale));
      });
    }), R(r, "onChange", function(i) {
      return r.props.onChange(i);
    }), R(r, "handleClickOutside", function() {
      r.props.onCancel();
    }), r.state = {
      monthYearsList: BC(r.props.minDate, r.props.maxDate)
    }, r;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r = Ot({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return /* @__PURE__ */ K.createElement("div", {
        className: r
      }, this.renderOptions());
    }
  }]);
}(K.Component), jC = Na(WC), GC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "state", {
      dropdownVisible: !1
    }), R(t, "renderSelectOptions", function() {
      for (var a = An(t.props.minDate), c = An(t.props.maxDate), d = []; !zn(a, c); ) {
        var p = oc(a);
        d.push(/* @__PURE__ */ K.createElement("option", {
          key: p,
          value: p
        }, lt(a, t.props.dateFormat, t.props.locale))), a = Dr(a, 1);
      }
      return d;
    }), R(t, "onSelectChange", function(a) {
      t.onChange(a.target.value);
    }), R(t, "renderSelectMode", function() {
      return /* @__PURE__ */ K.createElement("select", {
        value: oc(An(t.props.date)),
        className: "react-datepicker__month-year-select",
        onChange: t.onSelectChange
      }, t.renderSelectOptions());
    }), R(t, "renderReadView", function(a) {
      var c = lt(t.props.date, t.props.dateFormat, t.props.locale);
      return /* @__PURE__ */ K.createElement("div", {
        key: "read",
        style: {
          visibility: a ? "visible" : "hidden"
        },
        className: "react-datepicker__month-year-read-view",
        onClick: function(p) {
          return t.toggleDropdown(p);
        }
      }, /* @__PURE__ */ K.createElement("span", {
        className: "react-datepicker__month-year-read-view--down-arrow"
      }), /* @__PURE__ */ K.createElement("span", {
        className: "react-datepicker__month-year-read-view--selected-month-year"
      }, c));
    }), R(t, "renderDropdown", function() {
      return /* @__PURE__ */ K.createElement(jC, {
        key: "dropdown",
        date: t.props.date,
        dateFormat: t.props.dateFormat,
        onChange: t.onChange,
        onCancel: t.toggleDropdown,
        minDate: t.props.minDate,
        maxDate: t.props.maxDate,
        scrollableMonthYearDropdown: t.props.scrollableMonthYearDropdown,
        locale: t.props.locale
      });
    }), R(t, "renderScrollMode", function() {
      var a = t.state.dropdownVisible, c = [t.renderReadView(!a)];
      return a && c.unshift(t.renderDropdown()), c;
    }), R(t, "onChange", function(a) {
      t.toggleDropdown();
      var c = rt(parseInt(a));
      Or(t.props.date, c) && ar(t.props.date, c) || t.props.onChange(c);
    }), R(t, "toggleDropdown", function() {
      return t.setState({
        dropdownVisible: !t.state.dropdownVisible
      });
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode();
          break;
        case "select":
          r = this.renderSelectMode();
          break;
      }
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
      }, r);
    }
  }]);
}(K.Component), qC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "dayEl", /* @__PURE__ */ K.createRef()), R(t, "handleClick", function(a) {
      !t.isDisabled() && t.props.onClick && t.props.onClick(a);
    }), R(t, "handleMouseEnter", function(a) {
      !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(a);
    }), R(t, "handleOnKeyDown", function(a) {
      var c = a.key;
      c === " " && (a.preventDefault(), a.key = "Enter"), t.props.handleOnKeyDown(a);
    }), R(t, "isSameDay", function(a) {
      return Ue(t.props.day, a);
    }), R(t, "isKeyboardSelected", function() {
      var a;
      if (t.props.disabledKeyboardNavigation)
        return !1;
      var c = t.props.selectsMultiple ? (a = t.props.selectedDates) === null || a === void 0 ? void 0 : a.some(function(d) {
        return t.isSameDayOrWeek(d);
      }) : t.isSameDayOrWeek(t.props.selected);
      return !c && t.isSameDayOrWeek(t.props.preSelection);
    }), R(t, "isDisabled", function() {
      return za(t.props.day, t.props);
    }), R(t, "isExcluded", function() {
      return fu(t.props.day, t.props);
    }), R(t, "isStartOfWeek", function() {
      return Ue(t.props.day, Rn(t.props.day, t.props.locale, t.props.calendarStartDay));
    }), R(t, "isSameWeek", function(a) {
      return t.props.showWeekPicker && Ue(a, Rn(t.props.day, t.props.locale, t.props.calendarStartDay));
    }), R(t, "isSameDayOrWeek", function(a) {
      return t.isSameDay(a) || t.isSameWeek(a);
    }), R(t, "getHighLightedClass", function() {
      var a = t.props, c = a.day, d = a.highlightDates;
      if (!d)
        return !1;
      var p = lt(c, "MM.dd.yyyy");
      return d.get(p);
    }), R(t, "getHolidaysClass", function() {
      var a = t.props, c = a.day, d = a.holidays;
      if (!d)
        return !1;
      var p = lt(c, "MM.dd.yyyy");
      if (d.has(p))
        return [d.get(p).className];
    }), R(t, "isInRange", function() {
      var a = t.props, c = a.day, d = a.startDate, p = a.endDate;
      return !d || !p ? !1 : Es(c, d, p);
    }), R(t, "isInSelectingRange", function() {
      var a, c = t.props, d = c.day, p = c.selectsStart, m = c.selectsEnd, v = c.selectsRange, y = c.selectsDisabledDaysInRange, _ = c.startDate, S = c.endDate, E = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return !(p || m || v) || !E || !y && t.isDisabled() ? !1 : p && S && (wi(E, S) || ai(E, S)) ? Es(d, E, S) : m && _ && (zn(E, _) || ai(E, _)) || v && _ && !S && (zn(E, _) || ai(E, _)) ? Es(d, _, E) : !1;
    }), R(t, "isSelectingRangeStart", function() {
      var a;
      if (!t.isInSelectingRange())
        return !1;
      var c = t.props, d = c.day, p = c.startDate, m = c.selectsStart, v = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return m ? Ue(d, v) : Ue(d, p);
    }), R(t, "isSelectingRangeEnd", function() {
      var a;
      if (!t.isInSelectingRange())
        return !1;
      var c = t.props, d = c.day, p = c.endDate, m = c.selectsEnd, v = c.selectsRange, y = (a = t.props.selectingDate) !== null && a !== void 0 ? a : t.props.preSelection;
      return m || v ? Ue(d, y) : Ue(d, p);
    }), R(t, "isRangeStart", function() {
      var a = t.props, c = a.day, d = a.startDate, p = a.endDate;
      return !d || !p ? !1 : Ue(d, c);
    }), R(t, "isRangeEnd", function() {
      var a = t.props, c = a.day, d = a.startDate, p = a.endDate;
      return !d || !p ? !1 : Ue(p, c);
    }), R(t, "isWeekend", function() {
      var a = MS(t.props.day);
      return a === 0 || a === 6;
    }), R(t, "isAfterMonth", function() {
      return t.props.month !== void 0 && (t.props.month + 1) % 12 === Ut(t.props.day);
    }), R(t, "isBeforeMonth", function() {
      return t.props.month !== void 0 && (Ut(t.props.day) + 1) % 12 === t.props.month;
    }), R(t, "isCurrentDay", function() {
      return t.isSameDay(rt());
    }), R(t, "isSelected", function() {
      if (t.props.selectsMultiple) {
        var a;
        return (a = t.props.selectedDates) === null || a === void 0 ? void 0 : a.some(function(c) {
          return t.isSameDayOrWeek(c);
        });
      }
      return t.isSameDayOrWeek(t.props.selected);
    }), R(t, "getClassNames", function(a) {
      var c = t.props.dayClassName ? t.props.dayClassName(a) : void 0;
      return Ot("react-datepicker__day", c, "react-datepicker__day--" + bC(t.props.day), {
        "react-datepicker__day--disabled": t.isDisabled(),
        "react-datepicker__day--excluded": t.isExcluded(),
        "react-datepicker__day--selected": t.isSelected(),
        "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
        "react-datepicker__day--range-start": t.isRangeStart(),
        "react-datepicker__day--range-end": t.isRangeEnd(),
        "react-datepicker__day--in-range": t.isInRange(),
        "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
        "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
        "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
        "react-datepicker__day--today": t.isCurrentDay(),
        "react-datepicker__day--weekend": t.isWeekend(),
        "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
      }, t.getHighLightedClass("react-datepicker__day--highlighted"), t.getHolidaysClass());
    }), R(t, "getAriaLabel", function() {
      var a = t.props, c = a.day, d = a.ariaLabelPrefixWhenEnabled, p = d === void 0 ? "Choose" : d, m = a.ariaLabelPrefixWhenDisabled, v = m === void 0 ? "Not available" : m, y = t.isDisabled() || t.isExcluded() ? v : p;
      return "".concat(y, " ").concat(lt(c, "PPPP", t.props.locale));
    }), R(t, "getTitle", function() {
      var a = t.props, c = a.day, d = a.holidays, p = d === void 0 ? /* @__PURE__ */ new Map() : d, m = a.excludeDates, v = lt(c, "MM.dd.yyyy"), y = [];
      return p.has(v) && y.push.apply(y, Vn(p.get(v).holidayNames)), t.isExcluded() && y.push(m == null ? void 0 : m.filter(function(_) {
        return Ue(_.date ? _.date : _, c);
      }).map(function(_) {
        return _.message;
      })), y.join(", ");
    }), R(t, "getTabIndex", function(a, c) {
      var d = a || t.props.selected, p = c || t.props.preSelection, m = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(d) && Ue(p, d)) ? 0 : -1;
      return m;
    }), R(t, "handleFocusDay", function() {
      var a, c = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, d = !1;
      t.getTabIndex() === 0 && !c.isInputFocused && t.isSameDay(t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (d = !0), t.props.inline && !t.props.shouldFocusDayInline && (d = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (d = !0), t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() && (d = !1), t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() && (d = !1)), d && ((a = t.dayEl.current) === null || a === void 0 || a.focus({
        preventScroll: !0
      }));
    }), R(t, "renderDayContents", function() {
      return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(hf(t.props.day), t.props.day) : hf(t.props.day);
    }), R(t, "render", function() {
      return /* @__PURE__ */ K.createElement("div", {
        ref: t.dayEl,
        className: t.getClassNames(t.props.day),
        onKeyDown: t.handleOnKeyDown,
        onClick: t.handleClick,
        onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter,
        onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0,
        tabIndex: t.getTabIndex(),
        "aria-label": t.getAriaLabel(),
        role: "option",
        title: t.getTitle(),
        "aria-disabled": t.isDisabled(),
        "aria-current": t.isCurrentDay() ? "date" : void 0,
        "aria-selected": t.isSelected() || t.isInRange()
      }, t.renderDayContents(), t.getTitle() !== "" && /* @__PURE__ */ K.createElement("span", {
        className: "overlay"
      }, t.getTitle()));
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      this.handleFocusDay();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      this.handleFocusDay(r);
    }
  }]);
}(K.Component), KC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "weekNumberEl", /* @__PURE__ */ K.createRef()), R(t, "handleClick", function(a) {
      t.props.onClick && t.props.onClick(a);
    }), R(t, "handleOnKeyDown", function(a) {
      var c = a.key;
      c === " " && (a.preventDefault(), a.key = "Enter"), t.props.handleOnKeyDown(a);
    }), R(t, "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !Ue(t.props.date, t.props.selected) && Ue(t.props.date, t.props.preSelection);
    }), R(t, "getTabIndex", function() {
      return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || Ue(t.props.date, t.props.selected) && Ue(t.props.preSelection, t.props.selected)) ? 0 : -1;
    }), R(t, "handleFocusWeekNumber", function() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, c = !1;
      t.getTabIndex() === 0 && !a.isInputFocused && Ue(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (c = !0), t.props.inline && !t.props.shouldFocusDayInline && (c = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (c = !0)), c && t.weekNumberEl.current && t.weekNumberEl.current.focus({
        preventScroll: !0
      });
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      this.handleFocusWeekNumber();
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      this.handleFocusWeekNumber(r);
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.weekNumber, o = r.ariaLabelPrefix, a = o === void 0 ? "week " : o, c = r.onClick, d = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!c,
        "react-datepicker__week-number--selected": !!c && Ue(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ K.createElement("div", {
        ref: this.weekNumberEl,
        className: Ot(d),
        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
        onClick: this.handleClick,
        onKeyDown: this.handleOnKeyDown,
        tabIndex: this.getTabIndex()
      }, i);
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        ariaLabelPrefix: "week "
      };
    }
  }]);
}(K.Component), UC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "handleDayClick", function(a, c) {
      t.props.onDayClick && t.props.onDayClick(a, c);
    }), R(t, "handleDayMouseEnter", function(a) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
    }), R(t, "handleWeekClick", function(a, c, d) {
      typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(a, c, d), t.props.showWeekPicker && t.handleDayClick(a, d), t.props.shouldCloseOnSelect && t.props.setOpen(!1);
    }), R(t, "formatWeekNumber", function(a) {
      return t.props.formatWeekNumber ? t.props.formatWeekNumber(a) : yC(a);
    }), R(t, "renderDays", function() {
      var a = t.startOfWeek(), c = [], d = t.formatWeekNumber(a);
      if (t.props.showWeekNumber) {
        var p = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, a, d) : void 0;
        c.push(/* @__PURE__ */ K.createElement(KC, {
          key: "W",
          weekNumber: d,
          date: a,
          onClick: p,
          selected: t.props.selected,
          preSelection: t.props.preSelection,
          ariaLabelPrefix: t.props.ariaLabelPrefix,
          showWeekPicker: t.props.showWeekPicker,
          showWeekNumber: t.props.showWeekNumber,
          disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
          handleOnKeyDown: t.props.handleOnKeyDown,
          isInputFocused: t.props.isInputFocused,
          containerRef: t.props.containerRef
        }));
      }
      return c.concat([0, 1, 2, 3, 4, 5, 6].map(function(m) {
        var v = Kn(a, m);
        return /* @__PURE__ */ K.createElement(qC, {
          ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix,
          ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix,
          key: v.valueOf(),
          day: v,
          month: t.props.month,
          onClick: t.handleDayClick.bind(t, v),
          usePointerEvent: t.props.usePointerEvent,
          onMouseEnter: t.handleDayMouseEnter.bind(t, v),
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          calendarStartDay: t.props.calendarStartDay,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDates: t.props.includeDates,
          includeDateIntervals: t.props.includeDateIntervals,
          highlightDates: t.props.highlightDates,
          holidays: t.props.holidays,
          selectingDate: t.props.selectingDate,
          filterDate: t.props.filterDate,
          preSelection: t.props.preSelection,
          selected: t.props.selected,
          selectsStart: t.props.selectsStart,
          selectsEnd: t.props.selectsEnd,
          selectsRange: t.props.selectsRange,
          showWeekPicker: t.props.showWeekPicker,
          showWeekNumber: t.props.showWeekNumber,
          selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange,
          selectsMultiple: t.props.selectsMultiple,
          selectedDates: t.props.selectedDates,
          startDate: t.props.startDate,
          endDate: t.props.endDate,
          dayClassName: t.props.dayClassName,
          renderDayContents: t.props.renderDayContents,
          disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
          handleOnKeyDown: t.props.handleOnKeyDown,
          isInputFocused: t.props.isInputFocused,
          containerRef: t.props.containerRef,
          inline: t.props.inline,
          shouldFocusDayInline: t.props.shouldFocusDayInline,
          monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd,
          monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart,
          locale: t.props.locale
        });
      }));
    }), R(t, "startOfWeek", function() {
      return Rn(t.props.day, t.props.locale, t.props.calendarStartDay);
    }), R(t, "isKeyboardSelected", function() {
      return !t.props.disabledKeyboardNavigation && !Ue(t.startOfWeek(), t.props.selected) && Ue(t.startOfWeek(), t.props.preSelection);
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": Ue(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return /* @__PURE__ */ K.createElement("div", {
        className: Ot(r)
      }, this.renderDays());
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        shouldCloseOnSelect: !0
      };
    }
  }]);
}(K.Component), QC = 6, zi = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, Cl = R(R(R({}, zi.TWO_COLUMNS, {
  grid: [[0, 1], [2, 3], [4, 5], [6, 7], [8, 9], [10, 11]],
  verticalNavigationOffset: 2
}), zi.THREE_COLUMNS, {
  grid: [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]],
  verticalNavigationOffset: 3
}), zi.FOUR_COLUMNS, {
  grid: [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]],
  verticalNavigationOffset: 4
}), Eo = 1;
function Ff(e, n) {
  return e ? zi.FOUR_COLUMNS : n ? zi.TWO_COLUMNS : zi.THREE_COLUMNS;
}
var XC = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "MONTH_REFS", Vn(Array(12)).map(function() {
      return /* @__PURE__ */ K.createRef();
    })), R(t, "QUARTER_REFS", Vn(Array(4)).map(function() {
      return /* @__PURE__ */ K.createRef();
    })), R(t, "isDisabled", function(a) {
      return za(a, t.props);
    }), R(t, "isExcluded", function(a) {
      return fu(a, t.props);
    }), R(t, "handleDayClick", function(a, c) {
      t.props.onDayClick && t.props.onDayClick(a, c, t.props.orderInDisplay);
    }), R(t, "handleDayMouseEnter", function(a) {
      t.props.onDayMouseEnter && t.props.onDayMouseEnter(a);
    }), R(t, "handleMouseLeave", function() {
      t.props.onMouseLeave && t.props.onMouseLeave();
    }), R(t, "isRangeStartMonth", function(a) {
      var c = t.props, d = c.day, p = c.startDate, m = c.endDate;
      return !p || !m ? !1 : ar(Kt(d, a), p);
    }), R(t, "isRangeStartQuarter", function(a) {
      var c = t.props, d = c.day, p = c.startDate, m = c.endDate;
      return !p || !m ? !1 : ga(Li(d, a), p);
    }), R(t, "isRangeEndMonth", function(a) {
      var c = t.props, d = c.day, p = c.startDate, m = c.endDate;
      return !p || !m ? !1 : ar(Kt(d, a), m);
    }), R(t, "isRangeEndQuarter", function(a) {
      var c = t.props, d = c.day, p = c.startDate, m = c.endDate;
      return !p || !m ? !1 : ga(Li(d, a), m);
    }), R(t, "isInSelectingRangeMonth", function(a) {
      var c, d = t.props, p = d.day, m = d.selectsStart, v = d.selectsEnd, y = d.selectsRange, _ = d.startDate, S = d.endDate, E = (c = t.props.selectingDate) !== null && c !== void 0 ? c : t.props.preSelection;
      return !(m || v || y) || !E ? !1 : m && S ? ko(E, S, a, p) : v && _ || y && _ && !S ? ko(_, E, a, p) : !1;
    }), R(t, "isSelectingMonthRangeStart", function(a) {
      var c;
      if (!t.isInSelectingRangeMonth(a))
        return !1;
      var d = t.props, p = d.day, m = d.startDate, v = d.selectsStart, y = Kt(p, a), _ = (c = t.props.selectingDate) !== null && c !== void 0 ? c : t.props.preSelection;
      return v ? ar(y, _) : ar(y, m);
    }), R(t, "isSelectingMonthRangeEnd", function(a) {
      var c;
      if (!t.isInSelectingRangeMonth(a))
        return !1;
      var d = t.props, p = d.day, m = d.endDate, v = d.selectsEnd, y = d.selectsRange, _ = Kt(p, a), S = (c = t.props.selectingDate) !== null && c !== void 0 ? c : t.props.preSelection;
      return v || y ? ar(_, S) : ar(_, m);
    }), R(t, "isInSelectingRangeQuarter", function(a) {
      var c, d = t.props, p = d.day, m = d.selectsStart, v = d.selectsEnd, y = d.selectsRange, _ = d.startDate, S = d.endDate, E = (c = t.props.selectingDate) !== null && c !== void 0 ? c : t.props.preSelection;
      return !(m || v || y) || !E ? !1 : m && S ? Do(E, S, a, p) : v && _ || y && _ && !S ? Do(_, E, a, p) : !1;
    }), R(t, "isWeekInMonth", function(a) {
      var c = t.props.day, d = Kn(a, 6);
      return ar(a, c) || ar(d, c);
    }), R(t, "isCurrentMonth", function(a, c) {
      return He(a) === He(rt()) && c === Ut(rt());
    }), R(t, "isCurrentQuarter", function(a, c) {
      return He(a) === He(rt()) && c === fi(rt());
    }), R(t, "isSelectedMonth", function(a, c, d) {
      return Ut(d) === c && He(a) === He(d);
    }), R(t, "isSelectedQuarter", function(a, c, d) {
      return fi(a) === c && He(a) === He(d);
    }), R(t, "renderWeeks", function() {
      for (var a = [], c = t.props.fixedHeight, d = 0, p = !1, m = Rn(An(t.props.day), t.props.locale, t.props.calendarStartDay), v = t.props.showWeekPicker ? Rn(t.props.selected, t.props.locale, t.props.calendarStartDay) : t.props.selected, y = t.props.showWeekPicker ? Rn(t.props.preSelection, t.props.locale, t.props.calendarStartDay) : t.props.preSelection; a.push(/* @__PURE__ */ K.createElement(UC, {
        ariaLabelPrefix: t.props.weekAriaLabelPrefix,
        chooseDayAriaLabelPrefix: t.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: t.props.disabledDayAriaLabelPrefix,
        key: d,
        day: m,
        month: Ut(t.props.day),
        onDayClick: t.handleDayClick,
        usePointerEvent: t.props.usePointerEvent,
        onDayMouseEnter: t.handleDayMouseEnter,
        onWeekSelect: t.props.onWeekSelect,
        formatWeekNumber: t.props.formatWeekNumber,
        locale: t.props.locale,
        minDate: t.props.minDate,
        maxDate: t.props.maxDate,
        excludeDates: t.props.excludeDates,
        excludeDateIntervals: t.props.excludeDateIntervals,
        includeDates: t.props.includeDates,
        includeDateIntervals: t.props.includeDateIntervals,
        inline: t.props.inline,
        shouldFocusDayInline: t.props.shouldFocusDayInline,
        highlightDates: t.props.highlightDates,
        holidays: t.props.holidays,
        selectingDate: t.props.selectingDate,
        filterDate: t.props.filterDate,
        preSelection: y,
        selected: v,
        selectsStart: t.props.selectsStart,
        selectsEnd: t.props.selectsEnd,
        selectsRange: t.props.selectsRange,
        selectsDisabledDaysInRange: t.props.selectsDisabledDaysInRange,
        selectsMultiple: t.props.selectsMultiple,
        selectedDates: t.props.selectedDates,
        showWeekNumber: t.props.showWeekNumbers,
        showWeekPicker: t.props.showWeekPicker,
        startDate: t.props.startDate,
        endDate: t.props.endDate,
        dayClassName: t.props.dayClassName,
        setOpen: t.props.setOpen,
        shouldCloseOnSelect: t.props.shouldCloseOnSelect,
        disabledKeyboardNavigation: t.props.disabledKeyboardNavigation,
        renderDayContents: t.props.renderDayContents,
        handleOnKeyDown: t.props.handleOnKeyDown,
        isInputFocused: t.props.isInputFocused,
        containerRef: t.props.containerRef,
        calendarStartDay: t.props.calendarStartDay,
        monthShowsDuplicateDaysEnd: t.props.monthShowsDuplicateDaysEnd,
        monthShowsDuplicateDaysStart: t.props.monthShowsDuplicateDaysStart
      })), !p; ) {
        d++, m = ca(m, 1);
        var _ = c && d >= QC, S = !c && !t.isWeekInMonth(m);
        if (_ || S)
          if (t.props.peekNextMonth)
            p = !0;
          else
            break;
      }
      return a;
    }), R(t, "onMonthClick", function(a, c) {
      var d = Kt(t.props.day, c);
      Bo(d, t.props) || t.handleDayClick(An(d), a);
    }), R(t, "onMonthMouseEnter", function(a) {
      var c = Kt(t.props.day, a);
      Bo(c, t.props) || t.handleDayMouseEnter(An(c));
    }), R(t, "handleMonthNavigation", function(a, c) {
      t.isDisabled(c) || t.isExcluded(c) || (t.props.setPreSelection(c), t.MONTH_REFS[a].current && t.MONTH_REFS[a].current.focus());
    }), R(t, "onMonthKeyDown", function(a, c) {
      var d = t.props, p = d.selected, m = d.preSelection, v = d.disabledKeyboardNavigation, y = d.showTwoColumnMonthYearPicker, _ = d.showFourColumnMonthYearPicker, S = d.setPreSelection, E = d.handleOnMonthKeyDown, Y = a.key;
      if (Y !== "Tab" && a.preventDefault(), !v) {
        var N = Ff(_, y), I = Cl[N].verticalNavigationOffset, Q = Cl[N].grid;
        switch (Y) {
          case "Enter":
            t.onMonthClick(a, c), S(p);
            break;
          case "ArrowRight":
            t.handleMonthNavigation(c === 11 ? 0 : c + Eo, Dr(m, Eo));
            break;
          case "ArrowLeft":
            t.handleMonthNavigation(c === 0 ? 11 : c - Eo, Ui(m, Eo));
            break;
          case "ArrowUp":
            t.handleMonthNavigation(
              // Check if month on the first row
              Q[0].includes(c) ? c + 12 - I : c - I,
              Ui(m, I)
            );
            break;
          case "ArrowDown":
            t.handleMonthNavigation(
              // Check if month on the last row
              Q[Q.length - 1].includes(c) ? c - 12 + I : c + I,
              Dr(m, I)
            );
            break;
        }
      }
      E && E(a);
    }), R(t, "onQuarterClick", function(a, c) {
      var d = Li(t.props.day, c);
      kl(d, t.props) || t.handleDayClick(wf(d), a);
    }), R(t, "onQuarterMouseEnter", function(a) {
      var c = Li(t.props.day, a);
      kl(c, t.props) || t.handleDayMouseEnter(wf(c));
    }), R(t, "handleQuarterNavigation", function(a, c) {
      t.isDisabled(c) || t.isExcluded(c) || (t.props.setPreSelection(c), t.QUARTER_REFS[a - 1].current && t.QUARTER_REFS[a - 1].current.focus());
    }), R(t, "onQuarterKeyDown", function(a, c) {
      var d = a.key;
      if (!t.props.disabledKeyboardNavigation)
        switch (d) {
          case "Enter":
            t.onQuarterClick(a, c), t.props.setPreSelection(t.props.selected);
            break;
          case "ArrowRight":
            t.handleQuarterNavigation(c === 4 ? 1 : c + 1, lu(t.props.preSelection, 1));
            break;
          case "ArrowLeft":
            t.handleQuarterNavigation(c === 1 ? 4 : c - 1, zh(t.props.preSelection, 1));
            break;
        }
    }), R(t, "isMonthDisabled", function(a) {
      var c = t.props, d = c.day, p = c.minDate, m = c.maxDate, v = c.excludeDates, y = c.includeDates, _ = Kt(d, a);
      return (p || m || v || y) && Bo(_, t.props);
    }), R(t, "getMonthClassNames", function(a) {
      var c = t.props, d = c.day, p = c.startDate, m = c.endDate, v = c.selected, y = c.preSelection, _ = c.monthClassName, S = _ ? _(Kt(d, a)) : void 0;
      return Ot("react-datepicker__month-text", "react-datepicker__month-".concat(a), S, {
        "react-datepicker__month-text--disabled": t.isMonthDisabled(a),
        "react-datepicker__month-text--selected": t.isSelectedMonth(d, a, v),
        "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && t.isSelectedMonth(d, a, y),
        "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(a),
        "react-datepicker__month-text--in-range": ko(p, m, a, d),
        "react-datepicker__month-text--range-start": t.isRangeStartMonth(a),
        "react-datepicker__month-text--range-end": t.isRangeEndMonth(a),
        "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(a),
        "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(a),
        "react-datepicker__month-text--today": t.isCurrentMonth(d, a)
      });
    }), R(t, "getTabIndex", function(a) {
      var c = Ut(t.props.preSelection), d = !t.props.disabledKeyboardNavigation && a === c ? "0" : "-1";
      return d;
    }), R(t, "getQuarterTabIndex", function(a) {
      var c = fi(t.props.preSelection), d = !t.props.disabledKeyboardNavigation && a === c ? "0" : "-1";
      return d;
    }), R(t, "getAriaLabel", function(a) {
      var c = t.props, d = c.chooseDayAriaLabelPrefix, p = d === void 0 ? "Choose" : d, m = c.disabledDayAriaLabelPrefix, v = m === void 0 ? "Not available" : m, y = c.day, _ = c.locale, S = Kt(y, a), E = t.isDisabled(S) || t.isExcluded(S) ? v : p;
      return "".concat(E, " ").concat(lt(S, "MMMM yyyy", _));
    }), R(t, "getQuarterClassNames", function(a) {
      var c = t.props, d = c.day, p = c.startDate, m = c.endDate, v = c.selected, y = c.minDate, _ = c.maxDate, S = c.preSelection, E = c.disabledKeyboardNavigation;
      return Ot("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(a), {
        "react-datepicker__quarter-text--disabled": (y || _) && kl(Li(d, a), t.props),
        "react-datepicker__quarter-text--selected": t.isSelectedQuarter(d, a, v),
        "react-datepicker__quarter-text--keyboard-selected": !E && t.isSelectedQuarter(d, a, S),
        "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(a),
        "react-datepicker__quarter-text--in-range": Do(p, m, a, d),
        "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(a),
        "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(a)
      });
    }), R(t, "getMonthContent", function(a) {
      var c = t.props, d = c.showFullMonthYearPicker, p = c.renderMonthContent, m = c.locale, v = c.day, y = Uh(a, m), _ = du(a, m);
      return p ? p(a, y, _, v) : d ? _ : y;
    }), R(t, "getQuarterContent", function(a) {
      var c = t.props, d = c.renderQuarterContent, p = c.locale, m = DC(a, p);
      return d ? d(a, m) : m;
    }), R(t, "renderMonths", function() {
      var a = t.props, c = a.showTwoColumnMonthYearPicker, d = a.showFourColumnMonthYearPicker, p = a.day, m = a.selected, v = Cl[Ff(d, c)].grid;
      return v.map(function(y, _) {
        return /* @__PURE__ */ K.createElement("div", {
          className: "react-datepicker__month-wrapper",
          key: _
        }, y.map(function(S, E) {
          return /* @__PURE__ */ K.createElement("div", {
            ref: t.MONTH_REFS[S],
            key: E,
            onClick: function(N) {
              t.onMonthClick(N, S);
            },
            onKeyDown: function(N) {
              Jh(N) && (N.preventDefault(), N.key = "Enter"), t.onMonthKeyDown(N, S);
            },
            onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(S);
            },
            onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(S);
            } : void 0,
            tabIndex: t.getTabIndex(S),
            className: t.getMonthClassNames(S),
            "aria-disabled": t.isMonthDisabled(S),
            role: "option",
            "aria-label": t.getAriaLabel(S),
            "aria-current": t.isCurrentMonth(p, S) ? "date" : void 0,
            "aria-selected": t.isSelectedMonth(p, S, m)
          }, t.getMonthContent(S));
        }));
      });
    }), R(t, "renderQuarters", function() {
      var a = t.props, c = a.day, d = a.selected, p = [1, 2, 3, 4];
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__quarter-wrapper"
      }, p.map(function(m, v) {
        return /* @__PURE__ */ K.createElement("div", {
          key: v,
          ref: t.QUARTER_REFS[v],
          role: "option",
          onClick: function(_) {
            t.onQuarterClick(_, m);
          },
          onKeyDown: function(_) {
            t.onQuarterKeyDown(_, m);
          },
          onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(m);
          },
          onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(m);
          } : void 0,
          className: t.getQuarterClassNames(m),
          "aria-selected": t.isSelectedQuarter(c, m, d),
          tabIndex: t.getQuarterTabIndex(m),
          "aria-current": t.isCurrentQuarter(c, m) ? "date" : void 0
        }, t.getQuarterContent(m));
      }));
    }), R(t, "getClassNames", function() {
      var a = t.props, c = a.selectingDate, d = a.selectsStart, p = a.selectsEnd, m = a.showMonthYearPicker, v = a.showQuarterYearPicker, y = a.showWeekPicker;
      return Ot("react-datepicker__month", {
        "react-datepicker__month--selecting-range": c && (d || p)
      }, {
        "react-datepicker__monthPicker": m
      }, {
        "react-datepicker__quarterPicker": v
      }, {
        "react-datepicker__weekPicker": y
      });
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.showMonthYearPicker, o = r.showQuarterYearPicker, a = r.day, c = r.ariaLabelPrefix, d = c === void 0 ? "Month " : c, p = d ? d.trim() + " " : "";
      return /* @__PURE__ */ K.createElement("div", {
        className: this.getClassNames(),
        onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave,
        onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0,
        "aria-label": "".concat(p).concat(lt(a, "MMMM, yyyy", this.props.locale)),
        role: "listbox"
      }, i ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks());
    }
  }]);
}(K.Component), eg = /* @__PURE__ */ function(e) {
  function n() {
    var t;
    $t(this, n);
    for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    return t = Mt(this, n, [].concat(i)), R(t, "state", {
      height: null
    }), R(t, "scrollToTheSelectedTime", function() {
      requestAnimationFrame(function() {
        t.list && (t.list.scrollTop = t.centerLi && n.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - t.header.clientHeight : t.list.clientHeight, t.centerLi));
      });
    }), R(t, "handleClick", function(a) {
      (t.props.minTime || t.props.maxTime) && Cf(a, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && kf(a, t.props) || t.props.onChange(a);
    }), R(t, "isSelectedTime", function(a) {
      return t.props.selected && FC(t.props.selected, a);
    }), R(t, "isDisabledTime", function(a) {
      return (t.props.minTime || t.props.maxTime) && Cf(a, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && kf(a, t.props);
    }), R(t, "liClasses", function(a) {
      var c = ["react-datepicker__time-list-item", t.props.timeClassName ? t.props.timeClassName(a) : void 0];
      return t.isSelectedTime(a) && c.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(a) && c.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (Yr(a) * 3600 + Vr(a) * 60 + sn(a)) % (t.props.intervals * 60) !== 0 && c.push("react-datepicker__time-list-item--injected"), c.join(" ");
    }), R(t, "handleOnKeyDown", function(a, c) {
      a.key === " " && (a.preventDefault(), a.key = "Enter"), (a.key === "ArrowUp" || a.key === "ArrowLeft") && a.target.previousSibling && (a.preventDefault(), a.target.previousSibling.focus()), (a.key === "ArrowDown" || a.key === "ArrowRight") && a.target.nextSibling && (a.preventDefault(), a.target.nextSibling.focus()), a.key === "Enter" && t.handleClick(c), t.props.handleOnKeyDown(a);
    }), R(t, "renderTimes", function() {
      for (var a = [], c = t.props.format ? t.props.format : "p", d = t.props.intervals, p = t.props.selected || t.props.openToDate || rt(), m = wC(p), v = t.props.injectTimes && t.props.injectTimes.sort(function(I, Q) {
        return I - Q;
      }), y = 60 * AC(p), _ = y / d, S = 0; S < _; S++) {
        var E = sc(m, S * d);
        if (a.push(E), v) {
          var Y = RC(m, E, S, d, v);
          a = a.concat(Y);
        }
      }
      var N = a.reduce(function(I, Q) {
        return Q.getTime() <= p.getTime() ? Q : I;
      }, a[0]);
      return a.map(function(I, Q) {
        return /* @__PURE__ */ K.createElement("li", {
          key: Q,
          onClick: t.handleClick.bind(t, I),
          className: t.liClasses(I),
          ref: function(ie) {
            I === N && (t.centerLi = ie);
          },
          onKeyDown: function(ie) {
            t.handleOnKeyDown(ie, I);
          },
          tabIndex: I === N ? 0 : -1,
          role: "option",
          "aria-selected": t.isSelectedTime(I) ? "true" : void 0,
          "aria-disabled": t.isDisabledTime(I) ? "true" : void 0
        }, lt(I, c, t.props.locale));
      });
    }), t;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.state.height;
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
        ref: function(a) {
          r.header = a;
        }
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker-time__header"
      }, this.props.timeCaption)), /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__time"
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__time-box"
      }, /* @__PURE__ */ K.createElement("ul", {
        className: "react-datepicker__time-list",
        ref: function(a) {
          r.list = a;
        },
        style: i ? {
          height: i
        } : {},
        role: "listbox",
        "aria-label": this.props.timeCaption
      }, this.renderTimes()))));
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        intervals: 30,
        onTimeChange: function() {
        },
        todayButton: null,
        timeCaption: "Time"
      };
    }
  }]);
}(K.Component);
R(eg, "calcCenterPosition", function(e, n) {
  return n.offsetTop - (e / 2 - n.clientHeight / 2);
});
var Of = 3, ZC = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), R(r, "YEAR_REFS", Vn(Array(r.props.yearItemNumber)).map(function() {
      return /* @__PURE__ */ K.createRef();
    })), R(r, "isDisabled", function(i) {
      return za(i, r.props);
    }), R(r, "isExcluded", function(i) {
      return fu(i, r.props);
    }), R(r, "selectingDate", function() {
      var i;
      return (i = r.props.selectingDate) !== null && i !== void 0 ? i : r.props.preSelection;
    }), R(r, "updateFocusOnPaginate", function(i) {
      var o = (function() {
        this.YEAR_REFS[i].current.focus();
      }).bind(r);
      window.requestAnimationFrame(o);
    }), R(r, "handleYearClick", function(i, o) {
      r.props.onDayClick && r.props.onDayClick(i, o);
    }), R(r, "handleYearNavigation", function(i, o) {
      var a = r.props, c = a.date, d = a.yearItemNumber, p = Pn(c, d), m = p.startPeriod;
      r.isDisabled(o) || r.isExcluded(o) || (r.props.setPreSelection(o), i - m < 0 ? r.updateFocusOnPaginate(d - (m - i)) : i - m >= d ? r.updateFocusOnPaginate(Math.abs(d - (i - m))) : r.YEAR_REFS[i - m].current.focus());
    }), R(r, "isSameDay", function(i, o) {
      return Ue(i, o);
    }), R(r, "isCurrentYear", function(i) {
      return i === He(rt());
    }), R(r, "isRangeStart", function(i) {
      return r.props.startDate && r.props.endDate && Or(Ar(rt(), i), r.props.startDate);
    }), R(r, "isRangeEnd", function(i) {
      return r.props.startDate && r.props.endDate && Or(Ar(rt(), i), r.props.endDate);
    }), R(r, "isInRange", function(i) {
      return Co(i, r.props.startDate, r.props.endDate);
    }), R(r, "isInSelectingRange", function(i) {
      var o = r.props, a = o.selectsStart, c = o.selectsEnd, d = o.selectsRange, p = o.startDate, m = o.endDate;
      return !(a || c || d) || !r.selectingDate() ? !1 : a && m ? Co(i, r.selectingDate(), m) : c && p || d && p && !m ? Co(i, p, r.selectingDate()) : !1;
    }), R(r, "isSelectingRangeStart", function(i) {
      if (!r.isInSelectingRange(i))
        return !1;
      var o = r.props, a = o.startDate, c = o.selectsStart, d = Ar(rt(), i);
      return c ? Or(d, r.selectingDate()) : Or(d, a);
    }), R(r, "isSelectingRangeEnd", function(i) {
      if (!r.isInSelectingRange(i))
        return !1;
      var o = r.props, a = o.endDate, c = o.selectsEnd, d = o.selectsRange, p = Ar(rt(), i);
      return c || d ? Or(p, r.selectingDate()) : Or(p, a);
    }), R(r, "isKeyboardSelected", function(i) {
      var o = Ds(Ar(r.props.date, i));
      return !r.props.disabledKeyboardNavigation && !r.props.inline && !Ue(o, Ds(r.props.selected)) && Ue(o, Ds(r.props.preSelection));
    }), R(r, "onYearClick", function(i, o) {
      var a = r.props.date;
      r.handleYearClick(Ds(Ar(a, o)), i);
    }), R(r, "onYearKeyDown", function(i, o) {
      var a = i.key, c = r.props, d = c.date, p = c.yearItemNumber, m = c.handleOnKeyDown;
      if (a !== "Tab" && i.preventDefault(), !r.props.disabledKeyboardNavigation)
        switch (a) {
          case "Enter":
            r.onYearClick(i, o), r.props.setPreSelection(r.props.selected);
            break;
          case "ArrowRight":
            r.handleYearNavigation(o + 1, nn(r.props.preSelection, 1));
            break;
          case "ArrowLeft":
            r.handleYearNavigation(o - 1, Qi(r.props.preSelection, 1));
            break;
          case "ArrowUp": {
            var v = Pn(d, p), y = v.startPeriod, _ = Of, S = o - _;
            if (S < y) {
              var E = p % _;
              o >= y && o < y + E ? _ = E : _ += E, S = o - _;
            }
            r.handleYearNavigation(S, Qi(r.props.preSelection, _));
            break;
          }
          case "ArrowDown": {
            var Y = Pn(d, p), N = Y.endPeriod, I = Of, Q = o + I;
            if (Q > N) {
              var te = p % I;
              o <= N && o > N - te ? I = te : I += te, Q = o + I;
            }
            r.handleYearNavigation(Q, nn(r.props.preSelection, I));
            break;
          }
        }
      m && m(i);
    }), R(r, "getYearClassNames", function(i) {
      var o = r.props, a = o.date, c = o.minDate, d = o.maxDate, p = o.selected, m = o.excludeDates, v = o.includeDates, y = o.filterDate, _ = o.yearClassName;
      return Ot("react-datepicker__year-text", "react-datepicker__year-".concat(i), _ ? _(Ar(a, i)) : void 0, {
        "react-datepicker__year-text--selected": i === He(p),
        "react-datepicker__year-text--disabled": (c || d || m || v || y) && Qh(i, r.props),
        "react-datepicker__year-text--keyboard-selected": r.isKeyboardSelected(i),
        "react-datepicker__year-text--range-start": r.isRangeStart(i),
        "react-datepicker__year-text--range-end": r.isRangeEnd(i),
        "react-datepicker__year-text--in-range": r.isInRange(i),
        "react-datepicker__year-text--in-selecting-range": r.isInSelectingRange(i),
        "react-datepicker__year-text--selecting-range-start": r.isSelectingRangeStart(i),
        "react-datepicker__year-text--selecting-range-end": r.isSelectingRangeEnd(i),
        "react-datepicker__year-text--today": r.isCurrentYear(i)
      });
    }), R(r, "getYearTabIndex", function(i) {
      if (r.props.disabledKeyboardNavigation)
        return "-1";
      var o = He(r.props.preSelection);
      return i === o ? "0" : "-1";
    }), R(r, "getYearContainerClassNames", function() {
      var i = r.props, o = i.selectingDate, a = i.selectsStart, c = i.selectsEnd, d = i.selectsRange;
      return Ot("react-datepicker__year", {
        "react-datepicker__year--selecting-range": o && (a || c || d)
      });
    }), R(r, "getYearContent", function(i) {
      return r.props.renderYearContent ? r.props.renderYearContent(i) : i;
    }), r;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      for (var r = this, i = [], o = this.props, a = o.date, c = o.yearItemNumber, d = o.onYearMouseEnter, p = o.onYearMouseLeave, m = Pn(a, c), v = m.startPeriod, y = m.endPeriod, _ = function(Y) {
        i.push(/* @__PURE__ */ K.createElement("div", {
          ref: r.YEAR_REFS[Y - v],
          onClick: function(I) {
            r.onYearClick(I, Y);
          },
          onKeyDown: function(I) {
            Jh(I) && (I.preventDefault(), I.key = "Enter"), r.onYearKeyDown(I, Y);
          },
          tabIndex: r.getYearTabIndex(Y),
          className: r.getYearClassNames(Y),
          onMouseEnter: r.props.usePointerEvent ? void 0 : function(N) {
            return d(N, Y);
          },
          onPointerEnter: r.props.usePointerEvent ? function(N) {
            return d(N, Y);
          } : void 0,
          onMouseLeave: r.props.usePointerEvent ? void 0 : function(N) {
            return p(N, Y);
          },
          onPointerLeave: r.props.usePointerEvent ? function(N) {
            return p(N, Y);
          } : void 0,
          key: Y,
          "aria-current": r.isCurrentYear(Y) ? "date" : void 0
        }, r.getYearContent(Y)));
      }, S = v; S <= y; S++)
        _(S);
      return /* @__PURE__ */ K.createElement("div", {
        className: this.getYearContainerClassNames()
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__year-wrapper",
        onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate,
        onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0
      }, i));
    }
  }]);
}(K.Component), JC = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), R(r, "onTimeChange", function(i) {
      r.setState({
        time: i
      });
      var o = r.props.date, a = o instanceof Date && !isNaN(o), c = a ? o : /* @__PURE__ */ new Date();
      c.setHours(i.split(":")[0]), c.setMinutes(i.split(":")[1]), r.props.onChange(c);
    }), R(r, "renderTimeInput", function() {
      var i = r.state.time, o = r.props, a = o.date, c = o.timeString, d = o.customTimeInput;
      return d ? /* @__PURE__ */ K.cloneElement(d, {
        date: a,
        value: i,
        onChange: r.onTimeChange
      }) : /* @__PURE__ */ K.createElement("input", {
        type: "time",
        className: "react-datepicker-time__input",
        placeholder: "Time",
        name: "time-input",
        required: !0,
        value: i,
        onChange: function(m) {
          r.onTimeChange(m.target.value || c);
        }
      });
    }), r.state = {
      time: r.props.timeString
    }, r;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__input-time-container"
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker-time__caption"
      }, this.props.timeInputLabel), /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker-time__input-container"
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker-time__input"
      }, this.renderTimeInput())));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.timeString !== i.time ? {
        time: r.timeString
      } : null;
    }
  }]);
}(K.Component);
function eD(e) {
  var n = e.showTimeSelectOnly, t = n === void 0 ? !1 : n, r = e.showTime, i = r === void 0 ? !1 : r, o = e.className, a = e.children, c = t ? "Choose Time" : "Choose Date".concat(i ? " and Time" : "");
  return /* @__PURE__ */ K.createElement("div", {
    className: o,
    role: "dialog",
    "aria-label": c,
    "aria-modal": "true"
  }, a);
}
var tD = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"], rD = function() {
  var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = (n.className || "").split(/\s+/);
  return tD.some(function(r) {
    return t.indexOf(r) >= 0;
  });
}, nD = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), R(r, "handleClickOutside", function(i) {
      r.props.onClickOutside(i);
    }), R(r, "setClickOutsideRef", function() {
      return r.containerRef.current;
    }), R(r, "handleDropdownFocus", function(i) {
      rD(i.target) && r.props.onDropdownFocus();
    }), R(r, "getDateInView", function() {
      var i = r.props, o = i.preSelection, a = i.selected, c = i.openToDate, d = Xh(r.props), p = Zh(r.props), m = rt(), v = c || a || o;
      return v || (d && wi(m, d) ? d : p && zn(m, p) ? p : m);
    }), R(r, "increaseMonth", function() {
      r.setState(function(i) {
        var o = i.date;
        return {
          date: Dr(o, 1)
        };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), R(r, "decreaseMonth", function() {
      r.setState(function(i) {
        var o = i.date;
        return {
          date: Ui(o, 1)
        };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), R(r, "handleDayClick", function(i, o, a) {
      r.props.onSelect(i, o, a), r.props.setPreSelection && r.props.setPreSelection(i);
    }), R(r, "handleDayMouseEnter", function(i) {
      r.setState({
        selectingDate: i
      }), r.props.onDayMouseEnter && r.props.onDayMouseEnter(i);
    }), R(r, "handleMonthMouseLeave", function() {
      r.setState({
        selectingDate: null
      }), r.props.onMonthMouseLeave && r.props.onMonthMouseLeave();
    }), R(r, "handleYearMouseEnter", function(i, o) {
      r.setState({
        selectingDate: Ar(rt(), o)
      }), r.props.onYearMouseEnter && r.props.onYearMouseEnter(i, o);
    }), R(r, "handleYearMouseLeave", function(i, o) {
      r.props.onYearMouseLeave && r.props.onYearMouseLeave(i, o);
    }), R(r, "handleYearChange", function(i) {
      r.props.onYearChange && (r.props.onYearChange(i), r.setState({
        isRenderAriaLiveMessage: !0
      })), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(i), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(i);
    }), R(r, "handleMonthChange", function(i) {
      r.handleCustomMonthChange(i), r.props.adjustDateOnChange && (r.props.onSelect && r.props.onSelect(i), r.props.setOpen && r.props.setOpen(!0)), r.props.setPreSelection && r.props.setPreSelection(i);
    }), R(r, "handleCustomMonthChange", function(i) {
      r.props.onMonthChange && (r.props.onMonthChange(i), r.setState({
        isRenderAriaLiveMessage: !0
      }));
    }), R(r, "handleMonthYearChange", function(i) {
      r.handleYearChange(i), r.handleMonthChange(i);
    }), R(r, "changeYear", function(i) {
      r.setState(function(o) {
        var a = o.date;
        return {
          date: Ar(a, i)
        };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), R(r, "changeMonth", function(i) {
      r.setState(function(o) {
        var a = o.date;
        return {
          date: Kt(a, i)
        };
      }, function() {
        return r.handleMonthChange(r.state.date);
      });
    }), R(r, "changeMonthYear", function(i) {
      r.setState(function(o) {
        var a = o.date;
        return {
          date: Ar(Kt(a, Ut(i)), He(i))
        };
      }, function() {
        return r.handleMonthYearChange(r.state.date);
      });
    }), R(r, "header", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.state.date, o = Rn(i, r.props.locale, r.props.calendarStartDay), a = [];
      return r.props.showWeekNumbers && a.push(/* @__PURE__ */ K.createElement("div", {
        key: "W",
        className: "react-datepicker__day-name"
      }, r.props.weekLabel || "#")), a.concat([0, 1, 2, 3, 4, 5, 6].map(function(c) {
        var d = Kn(o, c), p = r.formatWeekday(d, r.props.locale), m = r.props.weekDayClassName ? r.props.weekDayClassName(d) : void 0;
        return /* @__PURE__ */ K.createElement("div", {
          key: c,
          "aria-label": lt(d, "EEEE", r.props.locale),
          className: Ot("react-datepicker__day-name", m)
        }, p);
      }));
    }), R(r, "formatWeekday", function(i, o) {
      return r.props.formatWeekDay ? SC(i, r.props.formatWeekDay, o) : r.props.useWeekdaysShort ? CC(i, o) : kC(i, o);
    }), R(r, "decreaseYear", function() {
      r.setState(function(i) {
        var o = i.date;
        return {
          date: Qi(o, r.props.showYearPicker ? r.props.yearItemNumber : 1)
        };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), R(r, "clearSelectingDate", function() {
      r.setState({
        selectingDate: null
      });
    }), R(r, "renderPreviousButton", function() {
      if (!r.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case r.props.showMonthYearPicker:
            i = Pf(r.state.date, r.props);
            break;
          case r.props.showYearPicker:
            i = MC(r.state.date, r.props);
            break;
          case r.props.showQuarterYearPicker:
            i = EC(r.state.date, r.props);
            break;
          default:
            i = Df(r.state.date, r.props);
            break;
        }
        if (!(!r.props.forceShowMonthNavigation && !r.props.showDisabledMonthNavigation && i || r.props.showTimeSelectOnly)) {
          var o = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--previous"], a = ["react-datepicker__navigation", "react-datepicker__navigation--previous"], c = r.decreaseMonth;
          (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (c = r.decreaseYear), i && r.props.showDisabledMonthNavigation && (a.push("react-datepicker__navigation--previous--disabled"), c = null);
          var d = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, p = r.props, m = p.previousMonthButtonLabel, v = p.previousYearButtonLabel, y = r.props, _ = y.previousMonthAriaLabel, S = _ === void 0 ? typeof m == "string" ? m : "Previous Month" : _, E = y.previousYearAriaLabel, Y = E === void 0 ? typeof v == "string" ? v : "Previous Year" : E;
          return /* @__PURE__ */ K.createElement("button", {
            type: "button",
            className: a.join(" "),
            onClick: c,
            onKeyDown: r.props.handleOnKeyDown,
            "aria-label": d ? Y : S
          }, /* @__PURE__ */ K.createElement("span", {
            className: o.join(" ")
          }, d ? r.props.previousYearButtonLabel : r.props.previousMonthButtonLabel));
        }
      }
    }), R(r, "increaseYear", function() {
      r.setState(function(i) {
        var o = i.date;
        return {
          date: nn(o, r.props.showYearPicker ? r.props.yearItemNumber : 1)
        };
      }, function() {
        return r.handleYearChange(r.state.date);
      });
    }), R(r, "renderNextButton", function() {
      if (!r.props.renderCustomHeader) {
        var i;
        switch (!0) {
          case r.props.showMonthYearPicker:
            i = Mf(r.state.date, r.props);
            break;
          case r.props.showYearPicker:
            i = $C(r.state.date, r.props);
            break;
          case r.props.showQuarterYearPicker:
            i = PC(r.state.date, r.props);
            break;
          default:
            i = Ef(r.state.date, r.props);
            break;
        }
        if (!(!r.props.forceShowMonthNavigation && !r.props.showDisabledMonthNavigation && i || r.props.showTimeSelectOnly)) {
          var o = ["react-datepicker__navigation", "react-datepicker__navigation--next"], a = ["react-datepicker__navigation-icon", "react-datepicker__navigation-icon--next"];
          r.props.showTimeSelect && o.push("react-datepicker__navigation--next--with-time"), r.props.todayButton && o.push("react-datepicker__navigation--next--with-today-button");
          var c = r.increaseMonth;
          (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker) && (c = r.increaseYear), i && r.props.showDisabledMonthNavigation && (o.push("react-datepicker__navigation--next--disabled"), c = null);
          var d = r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker, p = r.props, m = p.nextMonthButtonLabel, v = p.nextYearButtonLabel, y = r.props, _ = y.nextMonthAriaLabel, S = _ === void 0 ? typeof m == "string" ? m : "Next Month" : _, E = y.nextYearAriaLabel, Y = E === void 0 ? typeof v == "string" ? v : "Next Year" : E;
          return /* @__PURE__ */ K.createElement("button", {
            type: "button",
            className: o.join(" "),
            onClick: c,
            onKeyDown: r.props.handleOnKeyDown,
            "aria-label": d ? Y : S
          }, /* @__PURE__ */ K.createElement("span", {
            className: a.join(" ")
          }, d ? r.props.nextYearButtonLabel : r.props.nextMonthButtonLabel));
        }
      }
    }), R(r, "renderCurrentMonth", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : r.state.date, o = ["react-datepicker__current-month"];
      return r.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), r.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), r.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), /* @__PURE__ */ K.createElement("div", {
        className: o.join(" ")
      }, lt(i, r.props.dateFormat, r.props.locale));
    }), R(r, "renderYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (!(!r.props.showYearDropdown || i))
        return /* @__PURE__ */ K.createElement(zC, {
          adjustDateOnChange: r.props.adjustDateOnChange,
          date: r.state.date,
          onSelect: r.props.onSelect,
          setOpen: r.props.setOpen,
          dropdownMode: r.props.dropdownMode,
          onChange: r.changeYear,
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          year: He(r.state.date),
          scrollableYearDropdown: r.props.scrollableYearDropdown,
          yearDropdownItemNumber: r.props.yearDropdownItemNumber
        });
    }), R(r, "renderMonthDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (!(!r.props.showMonthDropdown || i))
        return /* @__PURE__ */ K.createElement(HC, {
          dropdownMode: r.props.dropdownMode,
          locale: r.props.locale,
          onChange: r.changeMonth,
          month: Ut(r.state.date),
          useShortMonthInDropdown: r.props.useShortMonthInDropdown
        });
    }), R(r, "renderMonthYearDropdown", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      if (!(!r.props.showMonthYearDropdown || i))
        return /* @__PURE__ */ K.createElement(GC, {
          dropdownMode: r.props.dropdownMode,
          locale: r.props.locale,
          dateFormat: r.props.dateFormat,
          onChange: r.changeMonthYear,
          minDate: r.props.minDate,
          maxDate: r.props.maxDate,
          date: r.state.date,
          scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown
        });
    }), R(r, "handleTodayButtonClick", function(i) {
      r.props.onSelect(xf(), i), r.props.setPreSelection && r.props.setPreSelection(xf());
    }), R(r, "renderTodayButton", function() {
      if (!(!r.props.todayButton || r.props.showTimeSelectOnly))
        return /* @__PURE__ */ K.createElement("div", {
          className: "react-datepicker__today-button",
          onClick: function(o) {
            return r.handleTodayButtonClick(o);
          }
        }, r.props.todayButton);
    }), R(r, "renderDefaultHeader", function(i) {
      var o = i.monthDate, a = i.i;
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__header ".concat(r.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
      }, r.renderCurrentMonth(o), /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(r.props.dropdownMode),
        onFocus: r.handleDropdownFocus
      }, r.renderMonthDropdown(a !== 0), r.renderMonthYearDropdown(a !== 0), r.renderYearDropdown(a !== 0)), /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__day-names"
      }, r.header(o)));
    }), R(r, "renderCustomHeader", function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, o = i.monthDate, a = i.i;
      if (r.props.showTimeSelect && !r.state.monthContainer || r.props.showTimeSelectOnly)
        return null;
      var c = Df(r.state.date, r.props), d = Ef(r.state.date, r.props), p = Pf(r.state.date, r.props), m = Mf(r.state.date, r.props), v = !r.props.showMonthYearPicker && !r.props.showQuarterYearPicker && !r.props.showYearPicker;
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__header react-datepicker__header--custom",
        onFocus: r.props.onDropdownFocus
      }, r.props.renderCustomHeader(Jr(Jr({}, r.state), {}, {
        customHeaderCount: a,
        monthDate: o,
        changeMonth: r.changeMonth,
        changeYear: r.changeYear,
        decreaseMonth: r.decreaseMonth,
        increaseMonth: r.increaseMonth,
        decreaseYear: r.decreaseYear,
        increaseYear: r.increaseYear,
        prevMonthButtonDisabled: c,
        nextMonthButtonDisabled: d,
        prevYearButtonDisabled: p,
        nextYearButtonDisabled: m
      })), v && /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__day-names"
      }, r.header(o)));
    }), R(r, "renderYearHeader", function(i) {
      var o = i.monthDate, a = r.props, c = a.showYearPicker, d = a.yearItemNumber, p = Pn(o, d), m = p.startPeriod, v = p.endPeriod;
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__header react-datepicker-year-header"
      }, c ? "".concat(m, " - ").concat(v) : He(o));
    }), R(r, "renderHeader", function(i) {
      switch (!0) {
        case r.props.renderCustomHeader !== void 0:
          return r.renderCustomHeader(i);
        case (r.props.showMonthYearPicker || r.props.showQuarterYearPicker || r.props.showYearPicker):
          return r.renderYearHeader(i);
        default:
          return r.renderDefaultHeader(i);
      }
    }), R(r, "renderMonths", function() {
      var i;
      if (!(r.props.showTimeSelectOnly || r.props.showYearPicker)) {
        for (var o = [], a = r.props.showPreviousMonths ? r.props.monthsShown - 1 : 0, c = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? nn(r.state.date, a) : Ui(r.state.date, a), d = (i = r.props.monthSelectedIn) !== null && i !== void 0 ? i : a, p = 0; p < r.props.monthsShown; ++p) {
          var m = p - d + a, v = r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? nn(c, m) : Dr(c, m), y = "month-".concat(p), _ = p < r.props.monthsShown - 1, S = p > 0;
          o.push(/* @__PURE__ */ K.createElement("div", {
            key: y,
            ref: function(Y) {
              r.monthContainer = Y;
            },
            className: "react-datepicker__month-container"
          }, r.renderHeader({
            monthDate: v,
            i: p
          }), /* @__PURE__ */ K.createElement(XC, {
            chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
            disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
            weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
            ariaLabelPrefix: r.props.monthAriaLabelPrefix,
            onChange: r.changeMonthYear,
            day: v,
            dayClassName: r.props.dayClassName,
            calendarStartDay: r.props.calendarStartDay,
            monthClassName: r.props.monthClassName,
            onDayClick: r.handleDayClick,
            handleOnKeyDown: r.props.handleOnDayKeyDown,
            handleOnMonthKeyDown: r.props.handleOnKeyDown,
            usePointerEvent: r.props.usePointerEvent,
            onDayMouseEnter: r.handleDayMouseEnter,
            onMouseLeave: r.handleMonthMouseLeave,
            onWeekSelect: r.props.onWeekSelect,
            orderInDisplay: p,
            formatWeekNumber: r.props.formatWeekNumber,
            locale: r.props.locale,
            minDate: r.props.minDate,
            maxDate: r.props.maxDate,
            excludeDates: r.props.excludeDates,
            excludeDateIntervals: r.props.excludeDateIntervals,
            highlightDates: r.props.highlightDates,
            holidays: r.props.holidays,
            selectingDate: r.state.selectingDate,
            includeDates: r.props.includeDates,
            includeDateIntervals: r.props.includeDateIntervals,
            inline: r.props.inline,
            shouldFocusDayInline: r.props.shouldFocusDayInline,
            fixedHeight: r.props.fixedHeight,
            filterDate: r.props.filterDate,
            preSelection: r.props.preSelection,
            setPreSelection: r.props.setPreSelection,
            selected: r.props.selected,
            selectsStart: r.props.selectsStart,
            selectsEnd: r.props.selectsEnd,
            selectsRange: r.props.selectsRange,
            selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
            selectsMultiple: r.props.selectsMultiple,
            selectedDates: r.props.selectedDates,
            showWeekNumbers: r.props.showWeekNumbers,
            startDate: r.props.startDate,
            endDate: r.props.endDate,
            peekNextMonth: r.props.peekNextMonth,
            setOpen: r.props.setOpen,
            shouldCloseOnSelect: r.props.shouldCloseOnSelect,
            renderDayContents: r.props.renderDayContents,
            renderMonthContent: r.props.renderMonthContent,
            renderQuarterContent: r.props.renderQuarterContent,
            renderYearContent: r.props.renderYearContent,
            disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
            showMonthYearPicker: r.props.showMonthYearPicker,
            showFullMonthYearPicker: r.props.showFullMonthYearPicker,
            showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
            showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
            showYearPicker: r.props.showYearPicker,
            showQuarterYearPicker: r.props.showQuarterYearPicker,
            showWeekPicker: r.props.showWeekPicker,
            isInputFocused: r.props.isInputFocused,
            containerRef: r.containerRef,
            monthShowsDuplicateDaysEnd: _,
            monthShowsDuplicateDaysStart: S
          })));
        }
        return o;
      }
    }), R(r, "renderYears", function() {
      if (!r.props.showTimeSelectOnly && r.props.showYearPicker)
        return /* @__PURE__ */ K.createElement("div", {
          className: "react-datepicker__year--container"
        }, r.renderHeader({
          monthDate: r.state.date
        }), /* @__PURE__ */ K.createElement(ZC, Hs({
          onDayClick: r.handleDayClick,
          selectingDate: r.state.selectingDate,
          clearSelectingDate: r.clearSelectingDate,
          date: r.state.date
        }, r.props, {
          onYearMouseEnter: r.handleYearMouseEnter,
          onYearMouseLeave: r.handleYearMouseLeave
        })));
    }), R(r, "renderTimeSection", function() {
      if (r.props.showTimeSelect && (r.state.monthContainer || r.props.showTimeSelectOnly))
        return /* @__PURE__ */ K.createElement(eg, {
          selected: r.props.selected,
          openToDate: r.props.openToDate,
          onChange: r.props.onTimeChange,
          timeClassName: r.props.timeClassName,
          format: r.props.timeFormat,
          includeTimes: r.props.includeTimes,
          intervals: r.props.timeIntervals,
          minTime: r.props.minTime,
          maxTime: r.props.maxTime,
          excludeTimes: r.props.excludeTimes,
          filterTime: r.props.filterTime,
          timeCaption: r.props.timeCaption,
          todayButton: r.props.todayButton,
          showMonthDropdown: r.props.showMonthDropdown,
          showMonthYearDropdown: r.props.showMonthYearDropdown,
          showYearDropdown: r.props.showYearDropdown,
          withPortal: r.props.withPortal,
          monthRef: r.state.monthContainer,
          injectTimes: r.props.injectTimes,
          locale: r.props.locale,
          handleOnKeyDown: r.props.handleOnKeyDown,
          showTimeSelectOnly: r.props.showTimeSelectOnly
        });
    }), R(r, "renderInputTimeSection", function() {
      var i = new Date(r.props.selected), o = Cn(i) && !!r.props.selected, a = o ? "".concat(Tf(i.getHours()), ":").concat(Tf(i.getMinutes())) : "";
      if (r.props.showTimeInput)
        return /* @__PURE__ */ K.createElement(JC, {
          date: i,
          timeString: a,
          timeInputLabel: r.props.timeInputLabel,
          onChange: r.props.onTimeChange,
          customTimeInput: r.props.customTimeInput
        });
    }), R(r, "renderAriaLiveRegion", function() {
      var i = Pn(r.state.date, r.props.yearItemNumber), o = i.startPeriod, a = i.endPeriod, c;
      return r.props.showYearPicker ? c = "".concat(o, " - ").concat(a) : r.props.showMonthYearPicker || r.props.showQuarterYearPicker ? c = He(r.state.date) : c = "".concat(du(Ut(r.state.date), r.props.locale), " ").concat(He(r.state.date)), /* @__PURE__ */ K.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, r.state.isRenderAriaLiveMessage && c);
    }), R(r, "renderChildren", function() {
      if (r.props.children)
        return /* @__PURE__ */ K.createElement("div", {
          className: "react-datepicker__children-container"
        }, r.props.children);
    }), r.containerRef = /* @__PURE__ */ K.createRef(), r.state = {
      date: r.getDateInView(),
      selectingDate: null,
      monthContainer: null,
      isRenderAriaLiveMessage: !1
    }, r;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      var r = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        r.setState({
          monthContainer: r.monthContainer
        });
      }());
    }
  }, {
    key: "componentDidUpdate",
    value: function(r) {
      var i = this;
      if (this.props.preSelection && (!Ue(this.props.preSelection, r.preSelection) || this.props.monthSelectedIn !== r.monthSelectedIn)) {
        var o = !ar(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return o && i.handleCustomMonthChange(i.state.date);
        });
      } else
        this.props.openToDate && !Ue(this.props.openToDate, r.openToDate) && this.setState({
          date: this.props.openToDate
        });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props.container || eD;
      return /* @__PURE__ */ K.createElement("div", {
        style: {
          display: "contents"
        },
        ref: this.containerRef
      }, /* @__PURE__ */ K.createElement(r, {
        className: Ot("react-datepicker", this.props.className, {
          "react-datepicker--time-only": this.props.showTimeSelectOnly
        }),
        showTime: this.props.showTimeSelect || this.props.showTimeInput,
        showTimeSelectOnly: this.props.showTimeSelectOnly
      }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        onDropdownFocus: function() {
        },
        monthsShown: 1,
        forceShowMonthNavigation: !1,
        timeCaption: "Time",
        previousYearButtonLabel: "Previous Year",
        nextYearButtonLabel: "Next Year",
        previousMonthButtonLabel: "Previous Month",
        nextMonthButtonLabel: "Next Month",
        customTimeInput: null,
        yearItemNumber: Qs
      };
    }
  }]);
}(K.Component), iD = function(n) {
  var t = n.icon, r = n.className, i = r === void 0 ? "" : r, o = n.onClick, a = "react-datepicker__calendar-icon";
  return /* @__PURE__ */ K.isValidElement(t) ? /* @__PURE__ */ K.cloneElement(t, {
    className: "".concat(t.props.className || "", " ").concat(a, " ").concat(i),
    onClick: function(d) {
      typeof t.props.onClick == "function" && t.props.onClick(d), typeof o == "function" && o(d);
    }
  }) : typeof t == "string" ? /* @__PURE__ */ K.createElement("i", {
    className: "".concat(a, " ").concat(t, " ").concat(i),
    "aria-hidden": "true",
    onClick: o
  }) : /* @__PURE__ */ K.createElement("svg", {
    className: "".concat(a, " ").concat(i),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    onClick: o
  }, /* @__PURE__ */ K.createElement("path", {
    d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
  }));
}, sD = iD, tg = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), r.el = document.createElement("div"), r;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.portalRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function() {
      return /* @__PURE__ */ Om.createPortal(this.props.children, this.el);
    }
  }]);
}(K.Component), oD = "[tabindex], a, button, input, select, textarea", aD = function(n) {
  return !n.disabled && n.tabIndex !== -1;
}, rg = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), R(r, "getTabChildren", function() {
      return Array.prototype.slice.call(r.tabLoopRef.current.querySelectorAll(oD), 1, -1).filter(aD);
    }), R(r, "handleFocusStart", function() {
      var i = r.getTabChildren();
      i && i.length > 1 && i[i.length - 1].focus();
    }), R(r, "handleFocusEnd", function() {
      var i = r.getTabChildren();
      i && i.length > 1 && i[0].focus();
    }), r.tabLoopRef = /* @__PURE__ */ K.createRef(), r;
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      return this.props.enableTabLoop ? /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__tab-loop",
        ref: this.tabLoopRef
      }, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__tab-loop__start",
        tabIndex: "0",
        onFocus: this.handleFocusStart
      }), this.props.children, /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__tab-loop__end",
        tabIndex: "0",
        onFocus: this.handleFocusEnd
      })) : this.props.children;
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        enableTabLoop: !0
      };
    }
  }]);
}(K.Component);
function lD(e) {
  var n = function(r) {
    var i = Jr(Jr({}, r), {}, {
      popperModifiers: r.popperModifiers || [],
      popperProps: r.popperProps || {},
      hidePopper: typeof r.hidePopper == "boolean" ? r.hidePopper : !0
    }), o = K.useRef(), a = Us(Jr({
      open: !i.hidePopper,
      whileElementsMounted: Ta,
      placement: i.popperPlacement,
      middleware: [Ia({
        padding: 15
      }), $a(10), Jp({
        element: o
      })].concat(Vn(i.popperModifiers))
    }, i.popperProps));
    return /* @__PURE__ */ K.createElement(e, Hs({}, i, {
      popperProps: Jr(Jr({}, a), {}, {
        arrowRef: o
      })
    }));
  };
  return n;
}
var cD = /* @__PURE__ */ function(e) {
  function n() {
    return $t(this, n), Mt(this, n, arguments);
  }
  return It(n, e), Tt(n, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.className, o = r.wrapperClassName, a = r.hidePopper, c = r.popperComponent, d = r.targetComponent, p = r.enableTabLoop, m = r.popperOnKeyDown, v = r.portalId, y = r.portalHost, _ = r.popperProps, S = r.showArrow, E;
      if (!a) {
        var Y = Ot("react-datepicker-popper", i);
        E = /* @__PURE__ */ K.createElement(rg, {
          enableTabLoop: p
        }, /* @__PURE__ */ K.createElement("div", {
          ref: _.refs.setFloating,
          style: _.floatingStyles,
          className: Y,
          "data-placement": _.placement,
          onKeyDown: m
        }, c, S && /* @__PURE__ */ K.createElement(sh, {
          ref: _.arrowRef,
          context: _.context,
          fill: "currentColor",
          strokeWidth: 1,
          height: 8,
          width: 16,
          style: {
            transform: "translateY(-1px)"
          },
          className: "react-datepicker__triangle"
        })));
      }
      this.props.popperContainer && (E = /* @__PURE__ */ K.createElement(this.props.popperContainer, {}, E)), v && !a && (E = /* @__PURE__ */ K.createElement(tg, {
        portalId: v,
        portalHost: y
      }, E));
      var N = Ot("react-datepicker-wrapper", o);
      return /* @__PURE__ */ K.createElement(K.Fragment, null, /* @__PURE__ */ K.createElement("div", {
        ref: _.refs.setReference,
        className: N
      }, d), E);
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        hidePopper: !0
      };
    }
  }]);
}(K.Component), uD = lD(cD), Lf = "react-datepicker-ignore-onclickoutside", dD = Na(nD);
function fD(e, n) {
  return e && n ? Ut(e) !== Ut(n) || He(e) !== He(n) : e !== n;
}
var Dl = "Date input not valid.", pD = /* @__PURE__ */ function(e) {
  function n(t) {
    var r;
    return $t(this, n), r = Mt(this, n, [t]), R(r, "getPreSelection", function() {
      return r.props.openToDate ? r.props.openToDate : r.props.selectsEnd && r.props.startDate ? r.props.startDate : r.props.selectsStart && r.props.endDate ? r.props.endDate : rt();
    }), R(r, "modifyHolidays", function() {
      var i;
      return (i = r.props.holidays) === null || i === void 0 ? void 0 : i.reduce(function(o, a) {
        var c = new Date(a.date);
        return zs(c) ? [].concat(Vn(o), [Jr(Jr({}, a), {}, {
          date: c
        })]) : o;
      }, []);
    }), R(r, "calcInitialState", function() {
      var i, o = r.getPreSelection(), a = Xh(r.props), c = Zh(r.props), d = a && wi(o, zr(a)) ? a : c && zn(o, lc(c)) ? c : o;
      return {
        open: r.props.startOpen || !1,
        preventFocus: !1,
        preSelection: (i = r.props.selectsRange ? r.props.startDate : r.props.selected) !== null && i !== void 0 ? i : d,
        // transforming highlighted days (perhaps nested array)
        // to flat Map for faster access in day.jsx
        highlightDates: $f(r.props.highlightDates),
        focused: !1,
        // used to focus day in inline version after month has changed, but not on
        // initial render
        shouldFocusDayInline: !1,
        isRenderAriaLiveMessage: !1
      };
    }), R(r, "clearPreventFocusTimeout", function() {
      r.preventFocusTimeout && clearTimeout(r.preventFocusTimeout);
    }), R(r, "setFocus", function() {
      r.input && r.input.focus && r.input.focus({
        preventScroll: !0
      });
    }), R(r, "setBlur", function() {
      r.input && r.input.blur && r.input.blur(), r.cancelFocusInput();
    }), R(r, "setOpen", function(i) {
      var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
      r.setState({
        open: i,
        preSelection: i && r.state.open ? r.state.preSelection : r.calcInitialState().preSelection,
        lastPreSelectChange: El
      }, function() {
        i || r.setState(function(a) {
          return {
            focused: o ? a.focused : !1
          };
        }, function() {
          !o && r.setBlur(), r.setState({
            inputValue: null
          });
        });
      });
    }), R(r, "inputOk", function() {
      return bi(r.state.preSelection);
    }), R(r, "isCalendarOpen", function() {
      return r.props.open === void 0 ? r.state.open && !r.props.disabled && !r.props.readOnly : r.props.open;
    }), R(r, "handleFocus", function(i) {
      r.state.preventFocus || (r.props.onFocus(i), !r.props.preventOpenOnFocus && !r.props.readOnly && r.setOpen(!0)), r.setState({
        focused: !0
      });
    }), R(r, "sendFocusBackToInput", function() {
      r.preventFocusTimeout && r.clearPreventFocusTimeout(), r.setState({
        preventFocus: !0
      }, function() {
        r.preventFocusTimeout = setTimeout(function() {
          r.setFocus(), r.setState({
            preventFocus: !1
          });
        });
      });
    }), R(r, "cancelFocusInput", function() {
      clearTimeout(r.inputFocusTimeout), r.inputFocusTimeout = null;
    }), R(r, "deferFocusInput", function() {
      r.cancelFocusInput(), r.inputFocusTimeout = setTimeout(function() {
        return r.setFocus();
      }, 1);
    }), R(r, "handleDropdownFocus", function() {
      r.cancelFocusInput();
    }), R(r, "handleBlur", function(i) {
      (!r.state.open || r.props.withPortal || r.props.showTimeInput) && r.props.onBlur(i), r.setState({
        focused: !1
      });
    }), R(r, "handleCalendarClickOutside", function(i) {
      r.props.inline || r.setOpen(!1), r.props.onClickOutside(i), r.props.withPortal && i.preventDefault();
    }), R(r, "handleChange", function() {
      for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
        o[a] = arguments[a];
      var c = o[0];
      if (!(r.props.onChangeRaw && (r.props.onChangeRaw.apply(r, o), typeof c.isDefaultPrevented != "function" || c.isDefaultPrevented()))) {
        r.setState({
          inputValue: c.target.value,
          lastPreSelectChange: hD
        });
        var d = mC(c.target.value, r.props.dateFormat, r.props.locale, r.props.strictParsing, r.props.minDate);
        r.props.showTimeSelectOnly && r.props.selected && d && !Ue(d, r.props.selected) && (d = Xk(r.props.selected, {
          hours: Yr(d),
          minutes: Vr(d),
          seconds: sn(d)
        })), (d || !c.target.value) && r.setSelected(d, c, !0);
      }
    }), R(r, "handleSelect", function(i, o, a) {
      if (r.props.shouldCloseOnSelect && !r.props.showTimeSelect && r.sendFocusBackToInput(), r.props.onChangeRaw && r.props.onChangeRaw(o), r.setSelected(i, o, !1, a), r.props.showDateSelect && r.setState({
        isRenderAriaLiveMessage: !0
      }), !r.props.shouldCloseOnSelect || r.props.showTimeSelect)
        r.setPreSelection(i);
      else if (!r.props.inline) {
        r.props.selectsRange || r.setOpen(!1);
        var c = r.props, d = c.startDate, p = c.endDate;
        d && !p && (r.props.swapRange || !Af(i, d)) && r.setOpen(!1);
      }
    }), R(r, "setSelected", function(i, o, a, c) {
      var d = i;
      if (r.props.showYearPicker) {
        if (d !== null && Qh(He(d), r.props))
          return;
      } else if (r.props.showMonthYearPicker) {
        if (d !== null && Bo(d, r.props))
          return;
      } else if (d !== null && za(d, r.props))
        return;
      var p = r.props, m = p.onChange, v = p.selectsRange, y = p.startDate, _ = p.endDate, S = p.selectsMultiple, E = p.selectedDates, Y = p.minTime, N = p.swapRange;
      if (!ai(r.props.selected, d) || r.props.allowSameDay || v || S)
        if (d !== null && (r.props.selected && (!a || !r.props.showTimeSelect && !r.props.showTimeSelectOnly && !r.props.showTimeInput) && (d = Sl(d, {
          hour: Yr(r.props.selected),
          minute: Vr(r.props.selected),
          second: sn(r.props.selected)
        })), !a && (r.props.showTimeSelect || r.props.showTimeSelectOnly) && Y && (d = Sl(d, {
          hour: Y.getHours(),
          minute: Y.getMinutes(),
          second: Y.getSeconds()
        })), r.props.inline || r.setState({
          preSelection: d
        }), r.props.focusSelectedMonth || r.setState({
          monthSelectedIn: c
        })), v) {
          var I = !y && !_, Q = y && !_, te = y && _;
          I ? m([d, null], o) : Q && (d === null ? m([null, null], o) : Af(d, y) ? m(N ? [d, y] : [d, null], o) : m([y, d], o)), te && m([d, null], o);
        } else if (S)
          if (!(E != null && E.length))
            m([d], o);
          else {
            var ie = E.some(function(re) {
              return Ue(re, d);
            });
            if (ie) {
              var ne = E.filter(function(re) {
                return !Ue(re, d);
              });
              m(ne, o);
            } else
              m([].concat(Vn(E), [d]), o);
          }
        else
          m(d, o);
      a || (r.props.onSelect(d, o), r.setState({
        inputValue: null
      }));
    }), R(r, "setPreSelection", function(i) {
      var o = typeof r.props.minDate < "u", a = typeof r.props.maxDate < "u", c = !0;
      if (i) {
        var d = zr(i);
        if (o && a)
          c = Es(i, r.props.minDate, r.props.maxDate);
        else if (o) {
          var p = zr(r.props.minDate);
          c = zn(i, p) || ai(d, p);
        } else if (a) {
          var m = lc(r.props.maxDate);
          c = wi(i, m) || ai(d, m);
        }
      }
      c && r.setState({
        preSelection: i
      });
    }), R(r, "toggleCalendar", function() {
      r.setOpen(!r.state.open);
    }), R(r, "handleTimeChange", function(i) {
      var o = r.props.selected ? r.props.selected : r.getPreSelection(), a = r.props.selected ? i : Sl(o, {
        hour: Yr(i),
        minute: Vr(i)
      });
      r.setState({
        preSelection: a
      }), r.props.onChange(a), r.props.shouldCloseOnSelect && (r.sendFocusBackToInput(), r.setOpen(!1)), r.props.showTimeInput && r.setOpen(!0), (r.props.showTimeSelectOnly || r.props.showTimeSelect) && r.setState({
        isRenderAriaLiveMessage: !0
      }), r.setState({
        inputValue: null
      });
    }), R(r, "onInputClick", function() {
      !r.props.disabled && !r.props.readOnly && r.setOpen(!0), r.props.onInputClick();
    }), R(r, "onInputKeyDown", function(i) {
      r.props.onKeyDown(i);
      var o = i.key;
      if (!r.state.open && !r.props.inline && !r.props.preventOpenOnFocus) {
        (o === "ArrowDown" || o === "ArrowUp" || o === "Enter") && r.onInputClick();
        return;
      }
      if (r.state.open) {
        if (o === "ArrowDown" || o === "ArrowUp") {
          i.preventDefault();
          var a = r.props.showWeekPicker && r.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : r.props.showFullMonthYearPicker || r.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', c = r.calendar.componentNode && r.calendar.componentNode.querySelector(a);
          c && c.focus({
            preventScroll: !0
          });
          return;
        }
        var d = rt(r.state.preSelection);
        o === "Enter" ? (i.preventDefault(), r.inputOk() && r.state.lastPreSelectChange === El ? (r.handleSelect(d, i), !r.props.shouldCloseOnSelect && r.setPreSelection(d)) : r.setOpen(!1)) : o === "Escape" ? (i.preventDefault(), r.sendFocusBackToInput(), r.setOpen(!1)) : o === "Tab" && r.setOpen(!1), r.inputOk() || r.props.onInputError({
          code: 1,
          msg: Dl
        });
      }
    }), R(r, "onPortalKeyDown", function(i) {
      var o = i.key;
      o === "Escape" && (i.preventDefault(), r.setState({
        preventFocus: !0
      }, function() {
        r.setOpen(!1), setTimeout(function() {
          r.setFocus(), r.setState({
            preventFocus: !1
          });
        });
      }));
    }), R(r, "onDayKeyDown", function(i) {
      r.props.onKeyDown(i);
      var o = i.key, a = i.shiftKey, c = rt(r.state.preSelection);
      if (o === "Enter")
        i.preventDefault(), r.handleSelect(c, i), !r.props.shouldCloseOnSelect && r.setPreSelection(c);
      else if (o === "Escape")
        i.preventDefault(), r.setOpen(!1), r.inputOk() || r.props.onInputError({
          code: 1,
          msg: Dl
        });
      else if (!r.props.disabledKeyboardNavigation) {
        var d;
        switch (o) {
          case "ArrowLeft":
            r.props.showWeekPicker ? d = pf(c, 1) : d = PS(c, 1);
            break;
          case "ArrowRight":
            r.props.showWeekPicker ? d = ca(c, 1) : d = Kn(c, 1);
            break;
          case "ArrowUp":
            d = pf(c, 1);
            break;
          case "ArrowDown":
            d = ca(c, 1);
            break;
          case "PageUp":
            d = a ? Qi(c, 1) : Ui(c, 1);
            break;
          case "PageDown":
            d = a ? nn(c, 1) : Dr(c, 1);
            break;
          case "Home":
            d = Rn(c, r.props.locale, r.props.calendarStartDay);
            break;
          case "End":
            d = xC(c);
            break;
          default:
            d = null;
            break;
        }
        if (!d) {
          r.props.onInputError && r.props.onInputError({
            code: 1,
            msg: Dl
          });
          return;
        }
        if (i.preventDefault(), r.setState({
          lastPreSelectChange: El
        }), r.props.adjustDateOnChange && r.setSelected(d), r.setPreSelection(d), r.props.inline) {
          var p = Ut(c), m = Ut(d), v = He(c), y = He(d);
          p !== m || v !== y ? r.setState({
            shouldFocusDayInline: !0
          }) : r.setState({
            shouldFocusDayInline: !1
          });
        }
      }
    }), R(r, "onPopperKeyDown", function(i) {
      var o = i.key;
      o === "Escape" && (i.preventDefault(), r.sendFocusBackToInput());
    }), R(r, "onClearClick", function(i) {
      i && i.preventDefault && i.preventDefault(), r.sendFocusBackToInput(), r.props.selectsRange ? r.props.onChange([null, null], i) : r.props.onChange(null, i), r.setState({
        inputValue: null
      });
    }), R(r, "clear", function() {
      r.onClearClick();
    }), R(r, "onScroll", function(i) {
      typeof r.props.closeOnScroll == "boolean" && r.props.closeOnScroll ? (i.target === document || i.target === document.documentElement || i.target === document.body) && r.setOpen(!1) : typeof r.props.closeOnScroll == "function" && r.props.closeOnScroll(i) && r.setOpen(!1);
    }), R(r, "renderCalendar", function() {
      return !r.props.inline && !r.isCalendarOpen() ? null : /* @__PURE__ */ K.createElement(dD, {
        ref: function(o) {
          r.calendar = o;
        },
        locale: r.props.locale,
        calendarStartDay: r.props.calendarStartDay,
        chooseDayAriaLabelPrefix: r.props.chooseDayAriaLabelPrefix,
        disabledDayAriaLabelPrefix: r.props.disabledDayAriaLabelPrefix,
        weekAriaLabelPrefix: r.props.weekAriaLabelPrefix,
        monthAriaLabelPrefix: r.props.monthAriaLabelPrefix,
        adjustDateOnChange: r.props.adjustDateOnChange,
        setOpen: r.setOpen,
        shouldCloseOnSelect: r.props.shouldCloseOnSelect,
        dateFormat: r.props.dateFormatCalendar,
        useWeekdaysShort: r.props.useWeekdaysShort,
        formatWeekDay: r.props.formatWeekDay,
        dropdownMode: r.props.dropdownMode,
        selected: r.props.selected,
        preSelection: r.state.preSelection,
        onSelect: r.handleSelect,
        onWeekSelect: r.props.onWeekSelect,
        openToDate: r.props.openToDate,
        minDate: r.props.minDate,
        maxDate: r.props.maxDate,
        selectsStart: r.props.selectsStart,
        selectsEnd: r.props.selectsEnd,
        selectsRange: r.props.selectsRange,
        selectsMultiple: r.props.selectsMultiple,
        selectedDates: r.props.selectedDates,
        startDate: r.props.startDate,
        endDate: r.props.endDate,
        excludeDates: r.props.excludeDates,
        excludeDateIntervals: r.props.excludeDateIntervals,
        filterDate: r.props.filterDate,
        onClickOutside: r.handleCalendarClickOutside,
        formatWeekNumber: r.props.formatWeekNumber,
        highlightDates: r.state.highlightDates,
        holidays: IC(r.modifyHolidays()),
        includeDates: r.props.includeDates,
        includeDateIntervals: r.props.includeDateIntervals,
        includeTimes: r.props.includeTimes,
        injectTimes: r.props.injectTimes,
        inline: r.props.inline,
        shouldFocusDayInline: r.state.shouldFocusDayInline,
        peekNextMonth: r.props.peekNextMonth,
        showMonthDropdown: r.props.showMonthDropdown,
        showPreviousMonths: r.props.showPreviousMonths,
        useShortMonthInDropdown: r.props.useShortMonthInDropdown,
        showMonthYearDropdown: r.props.showMonthYearDropdown,
        showWeekNumbers: r.props.showWeekNumbers,
        showYearDropdown: r.props.showYearDropdown,
        withPortal: r.props.withPortal,
        forceShowMonthNavigation: r.props.forceShowMonthNavigation,
        showDisabledMonthNavigation: r.props.showDisabledMonthNavigation,
        scrollableYearDropdown: r.props.scrollableYearDropdown,
        scrollableMonthYearDropdown: r.props.scrollableMonthYearDropdown,
        todayButton: r.props.todayButton,
        weekLabel: r.props.weekLabel,
        outsideClickIgnoreClass: Lf,
        fixedHeight: r.props.fixedHeight,
        monthsShown: r.props.monthsShown,
        monthSelectedIn: r.state.monthSelectedIn,
        onDropdownFocus: r.handleDropdownFocus,
        onMonthChange: r.props.onMonthChange,
        onYearChange: r.props.onYearChange,
        dayClassName: r.props.dayClassName,
        weekDayClassName: r.props.weekDayClassName,
        monthClassName: r.props.monthClassName,
        timeClassName: r.props.timeClassName,
        showDateSelect: r.props.showDateSelect,
        showTimeSelect: r.props.showTimeSelect,
        showTimeSelectOnly: r.props.showTimeSelectOnly,
        onTimeChange: r.handleTimeChange,
        timeFormat: r.props.timeFormat,
        timeIntervals: r.props.timeIntervals,
        minTime: r.props.minTime,
        maxTime: r.props.maxTime,
        excludeTimes: r.props.excludeTimes,
        filterTime: r.props.filterTime,
        timeCaption: r.props.timeCaption,
        className: r.props.calendarClassName,
        container: r.props.calendarContainer,
        yearItemNumber: r.props.yearItemNumber,
        yearDropdownItemNumber: r.props.yearDropdownItemNumber,
        previousMonthAriaLabel: r.props.previousMonthAriaLabel,
        previousMonthButtonLabel: r.props.previousMonthButtonLabel,
        nextMonthAriaLabel: r.props.nextMonthAriaLabel,
        nextMonthButtonLabel: r.props.nextMonthButtonLabel,
        previousYearAriaLabel: r.props.previousYearAriaLabel,
        previousYearButtonLabel: r.props.previousYearButtonLabel,
        nextYearAriaLabel: r.props.nextYearAriaLabel,
        nextYearButtonLabel: r.props.nextYearButtonLabel,
        timeInputLabel: r.props.timeInputLabel,
        disabledKeyboardNavigation: r.props.disabledKeyboardNavigation,
        renderCustomHeader: r.props.renderCustomHeader,
        popperProps: r.props.popperProps,
        renderDayContents: r.props.renderDayContents,
        renderMonthContent: r.props.renderMonthContent,
        renderQuarterContent: r.props.renderQuarterContent,
        renderYearContent: r.props.renderYearContent,
        onDayMouseEnter: r.props.onDayMouseEnter,
        onMonthMouseLeave: r.props.onMonthMouseLeave,
        onYearMouseEnter: r.props.onYearMouseEnter,
        onYearMouseLeave: r.props.onYearMouseLeave,
        selectsDisabledDaysInRange: r.props.selectsDisabledDaysInRange,
        showTimeInput: r.props.showTimeInput,
        showMonthYearPicker: r.props.showMonthYearPicker,
        showFullMonthYearPicker: r.props.showFullMonthYearPicker,
        showTwoColumnMonthYearPicker: r.props.showTwoColumnMonthYearPicker,
        showFourColumnMonthYearPicker: r.props.showFourColumnMonthYearPicker,
        showYearPicker: r.props.showYearPicker,
        showQuarterYearPicker: r.props.showQuarterYearPicker,
        showWeekPicker: r.props.showWeekPicker,
        excludeScrollbar: r.props.excludeScrollbar,
        handleOnKeyDown: r.props.onKeyDown,
        handleOnDayKeyDown: r.onDayKeyDown,
        isInputFocused: r.state.focused,
        customTimeInput: r.props.customTimeInput,
        setPreSelection: r.setPreSelection,
        usePointerEvent: r.props.usePointerEvent,
        yearClassName: r.props.yearClassName
      }, r.props.children);
    }), R(r, "renderAriaLiveRegion", function() {
      var i = r.props, o = i.dateFormat, a = i.locale, c = r.props.showTimeInput || r.props.showTimeSelect, d = c ? "PPPPp" : "PPPP", p;
      return r.props.selectsRange ? p = "Selected start date: ".concat(mr(r.props.startDate, {
        dateFormat: d,
        locale: a
      }), ". ").concat(r.props.endDate ? "End date: " + mr(r.props.endDate, {
        dateFormat: d,
        locale: a
      }) : "") : r.props.showTimeSelectOnly ? p = "Selected time: ".concat(mr(r.props.selected, {
        dateFormat: o,
        locale: a
      })) : r.props.showYearPicker ? p = "Selected year: ".concat(mr(r.props.selected, {
        dateFormat: "yyyy",
        locale: a
      })) : r.props.showMonthYearPicker ? p = "Selected month: ".concat(mr(r.props.selected, {
        dateFormat: "MMMM yyyy",
        locale: a
      })) : r.props.showQuarterYearPicker ? p = "Selected quarter: ".concat(mr(r.props.selected, {
        dateFormat: "yyyy, QQQ",
        locale: a
      })) : p = "Selected date: ".concat(mr(r.props.selected, {
        dateFormat: d,
        locale: a
      })), /* @__PURE__ */ K.createElement("span", {
        role: "alert",
        "aria-live": "polite",
        className: "react-datepicker__aria-live"
      }, p);
    }), R(r, "renderDateInput", function() {
      var i, o = Ot(r.props.className, R({}, Lf, r.state.open)), a = r.props.customInput || /* @__PURE__ */ K.createElement("input", {
        type: "text"
      }), c = r.props.customInputRef || "ref", d = typeof r.props.value == "string" ? r.props.value : typeof r.state.inputValue == "string" ? r.state.inputValue : r.props.selectsRange ? vC(r.props.startDate, r.props.endDate, r.props) : r.props.selectsMultiple ? _C(r.props.selectedDates, r.props) : mr(r.props.selected, r.props);
      return /* @__PURE__ */ K.cloneElement(a, (i = {}, R(R(R(R(R(R(R(R(R(R(i, c, function(p) {
        r.input = p;
      }), "value", d), "onBlur", r.handleBlur), "onChange", r.handleChange), "onClick", r.onInputClick), "onFocus", r.handleFocus), "onKeyDown", r.onInputKeyDown), "id", r.props.id), "name", r.props.name), "form", r.props.form), R(R(R(R(R(R(R(R(R(R(i, "autoFocus", r.props.autoFocus), "placeholder", r.props.placeholderText), "disabled", r.props.disabled), "autoComplete", r.props.autoComplete), "className", Ot(a.props.className, o)), "title", r.props.title), "readOnly", r.props.readOnly), "required", r.props.required), "tabIndex", r.props.tabIndex), "aria-describedby", r.props.ariaDescribedBy), R(R(R(i, "aria-invalid", r.props.ariaInvalid), "aria-labelledby", r.props.ariaLabelledBy), "aria-required", r.props.ariaRequired)));
    }), R(r, "renderClearButton", function() {
      var i = r.props, o = i.isClearable, a = i.disabled, c = i.selected, d = i.startDate, p = i.endDate, m = i.clearButtonTitle, v = i.clearButtonClassName, y = v === void 0 ? "" : v, _ = i.ariaLabelClose, S = _ === void 0 ? "Close" : _, E = i.selectedDates;
      return o && (c != null || d != null || p != null || E != null && E.length) ? /* @__PURE__ */ K.createElement("button", {
        type: "button",
        className: Ot("react-datepicker__close-icon", y, {
          "react-datepicker__close-icon--disabled": a
        }),
        disabled: a,
        "aria-label": S,
        onClick: r.onClearClick,
        title: m,
        tabIndex: -1
      }) : null;
    }), r.state = r.calcInitialState(), r.preventFocusTimeout = null, r;
  }
  return It(n, e), Tt(n, [{
    key: "componentDidMount",
    value: function() {
      window.addEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, i) {
      r.inline && fD(r.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && r.monthsShown !== this.props.monthsShown && this.setState({
        monthSelectedIn: 0
      }), r.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: $f(this.props.highlightDates)
      }), !i.focused && !ai(r.selected, this.props.selected) && this.setState({
        inputValue: null
      }), i.open !== this.state.open && (i.open === !1 && this.state.open === !0 && this.props.onCalendarOpen(), i.open === !0 && this.state.open === !1 && this.props.onCalendarClose());
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
    }
  }, {
    key: "renderInputContainer",
    value: function() {
      var r = this.props, i = r.showIcon, o = r.icon, a = r.calendarIconClassname, c = r.toggleCalendarOnIconClick, d = this.state.open;
      return /* @__PURE__ */ K.createElement("div", {
        className: "react-datepicker__input-container".concat(i ? " react-datepicker__view-calendar-icon" : "")
      }, i && /* @__PURE__ */ K.createElement(sD, Hs({
        icon: o,
        className: "".concat(a, " ").concat(d && "react-datepicker-ignore-onclickoutside")
      }, c ? {
        onClick: this.toggleCalendar
      } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    }
  }, {
    key: "render",
    value: function() {
      var r = this.renderCalendar();
      if (this.props.inline)
        return r;
      if (this.props.withPortal) {
        var i = this.state.open ? /* @__PURE__ */ K.createElement(rg, {
          enableTabLoop: this.props.enableTabLoop
        }, /* @__PURE__ */ K.createElement("div", {
          className: "react-datepicker__portal",
          tabIndex: -1,
          onKeyDown: this.onPortalKeyDown
        }, r)) : null;
        return this.state.open && this.props.portalId && (i = /* @__PURE__ */ K.createElement(tg, {
          portalId: this.props.portalId,
          portalHost: this.props.portalHost
        }, i)), /* @__PURE__ */ K.createElement("div", null, this.renderInputContainer(), i);
      }
      return /* @__PURE__ */ K.createElement(uD, {
        className: this.props.popperClassName,
        wrapperClassName: this.props.wrapperClassName,
        hidePopper: !this.isCalendarOpen(),
        portalId: this.props.portalId,
        portalHost: this.props.portalHost,
        popperModifiers: this.props.popperModifiers,
        targetComponent: this.renderInputContainer(),
        popperContainer: this.props.popperContainer,
        popperComponent: r,
        popperPlacement: this.props.popperPlacement,
        popperProps: this.props.popperProps,
        popperOnKeyDown: this.onPopperKeyDown,
        enableTabLoop: this.props.enableTabLoop,
        showArrow: this.props.showPopperArrow
      });
    }
  }], [{
    key: "defaultProps",
    get: function() {
      return {
        allowSameDay: !1,
        dateFormat: "MM/dd/yyyy",
        dateFormatCalendar: "LLLL yyyy",
        onChange: function() {
        },
        disabled: !1,
        disabledKeyboardNavigation: !1,
        dropdownMode: "scroll",
        onFocus: function() {
        },
        onBlur: function() {
        },
        onKeyDown: function() {
        },
        onInputClick: function() {
        },
        onSelect: function() {
        },
        onClickOutside: function() {
        },
        onMonthChange: function() {
        },
        onCalendarOpen: function() {
        },
        onCalendarClose: function() {
        },
        preventOpenOnFocus: !1,
        onYearChange: function() {
        },
        onInputError: function() {
        },
        monthsShown: 1,
        readOnly: !1,
        withPortal: !1,
        selectsDisabledDaysInRange: !1,
        shouldCloseOnSelect: !0,
        showTimeSelect: !1,
        showTimeInput: !1,
        showPreviousMonths: !1,
        showMonthYearPicker: !1,
        showFullMonthYearPicker: !1,
        showTwoColumnMonthYearPicker: !1,
        showFourColumnMonthYearPicker: !1,
        showYearPicker: !1,
        showQuarterYearPicker: !1,
        showWeekPicker: !1,
        strictParsing: !1,
        swapRange: !1,
        timeIntervals: 30,
        timeCaption: "Time",
        previousMonthAriaLabel: "Previous Month",
        previousMonthButtonLabel: "Previous Month",
        nextMonthAriaLabel: "Next Month",
        nextMonthButtonLabel: "Next Month",
        previousYearAriaLabel: "Previous Year",
        previousYearButtonLabel: "Previous Year",
        nextYearAriaLabel: "Next Year",
        nextYearButtonLabel: "Next Year",
        timeInputLabel: "Time",
        enableTabLoop: !0,
        yearItemNumber: Qs,
        focusSelectedMonth: !1,
        showPopperArrow: !0,
        excludeScrollbar: !0,
        customTimeInput: null,
        calendarStartDay: void 0,
        toggleCalendarOnIconClick: !1,
        usePointerEvent: !1
      };
    }
  }]);
}(K.Component), hD = "input", El = "navigate";
const gD = W.div`
  position: relative;
`, mD = W.i`
  color: var(--cc_color_link_subtle);
  font-size: var(--cc_size_text_m);
  position: absolute;
  inset-inline-end: var(--cc_size_spacing_xs);
  inset-block-start: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`, vD = W.select`
  all: unset;
  background: var(--cc_color_background_1);
  display: block;
  cursor: pointer;
  border: var(--cc_size_border_width_s) solid
    var(--cc_color_border_input_inactive);
  accent-color: var(--cc_color_button_background_secondary);
  border-radius: var(--cc_size_border_radius_m);
  padding: var(--cc_size_spacing_xs) calc(var(--cc_size_spacing_m) * 1.25)
    var(--cc_size_spacing_xs) var(--cc_size_spacing_s);
  color: var(--cc_color_link_secondary);
  font-size: var(--cc_size_text_s);
  text-align: start;
  ${Lt};

  &:focus-visible {
    outline: var(--cc_size_border_width_m) solid
      var(--cc_color_border_input_active);
  }
`;
function Nf({
  label: e,
  onChange: n,
  options: t,
  value: r,
  ...i
}) {
  return /* @__PURE__ */ pe(gD, { children: [
    /* @__PURE__ */ L(vD, { value: r, onChange: n, ...i, children: t.map((o) => /* @__PURE__ */ L("option", { value: o, children: o }, o)) }),
    /* @__PURE__ */ L(mD, { "aria-hidden": "true", className: "mdi mdi-chevron-down" })
  ] });
}
const _D = W.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
`, yD = W.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cc_size_spacing_xs);
`;
function bD({
  date: e,
  months: n,
  changeYear: t,
  changeMonth: r,
  decreaseMonth: i,
  increaseMonth: o,
  prevMonthButtonDisabled: a,
  nextMonthButtonDisabled: c
}) {
  function d(y) {
    return y.getMonth();
  }
  function p(y, _, S = 1) {
    const E = [];
    for (let Y = y; Y < _; Y += S)
      E.push(Y);
    return E;
  }
  function m(y) {
    return y.getFullYear();
  }
  const v = p(1990, m(/* @__PURE__ */ new Date()) + 1, 1);
  return /* @__PURE__ */ pe(_D, { children: [
    /* @__PURE__ */ L(
      sa,
      {
        onClick: i,
        disabled: a,
        accessibilityLabel: "Previous",
        iconName: "chevron-left"
      }
    ),
    /* @__PURE__ */ pe(yD, { children: [
      /* @__PURE__ */ L(
        Nf,
        {
          value: n[d(e)],
          onChange: ({ target: { value: y } }) => r(n.indexOf(y)),
          label: "Month",
          options: n
        }
      ),
      /* @__PURE__ */ L(
        Nf,
        {
          value: m(e).toString(),
          onChange: ({ target: { value: y } }) => t(Number(y)),
          label: "Year",
          options: v.map((y) => y.toString())
        }
      )
    ] }),
    /* @__PURE__ */ L(
      sa,
      {
        onClick: o,
        disabled: c,
        accessibilityLabel: "Next",
        iconName: "chevron-right"
      }
    )
  ] });
}
const wD = le`
  background: var(--cc_color_button_background_primary);
  color: var(--cc_color_button_text_primary);
  border-radius: var(--cc_size_border_radius_l);
  &:hover {
    background: var(--cc_color_button_background_primary);
  }
`, Pl = le`
  background: var(--cc_color_button_background_secondary);
  color: var(--cc_color_button_text_secondary);
  border-radius: var(--cc_size_border_radius_l);
  &:hover {
    background: var(--cc_color_button_background_secondary);
  }
`, xD = Yv`
  .react-datepicker {
    ${dr};
    background: var(--cc_color_background_1);
    color: var(--cc_color_link_secondary);
    border: none;
    box-shadow: 0 0 var(--cc_size_depth_2_blur) var(--cc_color_depth_2);
    border-radius: var(--cc_size_border_radius_l);
  }
  .react-datepicker__header {
    background: var(--cc_color_background_2);
    border-bottom: var(--cc_size_border_width_s) solid var(--cc_color_border_default);
    padding: var(--cc_size_spacing_s);
  }
  /* arrow icons */
  .react-datepicker__navigation-icon::before {
    border-color: var(--cc_color_link_subtle);
  }
  .react-datepicker__month {
    margin: var(--cc_size_spacing_s);
  }
  .react-datepicker__current-month {
    font-size: calc(var(--cc_size_text_s) * 1.125);
    font-weight: 600;
    color: var(--cc_color_text_default);
  }
  .react-datepicker__day-name {
    font-weight: 600;
    color: var(--cc_color_link_secondary);
  }
  .react-datepicker__day {
    color: var(--cc_color_link_subtle);
    border-radius: var(--cc_size_border_radius_l) !important;
    &:focus-visible {
      outline: var(--cc_size_border_width_s) solid var(--cc_color_border_input_active);
      outline-offset: var(--cc_size_border_width_m);
    }
  }
  .react-datepicker__day--selected,
  .react-datepicker__day--in-range,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end {
    ${Pl}
    &.react-datepicker__day--today {
      ${Pl}
      color: var(--cc_color_link_secondary);
    }
  }
  .react-datepicker__day--outside-month:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
    color: var(--cc_color_text_nonessential);
  }
  .react-datepicker__day--keyboard-selected, .react-datepicker__day--today {
    ${wD}
  }
  .react-datepicker__day--today.react-datepicker__day--in-selecting-range {
    color: var(--cc_color_link_secondary);
  }
  .react-datepicker__day--today.react-datepicker__day--in-range,
  .react-datepicker__day--today.react-datepicker__day--selected {
    color: var(--cc_color_button_text_secondary);
  }
  .react-datepicker__day:not(.react-datepicker__day--selected, .react-datepicker__day--in-range, .react-datepicker__day--keyboard-selected, .react-datepicker__day--today):hover,
  .react-datepicker__month-text:hover,
  .react-datepicker__quarter-text:hover,
  .react-datepicker__year-text:hover {
    background: var(--cc_color_button_background_secondary_alpha_10);
  }
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range, .react-datepicker__month-text--in-range, .react-datepicker__quarter-text--in-range, .react-datepicker__year-text--in-range) {
    background: var(--cc_color_button_background_primary_alpha_10);
    &.react-datepicker__day--selecting-range-start,
    &.react-datepicker__day--selecting-range-end {
      ${Pl}
    }
  }
`, SD = W.div`
  .react-datepicker-wrapper {
    display: block;
    background: var(--cc_color_background_1);
    border-width: var(--cc_size_border_width_s);
    border-style: solid;
    border-color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_border_input_inactive)"};
    border-radius: var(--cc_size_border_radius_l);
    transition: border-color 0.2s;

    ${(e) => e.$disabled ? le`
            ${_r}
            background-color: var(--cc_color_background_3);
          ` : le`
            &:hover {
              border-color: var(--cc_color_button_background_secondary);
            }
          `}

    ${(e) => e.$message ? "margin-block-end: var(--cc_size_spacing_xs);" : null}

    &:focus-within {
      ${(e) => Pt(e.$status).focusStyles}
      border-color: transparent;
      outline-offset: -2px;
    }
  }

  .react-datepicker__input-container {
    display: flex;
    align-items: center;
    padding-inline-start: ${(e) => e.$size === "large" ? "calc(var(--cc_size_spacing_m) * 0.75)" : "var(--cc_size_spacing_s)"};
  }

  .react-datepicker__calendar-icon {
    all: unset;
    color: var(--cc_color_text_nonessential);
    font-size: ${(e) => e.$size === "large" ? 22 : 20}px;
    transform: translateY(1px);
  }

  .react-datepicker__input {
    all: initial;
    display: block;
    width: 100%;
    color: var(--cc_color_text_default);
    ${Lt};
    font-size: ${(e) => e.$size === "large" ? "var(--cc_size_text_m)" : "var(--cc_size_text_s)"};
    height: ${(e) => e.$size === "medium" ? 38 : 48}px;
    padding: ${(e) => e.$size === "large" ? "0 var(--cc_size_spacing_m)" : "0 calc(var(--cc_size_spacing_m) * 0.75)"};
    ${(e) => e.$hideLabel ? le`
            &::placeholder {
              color: var(--cc_color_text_subtle);
            }
          ` : le`
            &::placeholder {
              color: var(--cc_color_text_nonessential);
            }
          `}
  }

  .react-datepicker__close-icon {
    padding-inline-end: var(--cc_size_spacing_s);
    flex-shrink: 0;
    &::after {
      background-color: transparent;
      color: var(--cc_color_link_subtle);
      height: var(--cc_size_text_l);
      width: var(--cc_size_text_l);
      font-size: var(--cc_size_text_l);
      flex-shrink: 0;
    }
  }
`, kD = W.label`
  ${(e) => e.$hideLabel ? fr : le`
          all: initial;
          display: block;
          margin-block-end: var(--cc_size_spacing_xs);
        `}
`;
function dI({
  hideLabel: e,
  label: n,
  onChange: t,
  children: r,
  placeholder: i,
  placement: o = "bottom-start",
  size: a = "medium",
  style: c,
  months: d,
  ...p
}) {
  const {
    status: m = "normal",
    disabled: v = !1,
    message: y,
    className: _,
    ...S
  } = p;
  return /* @__PURE__ */ pe(Bn, { children: [
    /* @__PURE__ */ L(xD, {}),
    /* @__PURE__ */ L(
      qn,
      {
        inputId: p.id,
        className: _,
        message: y,
        style: c,
        status: m,
        children: /* @__PURE__ */ pe(
          SD,
          {
            $disabled: v,
            $size: a,
            $status: m,
            $message: y,
            $hideLabel: e,
            $isClearable: p.isClearable,
            children: [
              /* @__PURE__ */ L(kD, { $hideLabel: e, htmlFor: p.id, children: /* @__PURE__ */ L(Ji, { children: n }) }),
              /* @__PURE__ */ L(
                pD,
                {
                  ...S,
                  onChange: t,
                  disabled: v,
                  "aria-describedby": y ? `${p.id}-message` : "",
                  "aria-invalid": m === "error",
                  showIcon: !0,
                  showPopperArrow: !1,
                  popperClassName: "react-datepicker__floating",
                  className: "react-datepicker__input",
                  icon: "mdi mdi-calendar",
                  renderCustomHeader: p.selectsRange ? void 0 : (E) => /* @__PURE__ */ L(bD, { ...E, months: d }),
                  placeholderText: i,
                  portalId: `react-datepicker-portal-${p.id}`,
                  popperPlacement: o,
                  toggleCalendarOnIconClick: !0,
                  children: r
                }
              )
            ]
          }
        )
      }
    )
  ] });
}
const CD = W.ul`
  list-style-type: none;
  margin: var(--cc_size_spacing_s) 0 0;
  padding: 0;
`, DD = W.li`
  all: initial;
`, pu = W.label`
  all: initial;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  place-items: center;
  align-content: center;
  gap: var(--cc_size_spacing_s);
  padding: var(--cc_size_spacing_xl);
  background: var(--cc_color_background_1);
  border-width: var(--cc_size_border_width_s);
  border-style: dashed;
  border-color: ${(e) => e.$status === "normal" ? "var(--cc_color_border_input_inactive)" : Pt(e.$status).accentColor};
  border-radius: var(--cc_size_border_radius_m);
`, ED = W.div`
  position: relative;
  ${(e) => e.$isDragOver ? le`
          ${pu} {
            border-color: var(--cc_color_border_input_active);
            border-style: solid;
            box-shadow: inset 0 0 0 var(--cc_size_border_width_s)
              var(--cc_color_border_input_active);
          }
        ` : null}
`, PD = W.input.attrs({ type: "file" })`
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  cursor: pointer;
  ${(e) => e.$isDragOver ? null : le`
          &:hover ~ ${pu} {
            border-color: var(--cc_color_button_background_secondary);
          }
        `}
`, MD = W.span`
  ${dr}
  font-weight: 600;
  display: inline-grid;
  place-items: center;
  height: ${Ea.medium};
  padding-inline: var(--cc_size_spacing_m);
  border-radius: var(--cc_size_border_radius_l);
  border: var(--cc_size_border_width_m) solid var(--cc_color_link_primary);
  color: var(--cc_color_link_primary);
  transition: background 0.2s;
  &:hover {
    background: var(--cc_color_button_background_primary_alpha_10);
  }
`;
function $D({ messages: e, id: n, status: t }) {
  return /* @__PURE__ */ L("div", { role: "region", "aria-live": "assertive", children: /* @__PURE__ */ L(CD, { id: n, children: e.map((r, i) => /* @__PURE__ */ L(DD, { children: /* @__PURE__ */ pe(Ch, { $status: t, children: [
    /* @__PURE__ */ L(
      Dh,
      {
        className: `mdi mdi-${Pt(t).icon}`,
        "aria-hidden": "true"
      }
    ),
    /* @__PURE__ */ L(Eh, { children: r })
  ] }) }, i)) }) });
}
const fI = ({
  onDrop: e,
  onDropAccepted: n,
  onDropRejected: t,
  accept: r,
  billboard: i,
  dropZoneStyle: o,
  fileUploadButtonLabel: a,
  multiple: c = !0,
  loading: d,
  messages: p,
  maxSize: m = 1 / 0,
  ...v
}) => {
  const { className: y, message: _, status: S = "normal", style: E, ...Y } = v, [N, I] = lr(!1), Q = (ne) => {
    const re = ne.target.files, ce = (r ?? "").split(",").map(($e) => $e.trim()), de = [], ge = [];
    re && Array.from(re).forEach(($e) => {
      $e.size <= m && ce.includes($e.type) ? de.push($e) : ge.push($e);
    }), de.length > 0 && n && n(de), ge.length > 0 && t && t(ge), e(de, ge, ne), I(!1);
  };
  return /* @__PURE__ */ pe(
    ED,
    {
      onDragEnter: (ne) => {
        I(!0);
      },
      onDragLeave: (ne) => {
        I(!1);
      },
      $isDragOver: N,
      children: [
        /* @__PURE__ */ L(
          PD,
          {
            "aria-describedby": _ ? `${v.id}-message` : "",
            "aria-disabled": d == null ? void 0 : d.isVisible,
            "aria-invalid": S === "error",
            type: "file",
            onChange: Q,
            accept: r,
            multiple: c,
            $status: S,
            $isDragOver: N,
            ...Y
          }
        ),
        /* @__PURE__ */ pe(pu, { htmlFor: v.id, $status: S, style: o, children: [
          d != null && d.isVisible ? d.component : null,
          !(d != null && d.isVisible) && i ? /* @__PURE__ */ L(
            Vw,
            {
              title: i.title,
              iconName: i.iconName,
              message: i.message,
              color: i.color,
              image: i.image
            }
          ) : null,
          !(d != null && d.isVisible) && a ? /* @__PURE__ */ L(MD, { children: a }) : null
        ] }),
        p ? /* @__PURE__ */ L(
          $D,
          {
            id: _ ? `${v.id}-message` : "",
            messages: p,
            status: S
          },
          v.id
        ) : null
      ]
    }
  );
}, TD = W.label`
  all: initial;
  ${(e) => e.$hideLabel ? fr : le`
          box-sizing: border-box;
          display: block;
          margin-block-end: var(--cc_size_spacing_xs);
        `}
`, ID = W.input`
  all: initial;
  box-sizing: border-box;
  background: transparent;
  ${Lt};
  font-size: ${(e) => e.$inputSize === "large" ? "var(--cc_size_text_m)" : "var(--cc_size_text_s)"};
  color: var(--cc_color_text_default);
  padding: ${(e) => e.$inputSize === "large" ? "0 var(--cc_size_spacing_m)" : "0 calc(var(--cc_size_spacing_m) * 0.75)"};
  flex: 1;
  height: ${(e) => e.$inputSize === "medium" ? 38 : 48}px;
  overflow: hidden;
  max-width: 100%;
  &::placeholder {
    color: var(--cc_color_text_nonessential);
  }
  ${(e) => e.disabled ? le`
          cursor: not-allowed;
        ` : null}
`, RD = W.div`
  border-width: var(--cc_size_border_width_s);
  border-style: solid;
  border-color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_border_input_inactive)"};
  display: flex;
  align-items: center;
  min-width: 1px;
  transition: border-color 0.2s;
  border-radius: var(--cc_size_border_radius_l);
  background: var(--cc_color_background_1);
  ${(e) => e.$message ? "margin-block-end: var(--cc_size_spacing_xs);" : null}
  ${(e) => e.$disabled ? le`
          ${_r}
          background-color: var(--cc_color_background_3);
        ` : le`
          &:hover {
            border-color: var(--cc_color_button_background_secondary);
          }
        `}

  &:focus-within {
    ${(e) => Pt(e.$status).focusStyles}
    border-color: transparent;
    outline-offset: -2px;
  }
`, AD = W.i`
  color: var(--cc_color_text_nonessential);
  font-size: ${(e) => e.$inputSize === "large" ? 22 : 20}px;
  margin-inline-start: ${(e) => e.$inputSize === "large" ? "var(--cc_size_spacing_m)" : "calc(var(--cc_size_spacing_m) * 0.5)"};
  position: relative;
  top: 1px;
  line-height: 1;
`, zf = W.span`
  flex-shrink: 0;
`, FD = ({ type: e }) => {
  switch (e) {
    case "email":
      return "email-outline";
    case "tel":
      return "phone-outline";
    case "search":
      return "magnify";
    case "url":
      return "web";
    default:
      return null;
  }
};
function OD({
  label: e,
  onChange: n,
  contentBefore: t,
  contentAfter: r,
  hideLabel: i = !1,
  inputSize: o = "medium",
  name: a,
  testId: c,
  type: d = "text",
  value: p,
  ...m
}) {
  const {
    status: v = "normal",
    className: y,
    disabled: _ = !1,
    style: S,
    message: E,
    ...Y
  } = m, N = FD({ type: d }), I = t || N, Q = () => I ? /* @__PURE__ */ L(zf, { children: t || /* @__PURE__ */ L(AD, { className: `mdi mdi-${N}`, $inputSize: o }) }) : null;
  return /* @__PURE__ */ pe(
    qn,
    {
      inputId: m.id,
      message: E,
      className: y,
      status: v,
      style: S,
      children: [
        /* @__PURE__ */ L(TD, { htmlFor: m.id, $hideLabel: i, children: /* @__PURE__ */ L(Ji, { children: e }) }),
        /* @__PURE__ */ pe(
          RD,
          {
            $disabled: m.disabled || !1,
            $status: v,
            $type: d,
            $message: E,
            children: [
              Q(),
              /* @__PURE__ */ L(
                ID,
                {
                  disabled: _,
                  "aria-describedby": E ? `${m.id}-message` : "",
                  "aria-invalid": v === "error",
                  onChange: n,
                  name: a || m.id,
                  $inputSize: o,
                  "data-testid": c,
                  type: d,
                  value: p,
                  ...Y
                }
              ),
              r ? /* @__PURE__ */ L(zf, { children: r }) : null
            ]
          }
        )
      ]
    }
  );
}
const LD = W(bh)`
  margin-inline-end: var(--cc_size_spacing_s);
`;
function pI({ ...e }) {
  const [n, t] = lr();
  return /* @__PURE__ */ L(
    OD,
    {
      type: n ? "text" : "password",
      contentAfter: /* @__PURE__ */ L(
        LD,
        {
          onClick: () => {
            t((i) => !i);
          },
          design: "minimal",
          size: "small",
          iconName: n ? "eye-outline" : "eye-off-outline",
          accessibilityLabel: n ? "Hide Password" : "Show Password",
          disabled: e.disabled
        }
      ),
      ...e
    }
  );
}
const ND = W.div`
  position: relative;
  ${(e) => e.$disabled ? _r : null}
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_xxs);
`, ng = W.span`
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  width: var(--cc_size_spacing_m);
  height: var(--cc_size_spacing_m);
  border-width: var(--cc_size_border_width_s);
  border-style: solid;
  border-radius: 100%;
  background: var(--cc_color_background_1);
  transition: border-color 0.2s;
  &::after {
    content: '';
    position: absolute;
    width: var(--cc_size_spacing_s);
    height: var(--cc_size_spacing_s);
    top: 50%;
    left: 50%;
    border-radius: 100%;

    /* properties to transition */
    transform: translateX(-50%) translateY(-50%) scale(0.1);
    transition: all 0.2s;
    opacity: 0;
  }
  ${(e) => e.$checked ? le`
          border-color: ${e.$status !== "normal" && !e.$disabled ? Pt(e.$status).accentColor : "var(--cc_color_button_background_secondary)"};
          &::after {
            background-color: ${e.$status !== "normal" && !e.$disabled ? Pt(e.$status).accentColor : "var(--cc_color_button_background_secondary)"};
            opacity: 1;
            transform: translateX(-50%) translateY(-50%) scale(1);
          }
        ` : le`
          border-color: var(--cc_color_border_input_inactive);
        `}
`, ig = W.label`
  all: initial;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: var(--cc_size_spacing_s);
  cursor: ${(e) => e.$disabled ? "not-allowed;" : "pointer"};
  &:hover ${ng} {
    ${(e) => e.$disabled ? null : le`
            border-color: ${e.$checked ? "var(--cc_color_link_subtle)" : "var(--cc_color_link_secondary)"};
          `}
  }
`, zD = W.input`
  all: initial;
  ${fr}
  &:focus-visible ~ ${ig} {
    ${(e) => Pt(e.$status).focusStyles}
    border-radius: var(--cc_size_border_radius_m);
    outline-offset: var(--cc_size_spacing_xxs);
  }
`, VD = W.span`
  ${Lt}
  flex: 1;
  min-width: 1px;
  gap: var(--cc_size_spacing_s);
  font-size: var(--cc_size_text_s);
  color: var(--cc_color_link_secondary);
  transform: translateY(-1px);
  user-select: none;
`;
function YD({
  id: e,
  label: n,
  name: t,
  onChange: r,
  testId: i,
  value: o,
  ...a
}) {
  const {
    status: c = "normal",
    className: d,
    style: p,
    checked: m = !1,
    disabled: v = !1,
    ...y
  } = a;
  return /* @__PURE__ */ pe(
    ND,
    {
      $disabled: a.disabled,
      $status: c,
      style: p,
      className: d,
      children: [
        /* @__PURE__ */ L(
          zD,
          {
            type: "radio",
            "aria-invalid": c === "error",
            "aria-disabled": v,
            checked: m,
            "data-testid": i,
            id: e,
            name: t,
            onChange: r,
            value: o,
            $status: c,
            ...y
          }
        ),
        /* @__PURE__ */ pe(
          ig,
          {
            htmlFor: e,
            $checked: a.checked,
            $disabled: a.disabled,
            children: [
              /* @__PURE__ */ L(
                ng,
                {
                  $checked: a.checked,
                  $status: c,
                  $disabled: a.disabled
                }
              ),
              /* @__PURE__ */ L(VD, { children: n })
            ]
          }
        )
      ]
    }
  );
}
function hI({
  onChange: e,
  options: n,
  selectedValue: t,
  ...r
}) {
  return /* @__PURE__ */ L($h, { ...r, children: n.map((i) => /* @__PURE__ */ L(
    YD,
    {
      label: i.label,
      status: i.status || r.status,
      value: i.value,
      id: i.value,
      testId: i.testId,
      name: r.id,
      onChange: e,
      checked: t === i.value,
      disabled: i.disabled || r.disabled,
      style: i.style
    },
    i.value
  )) });
}
const HD = W.span`
  min-height: var(--cc_size_spacing_l);
  display: flex;
  align-items: center;
  ${(e) => e.$disabled ? _r : null}
`, Vf = W.span`
  flex-shrink: 0;
`, BD = W.label`
  all: initial;
  ${(e) => e.$hideLabel ? fr : le`
          box-sizing: border-box;
          display: block;
          margin-block-end: var(--cc_size_spacing_xs);
        `}
`, Yf = le`
  width: 100%;
  height: var(--cc_size_spacing_xs);
  background: var(--cc_color_button_background_subtle);
  border-radius: var(--cc_size_border_radius_pill);
  &:hover {
    border-color: var(--cc_color_link_secondary);
  }
`, Hf = (e, n) => le`
  box-sizing: border-box;
  background: ${e === "error" || e === "success" ? Pt(e).accentColor : "var(--cc_color_button_background_secondary)"};
  height: var(--cc_size_spacing_m);
  width: var(--cc_size_spacing_m);
  border-radius: 100%;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 0 0 var(--cc_size_spacing_s)
      var(--cc_color_button_background_secondary_alpha_10);
  }
`, WD = W.input`
  all: initial;
  position: relative;
  box-sizing: border-box;
  display: block;
  width: 100%;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  flex: 1;

  &::-webkit-slider-runnable-track {
    ${Yf}
  }

  &::-moz-range-track {
    ${Yf}
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    ${(e) => Hf(e.$status, e.disabled)}

    /* 
    track height in pixels / 2) - (thumb height in pixels / 2)
    https://www.smashingmagazine.com/2021/12/create-custom-range-input-consistent-browsers/
    */
    margin-top: calc(
      (var(--cc_size_spacing_xs) / 2) - (var(--cc_size_spacing_m) / 2)
    );
  }
  &::-moz-range-thumb {
    ${(e) => Hf(e.$status, e.disabled)}
    border: none;
  }

  &:disabled {
    pointer-events: none;
  }

  &:focus-visible {
    ${(e) => Pt(e.$status).focusStyles}
    border-radius: var(--cc_size_border_radius_m);
    outline-offset: var(--cc_size_spacing_s);
  }
`, jD = W.output`
  ${dr}
  font-weight: 500;
  font-size: calc(var(--cc_size_text_xs) + 1px);
  flex-shrink: 0;
  background: var(--cc_color_background_3);
  color: var(--cc_color_text_subtle);
  padding: var(--cc_size_spacing_xs) var(--cc_size_spacing_s);
  border-radius: var(--cc_size_border_radius_m);
  min-width: var(--cc_size_spacing_xxl);
  text-align: center;
  margin-inline-start: var(--cc_size_spacing_m);
`;
function gI({
  contentBefore: e,
  contentAfter: n,
  hideLabel: t = !1,
  hideValue: r = !1,
  formatValue: i,
  label: o,
  min: a,
  max: c,
  step: d,
  value: p,
  onChange: m,
  ...v
}) {
  const {
    status: y = "normal",
    className: _,
    disabled: S = !1,
    style: E,
    message: Y,
    ...N
  } = v;
  return /* @__PURE__ */ pe(
    qn,
    {
      inputId: v.id,
      message: Y,
      className: _,
      status: y,
      style: E,
      children: [
        /* @__PURE__ */ L(BD, { htmlFor: v.id, $hideLabel: t, children: /* @__PURE__ */ L(Ji, { children: o }) }),
        /* @__PURE__ */ pe(HD, { $disabled: S, children: [
          e ? /* @__PURE__ */ L(Vf, { children: e }) : null,
          /* @__PURE__ */ L(
            WD,
            {
              disabled: S,
              "aria-describedby": Y ? `${v.id}-message` : "",
              "aria-invalid": y === "error",
              "aria-valuenow": p,
              min: a,
              max: c,
              onChange: m,
              step: d,
              $status: y,
              type: "range",
              value: p,
              ...N
            }
          ),
          n ? /* @__PURE__ */ L(Vf, { children: n }) : null,
          r ? null : /* @__PURE__ */ L(jD, { htmlFor: v.id, children: i ? i(p) : p })
        ] })
      ]
    }
  );
}
const GD = W.label`
  all: initial;
  ${(e) => e.$hideLabel ? fr : le`
          box-sizing: border-box;
          display: block;
          margin-block-end: var(--cc_size_spacing_xs);
        `}
`, qD = W.div`
  position: relative;
  border-width: var(--cc_size_border_width_s);
  border-style: solid;
  border-color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_border_input_inactive)"};
  min-width: 165px;
  transition: border-color 0.2s;
  border-radius: var(--cc_size_border_radius_l);
  background: var(--cc_color_background_1);
  border-color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_border_input_inactive)"};
  ${(e) => e.$message ? "margin-block-end: var(--cc_size_spacing_xs);" : null}
  ${(e) => e.$disabled ? le`
          ${_r}
          background-color: var(--cc_color_background_3);
        ` : le`
          &:hover {
            border-color: var(--cc_color_button_background_secondary);
          }
        `}

  &:focus-within {
    ${(e) => Pt(e.$status).focusStyles}
    border-color: transparent;
    outline-offset: -2px;
  }
`, KD = W.select`
  all: initial;
  appearance: none;
  ${Lt};
  box-sizing: border-box;
  background: transparent;
  display: block;
  width: 100%;
  max-width: 100%;
  color: var(--cc_color_link_secondary);
  accent-color: var(--cc_color_link_secondary);
  font-size: ${(e) => e.$inputSize === "large" ? "var(--cc_size_text_m)" : "var(--cc_size_text_s)"};
  padding: ${(e) => e.$inputSize === "large" ? "0 var(--cc_size_spacing_xl) 0 var(--cc_size_spacing_m)" : "0 var(--cc_size_spacing_xl) 0 calc(var(--cc_size_spacing_m) * 0.75)"};

  height: ${(e) => e.$inputSize === "medium" ? 38 : 48}px;
  line-height: ${(e) => e.$inputSize === "medium" ? 38 : 48}px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &::placeholder {
    color: var(--cc_color_text_nonessential);
  }
  &:focus,
  &:focus-visible {
    outline: none;
  }
`, UD = W.i`
  position: absolute;
  inset-inline-end: var(--cc_size_spacing_s);
  inset-block-start: 50%;
  transform: translateY(-50%);
  font-size: var(--cc_size_text_l);
  color: var(--cc_color_link_subtle);
  pointer-events: none;
`;
function mI({
  className: e,
  style: n,
  message: t,
  status: r,
  label: i,
  hideLabel: o,
  options: a,
  inputSize: c = "medium",
  ...d
}) {
  return /* @__PURE__ */ pe(
    qn,
    {
      inputId: d.id,
      className: e,
      message: t,
      style: n,
      status: r,
      children: [
        /* @__PURE__ */ L(GD, { htmlFor: d.id, $hideLabel: o, children: /* @__PURE__ */ L(Ji, { children: i }) }),
        /* @__PURE__ */ pe(
          qD,
          {
            $message: t,
            $status: r,
            $disabled: d.disabled,
            children: [
              /* @__PURE__ */ L(
                KD,
                {
                  "aria-describedby": t ? `${d.id}-message` : "",
                  "aria-invalid": r === "error",
                  $inputSize: c,
                  ...d,
                  children: a.map((p) => /* @__PURE__ */ L(
                    "option",
                    {
                      value: p.value,
                      disabled: p.disabled,
                      children: p.label
                    },
                    p.value
                  ))
                }
              ),
              /* @__PURE__ */ L(UD, { className: "mdi mdi-chevron-down", role: "presentation" })
            ]
          }
        )
      ]
    }
  );
}
const QD = W.textarea`
  all: initial;
  box-sizing: border-box;
  display: block;
  white-space: pre-wrap; /* Needed for Firefox to respect line breaks: https://stackoverflow.com/questions/41011153/css-all-initial-breaks-firefox-newline-in-textareas */
  padding: ${(e) => e.$inputSize === "large" ? "var(--cc_size_spacing_m)" : "calc(var(--cc_size_spacing_m) * 0.75)"};
  width: 100%;
  max-width: 100%;
  ${Lt};
  font-size: ${(e) => e.$inputSize === "large" ? "var(--cc_size_text_m)" : "var(--cc_size_text_s)"};
  ${(e) => e.$message ? "margin-block-end: var(--cc_size_spacing_xs);" : null}
  background: var(--cc_color_background_1);
  color: var(--cc_color_text_default);
  border-width: var(--cc_size_border_width_s);
  border-style: solid;
  border-radius: var(--cc_size_border_radius_l);
  border-color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_border_input_inactive)"};
  overflow-y: ${(e) => e.rows ? "auto" : "hidden"};
  transition: border-color 0.2s, height 0.2s;

  &::placeholder {
    color: var(--cc_color_text_nonessential);
  }

  &:focus-visible {
    ${(e) => Pt(e.$status).focusStyles}
    border-color: transparent;
    outline-offset: -2px;
  }

  ${(e) => e.disabled ? le`
          ${_r}
          background-color: var(--cc_color_background_3);
        ` : le`
          &:hover {
            border-color: var(--cc_color_button_background_secondary);
          }
        `}
`, XD = W.label`
  all: initial;
  ${(e) => e.$hideLabel ? fr : le`
          box-sizing: border-box;
          display: block;
          margin-block-end: var(--cc_size_spacing_xs);
        `}
`;
function vI({
  hideLabel: e = !1,
  inputSize: n = "medium",
  label: t,
  value: r,
  onChange: i,
  ...o
}) {
  const a = We(null);
  ct(() => {
    if (!o.rows && a && a.current) {
      a.current.style.height = "auto";
      const _ = a.current.scrollHeight;
      a.current.style.height = `${_}px`;
    }
  }, [r, o.rows]);
  const {
    status: c = "normal",
    disabled: d = !1,
    message: p,
    className: m,
    style: v,
    ...y
  } = o;
  return /* @__PURE__ */ pe(
    qn,
    {
      inputId: o.id,
      className: m,
      message: p,
      style: v,
      status: c,
      children: [
        /* @__PURE__ */ L(XD, { htmlFor: o.id, $hideLabel: e, children: /* @__PURE__ */ L(Ji, { children: t }) }),
        /* @__PURE__ */ L(
          QD,
          {
            "aria-describedby": o.message ? `${o.id}-message` : "",
            "aria-invalid": c === "error",
            disabled: d,
            $inputSize: n,
            $message: p,
            onChange: i,
            ref: a,
            $status: c,
            value: r,
            ...y
          }
        )
      ]
    }
  );
}
const ZD = W.span`
  display: inline-flex;
  align-items: center;
  padding: 0 var(--cc_size_spacing_s);
  border-radius: var(--cc_size_border_radius_m);
  background-color: ${(e) => `var(--cc_color_label_${e.$color})`};
  height: var(--cc_size_avatar_s);
`, JD = W(Nt)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  color: ${(e) => e.$color === "yellow" ? pt.color_text_default_le : pt.color_text_default_de};
`;
function _I({ color: e, ...n }) {
  return /* @__PURE__ */ L(ZD, { ...n, $color: e, children: /* @__PURE__ */ L(
    JD,
    {
      forwardedAs: "span",
      family: "heading",
      size: "xs",
      weight: 500,
      $color: e,
      children: n.children
    }
  ) });
}
const eE = W.a`
  all: initial;
  display: inline-flex;
  align-items: center;
  gap: var(--cc_size_spacing_xs);
  color: var(--cc_color_link_primary);
  font-weight: 600;
  font-family: inherit;
  font-size: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: var(--cc_color_link_primary_alpha_20);
  text-decoration-thickness: 2px;

  &:hover {
    text-decoration-color: var(--cc_color_link_primary);
  }
`, tE = W.i`
  font-size: inherit;
  color: var(--cc_color_text_nonessential);
`;
function yI({ ...e }) {
  return /* @__PURE__ */ pe(eE, { ...e, children: [
    e.children,
    e.target === "_blank" && /* @__PURE__ */ L(
      tE,
      {
        "aria-hidden": "true",
        "data-testid": "link-external-icon",
        className: "mdi mdi-open-in-new"
      }
    )
  ] });
}
var hc = { exports: {} };
(function(e, n) {
  typeof navigator < "u" && function(t, r) {
    e.exports = r();
  }(Ss, function() {
    var t = "http://www.w3.org/2000/svg", r = "", i = !1, o = -999999, a = function(l) {
      i = !!l;
    }, c = function() {
      return i;
    }, d = function(l) {
      r = l;
    }, p = function() {
      return r;
    };
    function m(s) {
      return document.createElement(s);
    }
    function v(s, l) {
      var u, f = s.length, g;
      for (u = 0; u < f; u += 1) {
        g = s[u].prototype;
        for (var h in g)
          Object.prototype.hasOwnProperty.call(g, h) && (l.prototype[h] = g[h]);
      }
    }
    function y(s) {
      function l() {
      }
      return l.prototype = s, l;
    }
    var _ = function() {
      function s(l) {
        this.audios = [], this.audioFactory = l, this._volume = 1, this._isMuted = !1;
      }
      return s.prototype = {
        addAudio: function(u) {
          this.audios.push(u);
        },
        pause: function() {
          var u, f = this.audios.length;
          for (u = 0; u < f; u += 1)
            this.audios[u].pause();
        },
        resume: function() {
          var u, f = this.audios.length;
          for (u = 0; u < f; u += 1)
            this.audios[u].resume();
        },
        setRate: function(u) {
          var f, g = this.audios.length;
          for (f = 0; f < g; f += 1)
            this.audios[f].setRate(u);
        },
        createAudio: function(u) {
          return this.audioFactory ? this.audioFactory(u) : window.Howl ? new window.Howl({
            src: [u]
          }) : {
            isPlaying: !1,
            play: function() {
              this.isPlaying = !0;
            },
            seek: function() {
              this.isPlaying = !1;
            },
            playing: function() {
            },
            rate: function() {
            },
            setVolume: function() {
            }
          };
        },
        setAudioFactory: function(u) {
          this.audioFactory = u;
        },
        setVolume: function(u) {
          this._volume = u, this._updateVolume();
        },
        mute: function() {
          this._isMuted = !0, this._updateVolume();
        },
        unmute: function() {
          this._isMuted = !1, this._updateVolume();
        },
        getVolume: function() {
          return this._volume;
        },
        _updateVolume: function() {
          var u, f = this.audios.length;
          for (u = 0; u < f; u += 1)
            this.audios[u].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }, function() {
        return new s();
      };
    }(), S = /* @__PURE__ */ function() {
      function s(u, f) {
        var g = 0, h = [], w;
        switch (u) {
          case "int16":
          case "uint8c":
            w = 1;
            break;
          default:
            w = 1.1;
            break;
        }
        for (g = 0; g < f; g += 1)
          h.push(w);
        return h;
      }
      function l(u, f) {
        return u === "float32" ? new Float32Array(f) : u === "int16" ? new Int16Array(f) : u === "uint8c" ? new Uint8ClampedArray(f) : s(u, f);
      }
      return typeof Uint8ClampedArray == "function" && typeof Float32Array == "function" ? l : s;
    }();
    function E(s) {
      return Array.apply(null, {
        length: s
      });
    }
    var Y = !0, N = null, I = "", Q = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), te = Math.pow, ie = Math.sqrt, ne = Math.floor, re = Math.min, ce = 150, de = Math.PI / 180, ge = 0.5519;
    function $e(s, l, u, f) {
      this.type = s, this.currentTime = l, this.totalTime = u, this.direction = f < 0 ? -1 : 1;
    }
    function Le(s, l) {
      this.type = s, this.direction = l < 0 ? -1 : 1;
    }
    function ze(s, l, u, f) {
      this.type = s, this.currentLoop = u, this.totalLoops = l, this.direction = f < 0 ? -1 : 1;
    }
    function ke(s, l, u) {
      this.type = s, this.firstFrame = l, this.totalFrames = u;
    }
    function fe(s, l) {
      this.type = s, this.target = l;
    }
    function De(s, l) {
      this.type = "renderFrameError", this.nativeError = s, this.currentTime = l;
    }
    function _e(s) {
      this.type = "configError", this.nativeError = s;
    }
    var ue = /* @__PURE__ */ function() {
      var s = 0;
      return function() {
        return s += 1, I + "__lottie_element_" + s;
      };
    }();
    function Ve(s, l, u) {
      var f, g, h, w, M, x, A, z;
      switch (w = Math.floor(s * 6), M = s * 6 - w, x = u * (1 - l), A = u * (1 - M * l), z = u * (1 - (1 - M) * l), w % 6) {
        case 0:
          f = u, g = z, h = x;
          break;
        case 1:
          f = A, g = u, h = x;
          break;
        case 2:
          f = x, g = u, h = z;
          break;
        case 3:
          f = x, g = A, h = u;
          break;
        case 4:
          f = z, g = x, h = u;
          break;
        case 5:
          f = u, g = x, h = A;
          break;
      }
      return [f, g, h];
    }
    function Ne(s, l, u) {
      var f = Math.max(s, l, u), g = Math.min(s, l, u), h = f - g, w, M = f === 0 ? 0 : h / f, x = f / 255;
      switch (f) {
        case g:
          w = 0;
          break;
        case s:
          w = l - u + h * (l < u ? 6 : 0), w /= 6 * h;
          break;
        case l:
          w = u - s + h * 2, w /= 6 * h;
          break;
        case u:
          w = s - l + h * 4, w /= 6 * h;
          break;
      }
      return [w, M, x];
    }
    function Re(s, l) {
      var u = Ne(s[0] * 255, s[1] * 255, s[2] * 255);
      return u[1] += l, u[1] > 1 ? u[1] = 1 : u[1] <= 0 && (u[1] = 0), Ve(u[0], u[1], u[2]);
    }
    function Ee(s, l) {
      var u = Ne(s[0] * 255, s[1] * 255, s[2] * 255);
      return u[2] += l, u[2] > 1 ? u[2] = 1 : u[2] < 0 && (u[2] = 0), Ve(u[0], u[1], u[2]);
    }
    function Be(s, l) {
      var u = Ne(s[0] * 255, s[1] * 255, s[2] * 255);
      return u[0] += l / 360, u[0] > 1 ? u[0] -= 1 : u[0] < 0 && (u[0] += 1), Ve(u[0], u[1], u[2]);
    }
    (function() {
      var s = [], l, u;
      for (l = 0; l < 256; l += 1)
        u = l.toString(16), s[l] = u.length === 1 ? "0" + u : u;
      return function(f, g, h) {
        return f < 0 && (f = 0), g < 0 && (g = 0), h < 0 && (h = 0), "#" + s[f] + s[g] + s[h];
      };
    })();
    var je = function(l) {
      Y = !!l;
    }, Ke = function() {
      return Y;
    }, nt = function(l) {
      N = l;
    }, ut = function() {
      return N;
    }, wt = function(l) {
      ce = l;
    }, Rt = function() {
      return ce;
    }, Mr = function(l) {
      I = l;
    };
    function ve(s) {
      return document.createElementNS(t, s);
    }
    function dt(s) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? dt = function(u) {
        return typeof u;
      } : dt = function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, dt(s);
    }
    var St = /* @__PURE__ */ function() {
      var s = 1, l = [], u, f, g = {
        onmessage: function() {
        },
        postMessage: function(V) {
          u({
            data: V
          });
        }
      }, h = {
        postMessage: function(V) {
          g.onmessage({
            data: V
          });
        }
      };
      function w(D) {
        if (window.Worker && window.Blob && c()) {
          var V = new Blob(["var _workerSelf = self; self.onmessage = ", D.toString()], {
            type: "text/javascript"
          }), j = URL.createObjectURL(V);
          return new Worker(j);
        }
        return u = D, g;
      }
      function M() {
        f || (f = w(function(V) {
          function j() {
            function U(oe, $) {
              var B, b, k = oe.length, J, q, ye, Me;
              for (b = 0; b < k; b += 1)
                if (B = oe[b], "ks" in B && !B.completed) {
                  if (B.completed = !0, B.hasMask) {
                    var Ie = B.masksProperties;
                    for (q = Ie.length, J = 0; J < q; J += 1)
                      if (Ie[J].pt.k.i)
                        F(Ie[J].pt.k);
                      else
                        for (Me = Ie[J].pt.k.length, ye = 0; ye < Me; ye += 1)
                          Ie[J].pt.k[ye].s && F(Ie[J].pt.k[ye].s[0]), Ie[J].pt.k[ye].e && F(Ie[J].pt.k[ye].e[0]);
                  }
                  B.ty === 0 ? (B.layers = C(B.refId, $), U(B.layers, $)) : B.ty === 4 ? P(B.shapes) : B.ty === 5 && Ae(B);
                }
            }
            function O(oe, $) {
              if (oe) {
                var B = 0, b = oe.length;
                for (B = 0; B < b; B += 1)
                  oe[B].t === 1 && (oe[B].data.layers = C(oe[B].data.refId, $), U(oe[B].data.layers, $));
              }
            }
            function T(oe, $) {
              for (var B = 0, b = $.length; B < b; ) {
                if ($[B].id === oe)
                  return $[B];
                B += 1;
              }
              return null;
            }
            function C(oe, $) {
              var B = T(oe, $);
              return B ? B.layers.__used ? JSON.parse(JSON.stringify(B.layers)) : (B.layers.__used = !0, B.layers) : null;
            }
            function P(oe) {
              var $, B = oe.length, b, k;
              for ($ = B - 1; $ >= 0; $ -= 1)
                if (oe[$].ty === "sh")
                  if (oe[$].ks.k.i)
                    F(oe[$].ks.k);
                  else
                    for (k = oe[$].ks.k.length, b = 0; b < k; b += 1)
                      oe[$].ks.k[b].s && F(oe[$].ks.k[b].s[0]), oe[$].ks.k[b].e && F(oe[$].ks.k[b].e[0]);
                else
                  oe[$].ty === "gr" && P(oe[$].it);
            }
            function F(oe) {
              var $, B = oe.i.length;
              for ($ = 0; $ < B; $ += 1)
                oe.i[$][0] += oe.v[$][0], oe.i[$][1] += oe.v[$][1], oe.o[$][0] += oe.v[$][0], oe.o[$][1] += oe.v[$][1];
            }
            function G(oe, $) {
              var B = $ ? $.split(".") : [100, 100, 100];
              return oe[0] > B[0] ? !0 : B[0] > oe[0] ? !1 : oe[1] > B[1] ? !0 : B[1] > oe[1] ? !1 : oe[2] > B[2] ? !0 : B[2] > oe[2] ? !1 : null;
            }
            var X = /* @__PURE__ */ function() {
              var oe = [4, 4, 14];
              function $(b) {
                var k = b.t.d;
                b.t.d = {
                  k: [{
                    s: k,
                    t: 0
                  }]
                };
              }
              function B(b) {
                var k, J = b.length;
                for (k = 0; k < J; k += 1)
                  b[k].ty === 5 && $(b[k]);
              }
              return function(b) {
                if (G(oe, b.v) && (B(b.layers), b.assets)) {
                  var k, J = b.assets.length;
                  for (k = 0; k < J; k += 1)
                    b.assets[k].layers && B(b.assets[k].layers);
                }
              };
            }(), ee = /* @__PURE__ */ function() {
              var oe = [4, 7, 99];
              return function($) {
                if ($.chars && !G(oe, $.v)) {
                  var B, b = $.chars.length;
                  for (B = 0; B < b; B += 1) {
                    var k = $.chars[B];
                    k.data && k.data.shapes && (P(k.data.shapes), k.data.ip = 0, k.data.op = 99999, k.data.st = 0, k.data.sr = 1, k.data.ks = {
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      }
                    }, $.chars[B].t || (k.data.shapes.push({
                      ty: "no"
                    }), k.data.shapes[0].it.push({
                      p: {
                        k: [0, 0],
                        a: 0
                      },
                      s: {
                        k: [100, 100],
                        a: 0
                      },
                      a: {
                        k: [0, 0],
                        a: 0
                      },
                      r: {
                        k: 0,
                        a: 0
                      },
                      o: {
                        k: 100,
                        a: 0
                      },
                      sk: {
                        k: 0,
                        a: 0
                      },
                      sa: {
                        k: 0,
                        a: 0
                      },
                      ty: "tr"
                    })));
                  }
                }
              };
            }(), ae = /* @__PURE__ */ function() {
              var oe = [5, 7, 15];
              function $(b) {
                var k = b.t.p;
                typeof k.a == "number" && (k.a = {
                  a: 0,
                  k: k.a
                }), typeof k.p == "number" && (k.p = {
                  a: 0,
                  k: k.p
                }), typeof k.r == "number" && (k.r = {
                  a: 0,
                  k: k.r
                });
              }
              function B(b) {
                var k, J = b.length;
                for (k = 0; k < J; k += 1)
                  b[k].ty === 5 && $(b[k]);
              }
              return function(b) {
                if (G(oe, b.v) && (B(b.layers), b.assets)) {
                  var k, J = b.assets.length;
                  for (k = 0; k < J; k += 1)
                    b.assets[k].layers && B(b.assets[k].layers);
                }
              };
            }(), Te = /* @__PURE__ */ function() {
              var oe = [4, 1, 9];
              function $(b) {
                var k, J = b.length, q, ye;
                for (k = 0; k < J; k += 1)
                  if (b[k].ty === "gr")
                    $(b[k].it);
                  else if (b[k].ty === "fl" || b[k].ty === "st")
                    if (b[k].c.k && b[k].c.k[0].i)
                      for (ye = b[k].c.k.length, q = 0; q < ye; q += 1)
                        b[k].c.k[q].s && (b[k].c.k[q].s[0] /= 255, b[k].c.k[q].s[1] /= 255, b[k].c.k[q].s[2] /= 255, b[k].c.k[q].s[3] /= 255), b[k].c.k[q].e && (b[k].c.k[q].e[0] /= 255, b[k].c.k[q].e[1] /= 255, b[k].c.k[q].e[2] /= 255, b[k].c.k[q].e[3] /= 255);
                    else
                      b[k].c.k[0] /= 255, b[k].c.k[1] /= 255, b[k].c.k[2] /= 255, b[k].c.k[3] /= 255;
              }
              function B(b) {
                var k, J = b.length;
                for (k = 0; k < J; k += 1)
                  b[k].ty === 4 && $(b[k].shapes);
              }
              return function(b) {
                if (G(oe, b.v) && (B(b.layers), b.assets)) {
                  var k, J = b.assets.length;
                  for (k = 0; k < J; k += 1)
                    b.assets[k].layers && B(b.assets[k].layers);
                }
              };
            }(), Ce = /* @__PURE__ */ function() {
              var oe = [4, 4, 18];
              function $(b) {
                var k, J = b.length, q, ye;
                for (k = J - 1; k >= 0; k -= 1)
                  if (b[k].ty === "sh")
                    if (b[k].ks.k.i)
                      b[k].ks.k.c = b[k].closed;
                    else
                      for (ye = b[k].ks.k.length, q = 0; q < ye; q += 1)
                        b[k].ks.k[q].s && (b[k].ks.k[q].s[0].c = b[k].closed), b[k].ks.k[q].e && (b[k].ks.k[q].e[0].c = b[k].closed);
                  else
                    b[k].ty === "gr" && $(b[k].it);
              }
              function B(b) {
                var k, J, q = b.length, ye, Me, Ie, Ge;
                for (J = 0; J < q; J += 1) {
                  if (k = b[J], k.hasMask) {
                    var qe = k.masksProperties;
                    for (Me = qe.length, ye = 0; ye < Me; ye += 1)
                      if (qe[ye].pt.k.i)
                        qe[ye].pt.k.c = qe[ye].cl;
                      else
                        for (Ge = qe[ye].pt.k.length, Ie = 0; Ie < Ge; Ie += 1)
                          qe[ye].pt.k[Ie].s && (qe[ye].pt.k[Ie].s[0].c = qe[ye].cl), qe[ye].pt.k[Ie].e && (qe[ye].pt.k[Ie].e[0].c = qe[ye].cl);
                  }
                  k.ty === 4 && $(k.shapes);
                }
              }
              return function(b) {
                if (G(oe, b.v) && (B(b.layers), b.assets)) {
                  var k, J = b.assets.length;
                  for (k = 0; k < J; k += 1)
                    b.assets[k].layers && B(b.assets[k].layers);
                }
              };
            }();
            function he(oe) {
              oe.__complete || (Te(oe), X(oe), ee(oe), ae(oe), Ce(oe), U(oe.layers, oe.assets), O(oe.chars, oe.assets), oe.__complete = !0);
            }
            function Ae(oe) {
              oe.t.a.length === 0 && "m" in oe.t.p;
            }
            var xe = {};
            return xe.completeData = he, xe.checkColors = Te, xe.checkChars = ee, xe.checkPathProperties = ae, xe.checkShapes = Ce, xe.completeLayers = U, xe;
          }
          if (h.dataManager || (h.dataManager = j()), h.assetLoader || (h.assetLoader = /* @__PURE__ */ function() {
            function U(T) {
              var C = T.getResponseHeader("content-type");
              return C && T.responseType === "json" && C.indexOf("json") !== -1 || T.response && dt(T.response) === "object" ? T.response : T.response && typeof T.response == "string" ? JSON.parse(T.response) : T.responseText ? JSON.parse(T.responseText) : null;
            }
            function O(T, C, P, F) {
              var G, X = new XMLHttpRequest();
              try {
                X.responseType = "json";
              } catch {
              }
              X.onreadystatechange = function() {
                if (X.readyState === 4)
                  if (X.status === 200)
                    G = U(X), P(G);
                  else
                    try {
                      G = U(X), P(G);
                    } catch (ee) {
                      F && F(ee);
                    }
              };
              try {
                X.open(["G", "E", "T"].join(""), T, !0);
              } catch {
                X.open(["G", "E", "T"].join(""), C + "/" + T, !0);
              }
              X.send();
            }
            return {
              load: O
            };
          }()), V.data.type === "loadAnimation")
            h.assetLoader.load(V.data.path, V.data.fullPath, function(U) {
              h.dataManager.completeData(U), h.postMessage({
                id: V.data.id,
                payload: U,
                status: "success"
              });
            }, function() {
              h.postMessage({
                id: V.data.id,
                status: "error"
              });
            });
          else if (V.data.type === "complete") {
            var H = V.data.animation;
            h.dataManager.completeData(H), h.postMessage({
              id: V.data.id,
              payload: H,
              status: "success"
            });
          } else
            V.data.type === "loadData" && h.assetLoader.load(V.data.path, V.data.fullPath, function(U) {
              h.postMessage({
                id: V.data.id,
                payload: U,
                status: "success"
              });
            }, function() {
              h.postMessage({
                id: V.data.id,
                status: "error"
              });
            });
        }), f.onmessage = function(D) {
          var V = D.data, j = V.id, H = l[j];
          l[j] = null, V.status === "success" ? H.onComplete(V.payload) : H.onError && H.onError();
        });
      }
      function x(D, V) {
        s += 1;
        var j = "processId_" + s;
        return l[j] = {
          onComplete: D,
          onError: V
        }, j;
      }
      function A(D, V, j) {
        M();
        var H = x(V, j);
        f.postMessage({
          type: "loadAnimation",
          path: D,
          fullPath: window.location.origin + window.location.pathname,
          id: H
        });
      }
      function z(D, V, j) {
        M();
        var H = x(V, j);
        f.postMessage({
          type: "loadData",
          path: D,
          fullPath: window.location.origin + window.location.pathname,
          id: H
        });
      }
      function Z(D, V, j) {
        M();
        var H = x(V, j);
        f.postMessage({
          type: "complete",
          animation: D,
          id: H
        });
      }
      return {
        loadAnimation: A,
        loadData: z,
        completeAnimation: Z
      };
    }(), ki = function() {
      var s = function() {
        var O = m("canvas");
        O.width = 1, O.height = 1;
        var T = O.getContext("2d");
        return T.fillStyle = "rgba(0,0,0,0)", T.fillRect(0, 0, 1, 1), O;
      }();
      function l() {
        this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function u() {
        this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
      }
      function f(O, T, C) {
        var P = "";
        if (O.e)
          P = O.p;
        else if (T) {
          var F = O.p;
          F.indexOf("images/") !== -1 && (F = F.split("/")[1]), P = T + F;
        } else
          P = C, P += O.u ? O.u : "", P += O.p;
        return P;
      }
      function g(O) {
        var T = 0, C = setInterval((function() {
          var P = O.getBBox();
          (P.width || T > 500) && (this._imageLoaded(), clearInterval(C)), T += 1;
        }).bind(this), 50);
      }
      function h(O) {
        var T = f(O, this.assetsPath, this.path), C = ve("image");
        Q ? this.testImageLoaded(C) : C.addEventListener("load", this._imageLoaded, !1), C.addEventListener("error", (function() {
          P.img = s, this._imageLoaded();
        }).bind(this), !1), C.setAttributeNS("http://www.w3.org/1999/xlink", "href", T), this._elementHelper.append ? this._elementHelper.append(C) : this._elementHelper.appendChild(C);
        var P = {
          img: C,
          assetData: O
        };
        return P;
      }
      function w(O) {
        var T = f(O, this.assetsPath, this.path), C = m("img");
        C.crossOrigin = "anonymous", C.addEventListener("load", this._imageLoaded, !1), C.addEventListener("error", (function() {
          P.img = s, this._imageLoaded();
        }).bind(this), !1), C.src = T;
        var P = {
          img: C,
          assetData: O
        };
        return P;
      }
      function M(O) {
        var T = {
          assetData: O
        }, C = f(O, this.assetsPath, this.path);
        return St.loadData(C, (function(P) {
          T.img = P, this._footageLoaded();
        }).bind(this), (function() {
          T.img = {}, this._footageLoaded();
        }).bind(this)), T;
      }
      function x(O, T) {
        this.imagesLoadedCb = T;
        var C, P = O.length;
        for (C = 0; C < P; C += 1)
          O[C].layers || (!O[C].t || O[C].t === "seq" ? (this.totalImages += 1, this.images.push(this._createImageData(O[C]))) : O[C].t === 3 && (this.totalFootages += 1, this.images.push(this.createFootageData(O[C]))));
      }
      function A(O) {
        this.path = O || "";
      }
      function z(O) {
        this.assetsPath = O || "";
      }
      function Z(O) {
        for (var T = 0, C = this.images.length; T < C; ) {
          if (this.images[T].assetData === O)
            return this.images[T].img;
          T += 1;
        }
        return null;
      }
      function D() {
        this.imagesLoadedCb = null, this.images.length = 0;
      }
      function V() {
        return this.totalImages === this.loadedAssets;
      }
      function j() {
        return this.totalFootages === this.loadedFootagesCount;
      }
      function H(O, T) {
        O === "svg" ? (this._elementHelper = T, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
      }
      function U() {
        this._imageLoaded = l.bind(this), this._footageLoaded = u.bind(this), this.testImageLoaded = g.bind(this), this.createFootageData = M.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
      }
      return U.prototype = {
        loadAssets: x,
        setAssetsPath: z,
        setPath: A,
        loadedImages: V,
        loadedFootages: j,
        destroy: D,
        getAsset: Z,
        createImgData: w,
        createImageData: h,
        imageLoaded: l,
        footageLoaded: u,
        setCacheType: H
      }, U;
    }();
    function Du() {
    }
    Du.prototype = {
      triggerEvent: function(l, u) {
        if (this._cbs[l])
          for (var f = this._cbs[l], g = 0; g < f.length; g += 1)
            f[g](u);
      },
      addEventListener: function(l, u) {
        return this._cbs[l] || (this._cbs[l] = []), this._cbs[l].push(u), (function() {
          this.removeEventListener(l, u);
        }).bind(this);
      },
      removeEventListener: function(l, u) {
        if (!u)
          this._cbs[l] = null;
        else if (this._cbs[l]) {
          for (var f = 0, g = this._cbs[l].length; f < g; )
            this._cbs[l][f] === u && (this._cbs[l].splice(f, 1), f -= 1, g -= 1), f += 1;
          this._cbs[l].length || (this._cbs[l] = null);
        }
      }
    };
    var Ng = /* @__PURE__ */ function() {
      function s(l) {
        for (var u = l.split(`\r
`), f = {}, g, h = 0, w = 0; w < u.length; w += 1)
          g = u[w].split(":"), g.length === 2 && (f[g[0]] = g[1].trim(), h += 1);
        if (h === 0)
          throw new Error();
        return f;
      }
      return function(l) {
        for (var u = [], f = 0; f < l.length; f += 1) {
          var g = l[f], h = {
            time: g.tm,
            duration: g.dr
          };
          try {
            h.payload = JSON.parse(l[f].cm);
          } catch {
            try {
              h.payload = s(l[f].cm);
            } catch {
              h.payload = {
                name: l[f].cm
              };
            }
          }
          u.push(h);
        }
        return u;
      };
    }(), zg = /* @__PURE__ */ function() {
      function s(l) {
        this.compositions.push(l);
      }
      return function() {
        function l(u) {
          for (var f = 0, g = this.compositions.length; f < g; ) {
            if (this.compositions[f].data && this.compositions[f].data.nm === u)
              return this.compositions[f].prepareFrame && this.compositions[f].data.xt && this.compositions[f].prepareFrame(this.currentFrame), this.compositions[f].compInterface;
            f += 1;
          }
          return null;
        }
        return l.compositions = [], l.currentFrame = 0, l.registerComposition = s, l;
      };
    }(), ts = {}, Vg = function(l, u) {
      ts[l] = u;
    };
    function Yg(s) {
      return ts[s];
    }
    function Hg() {
      if (ts.canvas)
        return "canvas";
      for (var s in ts)
        if (ts[s])
          return s;
      return "";
    }
    function rs(s) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rs = function(u) {
        return typeof u;
      } : rs = function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, rs(s);
    }
    var Pe = function() {
      this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = ue(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = Ke(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = zg(), this.imagePreloader = new ki(), this.audioController = _(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new $e("drawnFrame", 0, 0, 0), this.expressionsPlugin = ut();
    };
    v([Du], Pe), Pe.prototype.setParams = function(s) {
      (s.wrapper || s.container) && (this.wrapper = s.wrapper || s.container);
      var l = "svg";
      s.animType ? l = s.animType : s.renderer && (l = s.renderer);
      var u = Yg(l);
      this.renderer = new u(this, s.rendererSettings), this.imagePreloader.setCacheType(l, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = l, s.loop === "" || s.loop === null || s.loop === void 0 || s.loop === !0 ? this.loop = !0 : s.loop === !1 ? this.loop = !1 : this.loop = parseInt(s.loop, 10), this.autoplay = "autoplay" in s ? s.autoplay : !0, this.name = s.name ? s.name : "", this.autoloadSegments = Object.prototype.hasOwnProperty.call(s, "autoloadSegments") ? s.autoloadSegments : !0, this.assetsPath = s.assetsPath, this.initialSegment = s.initialSegment, s.audioFactory && this.audioController.setAudioFactory(s.audioFactory), s.animationData ? this.setupAnimation(s.animationData) : s.path && (s.path.lastIndexOf("\\") !== -1 ? this.path = s.path.substr(0, s.path.lastIndexOf("\\") + 1) : this.path = s.path.substr(0, s.path.lastIndexOf("/") + 1), this.fileName = s.path.substr(s.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), St.loadAnimation(s.path, this.configAnimation, this.onSetupError));
    }, Pe.prototype.onSetupError = function() {
      this.trigger("data_failed");
    }, Pe.prototype.setupAnimation = function(s) {
      St.completeAnimation(s, this.configAnimation);
    }, Pe.prototype.setData = function(s, l) {
      l && rs(l) !== "object" && (l = JSON.parse(l));
      var u = {
        wrapper: s,
        animationData: l
      }, f = s.attributes;
      u.path = f.getNamedItem("data-animation-path") ? f.getNamedItem("data-animation-path").value : f.getNamedItem("data-bm-path") ? f.getNamedItem("data-bm-path").value : f.getNamedItem("bm-path") ? f.getNamedItem("bm-path").value : "", u.animType = f.getNamedItem("data-anim-type") ? f.getNamedItem("data-anim-type").value : f.getNamedItem("data-bm-type") ? f.getNamedItem("data-bm-type").value : f.getNamedItem("bm-type") ? f.getNamedItem("bm-type").value : f.getNamedItem("data-bm-renderer") ? f.getNamedItem("data-bm-renderer").value : f.getNamedItem("bm-renderer") ? f.getNamedItem("bm-renderer").value : Hg() || "canvas";
      var g = f.getNamedItem("data-anim-loop") ? f.getNamedItem("data-anim-loop").value : f.getNamedItem("data-bm-loop") ? f.getNamedItem("data-bm-loop").value : f.getNamedItem("bm-loop") ? f.getNamedItem("bm-loop").value : "";
      g === "false" ? u.loop = !1 : g === "true" ? u.loop = !0 : g !== "" && (u.loop = parseInt(g, 10));
      var h = f.getNamedItem("data-anim-autoplay") ? f.getNamedItem("data-anim-autoplay").value : f.getNamedItem("data-bm-autoplay") ? f.getNamedItem("data-bm-autoplay").value : f.getNamedItem("bm-autoplay") ? f.getNamedItem("bm-autoplay").value : !0;
      u.autoplay = h !== "false", u.name = f.getNamedItem("data-name") ? f.getNamedItem("data-name").value : f.getNamedItem("data-bm-name") ? f.getNamedItem("data-bm-name").value : f.getNamedItem("bm-name") ? f.getNamedItem("bm-name").value : "";
      var w = f.getNamedItem("data-anim-prerender") ? f.getNamedItem("data-anim-prerender").value : f.getNamedItem("data-bm-prerender") ? f.getNamedItem("data-bm-prerender").value : f.getNamedItem("bm-prerender") ? f.getNamedItem("bm-prerender").value : "";
      w === "false" && (u.prerender = !1), u.path ? this.setParams(u) : this.trigger("destroy");
    }, Pe.prototype.includeLayers = function(s) {
      s.op > this.animationData.op && (this.animationData.op = s.op, this.totalFrames = Math.floor(s.op - this.animationData.ip));
      var l = this.animationData.layers, u, f = l.length, g = s.layers, h, w = g.length;
      for (h = 0; h < w; h += 1)
        for (u = 0; u < f; ) {
          if (l[u].id === g[h].id) {
            l[u] = g[h];
            break;
          }
          u += 1;
        }
      if ((s.chars || s.fonts) && (this.renderer.globalData.fontManager.addChars(s.chars), this.renderer.globalData.fontManager.addFonts(s.fonts, this.renderer.globalData.defs)), s.assets)
        for (f = s.assets.length, u = 0; u < f; u += 1)
          this.animationData.assets.push(s.assets[u]);
      this.animationData.__complete = !1, St.completeAnimation(this.animationData, this.onSegmentComplete);
    }, Pe.prototype.onSegmentComplete = function(s) {
      this.animationData = s;
      var l = ut();
      l && l.initExpressions(this), this.loadNextSegment();
    }, Pe.prototype.loadNextSegment = function() {
      var s = this.animationData.segments;
      if (!s || s.length === 0 || !this.autoloadSegments) {
        this.trigger("data_ready"), this.timeCompleted = this.totalFrames;
        return;
      }
      var l = s.shift();
      this.timeCompleted = l.time * this.frameRate;
      var u = this.path + this.fileName + "_" + this.segmentPos + ".json";
      this.segmentPos += 1, St.loadData(u, this.includeLayers.bind(this), (function() {
        this.trigger("data_failed");
      }).bind(this));
    }, Pe.prototype.loadSegments = function() {
      var s = this.animationData.segments;
      s || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
    }, Pe.prototype.imagesLoaded = function() {
      this.trigger("loaded_images"), this.checkLoaded();
    }, Pe.prototype.preloadImages = function() {
      this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
    }, Pe.prototype.configAnimation = function(s) {
      if (this.renderer)
        try {
          this.animationData = s, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(s), s.assets || (s.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(s.assets), this.markers = Ng(s.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
        } catch (l) {
          this.triggerConfigError(l);
        }
    }, Pe.prototype.waitForFontsLoaded = function() {
      this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
    }, Pe.prototype.checkLoaded = function() {
      if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== "canvas") && this.imagePreloader.loadedFootages()) {
        this.isLoaded = !0;
        var s = ut();
        s && s.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
          this.trigger("DOMLoaded");
        }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
      }
    }, Pe.prototype.resize = function(s, l) {
      var u = typeof s == "number" ? s : void 0, f = typeof l == "number" ? l : void 0;
      this.renderer.updateContainerSize(u, f);
    }, Pe.prototype.setSubframe = function(s) {
      this.isSubframeEnabled = !!s;
    }, Pe.prototype.gotoFrame = function() {
      this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
    }, Pe.prototype.renderFrame = function() {
      if (!(this.isLoaded === !1 || !this.renderer))
        try {
          this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
        } catch (s) {
          this.triggerRenderFrameError(s);
        }
    }, Pe.prototype.play = function(s) {
      s && this.name !== s || this.isPaused === !0 && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
    }, Pe.prototype.pause = function(s) {
      s && this.name !== s || this.isPaused === !1 && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
    }, Pe.prototype.togglePause = function(s) {
      s && this.name !== s || (this.isPaused === !0 ? this.play() : this.pause());
    }, Pe.prototype.stop = function(s) {
      s && this.name !== s || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
    }, Pe.prototype.getMarkerData = function(s) {
      for (var l, u = 0; u < this.markers.length; u += 1)
        if (l = this.markers[u], l.payload && l.payload.name === s)
          return l;
      return null;
    }, Pe.prototype.goToAndStop = function(s, l, u) {
      if (!(u && this.name !== u)) {
        var f = Number(s);
        if (isNaN(f)) {
          var g = this.getMarkerData(s);
          g && this.goToAndStop(g.time, !0);
        } else
          l ? this.setCurrentRawFrameValue(s) : this.setCurrentRawFrameValue(s * this.frameModifier);
        this.pause();
      }
    }, Pe.prototype.goToAndPlay = function(s, l, u) {
      if (!(u && this.name !== u)) {
        var f = Number(s);
        if (isNaN(f)) {
          var g = this.getMarkerData(s);
          g && (g.duration ? this.playSegments([g.time, g.time + g.duration], !0) : this.goToAndStop(g.time, !0));
        } else
          this.goToAndStop(f, l, u);
        this.play();
      }
    }, Pe.prototype.advanceTime = function(s) {
      if (!(this.isPaused === !0 || this.isLoaded === !1)) {
        var l = this.currentRawFrame + s * this.frameModifier, u = !1;
        l >= this.totalFrames - 1 && this.frameModifier > 0 ? !this.loop || this.playCount === this.loop ? this.checkSegments(l > this.totalFrames ? l % this.totalFrames : 0) || (u = !0, l = this.totalFrames - 1) : l >= this.totalFrames ? (this.playCount += 1, this.checkSegments(l % this.totalFrames) || (this.setCurrentRawFrameValue(l % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(l) : l < 0 ? this.checkSegments(l % this.totalFrames) || (this.loop && !(this.playCount-- <= 0 && this.loop !== !0) ? (this.setCurrentRawFrameValue(this.totalFrames + l % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0) : (u = !0, l = 0)) : this.setCurrentRawFrameValue(l), u && (this.setCurrentRawFrameValue(l), this.pause(), this.trigger("complete"));
      }
    }, Pe.prototype.adjustSegment = function(s, l) {
      this.playCount = 0, s[1] < s[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = s[0] - s[1], this.timeCompleted = this.totalFrames, this.firstFrame = s[1], this.setCurrentRawFrameValue(this.totalFrames - 1e-3 - l)) : s[1] > s[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = s[1] - s[0], this.timeCompleted = this.totalFrames, this.firstFrame = s[0], this.setCurrentRawFrameValue(1e-3 + l)), this.trigger("segmentStart");
    }, Pe.prototype.setSegment = function(s, l) {
      var u = -1;
      this.isPaused && (this.currentRawFrame + this.firstFrame < s ? u = s : this.currentRawFrame + this.firstFrame > l && (u = l - s)), this.firstFrame = s, this.totalFrames = l - s, this.timeCompleted = this.totalFrames, u !== -1 && this.goToAndStop(u, !0);
    }, Pe.prototype.playSegments = function(s, l) {
      if (l && (this.segments.length = 0), rs(s[0]) === "object") {
        var u, f = s.length;
        for (u = 0; u < f; u += 1)
          this.segments.push(s[u]);
      } else
        this.segments.push(s);
      this.segments.length && l && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
    }, Pe.prototype.resetSegments = function(s) {
      this.segments.length = 0, this.segments.push([this.animationData.ip, this.animationData.op]), s && this.checkSegments(0);
    }, Pe.prototype.checkSegments = function(s) {
      return this.segments.length ? (this.adjustSegment(this.segments.shift(), s), !0) : !1;
    }, Pe.prototype.destroy = function(s) {
      s && this.name !== s || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
    }, Pe.prototype.setCurrentRawFrameValue = function(s) {
      this.currentRawFrame = s, this.gotoFrame();
    }, Pe.prototype.setSpeed = function(s) {
      this.playSpeed = s, this.updaFrameModifier();
    }, Pe.prototype.setDirection = function(s) {
      this.playDirection = s < 0 ? -1 : 1, this.updaFrameModifier();
    }, Pe.prototype.setLoop = function(s) {
      this.loop = s;
    }, Pe.prototype.setVolume = function(s, l) {
      l && this.name !== l || this.audioController.setVolume(s);
    }, Pe.prototype.getVolume = function() {
      return this.audioController.getVolume();
    }, Pe.prototype.mute = function(s) {
      s && this.name !== s || this.audioController.mute();
    }, Pe.prototype.unmute = function(s) {
      s && this.name !== s || this.audioController.unmute();
    }, Pe.prototype.updaFrameModifier = function() {
      this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
    }, Pe.prototype.getPath = function() {
      return this.path;
    }, Pe.prototype.getAssetsPath = function(s) {
      var l = "";
      if (s.e)
        l = s.p;
      else if (this.assetsPath) {
        var u = s.p;
        u.indexOf("images/") !== -1 && (u = u.split("/")[1]), l = this.assetsPath + u;
      } else
        l = this.path, l += s.u ? s.u : "", l += s.p;
      return l;
    }, Pe.prototype.getAssetData = function(s) {
      for (var l = 0, u = this.assets.length; l < u; ) {
        if (s === this.assets[l].id)
          return this.assets[l];
        l += 1;
      }
      return null;
    }, Pe.prototype.hide = function() {
      this.renderer.hide();
    }, Pe.prototype.show = function() {
      this.renderer.show();
    }, Pe.prototype.getDuration = function(s) {
      return s ? this.totalFrames : this.totalFrames / this.frameRate;
    }, Pe.prototype.updateDocumentData = function(s, l, u) {
      try {
        var f = this.renderer.getElementByPath(s);
        f.updateDocumentData(l, u);
      } catch {
      }
    }, Pe.prototype.trigger = function(s) {
      if (this._cbs && this._cbs[s])
        switch (s) {
          case "enterFrame":
            this.triggerEvent(s, new $e(s, this.currentFrame, this.totalFrames, this.frameModifier));
            break;
          case "drawnFrame":
            this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(s, this.drawnFrameEvent);
            break;
          case "loopComplete":
            this.triggerEvent(s, new ze(s, this.loop, this.playCount, this.frameMult));
            break;
          case "complete":
            this.triggerEvent(s, new Le(s, this.frameMult));
            break;
          case "segmentStart":
            this.triggerEvent(s, new ke(s, this.firstFrame, this.totalFrames));
            break;
          case "destroy":
            this.triggerEvent(s, new fe(s, this));
            break;
          default:
            this.triggerEvent(s);
        }
      s === "enterFrame" && this.onEnterFrame && this.onEnterFrame.call(this, new $e(s, this.currentFrame, this.totalFrames, this.frameMult)), s === "loopComplete" && this.onLoopComplete && this.onLoopComplete.call(this, new ze(s, this.loop, this.playCount, this.frameMult)), s === "complete" && this.onComplete && this.onComplete.call(this, new Le(s, this.frameMult)), s === "segmentStart" && this.onSegmentStart && this.onSegmentStart.call(this, new ke(s, this.firstFrame, this.totalFrames)), s === "destroy" && this.onDestroy && this.onDestroy.call(this, new fe(s, this));
    }, Pe.prototype.triggerRenderFrameError = function(s) {
      var l = new De(s, this.currentFrame);
      this.triggerEvent("error", l), this.onError && this.onError.call(this, l);
    }, Pe.prototype.triggerConfigError = function(s) {
      var l = new _e(s, this.currentFrame);
      this.triggerEvent("error", l), this.onError && this.onError.call(this, l);
    };
    var kt = function() {
      var s = {}, l = [], u = 0, f = 0, g = 0, h = !0, w = !1;
      function M($) {
        for (var B = 0, b = $.target; B < f; )
          l[B].animation === b && (l.splice(B, 1), B -= 1, f -= 1, b.isPaused || Z()), B += 1;
      }
      function x($, B) {
        if (!$)
          return null;
        for (var b = 0; b < f; ) {
          if (l[b].elem === $ && l[b].elem !== null)
            return l[b].animation;
          b += 1;
        }
        var k = new Pe();
        return D(k, $), k.setData($, B), k;
      }
      function A() {
        var $, B = l.length, b = [];
        for ($ = 0; $ < B; $ += 1)
          b.push(l[$].animation);
        return b;
      }
      function z() {
        g += 1, Te();
      }
      function Z() {
        g -= 1;
      }
      function D($, B) {
        $.addEventListener("destroy", M), $.addEventListener("_active", z), $.addEventListener("_idle", Z), l.push({
          elem: B,
          animation: $
        }), f += 1;
      }
      function V($) {
        var B = new Pe();
        return D(B, null), B.setParams($), B;
      }
      function j($, B) {
        var b;
        for (b = 0; b < f; b += 1)
          l[b].animation.setSpeed($, B);
      }
      function H($, B) {
        var b;
        for (b = 0; b < f; b += 1)
          l[b].animation.setDirection($, B);
      }
      function U($) {
        var B;
        for (B = 0; B < f; B += 1)
          l[B].animation.play($);
      }
      function O($) {
        var B = $ - u, b;
        for (b = 0; b < f; b += 1)
          l[b].animation.advanceTime(B);
        u = $, g && !w ? window.requestAnimationFrame(O) : h = !0;
      }
      function T($) {
        u = $, window.requestAnimationFrame(O);
      }
      function C($) {
        var B;
        for (B = 0; B < f; B += 1)
          l[B].animation.pause($);
      }
      function P($, B, b) {
        var k;
        for (k = 0; k < f; k += 1)
          l[k].animation.goToAndStop($, B, b);
      }
      function F($) {
        var B;
        for (B = 0; B < f; B += 1)
          l[B].animation.stop($);
      }
      function G($) {
        var B;
        for (B = 0; B < f; B += 1)
          l[B].animation.togglePause($);
      }
      function X($) {
        var B;
        for (B = f - 1; B >= 0; B -= 1)
          l[B].animation.destroy($);
      }
      function ee($, B, b) {
        var k = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), J, q = k.length;
        for (J = 0; J < q; J += 1)
          b && k[J].setAttribute("data-bm-type", b), x(k[J], $);
        if (B && q === 0) {
          b || (b = "svg");
          var ye = document.getElementsByTagName("body")[0];
          ye.innerText = "";
          var Me = m("div");
          Me.style.width = "100%", Me.style.height = "100%", Me.setAttribute("data-bm-type", b), ye.appendChild(Me), x(Me, $);
        }
      }
      function ae() {
        var $;
        for ($ = 0; $ < f; $ += 1)
          l[$].animation.resize();
      }
      function Te() {
        !w && g && h && (window.requestAnimationFrame(T), h = !1);
      }
      function Ce() {
        w = !0;
      }
      function he() {
        w = !1, Te();
      }
      function Ae($, B) {
        var b;
        for (b = 0; b < f; b += 1)
          l[b].animation.setVolume($, B);
      }
      function xe($) {
        var B;
        for (B = 0; B < f; B += 1)
          l[B].animation.mute($);
      }
      function oe($) {
        var B;
        for (B = 0; B < f; B += 1)
          l[B].animation.unmute($);
      }
      return s.registerAnimation = x, s.loadAnimation = V, s.setSpeed = j, s.setDirection = H, s.play = U, s.pause = C, s.stop = F, s.togglePause = G, s.searchAnimations = ee, s.resize = ae, s.goToAndStop = P, s.destroy = X, s.freeze = Ce, s.unfreeze = he, s.setVolume = Ae, s.mute = xe, s.unmute = oe, s.getRegisteredAnimations = A, s;
    }(), ns = function() {
      var s = {};
      s.getBezierEasing = u;
      var l = {};
      function u(T, C, P, F, G) {
        var X = G || ("bez_" + T + "_" + C + "_" + P + "_" + F).replace(/\./g, "p");
        if (l[X])
          return l[X];
        var ee = new O([T, C, P, F]);
        return l[X] = ee, ee;
      }
      var f = 4, g = 1e-3, h = 1e-7, w = 10, M = 11, x = 1 / (M - 1), A = typeof Float32Array == "function";
      function z(T, C) {
        return 1 - 3 * C + 3 * T;
      }
      function Z(T, C) {
        return 3 * C - 6 * T;
      }
      function D(T) {
        return 3 * T;
      }
      function V(T, C, P) {
        return ((z(C, P) * T + Z(C, P)) * T + D(C)) * T;
      }
      function j(T, C, P) {
        return 3 * z(C, P) * T * T + 2 * Z(C, P) * T + D(C);
      }
      function H(T, C, P, F, G) {
        var X, ee, ae = 0;
        do
          ee = C + (P - C) / 2, X = V(ee, F, G) - T, X > 0 ? P = ee : C = ee;
        while (Math.abs(X) > h && ++ae < w);
        return ee;
      }
      function U(T, C, P, F) {
        for (var G = 0; G < f; ++G) {
          var X = j(C, P, F);
          if (X === 0)
            return C;
          var ee = V(C, P, F) - T;
          C -= ee / X;
        }
        return C;
      }
      function O(T) {
        this._p = T, this._mSampleValues = A ? new Float32Array(M) : new Array(M), this._precomputed = !1, this.get = this.get.bind(this);
      }
      return O.prototype = {
        get: function(C) {
          var P = this._p[0], F = this._p[1], G = this._p[2], X = this._p[3];
          return this._precomputed || this._precompute(), P === F && G === X ? C : C === 0 ? 0 : C === 1 ? 1 : V(this._getTForX(C), F, X);
        },
        // Private part
        _precompute: function() {
          var C = this._p[0], P = this._p[1], F = this._p[2], G = this._p[3];
          this._precomputed = !0, (C !== P || F !== G) && this._calcSampleValues();
        },
        _calcSampleValues: function() {
          for (var C = this._p[0], P = this._p[2], F = 0; F < M; ++F)
            this._mSampleValues[F] = V(F * x, C, P);
        },
        /**
             * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
             */
        _getTForX: function(C) {
          for (var P = this._p[0], F = this._p[2], G = this._mSampleValues, X = 0, ee = 1, ae = M - 1; ee !== ae && G[ee] <= C; ++ee)
            X += x;
          --ee;
          var Te = (C - G[ee]) / (G[ee + 1] - G[ee]), Ce = X + Te * x, he = j(Ce, P, F);
          return he >= g ? U(C, Ce, P, F) : he === 0 ? Ce : H(C, X, X + x, P, F);
        }
      }, s;
    }(), Eu = /* @__PURE__ */ function() {
      function s(l) {
        return l.concat(E(l.length));
      }
      return {
        double: s
      };
    }(), Zs = /* @__PURE__ */ function() {
      return function(s, l, u) {
        var f = 0, g = s, h = E(g), w = {
          newElement: M,
          release: x
        };
        function M() {
          var A;
          return f ? (f -= 1, A = h[f]) : A = l(), A;
        }
        function x(A) {
          f === g && (h = Eu.double(h), g *= 2), u && u(A), h[f] = A, f += 1;
        }
        return w;
      };
    }(), Pu = function() {
      function s() {
        return {
          addedLength: 0,
          percents: S("float32", Rt()),
          lengths: S("float32", Rt())
        };
      }
      return Zs(8, s);
    }(), Mu = function() {
      function s() {
        return {
          lengths: [],
          totalLength: 0
        };
      }
      function l(u) {
        var f, g = u.lengths.length;
        for (f = 0; f < g; f += 1)
          Pu.release(u.lengths[f]);
        u.lengths.length = 0;
      }
      return Zs(8, s, l);
    }();
    function Bg() {
      var s = Math;
      function l(D, V, j, H, U, O) {
        var T = D * H + V * U + j * O - U * H - O * D - j * V;
        return T > -1e-3 && T < 1e-3;
      }
      function u(D, V, j, H, U, O, T, C, P) {
        if (j === 0 && O === 0 && P === 0)
          return l(D, V, H, U, T, C);
        var F = s.sqrt(s.pow(H - D, 2) + s.pow(U - V, 2) + s.pow(O - j, 2)), G = s.sqrt(s.pow(T - D, 2) + s.pow(C - V, 2) + s.pow(P - j, 2)), X = s.sqrt(s.pow(T - H, 2) + s.pow(C - U, 2) + s.pow(P - O, 2)), ee;
        return F > G ? F > X ? ee = F - G - X : ee = X - G - F : X > G ? ee = X - G - F : ee = G - F - X, ee > -1e-4 && ee < 1e-4;
      }
      var f = /* @__PURE__ */ function() {
        return function(D, V, j, H) {
          var U = Rt(), O, T, C, P, F, G = 0, X, ee = [], ae = [], Te = Pu.newElement();
          for (C = j.length, O = 0; O < U; O += 1) {
            for (F = O / (U - 1), X = 0, T = 0; T < C; T += 1)
              P = te(1 - F, 3) * D[T] + 3 * te(1 - F, 2) * F * j[T] + 3 * (1 - F) * te(F, 2) * H[T] + te(F, 3) * V[T], ee[T] = P, ae[T] !== null && (X += te(ee[T] - ae[T], 2)), ae[T] = ee[T];
            X && (X = ie(X), G += X), Te.percents[O] = F, Te.lengths[O] = G;
          }
          return Te.addedLength = G, Te;
        };
      }();
      function g(D) {
        var V = Mu.newElement(), j = D.c, H = D.v, U = D.o, O = D.i, T, C = D._length, P = V.lengths, F = 0;
        for (T = 0; T < C - 1; T += 1)
          P[T] = f(H[T], H[T + 1], U[T], O[T + 1]), F += P[T].addedLength;
        return j && C && (P[T] = f(H[T], H[0], U[T], O[0]), F += P[T].addedLength), V.totalLength = F, V;
      }
      function h(D) {
        this.segmentLength = 0, this.points = new Array(D);
      }
      function w(D, V) {
        this.partialLength = D, this.point = V;
      }
      var M = /* @__PURE__ */ function() {
        var D = {};
        return function(V, j, H, U) {
          var O = (V[0] + "_" + V[1] + "_" + j[0] + "_" + j[1] + "_" + H[0] + "_" + H[1] + "_" + U[0] + "_" + U[1]).replace(/\./g, "p");
          if (!D[O]) {
            var T = Rt(), C, P, F, G, X, ee = 0, ae, Te, Ce = null;
            V.length === 2 && (V[0] !== j[0] || V[1] !== j[1]) && l(V[0], V[1], j[0], j[1], V[0] + H[0], V[1] + H[1]) && l(V[0], V[1], j[0], j[1], j[0] + U[0], j[1] + U[1]) && (T = 2);
            var he = new h(T);
            for (F = H.length, C = 0; C < T; C += 1) {
              for (Te = E(F), X = C / (T - 1), ae = 0, P = 0; P < F; P += 1)
                G = te(1 - X, 3) * V[P] + 3 * te(1 - X, 2) * X * (V[P] + H[P]) + 3 * (1 - X) * te(X, 2) * (j[P] + U[P]) + te(X, 3) * j[P], Te[P] = G, Ce !== null && (ae += te(Te[P] - Ce[P], 2));
              ae = ie(ae), ee += ae, he.points[C] = new w(ae, Te), Ce = Te;
            }
            he.segmentLength = ee, D[O] = he;
          }
          return D[O];
        };
      }();
      function x(D, V) {
        var j = V.percents, H = V.lengths, U = j.length, O = ne((U - 1) * D), T = D * V.addedLength, C = 0;
        if (O === U - 1 || O === 0 || T === H[O])
          return j[O];
        for (var P = H[O] > T ? -1 : 1, F = !0; F; )
          if (H[O] <= T && H[O + 1] > T ? (C = (T - H[O]) / (H[O + 1] - H[O]), F = !1) : O += P, O < 0 || O >= U - 1) {
            if (O === U - 1)
              return j[O];
            F = !1;
          }
        return j[O] + (j[O + 1] - j[O]) * C;
      }
      function A(D, V, j, H, U, O) {
        var T = x(U, O), C = 1 - T, P = s.round((C * C * C * D[0] + (T * C * C + C * T * C + C * C * T) * j[0] + (T * T * C + C * T * T + T * C * T) * H[0] + T * T * T * V[0]) * 1e3) / 1e3, F = s.round((C * C * C * D[1] + (T * C * C + C * T * C + C * C * T) * j[1] + (T * T * C + C * T * T + T * C * T) * H[1] + T * T * T * V[1]) * 1e3) / 1e3;
        return [P, F];
      }
      var z = S("float32", 8);
      function Z(D, V, j, H, U, O, T) {
        U < 0 ? U = 0 : U > 1 && (U = 1);
        var C = x(U, T);
        O = O > 1 ? 1 : O;
        var P = x(O, T), F, G = D.length, X = 1 - C, ee = 1 - P, ae = X * X * X, Te = C * X * X * 3, Ce = C * C * X * 3, he = C * C * C, Ae = X * X * ee, xe = C * X * ee + X * C * ee + X * X * P, oe = C * C * ee + X * C * P + C * X * P, $ = C * C * P, B = X * ee * ee, b = C * ee * ee + X * P * ee + X * ee * P, k = C * P * ee + X * P * P + C * ee * P, J = C * P * P, q = ee * ee * ee, ye = P * ee * ee + ee * P * ee + ee * ee * P, Me = P * P * ee + ee * P * P + P * ee * P, Ie = P * P * P;
        for (F = 0; F < G; F += 1)
          z[F * 4] = s.round((ae * D[F] + Te * j[F] + Ce * H[F] + he * V[F]) * 1e3) / 1e3, z[F * 4 + 1] = s.round((Ae * D[F] + xe * j[F] + oe * H[F] + $ * V[F]) * 1e3) / 1e3, z[F * 4 + 2] = s.round((B * D[F] + b * j[F] + k * H[F] + J * V[F]) * 1e3) / 1e3, z[F * 4 + 3] = s.round((q * D[F] + ye * j[F] + Me * H[F] + Ie * V[F]) * 1e3) / 1e3;
        return z;
      }
      return {
        getSegmentsLength: g,
        getNewSegment: Z,
        getPointInSegment: A,
        buildBezierData: M,
        pointOnLine2D: l,
        pointOnLine3D: u
      };
    }
    var $r = Bg(), Un = o, $u = Math.abs;
    function Tu(s, l) {
      var u = this.offsetTime, f;
      this.propType === "multidimensional" && (f = S("float32", this.pv.length));
      for (var g = l.lastIndex, h = g, w = this.keyframes.length - 1, M = !0, x, A, z; M; ) {
        if (x = this.keyframes[h], A = this.keyframes[h + 1], h === w - 1 && s >= A.t - u) {
          x.h && (x = A), g = 0;
          break;
        }
        if (A.t - u > s) {
          g = h;
          break;
        }
        h < w - 1 ? h += 1 : (g = 0, M = !1);
      }
      z = this.keyframesMetadata[h] || {};
      var Z, D, V, j, H, U, O = A.t - u, T = x.t - u, C;
      if (x.to) {
        z.bezierData || (z.bezierData = $r.buildBezierData(x.s, A.s || x.e, x.to, x.ti));
        var P = z.bezierData;
        if (s >= O || s < T) {
          var F = s >= O ? P.points.length - 1 : 0;
          for (D = P.points[F].point.length, Z = 0; Z < D; Z += 1)
            f[Z] = P.points[F].point[Z];
        } else {
          z.__fnct ? U = z.__fnct : (U = ns.getBezierEasing(x.o.x, x.o.y, x.i.x, x.i.y, x.n).get, z.__fnct = U), V = U((s - T) / (O - T));
          var G = P.segmentLength * V, X, ee = l.lastFrame < s && l._lastKeyframeIndex === h ? l._lastAddedLength : 0;
          for (H = l.lastFrame < s && l._lastKeyframeIndex === h ? l._lastPoint : 0, M = !0, j = P.points.length; M; ) {
            if (ee += P.points[H].partialLength, G === 0 || V === 0 || H === P.points.length - 1) {
              for (D = P.points[H].point.length, Z = 0; Z < D; Z += 1)
                f[Z] = P.points[H].point[Z];
              break;
            } else if (G >= ee && G < ee + P.points[H + 1].partialLength) {
              for (X = (G - ee) / P.points[H + 1].partialLength, D = P.points[H].point.length, Z = 0; Z < D; Z += 1)
                f[Z] = P.points[H].point[Z] + (P.points[H + 1].point[Z] - P.points[H].point[Z]) * X;
              break;
            }
            H < j - 1 ? H += 1 : M = !1;
          }
          l._lastPoint = H, l._lastAddedLength = ee - P.points[H].partialLength, l._lastKeyframeIndex = h;
        }
      } else {
        var ae, Te, Ce, he, Ae;
        if (w = x.s.length, C = A.s || x.e, this.sh && x.h !== 1)
          if (s >= O)
            f[0] = C[0], f[1] = C[1], f[2] = C[2];
          else if (s <= T)
            f[0] = x.s[0], f[1] = x.s[1], f[2] = x.s[2];
          else {
            var xe = Iu(x.s), oe = Iu(C), $ = (s - T) / (O - T);
            jg(f, Wg(xe, oe, $));
          }
        else
          for (h = 0; h < w; h += 1)
            x.h !== 1 && (s >= O ? V = 1 : s < T ? V = 0 : (x.o.x.constructor === Array ? (z.__fnct || (z.__fnct = []), z.__fnct[h] ? U = z.__fnct[h] : (ae = x.o.x[h] === void 0 ? x.o.x[0] : x.o.x[h], Te = x.o.y[h] === void 0 ? x.o.y[0] : x.o.y[h], Ce = x.i.x[h] === void 0 ? x.i.x[0] : x.i.x[h], he = x.i.y[h] === void 0 ? x.i.y[0] : x.i.y[h], U = ns.getBezierEasing(ae, Te, Ce, he).get, z.__fnct[h] = U)) : z.__fnct ? U = z.__fnct : (ae = x.o.x, Te = x.o.y, Ce = x.i.x, he = x.i.y, U = ns.getBezierEasing(ae, Te, Ce, he).get, x.keyframeMetadata = U), V = U((s - T) / (O - T)))), C = A.s || x.e, Ae = x.h === 1 ? x.s[h] : x.s[h] + (C[h] - x.s[h]) * V, this.propType === "multidimensional" ? f[h] = Ae : f = Ae;
      }
      return l.lastIndex = g, f;
    }
    function Wg(s, l, u) {
      var f = [], g = s[0], h = s[1], w = s[2], M = s[3], x = l[0], A = l[1], z = l[2], Z = l[3], D, V, j, H, U;
      return V = g * x + h * A + w * z + M * Z, V < 0 && (V = -V, x = -x, A = -A, z = -z, Z = -Z), 1 - V > 1e-6 ? (D = Math.acos(V), j = Math.sin(D), H = Math.sin((1 - u) * D) / j, U = Math.sin(u * D) / j) : (H = 1 - u, U = u), f[0] = H * g + U * x, f[1] = H * h + U * A, f[2] = H * w + U * z, f[3] = H * M + U * Z, f;
    }
    function jg(s, l) {
      var u = l[0], f = l[1], g = l[2], h = l[3], w = Math.atan2(2 * f * h - 2 * u * g, 1 - 2 * f * f - 2 * g * g), M = Math.asin(2 * u * f + 2 * g * h), x = Math.atan2(2 * u * h - 2 * f * g, 1 - 2 * u * u - 2 * g * g);
      s[0] = w / de, s[1] = M / de, s[2] = x / de;
    }
    function Iu(s) {
      var l = s[0] * de, u = s[1] * de, f = s[2] * de, g = Math.cos(l / 2), h = Math.cos(u / 2), w = Math.cos(f / 2), M = Math.sin(l / 2), x = Math.sin(u / 2), A = Math.sin(f / 2), z = g * h * w - M * x * A, Z = M * x * w + g * h * A, D = M * h * w + g * x * A, V = g * x * w - M * h * A;
      return [Z, D, V, z];
    }
    function Ru() {
      var s = this.comp.renderedFrame - this.offsetTime, l = this.keyframes[0].t - this.offsetTime, u = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      if (!(s === this._caching.lastFrame || this._caching.lastFrame !== Un && (this._caching.lastFrame >= u && s >= u || this._caching.lastFrame < l && s < l))) {
        this._caching.lastFrame >= s && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
        var f = this.interpolateValue(s, this._caching);
        this.pv = f;
      }
      return this._caching.lastFrame = s, this.pv;
    }
    function Js(s) {
      var l;
      if (this.propType === "unidimensional")
        l = s * this.mult, $u(this.v - l) > 1e-5 && (this.v = l, this._mdf = !0);
      else
        for (var u = 0, f = this.v.length; u < f; )
          l = s[u] * this.mult, $u(this.v[u] - l) > 1e-5 && (this.v[u] = l, this._mdf = !0), u += 1;
    }
    function eo() {
      if (!(this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length)) {
        if (this.lock) {
          this.setVValue(this.pv);
          return;
        }
        this.lock = !0, this._mdf = this._isFirstFrame;
        var s, l = this.effectsSequence.length, u = this.kf ? this.pv : this.data.k;
        for (s = 0; s < l; s += 1)
          u = this.effectsSequence[s](u);
        this.setVValue(u), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }
    function to(s) {
      this.effectsSequence.push(s), this.container.addDynamicProperty(this);
    }
    function Gg(s, l, u, f) {
      this.propType = "unidimensional", this.mult = u || 1, this.data = l, this.v = u ? l.k * u : l.k, this.pv = l.k, this._mdf = !1, this.elem = s, this.container = f, this.comp = s.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = eo, this.setVValue = Js, this.addEffect = to;
    }
    function qg(s, l, u, f) {
      this.propType = "multidimensional", this.mult = u || 1, this.data = l, this._mdf = !1, this.elem = s, this.container = f, this.comp = s.comp, this.k = !1, this.kf = !1, this.frameId = -1;
      var g, h = l.k.length;
      for (this.v = S("float32", h), this.pv = S("float32", h), this.vel = S("float32", h), g = 0; g < h; g += 1)
        this.v[g] = l.k[g] * this.mult, this.pv[g] = l.k[g];
      this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = eo, this.setVValue = Js, this.addEffect = to;
    }
    function Kg(s, l, u, f) {
      this.propType = "unidimensional", this.keyframes = l.k, this.keyframesMetadata = [], this.offsetTime = s.data.st, this.frameId = -1, this._caching = {
        lastFrame: Un,
        lastIndex: 0,
        value: 0,
        _lastKeyframeIndex: -1
      }, this.k = !0, this.kf = !0, this.data = l, this.mult = u || 1, this.elem = s, this.container = f, this.comp = s.comp, this.v = Un, this.pv = Un, this._isFirstFrame = !0, this.getValue = eo, this.setVValue = Js, this.interpolateValue = Tu, this.effectsSequence = [Ru.bind(this)], this.addEffect = to;
    }
    function Ug(s, l, u, f) {
      this.propType = "multidimensional";
      var g, h = l.k.length, w, M, x, A;
      for (g = 0; g < h - 1; g += 1)
        l.k[g].to && l.k[g].s && l.k[g + 1] && l.k[g + 1].s && (w = l.k[g].s, M = l.k[g + 1].s, x = l.k[g].to, A = l.k[g].ti, (w.length === 2 && !(w[0] === M[0] && w[1] === M[1]) && $r.pointOnLine2D(w[0], w[1], M[0], M[1], w[0] + x[0], w[1] + x[1]) && $r.pointOnLine2D(w[0], w[1], M[0], M[1], M[0] + A[0], M[1] + A[1]) || w.length === 3 && !(w[0] === M[0] && w[1] === M[1] && w[2] === M[2]) && $r.pointOnLine3D(w[0], w[1], w[2], M[0], M[1], M[2], w[0] + x[0], w[1] + x[1], w[2] + x[2]) && $r.pointOnLine3D(w[0], w[1], w[2], M[0], M[1], M[2], M[0] + A[0], M[1] + A[1], M[2] + A[2])) && (l.k[g].to = null, l.k[g].ti = null), w[0] === M[0] && w[1] === M[1] && x[0] === 0 && x[1] === 0 && A[0] === 0 && A[1] === 0 && (w.length === 2 || w[2] === M[2] && x[2] === 0 && A[2] === 0) && (l.k[g].to = null, l.k[g].ti = null));
      this.effectsSequence = [Ru.bind(this)], this.data = l, this.keyframes = l.k, this.keyframesMetadata = [], this.offsetTime = s.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = u || 1, this.elem = s, this.container = f, this.comp = s.comp, this.getValue = eo, this.setVValue = Js, this.interpolateValue = Tu, this.frameId = -1;
      var z = l.k[0].s.length;
      for (this.v = S("float32", z), this.pv = S("float32", z), g = 0; g < z; g += 1)
        this.v[g] = Un, this.pv[g] = Un;
      this._caching = {
        lastFrame: Un,
        lastIndex: 0,
        value: S("float32", z)
      }, this.addEffect = to;
    }
    var me = /* @__PURE__ */ function() {
      function s(u, f, g, h, w) {
        f.sid && (f = u.globalData.slotManager.getProp(f));
        var M;
        if (!f.k.length)
          M = new Gg(u, f, h, w);
        else if (typeof f.k[0] == "number")
          M = new qg(u, f, h, w);
        else
          switch (g) {
            case 0:
              M = new Kg(u, f, h, w);
              break;
            case 1:
              M = new Ug(u, f, h, w);
              break;
          }
        return M.effectsSequence.length && w.addDynamicProperty(M), M;
      }
      var l = {
        getProp: s
      };
      return l;
    }();
    function At() {
    }
    At.prototype = {
      addDynamicProperty: function(l) {
        this.dynamicProperties.indexOf(l) === -1 && (this.dynamicProperties.push(l), this.container.addDynamicProperty(this), this._isAnimated = !0);
      },
      iterateDynamicProperties: function() {
        this._mdf = !1;
        var l, u = this.dynamicProperties.length;
        for (l = 0; l < u; l += 1)
          this.dynamicProperties[l].getValue(), this.dynamicProperties[l]._mdf && (this._mdf = !0);
      },
      initDynamicPropertyContainer: function(l) {
        this.container = l, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
      }
    };
    var Qn = function() {
      function s() {
        return S("float32", 2);
      }
      return Zs(8, s);
    }();
    function Wr() {
      this.c = !1, this._length = 0, this._maxLength = 8, this.v = E(this._maxLength), this.o = E(this._maxLength), this.i = E(this._maxLength);
    }
    Wr.prototype.setPathData = function(s, l) {
      this.c = s, this.setLength(l);
      for (var u = 0; u < l; )
        this.v[u] = Qn.newElement(), this.o[u] = Qn.newElement(), this.i[u] = Qn.newElement(), u += 1;
    }, Wr.prototype.setLength = function(s) {
      for (; this._maxLength < s; )
        this.doubleArrayLength();
      this._length = s;
    }, Wr.prototype.doubleArrayLength = function() {
      this.v = this.v.concat(E(this._maxLength)), this.i = this.i.concat(E(this._maxLength)), this.o = this.o.concat(E(this._maxLength)), this._maxLength *= 2;
    }, Wr.prototype.setXYAt = function(s, l, u, f, g) {
      var h;
      switch (this._length = Math.max(this._length, f + 1), this._length >= this._maxLength && this.doubleArrayLength(), u) {
        case "v":
          h = this.v;
          break;
        case "i":
          h = this.i;
          break;
        case "o":
          h = this.o;
          break;
        default:
          h = [];
          break;
      }
      (!h[f] || h[f] && !g) && (h[f] = Qn.newElement()), h[f][0] = s, h[f][1] = l;
    }, Wr.prototype.setTripleAt = function(s, l, u, f, g, h, w, M) {
      this.setXYAt(s, l, "v", w, M), this.setXYAt(u, f, "o", w, M), this.setXYAt(g, h, "i", w, M);
    }, Wr.prototype.reverse = function() {
      var s = new Wr();
      s.setPathData(this.c, this._length);
      var l = this.v, u = this.o, f = this.i, g = 0;
      this.c && (s.setTripleAt(l[0][0], l[0][1], f[0][0], f[0][1], u[0][0], u[0][1], 0, !1), g = 1);
      var h = this._length - 1, w = this._length, M;
      for (M = g; M < w; M += 1)
        s.setTripleAt(l[h][0], l[h][1], f[h][0], f[h][1], u[h][0], u[h][1], M, !1), h -= 1;
      return s;
    }, Wr.prototype.length = function() {
      return this._length;
    };
    var zt = function() {
      function s() {
        return new Wr();
      }
      function l(g) {
        var h = g._length, w;
        for (w = 0; w < h; w += 1)
          Qn.release(g.v[w]), Qn.release(g.i[w]), Qn.release(g.o[w]), g.v[w] = null, g.i[w] = null, g.o[w] = null;
        g._length = 0, g.c = !1;
      }
      function u(g) {
        var h = f.newElement(), w, M = g._length === void 0 ? g.v.length : g._length;
        for (h.setLength(M), h.c = g.c, w = 0; w < M; w += 1)
          h.setTripleAt(g.v[w][0], g.v[w][1], g.o[w][0], g.o[w][1], g.i[w][0], g.i[w][1], w);
        return h;
      }
      var f = Zs(4, s, l);
      return f.clone = u, f;
    }();
    function qa() {
      this._length = 0, this._maxLength = 4, this.shapes = E(this._maxLength);
    }
    qa.prototype.addShape = function(s) {
      this._length === this._maxLength && (this.shapes = this.shapes.concat(E(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = s, this._length += 1;
    }, qa.prototype.releaseShapes = function() {
      var s;
      for (s = 0; s < this._length; s += 1)
        zt.release(this.shapes[s]);
      this._length = 0;
    };
    var Ci = function() {
      var s = {
        newShapeCollection: g,
        release: h
      }, l = 0, u = 4, f = E(u);
      function g() {
        var w;
        return l ? (l -= 1, w = f[l]) : w = new qa(), w;
      }
      function h(w) {
        var M, x = w._length;
        for (M = 0; M < x; M += 1)
          zt.release(w.shapes[M]);
        w._length = 0, l === u && (f = Eu.double(f), u *= 2), f[l] = w, l += 1;
      }
      return s;
    }(), ro = function() {
      var s = -999999;
      function l(O, T, C) {
        var P = C.lastIndex, F, G, X, ee, ae, Te, Ce, he, Ae, xe = this.keyframes;
        if (O < xe[0].t - this.offsetTime)
          F = xe[0].s[0], X = !0, P = 0;
        else if (O >= xe[xe.length - 1].t - this.offsetTime)
          F = xe[xe.length - 1].s ? xe[xe.length - 1].s[0] : xe[xe.length - 2].e[0], X = !0;
        else {
          for (var oe = P, $ = xe.length - 1, B = !0, b, k, J; B && (b = xe[oe], k = xe[oe + 1], !(k.t - this.offsetTime > O)); )
            oe < $ - 1 ? oe += 1 : B = !1;
          if (J = this.keyframesMetadata[oe] || {}, X = b.h === 1, P = oe, !X) {
            if (O >= k.t - this.offsetTime)
              he = 1;
            else if (O < b.t - this.offsetTime)
              he = 0;
            else {
              var q;
              J.__fnct ? q = J.__fnct : (q = ns.getBezierEasing(b.o.x, b.o.y, b.i.x, b.i.y).get, J.__fnct = q), he = q((O - (b.t - this.offsetTime)) / (k.t - this.offsetTime - (b.t - this.offsetTime)));
            }
            G = k.s ? k.s[0] : b.e[0];
          }
          F = b.s[0];
        }
        for (Te = T._length, Ce = F.i[0].length, C.lastIndex = P, ee = 0; ee < Te; ee += 1)
          for (ae = 0; ae < Ce; ae += 1)
            Ae = X ? F.i[ee][ae] : F.i[ee][ae] + (G.i[ee][ae] - F.i[ee][ae]) * he, T.i[ee][ae] = Ae, Ae = X ? F.o[ee][ae] : F.o[ee][ae] + (G.o[ee][ae] - F.o[ee][ae]) * he, T.o[ee][ae] = Ae, Ae = X ? F.v[ee][ae] : F.v[ee][ae] + (G.v[ee][ae] - F.v[ee][ae]) * he, T.v[ee][ae] = Ae;
      }
      function u() {
        var O = this.comp.renderedFrame - this.offsetTime, T = this.keyframes[0].t - this.offsetTime, C = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, P = this._caching.lastFrame;
        return P !== s && (P < T && O < T || P > C && O > C) || (this._caching.lastIndex = P < O ? this._caching.lastIndex : 0, this.interpolateShape(O, this.pv, this._caching)), this._caching.lastFrame = O, this.pv;
      }
      function f() {
        this.paths = this.localShapeCollection;
      }
      function g(O, T) {
        if (O._length !== T._length || O.c !== T.c)
          return !1;
        var C, P = O._length;
        for (C = 0; C < P; C += 1)
          if (O.v[C][0] !== T.v[C][0] || O.v[C][1] !== T.v[C][1] || O.o[C][0] !== T.o[C][0] || O.o[C][1] !== T.o[C][1] || O.i[C][0] !== T.i[C][0] || O.i[C][1] !== T.i[C][1])
            return !1;
        return !0;
      }
      function h(O) {
        g(this.v, O) || (this.v = zt.clone(O), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
      }
      function w() {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (!this.effectsSequence.length) {
            this._mdf = !1;
            return;
          }
          if (this.lock) {
            this.setVValue(this.pv);
            return;
          }
          this.lock = !0, this._mdf = !1;
          var O;
          this.kf ? O = this.pv : this.data.ks ? O = this.data.ks.k : O = this.data.pt.k;
          var T, C = this.effectsSequence.length;
          for (T = 0; T < C; T += 1)
            O = this.effectsSequence[T](O);
          this.setVValue(O), this.lock = !1, this.frameId = this.elem.globalData.frameId;
        }
      }
      function M(O, T, C) {
        this.propType = "shape", this.comp = O.comp, this.container = O, this.elem = O, this.data = T, this.k = !1, this.kf = !1, this._mdf = !1;
        var P = C === 3 ? T.pt.k : T.ks.k;
        this.v = zt.clone(P), this.pv = zt.clone(this.v), this.localShapeCollection = Ci.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = f, this.effectsSequence = [];
      }
      function x(O) {
        this.effectsSequence.push(O), this.container.addDynamicProperty(this);
      }
      M.prototype.interpolateShape = l, M.prototype.getValue = w, M.prototype.setVValue = h, M.prototype.addEffect = x;
      function A(O, T, C) {
        this.propType = "shape", this.comp = O.comp, this.elem = O, this.container = O, this.offsetTime = O.data.st, this.keyframes = C === 3 ? T.pt.k : T.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
        var P = this.keyframes[0].s[0].i.length;
        this.v = zt.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, P), this.pv = zt.clone(this.v), this.localShapeCollection = Ci.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = s, this.reset = f, this._caching = {
          lastFrame: s,
          lastIndex: 0
        }, this.effectsSequence = [u.bind(this)];
      }
      A.prototype.getValue = w, A.prototype.interpolateShape = l, A.prototype.setVValue = h, A.prototype.addEffect = x;
      var z = function() {
        var O = ge;
        function T(C, P) {
          this.v = zt.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = Ci.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = P.d, this.elem = C, this.comp = C.comp, this.frameId = -1, this.initDynamicPropertyContainer(C), this.p = me.getProp(C, P.p, 1, 0, this), this.s = me.getProp(C, P.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
        }
        return T.prototype = {
          reset: f,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
          },
          convertEllToPath: function() {
            var P = this.p.v[0], F = this.p.v[1], G = this.s.v[0] / 2, X = this.s.v[1] / 2, ee = this.d !== 3, ae = this.v;
            ae.v[0][0] = P, ae.v[0][1] = F - X, ae.v[1][0] = ee ? P + G : P - G, ae.v[1][1] = F, ae.v[2][0] = P, ae.v[2][1] = F + X, ae.v[3][0] = ee ? P - G : P + G, ae.v[3][1] = F, ae.i[0][0] = ee ? P - G * O : P + G * O, ae.i[0][1] = F - X, ae.i[1][0] = ee ? P + G : P - G, ae.i[1][1] = F - X * O, ae.i[2][0] = ee ? P + G * O : P - G * O, ae.i[2][1] = F + X, ae.i[3][0] = ee ? P - G : P + G, ae.i[3][1] = F + X * O, ae.o[0][0] = ee ? P + G * O : P - G * O, ae.o[0][1] = F - X, ae.o[1][0] = ee ? P + G : P - G, ae.o[1][1] = F + X * O, ae.o[2][0] = ee ? P - G * O : P + G * O, ae.o[2][1] = F + X, ae.o[3][0] = ee ? P - G : P + G, ae.o[3][1] = F - X * O;
          }
        }, v([At], T), T;
      }(), Z = function() {
        function O(T, C) {
          this.v = zt.newElement(), this.v.setPathData(!0, 0), this.elem = T, this.comp = T.comp, this.data = C, this.frameId = -1, this.d = C.d, this.initDynamicPropertyContainer(T), C.sy === 1 ? (this.ir = me.getProp(T, C.ir, 0, 0, this), this.is = me.getProp(T, C.is, 0, 0.01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = me.getProp(T, C.pt, 0, 0, this), this.p = me.getProp(T, C.p, 1, 0, this), this.r = me.getProp(T, C.r, 0, de, this), this.or = me.getProp(T, C.or, 0, 0, this), this.os = me.getProp(T, C.os, 0, 0.01, this), this.localShapeCollection = Ci.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
        }
        return O.prototype = {
          reset: f,
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
          },
          convertStarToPath: function() {
            var C = Math.floor(this.pt.v) * 2, P = Math.PI * 2 / C, F = !0, G = this.or.v, X = this.ir.v, ee = this.os.v, ae = this.is.v, Te = 2 * Math.PI * G / (C * 2), Ce = 2 * Math.PI * X / (C * 2), he, Ae, xe, oe, $ = -Math.PI / 2;
            $ += this.r.v;
            var B = this.data.d === 3 ? -1 : 1;
            for (this.v._length = 0, he = 0; he < C; he += 1) {
              Ae = F ? G : X, xe = F ? ee : ae, oe = F ? Te : Ce;
              var b = Ae * Math.cos($), k = Ae * Math.sin($), J = b === 0 && k === 0 ? 0 : k / Math.sqrt(b * b + k * k), q = b === 0 && k === 0 ? 0 : -b / Math.sqrt(b * b + k * k);
              b += +this.p.v[0], k += +this.p.v[1], this.v.setTripleAt(b, k, b - J * oe * xe * B, k - q * oe * xe * B, b + J * oe * xe * B, k + q * oe * xe * B, he, !0), F = !F, $ += P * B;
            }
          },
          convertPolygonToPath: function() {
            var C = Math.floor(this.pt.v), P = Math.PI * 2 / C, F = this.or.v, G = this.os.v, X = 2 * Math.PI * F / (C * 4), ee, ae = -Math.PI * 0.5, Te = this.data.d === 3 ? -1 : 1;
            for (ae += this.r.v, this.v._length = 0, ee = 0; ee < C; ee += 1) {
              var Ce = F * Math.cos(ae), he = F * Math.sin(ae), Ae = Ce === 0 && he === 0 ? 0 : he / Math.sqrt(Ce * Ce + he * he), xe = Ce === 0 && he === 0 ? 0 : -Ce / Math.sqrt(Ce * Ce + he * he);
              Ce += +this.p.v[0], he += +this.p.v[1], this.v.setTripleAt(Ce, he, Ce - Ae * X * G * Te, he - xe * X * G * Te, Ce + Ae * X * G * Te, he + xe * X * G * Te, ee, !0), ae += P * Te;
            }
            this.paths.length = 0, this.paths[0] = this.v;
          }
        }, v([At], O), O;
      }(), D = function() {
        function O(T, C) {
          this.v = zt.newElement(), this.v.c = !0, this.localShapeCollection = Ci.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = T, this.comp = T.comp, this.frameId = -1, this.d = C.d, this.initDynamicPropertyContainer(T), this.p = me.getProp(T, C.p, 1, 0, this), this.s = me.getProp(T, C.s, 1, 0, this), this.r = me.getProp(T, C.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
        }
        return O.prototype = {
          convertRectToPath: function() {
            var C = this.p.v[0], P = this.p.v[1], F = this.s.v[0] / 2, G = this.s.v[1] / 2, X = re(F, G, this.r.v), ee = X * (1 - ge);
            this.v._length = 0, this.d === 2 || this.d === 1 ? (this.v.setTripleAt(C + F, P - G + X, C + F, P - G + X, C + F, P - G + ee, 0, !0), this.v.setTripleAt(C + F, P + G - X, C + F, P + G - ee, C + F, P + G - X, 1, !0), X !== 0 ? (this.v.setTripleAt(C + F - X, P + G, C + F - X, P + G, C + F - ee, P + G, 2, !0), this.v.setTripleAt(C - F + X, P + G, C - F + ee, P + G, C - F + X, P + G, 3, !0), this.v.setTripleAt(C - F, P + G - X, C - F, P + G - X, C - F, P + G - ee, 4, !0), this.v.setTripleAt(C - F, P - G + X, C - F, P - G + ee, C - F, P - G + X, 5, !0), this.v.setTripleAt(C - F + X, P - G, C - F + X, P - G, C - F + ee, P - G, 6, !0), this.v.setTripleAt(C + F - X, P - G, C + F - ee, P - G, C + F - X, P - G, 7, !0)) : (this.v.setTripleAt(C - F, P + G, C - F + ee, P + G, C - F, P + G, 2), this.v.setTripleAt(C - F, P - G, C - F, P - G + ee, C - F, P - G, 3))) : (this.v.setTripleAt(C + F, P - G + X, C + F, P - G + ee, C + F, P - G + X, 0, !0), X !== 0 ? (this.v.setTripleAt(C + F - X, P - G, C + F - X, P - G, C + F - ee, P - G, 1, !0), this.v.setTripleAt(C - F + X, P - G, C - F + ee, P - G, C - F + X, P - G, 2, !0), this.v.setTripleAt(C - F, P - G + X, C - F, P - G + X, C - F, P - G + ee, 3, !0), this.v.setTripleAt(C - F, P + G - X, C - F, P + G - ee, C - F, P + G - X, 4, !0), this.v.setTripleAt(C - F + X, P + G, C - F + X, P + G, C - F + ee, P + G, 5, !0), this.v.setTripleAt(C + F - X, P + G, C + F - ee, P + G, C + F - X, P + G, 6, !0), this.v.setTripleAt(C + F, P + G - X, C + F, P + G - X, C + F, P + G - ee, 7, !0)) : (this.v.setTripleAt(C - F, P - G, C - F + ee, P - G, C - F, P - G, 1, !0), this.v.setTripleAt(C - F, P + G, C - F, P + G - ee, C - F, P + G, 2, !0), this.v.setTripleAt(C + F, P + G, C + F - ee, P + G, C + F, P + G, 3, !0)));
          },
          getValue: function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
          },
          reset: f
        }, v([At], O), O;
      }();
      function V(O, T, C) {
        var P;
        if (C === 3 || C === 4) {
          var F = C === 3 ? T.pt : T.ks, G = F.k;
          G.length ? P = new A(O, T, C) : P = new M(O, T, C);
        } else
          C === 5 ? P = new D(O, T) : C === 6 ? P = new z(O, T) : C === 7 && (P = new Z(O, T));
        return P.k && O.addDynamicProperty(P), P;
      }
      function j() {
        return M;
      }
      function H() {
        return A;
      }
      var U = {};
      return U.getShapeProp = V, U.getConstructorFunction = j, U.getKeyframedConstructorFunction = H, U;
    }();
    /*!
     Transformation Matrix v2.0
     (c) Epistemex 2014-2015
     www.epistemex.com
     By Ken Fyrstenberg
     Contributions by leeoniya.
     License: MIT, header required.
     */
    var Vt = /* @__PURE__ */ function() {
      var s = Math.cos, l = Math.sin, u = Math.tan, f = Math.round;
      function g() {
        return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
      }
      function h(b) {
        if (b === 0)
          return this;
        var k = s(b), J = l(b);
        return this._t(k, -J, 0, 0, J, k, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function w(b) {
        if (b === 0)
          return this;
        var k = s(b), J = l(b);
        return this._t(1, 0, 0, 0, 0, k, -J, 0, 0, J, k, 0, 0, 0, 0, 1);
      }
      function M(b) {
        if (b === 0)
          return this;
        var k = s(b), J = l(b);
        return this._t(k, 0, J, 0, 0, 1, 0, 0, -J, 0, k, 0, 0, 0, 0, 1);
      }
      function x(b) {
        if (b === 0)
          return this;
        var k = s(b), J = l(b);
        return this._t(k, -J, 0, 0, J, k, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function A(b, k) {
        return this._t(1, k, b, 1, 0, 0);
      }
      function z(b, k) {
        return this.shear(u(b), u(k));
      }
      function Z(b, k) {
        var J = s(k), q = l(k);
        return this._t(J, q, 0, 0, -q, J, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, u(b), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(J, -q, 0, 0, q, J, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
      }
      function D(b, k, J) {
        return !J && J !== 0 && (J = 1), b === 1 && k === 1 && J === 1 ? this : this._t(b, 0, 0, 0, 0, k, 0, 0, 0, 0, J, 0, 0, 0, 0, 1);
      }
      function V(b, k, J, q, ye, Me, Ie, Ge, qe, xt, Zt, Ir, Jt, Ft, or, it) {
        return this.props[0] = b, this.props[1] = k, this.props[2] = J, this.props[3] = q, this.props[4] = ye, this.props[5] = Me, this.props[6] = Ie, this.props[7] = Ge, this.props[8] = qe, this.props[9] = xt, this.props[10] = Zt, this.props[11] = Ir, this.props[12] = Jt, this.props[13] = Ft, this.props[14] = or, this.props[15] = it, this;
      }
      function j(b, k, J) {
        return J = J || 0, b !== 0 || k !== 0 || J !== 0 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, b, k, J, 1) : this;
      }
      function H(b, k, J, q, ye, Me, Ie, Ge, qe, xt, Zt, Ir, Jt, Ft, or, it) {
        var Se = this.props;
        if (b === 1 && k === 0 && J === 0 && q === 0 && ye === 0 && Me === 1 && Ie === 0 && Ge === 0 && qe === 0 && xt === 0 && Zt === 1 && Ir === 0)
          return Se[12] = Se[12] * b + Se[15] * Jt, Se[13] = Se[13] * Me + Se[15] * Ft, Se[14] = Se[14] * Zt + Se[15] * or, Se[15] *= it, this._identityCalculated = !1, this;
        var qr = Se[0], yn = Se[1], Kr = Se[2], Rr = Se[3], Ur = Se[4], Qr = Se[5], er = Se[6], bn = Se[7], wn = Se[8], br = Se[9], xn = Se[10], wr = Se[11], ei = Se[12], co = Se[13], uo = Se[14], fo = Se[15];
        return Se[0] = qr * b + yn * ye + Kr * qe + Rr * Jt, Se[1] = qr * k + yn * Me + Kr * xt + Rr * Ft, Se[2] = qr * J + yn * Ie + Kr * Zt + Rr * or, Se[3] = qr * q + yn * Ge + Kr * Ir + Rr * it, Se[4] = Ur * b + Qr * ye + er * qe + bn * Jt, Se[5] = Ur * k + Qr * Me + er * xt + bn * Ft, Se[6] = Ur * J + Qr * Ie + er * Zt + bn * or, Se[7] = Ur * q + Qr * Ge + er * Ir + bn * it, Se[8] = wn * b + br * ye + xn * qe + wr * Jt, Se[9] = wn * k + br * Me + xn * xt + wr * Ft, Se[10] = wn * J + br * Ie + xn * Zt + wr * or, Se[11] = wn * q + br * Ge + xn * Ir + wr * it, Se[12] = ei * b + co * ye + uo * qe + fo * Jt, Se[13] = ei * k + co * Me + uo * xt + fo * Ft, Se[14] = ei * J + co * Ie + uo * Zt + fo * or, Se[15] = ei * q + co * Ge + uo * Ir + fo * it, this._identityCalculated = !1, this;
      }
      function U(b) {
        var k = b.props;
        return this.transform(k[0], k[1], k[2], k[3], k[4], k[5], k[6], k[7], k[8], k[9], k[10], k[11], k[12], k[13], k[14], k[15]);
      }
      function O() {
        return this._identityCalculated || (this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1), this._identityCalculated = !0), this._identity;
      }
      function T(b) {
        for (var k = 0; k < 16; ) {
          if (b.props[k] !== this.props[k])
            return !1;
          k += 1;
        }
        return !0;
      }
      function C(b) {
        var k;
        for (k = 0; k < 16; k += 1)
          b.props[k] = this.props[k];
        return b;
      }
      function P(b) {
        var k;
        for (k = 0; k < 16; k += 1)
          this.props[k] = b[k];
      }
      function F(b, k, J) {
        return {
          x: b * this.props[0] + k * this.props[4] + J * this.props[8] + this.props[12],
          y: b * this.props[1] + k * this.props[5] + J * this.props[9] + this.props[13],
          z: b * this.props[2] + k * this.props[6] + J * this.props[10] + this.props[14]
        };
      }
      function G(b, k, J) {
        return b * this.props[0] + k * this.props[4] + J * this.props[8] + this.props[12];
      }
      function X(b, k, J) {
        return b * this.props[1] + k * this.props[5] + J * this.props[9] + this.props[13];
      }
      function ee(b, k, J) {
        return b * this.props[2] + k * this.props[6] + J * this.props[10] + this.props[14];
      }
      function ae() {
        var b = this.props[0] * this.props[5] - this.props[1] * this.props[4], k = this.props[5] / b, J = -this.props[1] / b, q = -this.props[4] / b, ye = this.props[0] / b, Me = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / b, Ie = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / b, Ge = new Vt();
        return Ge.props[0] = k, Ge.props[1] = J, Ge.props[4] = q, Ge.props[5] = ye, Ge.props[12] = Me, Ge.props[13] = Ie, Ge;
      }
      function Te(b) {
        var k = this.getInverseMatrix();
        return k.applyToPointArray(b[0], b[1], b[2] || 0);
      }
      function Ce(b) {
        var k, J = b.length, q = [];
        for (k = 0; k < J; k += 1)
          q[k] = Te(b[k]);
        return q;
      }
      function he(b, k, J) {
        var q = S("float32", 6);
        if (this.isIdentity())
          q[0] = b[0], q[1] = b[1], q[2] = k[0], q[3] = k[1], q[4] = J[0], q[5] = J[1];
        else {
          var ye = this.props[0], Me = this.props[1], Ie = this.props[4], Ge = this.props[5], qe = this.props[12], xt = this.props[13];
          q[0] = b[0] * ye + b[1] * Ie + qe, q[1] = b[0] * Me + b[1] * Ge + xt, q[2] = k[0] * ye + k[1] * Ie + qe, q[3] = k[0] * Me + k[1] * Ge + xt, q[4] = J[0] * ye + J[1] * Ie + qe, q[5] = J[0] * Me + J[1] * Ge + xt;
        }
        return q;
      }
      function Ae(b, k, J) {
        var q;
        return this.isIdentity() ? q = [b, k, J] : q = [b * this.props[0] + k * this.props[4] + J * this.props[8] + this.props[12], b * this.props[1] + k * this.props[5] + J * this.props[9] + this.props[13], b * this.props[2] + k * this.props[6] + J * this.props[10] + this.props[14]], q;
      }
      function xe(b, k) {
        if (this.isIdentity())
          return b + "," + k;
        var J = this.props;
        return Math.round((b * J[0] + k * J[4] + J[12]) * 100) / 100 + "," + Math.round((b * J[1] + k * J[5] + J[13]) * 100) / 100;
      }
      function oe() {
        for (var b = 0, k = this.props, J = "matrix3d(", q = 1e4; b < 16; )
          J += f(k[b] * q) / q, J += b === 15 ? ")" : ",", b += 1;
        return J;
      }
      function $(b) {
        var k = 1e4;
        return b < 1e-6 && b > 0 || b > -1e-6 && b < 0 ? f(b * k) / k : b;
      }
      function B() {
        var b = this.props, k = $(b[0]), J = $(b[1]), q = $(b[4]), ye = $(b[5]), Me = $(b[12]), Ie = $(b[13]);
        return "matrix(" + k + "," + J + "," + q + "," + ye + "," + Me + "," + Ie + ")";
      }
      return function() {
        this.reset = g, this.rotate = h, this.rotateX = w, this.rotateY = M, this.rotateZ = x, this.skew = z, this.skewFromAxis = Z, this.shear = A, this.scale = D, this.setTransform = V, this.translate = j, this.transform = H, this.multiply = U, this.applyToPoint = F, this.applyToX = G, this.applyToY = X, this.applyToZ = ee, this.applyToPointArray = Ae, this.applyToTriplePoints = he, this.applyToPointStringified = xe, this.toCSS = oe, this.to2dCSS = B, this.clone = C, this.cloneFromProps = P, this.equals = T, this.inversePoints = Ce, this.inversePoint = Te, this.getInverseMatrix = ae, this._t = this.transform, this.isIdentity = O, this._identity = !0, this._identityCalculated = !1, this.props = S("float32", 16), this.reset();
      };
    }();
    function no(s) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? no = function(u) {
        return typeof u;
      } : no = function(u) {
        return u && typeof Symbol == "function" && u.constructor === Symbol && u !== Symbol.prototype ? "symbol" : typeof u;
      }, no(s);
    }
    var Ze = {};
    function Qg(s) {
      d(s);
    }
    function Au() {
      kt.searchAnimations();
    }
    function Xg(s) {
      je(s);
    }
    function Zg(s) {
      Mr(s);
    }
    function Jg(s) {
      return kt.loadAnimation(s);
    }
    function em(s) {
      if (typeof s == "string")
        switch (s) {
          case "high":
            wt(200);
            break;
          default:
          case "medium":
            wt(50);
            break;
          case "low":
            wt(10);
            break;
        }
      else
        !isNaN(s) && s > 1 && wt(s);
    }
    function tm() {
      return typeof navigator < "u";
    }
    function rm(s, l) {
      s === "expressions" && nt(l);
    }
    function nm(s) {
      switch (s) {
        case "propertyFactory":
          return me;
        case "shapePropertyFactory":
          return ro;
        case "matrix":
          return Vt;
        default:
          return null;
      }
    }
    Ze.play = kt.play, Ze.pause = kt.pause, Ze.setLocationHref = Qg, Ze.togglePause = kt.togglePause, Ze.setSpeed = kt.setSpeed, Ze.setDirection = kt.setDirection, Ze.stop = kt.stop, Ze.searchAnimations = Au, Ze.registerAnimation = kt.registerAnimation, Ze.loadAnimation = Jg, Ze.setSubframeRendering = Xg, Ze.resize = kt.resize, Ze.goToAndStop = kt.goToAndStop, Ze.destroy = kt.destroy, Ze.setQuality = em, Ze.inBrowser = tm, Ze.installPlugin = rm, Ze.freeze = kt.freeze, Ze.unfreeze = kt.unfreeze, Ze.setVolume = kt.setVolume, Ze.mute = kt.mute, Ze.unmute = kt.unmute, Ze.getRegisteredAnimations = kt.getRegisteredAnimations, Ze.useWebWorker = a, Ze.setIDPrefix = Zg, Ze.__getFactory = nm, Ze.version = "5.12.2";
    function im() {
      document.readyState === "complete" && (clearInterval(am), Au());
    }
    function sm(s) {
      for (var l = Fu.split("&"), u = 0; u < l.length; u += 1) {
        var f = l[u].split("=");
        if (decodeURIComponent(f[0]) == s)
          return decodeURIComponent(f[1]);
      }
      return null;
    }
    var Fu = "";
    {
      var Ou = document.getElementsByTagName("script"), om = Ou.length - 1, Lu = Ou[om] || {
        src: ""
      };
      Fu = Lu.src ? Lu.src.replace(/^[^\?]+\??/, "") : "", sm("renderer");
    }
    var am = setInterval(im, 100);
    try {
      no(n) !== "object" && (window.bodymovin = Ze);
    } catch {
    }
    var pn = function() {
      var s = {}, l = {};
      s.registerModifier = u, s.getModifier = f;
      function u(g, h) {
        l[g] || (l[g] = h);
      }
      function f(g, h, w) {
        return new l[g](h, w);
      }
      return s;
    }();
    function hr() {
    }
    hr.prototype.initModifierProperties = function() {
    }, hr.prototype.addShapeToModifier = function() {
    }, hr.prototype.addShape = function(s) {
      if (!this.closed) {
        s.sh.container.addDynamicProperty(s.sh);
        var l = {
          shape: s.sh,
          data: s,
          localShapeCollection: Ci.newShapeCollection()
        };
        this.shapes.push(l), this.addShapeToModifier(l), this._isAnimated && s.setAsAnimated();
      }
    }, hr.prototype.init = function(s, l) {
      this.shapes = [], this.elem = s, this.initDynamicPropertyContainer(s), this.initModifierProperties(s, l), this.frameId = o, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, hr.prototype.processKeys = function() {
      this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
    }, v([At], hr);
    function yr() {
    }
    v([hr], yr), yr.prototype.initModifierProperties = function(s, l) {
      this.s = me.getProp(s, l.s, 0, 0.01, this), this.e = me.getProp(s, l.e, 0, 0.01, this), this.o = me.getProp(s, l.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = l.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
    }, yr.prototype.addShapeToModifier = function(s) {
      s.pathsData = [];
    }, yr.prototype.calculateShapeEdges = function(s, l, u, f, g) {
      var h = [];
      l <= 1 ? h.push({
        s,
        e: l
      }) : s >= 1 ? h.push({
        s: s - 1,
        e: l - 1
      }) : (h.push({
        s,
        e: 1
      }), h.push({
        s: 0,
        e: l - 1
      }));
      var w = [], M, x = h.length, A;
      for (M = 0; M < x; M += 1)
        if (A = h[M], !(A.e * g < f || A.s * g > f + u)) {
          var z, Z;
          A.s * g <= f ? z = 0 : z = (A.s * g - f) / u, A.e * g >= f + u ? Z = 1 : Z = (A.e * g - f) / u, w.push([z, Z]);
        }
      return w.length || w.push([0, 0]), w;
    }, yr.prototype.releasePathsData = function(s) {
      var l, u = s.length;
      for (l = 0; l < u; l += 1)
        Mu.release(s[l]);
      return s.length = 0, s;
    }, yr.prototype.processShapes = function(s) {
      var l, u;
      if (this._mdf || s) {
        var f = this.o.v % 360 / 360;
        if (f < 0 && (f += 1), this.s.v > 1 ? l = 1 + f : this.s.v < 0 ? l = 0 + f : l = this.s.v + f, this.e.v > 1 ? u = 1 + f : this.e.v < 0 ? u = 0 + f : u = this.e.v + f, l > u) {
          var g = l;
          l = u, u = g;
        }
        l = Math.round(l * 1e4) * 1e-4, u = Math.round(u * 1e4) * 1e-4, this.sValue = l, this.eValue = u;
      } else
        l = this.sValue, u = this.eValue;
      var h, w, M = this.shapes.length, x, A, z, Z, D, V = 0;
      if (u === l)
        for (w = 0; w < M; w += 1)
          this.shapes[w].localShapeCollection.releaseShapes(), this.shapes[w].shape._mdf = !0, this.shapes[w].shape.paths = this.shapes[w].localShapeCollection, this._mdf && (this.shapes[w].pathsData.length = 0);
      else if (u === 1 && l === 0 || u === 0 && l === 1) {
        if (this._mdf)
          for (w = 0; w < M; w += 1)
            this.shapes[w].pathsData.length = 0, this.shapes[w].shape._mdf = !0;
      } else {
        var j = [], H, U;
        for (w = 0; w < M; w += 1)
          if (H = this.shapes[w], !H.shape._mdf && !this._mdf && !s && this.m !== 2)
            H.shape.paths = H.localShapeCollection;
          else {
            if (h = H.shape.paths, A = h._length, D = 0, !H.shape._mdf && H.pathsData.length)
              D = H.totalShapeLength;
            else {
              for (z = this.releasePathsData(H.pathsData), x = 0; x < A; x += 1)
                Z = $r.getSegmentsLength(h.shapes[x]), z.push(Z), D += Z.totalLength;
              H.totalShapeLength = D, H.pathsData = z;
            }
            V += D, H.shape._mdf = !0;
          }
        var O = l, T = u, C = 0, P;
        for (w = M - 1; w >= 0; w -= 1)
          if (H = this.shapes[w], H.shape._mdf) {
            for (U = H.localShapeCollection, U.releaseShapes(), this.m === 2 && M > 1 ? (P = this.calculateShapeEdges(l, u, H.totalShapeLength, C, V), C += H.totalShapeLength) : P = [[O, T]], A = P.length, x = 0; x < A; x += 1) {
              O = P[x][0], T = P[x][1], j.length = 0, T <= 1 ? j.push({
                s: H.totalShapeLength * O,
                e: H.totalShapeLength * T
              }) : O >= 1 ? j.push({
                s: H.totalShapeLength * (O - 1),
                e: H.totalShapeLength * (T - 1)
              }) : (j.push({
                s: H.totalShapeLength * O,
                e: H.totalShapeLength
              }), j.push({
                s: 0,
                e: H.totalShapeLength * (T - 1)
              }));
              var F = this.addShapes(H, j[0]);
              if (j[0].s !== j[0].e) {
                if (j.length > 1) {
                  var G = H.shape.paths.shapes[H.shape.paths._length - 1];
                  if (G.c) {
                    var X = F.pop();
                    this.addPaths(F, U), F = this.addShapes(H, j[1], X);
                  } else
                    this.addPaths(F, U), F = this.addShapes(H, j[1]);
                }
                this.addPaths(F, U);
              }
            }
            H.shape.paths = U;
          }
      }
    }, yr.prototype.addPaths = function(s, l) {
      var u, f = s.length;
      for (u = 0; u < f; u += 1)
        l.addShape(s[u]);
    }, yr.prototype.addSegment = function(s, l, u, f, g, h, w) {
      g.setXYAt(l[0], l[1], "o", h), g.setXYAt(u[0], u[1], "i", h + 1), w && g.setXYAt(s[0], s[1], "v", h), g.setXYAt(f[0], f[1], "v", h + 1);
    }, yr.prototype.addSegmentFromArray = function(s, l, u, f) {
      l.setXYAt(s[1], s[5], "o", u), l.setXYAt(s[2], s[6], "i", u + 1), f && l.setXYAt(s[0], s[4], "v", u), l.setXYAt(s[3], s[7], "v", u + 1);
    }, yr.prototype.addShapes = function(s, l, u) {
      var f = s.pathsData, g = s.shape.paths.shapes, h, w = s.shape.paths._length, M, x, A = 0, z, Z, D, V, j = [], H, U = !0;
      for (u ? (Z = u._length, H = u._length) : (u = zt.newElement(), Z = 0, H = 0), j.push(u), h = 0; h < w; h += 1) {
        for (D = f[h].lengths, u.c = g[h].c, x = g[h].c ? D.length : D.length + 1, M = 1; M < x; M += 1)
          if (z = D[M - 1], A + z.addedLength < l.s)
            A += z.addedLength, u.c = !1;
          else if (A > l.e) {
            u.c = !1;
            break;
          } else
            l.s <= A && l.e >= A + z.addedLength ? (this.addSegment(g[h].v[M - 1], g[h].o[M - 1], g[h].i[M], g[h].v[M], u, Z, U), U = !1) : (V = $r.getNewSegment(g[h].v[M - 1], g[h].v[M], g[h].o[M - 1], g[h].i[M], (l.s - A) / z.addedLength, (l.e - A) / z.addedLength, D[M - 1]), this.addSegmentFromArray(V, u, Z, U), U = !1, u.c = !1), A += z.addedLength, Z += 1;
        if (g[h].c && D.length) {
          if (z = D[M - 1], A <= l.e) {
            var O = D[M - 1].addedLength;
            l.s <= A && l.e >= A + O ? (this.addSegment(g[h].v[M - 1], g[h].o[M - 1], g[h].i[0], g[h].v[0], u, Z, U), U = !1) : (V = $r.getNewSegment(g[h].v[M - 1], g[h].v[0], g[h].o[M - 1], g[h].i[0], (l.s - A) / O, (l.e - A) / O, D[M - 1]), this.addSegmentFromArray(V, u, Z, U), U = !1, u.c = !1);
          } else
            u.c = !1;
          A += z.addedLength, Z += 1;
        }
        if (u._length && (u.setXYAt(u.v[H][0], u.v[H][1], "i", H), u.setXYAt(u.v[u._length - 1][0], u.v[u._length - 1][1], "o", u._length - 1)), A > l.e)
          break;
        h < w - 1 && (u = zt.newElement(), U = !0, j.push(u), Z = 0);
      }
      return j;
    };
    function is() {
    }
    v([hr], is), is.prototype.initModifierProperties = function(s, l) {
      this.getValue = this.processKeys, this.amount = me.getProp(s, l.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
    }, is.prototype.processPath = function(s, l) {
      var u = l / 100, f = [0, 0], g = s._length, h = 0;
      for (h = 0; h < g; h += 1)
        f[0] += s.v[h][0], f[1] += s.v[h][1];
      f[0] /= g, f[1] /= g;
      var w = zt.newElement();
      w.c = s.c;
      var M, x, A, z, Z, D;
      for (h = 0; h < g; h += 1)
        M = s.v[h][0] + (f[0] - s.v[h][0]) * u, x = s.v[h][1] + (f[1] - s.v[h][1]) * u, A = s.o[h][0] + (f[0] - s.o[h][0]) * -u, z = s.o[h][1] + (f[1] - s.o[h][1]) * -u, Z = s.i[h][0] + (f[0] - s.i[h][0]) * -u, D = s.i[h][1] + (f[1] - s.i[h][1]) * -u, w.setTripleAt(M, x, A, z, Z, D, h);
      return w;
    }, is.prototype.processShapes = function(s) {
      var l, u, f = this.shapes.length, g, h, w = this.amount.v;
      if (w !== 0) {
        var M, x;
        for (u = 0; u < f; u += 1) {
          if (M = this.shapes[u], x = M.localShapeCollection, !(!M.shape._mdf && !this._mdf && !s))
            for (x.releaseShapes(), M.shape._mdf = !0, l = M.shape.paths.shapes, h = M.shape.paths._length, g = 0; g < h; g += 1)
              x.addShape(this.processPath(l[g], w));
          M.shape.paths = M.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    var Ka = function() {
      var s = [0, 0];
      function l(x) {
        var A = this._mdf;
        this.iterateDynamicProperties(), this._mdf = this._mdf || A, this.a && x.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && x.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && x.skewFromAxis(-this.sk.v, this.sa.v), this.r ? x.rotate(-this.r.v) : x.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? x.translate(this.px.v, this.py.v, -this.pz.v) : x.translate(this.px.v, this.py.v, 0) : x.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
      function u(x) {
        if (this.elem.globalData.frameId !== this.frameId) {
          if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || x) {
            var A;
            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
              var z, Z;
              if (A = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime)
                this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (z = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / A, 0), Z = this.p.getValueAtTime(this.p.keyframes[0].t / A, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (z = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / A, 0), Z = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / A, 0)) : (z = this.p.pv, Z = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / A, this.p.offsetTime));
              else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                z = [], Z = [];
                var D = this.px, V = this.py;
                D._caching.lastFrame + D.offsetTime <= D.keyframes[0].t ? (z[0] = D.getValueAtTime((D.keyframes[0].t + 0.01) / A, 0), z[1] = V.getValueAtTime((V.keyframes[0].t + 0.01) / A, 0), Z[0] = D.getValueAtTime(D.keyframes[0].t / A, 0), Z[1] = V.getValueAtTime(V.keyframes[0].t / A, 0)) : D._caching.lastFrame + D.offsetTime >= D.keyframes[D.keyframes.length - 1].t ? (z[0] = D.getValueAtTime(D.keyframes[D.keyframes.length - 1].t / A, 0), z[1] = V.getValueAtTime(V.keyframes[V.keyframes.length - 1].t / A, 0), Z[0] = D.getValueAtTime((D.keyframes[D.keyframes.length - 1].t - 0.01) / A, 0), Z[1] = V.getValueAtTime((V.keyframes[V.keyframes.length - 1].t - 0.01) / A, 0)) : (z = [D.pv, V.pv], Z[0] = D.getValueAtTime((D._caching.lastFrame + D.offsetTime - 0.01) / A, D.offsetTime), Z[1] = V.getValueAtTime((V._caching.lastFrame + V.offsetTime - 0.01) / A, V.offsetTime));
              } else
                Z = s, z = Z;
              this.v.rotate(-Math.atan2(z[1] - Z[1], z[0] - Z[0]));
            }
            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
          }
          this.frameId = this.elem.globalData.frameId;
        }
      }
      function f() {
        if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length)
          this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1;
        else
          return;
        if (!this.s.effectsSequence.length)
          this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2;
        else
          return;
        if (this.sk)
          if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length)
            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
          else
            return;
        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : !this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length && (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
      }
      function g() {
      }
      function h(x) {
        this._addDynamicProperty(x), this.elem.addDynamicProperty(x), this._isDirty = !0;
      }
      function w(x, A, z) {
        if (this.elem = x, this.frameId = -1, this.propType = "transform", this.data = A, this.v = new Vt(), this.pre = new Vt(), this.appliedTransformations = 0, this.initDynamicPropertyContainer(z || x), A.p && A.p.s ? (this.px = me.getProp(x, A.p.x, 0, 0, this), this.py = me.getProp(x, A.p.y, 0, 0, this), A.p.z && (this.pz = me.getProp(x, A.p.z, 0, 0, this))) : this.p = me.getProp(x, A.p || {
          k: [0, 0, 0]
        }, 1, 0, this), A.rx) {
          if (this.rx = me.getProp(x, A.rx, 0, de, this), this.ry = me.getProp(x, A.ry, 0, de, this), this.rz = me.getProp(x, A.rz, 0, de, this), A.or.k[0].ti) {
            var Z, D = A.or.k.length;
            for (Z = 0; Z < D; Z += 1)
              A.or.k[Z].to = null, A.or.k[Z].ti = null;
          }
          this.or = me.getProp(x, A.or, 1, de, this), this.or.sh = !0;
        } else
          this.r = me.getProp(x, A.r || {
            k: 0
          }, 0, de, this);
        A.sk && (this.sk = me.getProp(x, A.sk, 0, de, this), this.sa = me.getProp(x, A.sa, 0, de, this)), this.a = me.getProp(x, A.a || {
          k: [0, 0, 0]
        }, 1, 0, this), this.s = me.getProp(x, A.s || {
          k: [100, 100, 100]
        }, 1, 0.01, this), A.o ? this.o = me.getProp(x, A.o, 0, 0.01, x) : this.o = {
          _mdf: !1,
          v: 1
        }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
      }
      w.prototype = {
        applyToMatrix: l,
        getValue: u,
        precalculateMatrix: f,
        autoOrient: g
      }, v([At], w), w.prototype.addDynamicProperty = h, w.prototype._addDynamicProperty = At.prototype.addDynamicProperty;
      function M(x, A, z) {
        return new w(x, A, z);
      }
      return {
        getTransformProperty: M
      };
    }();
    function Tr() {
    }
    v([hr], Tr), Tr.prototype.initModifierProperties = function(s, l) {
      this.getValue = this.processKeys, this.c = me.getProp(s, l.c, 0, null, this), this.o = me.getProp(s, l.o, 0, null, this), this.tr = Ka.getTransformProperty(s, l.tr, this), this.so = me.getProp(s, l.tr.so, 0, 0.01, this), this.eo = me.getProp(s, l.tr.eo, 0, 0.01, this), this.data = l, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Vt(), this.rMatrix = new Vt(), this.sMatrix = new Vt(), this.tMatrix = new Vt(), this.matrix = new Vt();
    }, Tr.prototype.applyTransforms = function(s, l, u, f, g, h) {
      var w = h ? -1 : 1, M = f.s.v[0] + (1 - f.s.v[0]) * (1 - g), x = f.s.v[1] + (1 - f.s.v[1]) * (1 - g);
      s.translate(f.p.v[0] * w * g, f.p.v[1] * w * g, f.p.v[2]), l.translate(-f.a.v[0], -f.a.v[1], f.a.v[2]), l.rotate(-f.r.v * w * g), l.translate(f.a.v[0], f.a.v[1], f.a.v[2]), u.translate(-f.a.v[0], -f.a.v[1], f.a.v[2]), u.scale(h ? 1 / M : M, h ? 1 / x : x), u.translate(f.a.v[0], f.a.v[1], f.a.v[2]);
    }, Tr.prototype.init = function(s, l, u, f) {
      for (this.elem = s, this.arr = l, this.pos = u, this.elemsData = f, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(s), this.initModifierProperties(s, l[u]); u > 0; )
        u -= 1, this._elements.unshift(l[u]);
      this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
    }, Tr.prototype.resetElements = function(s) {
      var l, u = s.length;
      for (l = 0; l < u; l += 1)
        s[l]._processed = !1, s[l].ty === "gr" && this.resetElements(s[l].it);
    }, Tr.prototype.cloneElements = function(s) {
      var l = JSON.parse(JSON.stringify(s));
      return this.resetElements(l), l;
    }, Tr.prototype.changeGroupRender = function(s, l) {
      var u, f = s.length;
      for (u = 0; u < f; u += 1)
        s[u]._render = l, s[u].ty === "gr" && this.changeGroupRender(s[u].it, l);
    }, Tr.prototype.processShapes = function(s) {
      var l, u, f, g, h, w = !1;
      if (this._mdf || s) {
        var M = Math.ceil(this.c.v);
        if (this._groups.length < M) {
          for (; this._groups.length < M; ) {
            var x = {
              it: this.cloneElements(this._elements),
              ty: "gr"
            };
            x.it.push({
              a: {
                a: 0,
                ix: 1,
                k: [0, 0]
              },
              nm: "Transform",
              o: {
                a: 0,
                ix: 7,
                k: 100
              },
              p: {
                a: 0,
                ix: 2,
                k: [0, 0]
              },
              r: {
                a: 1,
                ix: 6,
                k: [{
                  s: 0,
                  e: 0,
                  t: 0
                }, {
                  s: 0,
                  e: 0,
                  t: 1
                }]
              },
              s: {
                a: 0,
                ix: 3,
                k: [100, 100]
              },
              sa: {
                a: 0,
                ix: 5,
                k: 0
              },
              sk: {
                a: 0,
                ix: 4,
                k: 0
              },
              ty: "tr"
            }), this.arr.splice(0, 0, x), this._groups.splice(0, 0, x), this._currentCopies += 1;
          }
          this.elem.reloadShapes(), w = !0;
        }
        h = 0;
        var A;
        for (f = 0; f <= this._groups.length - 1; f += 1) {
          if (A = h < M, this._groups[f]._render = A, this.changeGroupRender(this._groups[f].it, A), !A) {
            var z = this.elemsData[f].it, Z = z[z.length - 1];
            Z.transform.op.v !== 0 ? (Z.transform.op._mdf = !0, Z.transform.op.v = 0) : Z.transform.op._mdf = !1;
          }
          h += 1;
        }
        this._currentCopies = M;
        var D = this.o.v, V = D % 1, j = D > 0 ? Math.floor(D) : Math.ceil(D), H = this.pMatrix.props, U = this.rMatrix.props, O = this.sMatrix.props;
        this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
        var T = 0;
        if (D > 0) {
          for (; T < j; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), T += 1;
          V && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, V, !1), T += V);
        } else if (D < 0) {
          for (; T > j; )
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), T -= 1;
          V && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -V, !0), T -= V);
        }
        f = this.data.m === 1 ? 0 : this._currentCopies - 1, g = this.data.m === 1 ? 1 : -1, h = this._currentCopies;
        for (var C, P; h; ) {
          if (l = this.elemsData[f].it, u = l[l.length - 1].transform.mProps.v.props, P = u.length, l[l.length - 1].transform.mProps._mdf = !0, l[l.length - 1].transform.op._mdf = !0, l[l.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (f / (this._currentCopies - 1)), T !== 0) {
            for ((f !== 0 && g === 1 || f !== this._currentCopies - 1 && g === -1) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(U[0], U[1], U[2], U[3], U[4], U[5], U[6], U[7], U[8], U[9], U[10], U[11], U[12], U[13], U[14], U[15]), this.matrix.transform(O[0], O[1], O[2], O[3], O[4], O[5], O[6], O[7], O[8], O[9], O[10], O[11], O[12], O[13], O[14], O[15]), this.matrix.transform(H[0], H[1], H[2], H[3], H[4], H[5], H[6], H[7], H[8], H[9], H[10], H[11], H[12], H[13], H[14], H[15]), C = 0; C < P; C += 1)
              u[C] = this.matrix.props[C];
            this.matrix.reset();
          } else
            for (this.matrix.reset(), C = 0; C < P; C += 1)
              u[C] = this.matrix.props[C];
          T += 1, h -= 1, f += g;
        }
      } else
        for (h = this._currentCopies, f = 0, g = 1; h; )
          l = this.elemsData[f].it, u = l[l.length - 1].transform.mProps.v.props, l[l.length - 1].transform.mProps._mdf = !1, l[l.length - 1].transform.op._mdf = !1, h -= 1, f += g;
      return w;
    }, Tr.prototype.addShape = function() {
    };
    function ss() {
    }
    v([hr], ss), ss.prototype.initModifierProperties = function(s, l) {
      this.getValue = this.processKeys, this.rd = me.getProp(s, l.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
    }, ss.prototype.processPath = function(s, l) {
      var u = zt.newElement();
      u.c = s.c;
      var f, g = s._length, h, w, M, x, A, z, Z = 0, D, V, j, H, U, O;
      for (f = 0; f < g; f += 1)
        h = s.v[f], M = s.o[f], w = s.i[f], h[0] === M[0] && h[1] === M[1] && h[0] === w[0] && h[1] === w[1] ? (f === 0 || f === g - 1) && !s.c ? (u.setTripleAt(h[0], h[1], M[0], M[1], w[0], w[1], Z), Z += 1) : (f === 0 ? x = s.v[g - 1] : x = s.v[f - 1], A = Math.sqrt(Math.pow(h[0] - x[0], 2) + Math.pow(h[1] - x[1], 2)), z = A ? Math.min(A / 2, l) / A : 0, U = h[0] + (x[0] - h[0]) * z, D = U, O = h[1] - (h[1] - x[1]) * z, V = O, j = D - (D - h[0]) * ge, H = V - (V - h[1]) * ge, u.setTripleAt(D, V, j, H, U, O, Z), Z += 1, f === g - 1 ? x = s.v[0] : x = s.v[f + 1], A = Math.sqrt(Math.pow(h[0] - x[0], 2) + Math.pow(h[1] - x[1], 2)), z = A ? Math.min(A / 2, l) / A : 0, j = h[0] + (x[0] - h[0]) * z, D = j, H = h[1] + (x[1] - h[1]) * z, V = H, U = D - (D - h[0]) * ge, O = V - (V - h[1]) * ge, u.setTripleAt(D, V, j, H, U, O, Z), Z += 1) : (u.setTripleAt(s.v[f][0], s.v[f][1], s.o[f][0], s.o[f][1], s.i[f][0], s.i[f][1], Z), Z += 1);
      return u;
    }, ss.prototype.processShapes = function(s) {
      var l, u, f = this.shapes.length, g, h, w = this.rd.v;
      if (w !== 0) {
        var M, x;
        for (u = 0; u < f; u += 1) {
          if (M = this.shapes[u], x = M.localShapeCollection, !(!M.shape._mdf && !this._mdf && !s))
            for (x.releaseShapes(), M.shape._mdf = !0, l = M.shape.paths.shapes, h = M.shape.paths._length, g = 0; g < h; g += 1)
              x.addShape(this.processPath(l[g], w));
          M.shape.paths = M.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function io(s, l) {
      return Math.abs(s - l) * 1e5 <= Math.min(Math.abs(s), Math.abs(l));
    }
    function Ua(s) {
      return Math.abs(s) <= 1e-5;
    }
    function Nu(s, l, u) {
      return s * (1 - u) + l * u;
    }
    function hn(s, l, u) {
      return [Nu(s[0], l[0], u), Nu(s[1], l[1], u)];
    }
    function lm(s, l, u) {
      if (s === 0)
        return [];
      var f = l * l - 4 * s * u;
      if (f < 0)
        return [];
      var g = -l / (2 * s);
      if (f === 0)
        return [g];
      var h = Math.sqrt(f) / (2 * s);
      return [g - h, g + h];
    }
    function zu(s, l, u, f) {
      return [-s + 3 * l - 3 * u + f, 3 * s - 6 * l + 3 * u, -3 * s + 3 * l, s];
    }
    function Vu(s) {
      return new gt(s, s, s, s, !1);
    }
    function gt(s, l, u, f, g) {
      g && Ei(s, l) && (l = hn(s, f, 1 / 3)), g && Ei(u, f) && (u = hn(s, f, 2 / 3));
      var h = zu(s[0], l[0], u[0], f[0]), w = zu(s[1], l[1], u[1], f[1]);
      this.a = [h[0], w[0]], this.b = [h[1], w[1]], this.c = [h[2], w[2]], this.d = [h[3], w[3]], this.points = [s, l, u, f];
    }
    gt.prototype.point = function(s) {
      return [((this.a[0] * s + this.b[0]) * s + this.c[0]) * s + this.d[0], ((this.a[1] * s + this.b[1]) * s + this.c[1]) * s + this.d[1]];
    }, gt.prototype.derivative = function(s) {
      return [(3 * s * this.a[0] + 2 * this.b[0]) * s + this.c[0], (3 * s * this.a[1] + 2 * this.b[1]) * s + this.c[1]];
    }, gt.prototype.tangentAngle = function(s) {
      var l = this.derivative(s);
      return Math.atan2(l[1], l[0]);
    }, gt.prototype.normalAngle = function(s) {
      var l = this.derivative(s);
      return Math.atan2(l[0], l[1]);
    }, gt.prototype.inflectionPoints = function() {
      var s = this.a[1] * this.b[0] - this.a[0] * this.b[1];
      if (Ua(s))
        return [];
      var l = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / s, u = l * l - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / s;
      if (u < 0)
        return [];
      var f = Math.sqrt(u);
      return Ua(f) ? f > 0 && f < 1 ? [l] : [] : [l - f, l + f].filter(function(g) {
        return g > 0 && g < 1;
      });
    }, gt.prototype.split = function(s) {
      if (s <= 0)
        return [Vu(this.points[0]), this];
      if (s >= 1)
        return [this, Vu(this.points[this.points.length - 1])];
      var l = hn(this.points[0], this.points[1], s), u = hn(this.points[1], this.points[2], s), f = hn(this.points[2], this.points[3], s), g = hn(l, u, s), h = hn(u, f, s), w = hn(g, h, s);
      return [new gt(this.points[0], l, g, w, !0), new gt(w, h, f, this.points[3], !0)];
    };
    function Yu(s, l) {
      var u = s.points[0][l], f = s.points[s.points.length - 1][l];
      if (u > f) {
        var g = f;
        f = u, u = g;
      }
      for (var h = lm(3 * s.a[l], 2 * s.b[l], s.c[l]), w = 0; w < h.length; w += 1)
        if (h[w] > 0 && h[w] < 1) {
          var M = s.point(h[w])[l];
          M < u ? u = M : M > f && (f = M);
        }
      return {
        min: u,
        max: f
      };
    }
    gt.prototype.bounds = function() {
      return {
        x: Yu(this, 0),
        y: Yu(this, 1)
      };
    }, gt.prototype.boundingBox = function() {
      var s = this.bounds();
      return {
        left: s.x.min,
        right: s.x.max,
        top: s.y.min,
        bottom: s.y.max,
        width: s.x.max - s.x.min,
        height: s.y.max - s.y.min,
        cx: (s.x.max + s.x.min) / 2,
        cy: (s.y.max + s.y.min) / 2
      };
    };
    function so(s, l, u) {
      var f = s.boundingBox();
      return {
        cx: f.cx,
        cy: f.cy,
        width: f.width,
        height: f.height,
        bez: s,
        t: (l + u) / 2,
        t1: l,
        t2: u
      };
    }
    function Hu(s) {
      var l = s.bez.split(0.5);
      return [so(l[0], s.t1, s.t), so(l[1], s.t, s.t2)];
    }
    function cm(s, l) {
      return Math.abs(s.cx - l.cx) * 2 < s.width + l.width && Math.abs(s.cy - l.cy) * 2 < s.height + l.height;
    }
    function os(s, l, u, f, g, h) {
      if (cm(s, l)) {
        if (u >= h || s.width <= f && s.height <= f && l.width <= f && l.height <= f) {
          g.push([s.t, l.t]);
          return;
        }
        var w = Hu(s), M = Hu(l);
        os(w[0], M[0], u + 1, f, g, h), os(w[0], M[1], u + 1, f, g, h), os(w[1], M[0], u + 1, f, g, h), os(w[1], M[1], u + 1, f, g, h);
      }
    }
    gt.prototype.intersections = function(s, l, u) {
      l === void 0 && (l = 2), u === void 0 && (u = 7);
      var f = [];
      return os(so(this, 0, 1), so(s, 0, 1), 0, l, f, u), f;
    }, gt.shapeSegment = function(s, l) {
      var u = (l + 1) % s.length();
      return new gt(s.v[l], s.o[l], s.i[u], s.v[u], !0);
    }, gt.shapeSegmentInverted = function(s, l) {
      var u = (l + 1) % s.length();
      return new gt(s.v[u], s.i[u], s.o[l], s.v[l], !0);
    };
    function Qa(s, l) {
      return [s[1] * l[2] - s[2] * l[1], s[2] * l[0] - s[0] * l[2], s[0] * l[1] - s[1] * l[0]];
    }
    function oo(s, l, u, f) {
      var g = [s[0], s[1], 1], h = [l[0], l[1], 1], w = [u[0], u[1], 1], M = [f[0], f[1], 1], x = Qa(Qa(g, h), Qa(w, M));
      return Ua(x[2]) ? null : [x[0] / x[2], x[1] / x[2]];
    }
    function Di(s, l, u) {
      return [s[0] + Math.cos(l) * u, s[1] - Math.sin(l) * u];
    }
    function Xa(s, l) {
      return Math.hypot(s[0] - l[0], s[1] - l[1]);
    }
    function Ei(s, l) {
      return io(s[0], l[0]) && io(s[1], l[1]);
    }
    function as() {
    }
    v([hr], as), as.prototype.initModifierProperties = function(s, l) {
      this.getValue = this.processKeys, this.amplitude = me.getProp(s, l.s, 0, null, this), this.frequency = me.getProp(s, l.r, 0, null, this), this.pointsType = me.getProp(s, l.pt, 0, null, this), this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
    };
    function Bu(s, l, u, f, g, h, w) {
      var M = u - Math.PI / 2, x = u + Math.PI / 2, A = l[0] + Math.cos(u) * f * g, z = l[1] - Math.sin(u) * f * g;
      s.setTripleAt(A, z, A + Math.cos(M) * h, z - Math.sin(M) * h, A + Math.cos(x) * w, z - Math.sin(x) * w, s.length());
    }
    function um(s, l) {
      var u = [l[0] - s[0], l[1] - s[1]], f = -Math.PI * 0.5, g = [Math.cos(f) * u[0] - Math.sin(f) * u[1], Math.sin(f) * u[0] + Math.cos(f) * u[1]];
      return g;
    }
    function dm(s, l) {
      var u = l === 0 ? s.length() - 1 : l - 1, f = (l + 1) % s.length(), g = s.v[u], h = s.v[f], w = um(g, h);
      return Math.atan2(0, 1) - Math.atan2(w[1], w[0]);
    }
    function Wu(s, l, u, f, g, h, w) {
      var M = dm(l, u), x = l.v[u % l._length], A = l.v[u === 0 ? l._length - 1 : u - 1], z = l.v[(u + 1) % l._length], Z = h === 2 ? Math.sqrt(Math.pow(x[0] - A[0], 2) + Math.pow(x[1] - A[1], 2)) : 0, D = h === 2 ? Math.sqrt(Math.pow(x[0] - z[0], 2) + Math.pow(x[1] - z[1], 2)) : 0;
      Bu(s, l.v[u % l._length], M, w, f, D / ((g + 1) * 2), Z / ((g + 1) * 2));
    }
    function fm(s, l, u, f, g, h) {
      for (var w = 0; w < f; w += 1) {
        var M = (w + 1) / (f + 1), x = g === 2 ? Math.sqrt(Math.pow(l.points[3][0] - l.points[0][0], 2) + Math.pow(l.points[3][1] - l.points[0][1], 2)) : 0, A = l.normalAngle(M), z = l.point(M);
        Bu(s, z, A, h, u, x / ((f + 1) * 2), x / ((f + 1) * 2)), h = -h;
      }
      return h;
    }
    as.prototype.processPath = function(s, l, u, f) {
      var g = s._length, h = zt.newElement();
      if (h.c = s.c, s.c || (g -= 1), g === 0)
        return h;
      var w = -1, M = gt.shapeSegment(s, 0);
      Wu(h, s, 0, l, u, f, w);
      for (var x = 0; x < g; x += 1)
        w = fm(h, M, l, u, f, -w), x === g - 1 && !s.c ? M = null : M = gt.shapeSegment(s, (x + 1) % g), Wu(h, s, x + 1, l, u, f, w);
      return h;
    }, as.prototype.processShapes = function(s) {
      var l, u, f = this.shapes.length, g, h, w = this.amplitude.v, M = Math.max(0, Math.round(this.frequency.v)), x = this.pointsType.v;
      if (w !== 0) {
        var A, z;
        for (u = 0; u < f; u += 1) {
          if (A = this.shapes[u], z = A.localShapeCollection, !(!A.shape._mdf && !this._mdf && !s))
            for (z.releaseShapes(), A.shape._mdf = !0, l = A.shape.paths.shapes, h = A.shape.paths._length, g = 0; g < h; g += 1)
              z.addShape(this.processPath(l[g], w, M, x));
          A.shape.paths = A.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function Za(s, l, u) {
      var f = Math.atan2(l[0] - s[0], l[1] - s[1]);
      return [Di(s, f, u), Di(l, f, u)];
    }
    function Pi(s, l) {
      var u, f, g, h, w, M, x;
      x = Za(s.points[0], s.points[1], l), u = x[0], f = x[1], x = Za(s.points[1], s.points[2], l), g = x[0], h = x[1], x = Za(s.points[2], s.points[3], l), w = x[0], M = x[1];
      var A = oo(u, f, g, h);
      A === null && (A = f);
      var z = oo(w, M, g, h);
      return z === null && (z = w), new gt(u, A, z, M);
    }
    function ju(s, l, u, f, g) {
      var h = l.points[3], w = u.points[0];
      if (f === 3 || Ei(h, w))
        return h;
      if (f === 2) {
        var M = -l.tangentAngle(1), x = -u.tangentAngle(0) + Math.PI, A = oo(h, Di(h, M + Math.PI / 2, 100), w, Di(w, M + Math.PI / 2, 100)), z = A ? Xa(A, h) : Xa(h, w) / 2, Z = Di(h, M, 2 * z * ge);
        return s.setXYAt(Z[0], Z[1], "o", s.length() - 1), Z = Di(w, x, 2 * z * ge), s.setTripleAt(w[0], w[1], w[0], w[1], Z[0], Z[1], s.length()), w;
      }
      var D = Ei(h, l.points[2]) ? l.points[0] : l.points[2], V = Ei(w, u.points[1]) ? u.points[3] : u.points[1], j = oo(D, h, w, V);
      return j && Xa(j, h) < g ? (s.setTripleAt(j[0], j[1], j[0], j[1], j[0], j[1], s.length()), j) : h;
    }
    function Gu(s, l) {
      var u = s.intersections(l);
      return u.length && io(u[0][0], 1) && u.shift(), u.length ? u[0] : null;
    }
    function qu(s, l) {
      var u = s.slice(), f = l.slice(), g = Gu(s[s.length - 1], l[0]);
      return g && (u[s.length - 1] = s[s.length - 1].split(g[0])[0], f[0] = l[0].split(g[1])[1]), s.length > 1 && l.length > 1 && (g = Gu(s[0], l[l.length - 1]), g) ? [[s[0].split(g[0])[0]], [l[l.length - 1].split(g[1])[1]]] : [u, f];
    }
    function pm(s) {
      for (var l, u = 1; u < s.length; u += 1)
        l = qu(s[u - 1], s[u]), s[u - 1] = l[0], s[u] = l[1];
      return s.length > 1 && (l = qu(s[s.length - 1], s[0]), s[s.length - 1] = l[0], s[0] = l[1]), s;
    }
    function Ku(s, l) {
      var u = s.inflectionPoints(), f, g, h, w;
      if (u.length === 0)
        return [Pi(s, l)];
      if (u.length === 1 || io(u[1], 1))
        return h = s.split(u[0]), f = h[0], g = h[1], [Pi(f, l), Pi(g, l)];
      h = s.split(u[0]), f = h[0];
      var M = (u[1] - u[0]) / (1 - u[0]);
      return h = h[1].split(M), w = h[0], g = h[1], [Pi(f, l), Pi(w, l), Pi(g, l)];
    }
    function ls() {
    }
    v([hr], ls), ls.prototype.initModifierProperties = function(s, l) {
      this.getValue = this.processKeys, this.amount = me.getProp(s, l.a, 0, null, this), this.miterLimit = me.getProp(s, l.ml, 0, null, this), this.lineJoin = l.lj, this._isAnimated = this.amount.effectsSequence.length !== 0;
    }, ls.prototype.processPath = function(s, l, u, f) {
      var g = zt.newElement();
      g.c = s.c;
      var h = s.length();
      s.c || (h -= 1);
      var w, M, x, A = [];
      for (w = 0; w < h; w += 1)
        x = gt.shapeSegment(s, w), A.push(Ku(x, l));
      if (!s.c)
        for (w = h - 1; w >= 0; w -= 1)
          x = gt.shapeSegmentInverted(s, w), A.push(Ku(x, l));
      A = pm(A);
      var z = null, Z = null;
      for (w = 0; w < A.length; w += 1) {
        var D = A[w];
        for (Z && (z = ju(g, Z, D[0], u, f)), Z = D[D.length - 1], M = 0; M < D.length; M += 1)
          x = D[M], z && Ei(x.points[0], z) ? g.setXYAt(x.points[1][0], x.points[1][1], "o", g.length() - 1) : g.setTripleAt(x.points[0][0], x.points[0][1], x.points[1][0], x.points[1][1], x.points[0][0], x.points[0][1], g.length()), g.setTripleAt(x.points[3][0], x.points[3][1], x.points[3][0], x.points[3][1], x.points[2][0], x.points[2][1], g.length()), z = x.points[3];
      }
      return A.length && ju(g, Z, A[0][0], u, f), g;
    }, ls.prototype.processShapes = function(s) {
      var l, u, f = this.shapes.length, g, h, w = this.amount.v, M = this.miterLimit.v, x = this.lineJoin;
      if (w !== 0) {
        var A, z;
        for (u = 0; u < f; u += 1) {
          if (A = this.shapes[u], z = A.localShapeCollection, !(!A.shape._mdf && !this._mdf && !s))
            for (z.releaseShapes(), A.shape._mdf = !0, l = A.shape.paths.shapes, h = A.shape.paths._length, g = 0; g < h; g += 1)
              z.addShape(this.processPath(l[g], w, x, M));
          A.shape.paths = A.localShapeCollection;
        }
      }
      this.dynamicProperties.length || (this._mdf = !1);
    };
    function Uu(s) {
      for (var l = s.fStyle ? s.fStyle.split(" ") : [], u = "normal", f = "normal", g = l.length, h, w = 0; w < g; w += 1)
        switch (h = l[w].toLowerCase(), h) {
          case "italic":
            f = "italic";
            break;
          case "bold":
            u = "700";
            break;
          case "black":
            u = "900";
            break;
          case "medium":
            u = "500";
            break;
          case "regular":
          case "normal":
            u = "400";
            break;
          case "light":
          case "thin":
            u = "200";
            break;
        }
      return {
        style: f,
        weight: s.fWeight || u
      };
    }
    var Xn = function() {
      var s = 5e3, l = {
        w: 0,
        size: 0,
        shapes: [],
        data: {
          shapes: []
        }
      }, u = [];
      u = u.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
      var f = 127988, g = 917631, h = 917601, w = 917626, M = 65039, x = 8205, A = 127462, z = 127487, Z = ["d83cdffb", "d83cdffc", "d83cdffd", "d83cdffe", "d83cdfff"];
      function D($) {
        var B = $.split(","), b, k = B.length, J = [];
        for (b = 0; b < k; b += 1)
          B[b] !== "sans-serif" && B[b] !== "monospace" && J.push(B[b]);
        return J.join(",");
      }
      function V($, B) {
        var b = m("span");
        b.setAttribute("aria-hidden", !0), b.style.fontFamily = B;
        var k = m("span");
        k.innerText = "giItT1WQy@!-/#", b.style.position = "absolute", b.style.left = "-10000px", b.style.top = "-10000px", b.style.fontSize = "300px", b.style.fontVariant = "normal", b.style.fontStyle = "normal", b.style.fontWeight = "normal", b.style.letterSpacing = "0", b.appendChild(k), document.body.appendChild(b);
        var J = k.offsetWidth;
        return k.style.fontFamily = D($) + ", " + B, {
          node: k,
          w: J,
          parent: b
        };
      }
      function j() {
        var $, B = this.fonts.length, b, k, J = B;
        for ($ = 0; $ < B; $ += 1)
          this.fonts[$].loaded ? J -= 1 : this.fonts[$].fOrigin === "n" || this.fonts[$].origin === 0 ? this.fonts[$].loaded = !0 : (b = this.fonts[$].monoCase.node, k = this.fonts[$].monoCase.w, b.offsetWidth !== k ? (J -= 1, this.fonts[$].loaded = !0) : (b = this.fonts[$].sansCase.node, k = this.fonts[$].sansCase.w, b.offsetWidth !== k && (J -= 1, this.fonts[$].loaded = !0)), this.fonts[$].loaded && (this.fonts[$].sansCase.parent.parentNode.removeChild(this.fonts[$].sansCase.parent), this.fonts[$].monoCase.parent.parentNode.removeChild(this.fonts[$].monoCase.parent)));
        J !== 0 && Date.now() - this.initTime < s ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
      }
      function H($, B) {
        var b = document.body && B ? "svg" : "canvas", k, J = Uu($);
        if (b === "svg") {
          var q = ve("text");
          q.style.fontSize = "100px", q.setAttribute("font-family", $.fFamily), q.setAttribute("font-style", J.style), q.setAttribute("font-weight", J.weight), q.textContent = "1", $.fClass ? (q.style.fontFamily = "inherit", q.setAttribute("class", $.fClass)) : q.style.fontFamily = $.fFamily, B.appendChild(q), k = q;
        } else {
          var ye = new OffscreenCanvas(500, 500).getContext("2d");
          ye.font = J.style + " " + J.weight + " 100px " + $.fFamily, k = ye;
        }
        function Me(Ie) {
          return b === "svg" ? (k.textContent = Ie, k.getComputedTextLength()) : k.measureText(Ie).width;
        }
        return {
          measureText: Me
        };
      }
      function U($, B) {
        if (!$) {
          this.isLoaded = !0;
          return;
        }
        if (this.chars) {
          this.isLoaded = !0, this.fonts = $.list;
          return;
        }
        if (!document.body) {
          this.isLoaded = !0, $.list.forEach(function(Zt) {
            Zt.helper = H(Zt), Zt.cache = {};
          }), this.fonts = $.list;
          return;
        }
        var b = $.list, k, J = b.length, q = J;
        for (k = 0; k < J; k += 1) {
          var ye = !0, Me, Ie;
          if (b[k].loaded = !1, b[k].monoCase = V(b[k].fFamily, "monospace"), b[k].sansCase = V(b[k].fFamily, "sans-serif"), !b[k].fPath)
            b[k].loaded = !0, q -= 1;
          else if (b[k].fOrigin === "p" || b[k].origin === 3) {
            if (Me = document.querySelectorAll('style[f-forigin="p"][f-family="' + b[k].fFamily + '"], style[f-origin="3"][f-family="' + b[k].fFamily + '"]'), Me.length > 0 && (ye = !1), ye) {
              var Ge = m("style");
              Ge.setAttribute("f-forigin", b[k].fOrigin), Ge.setAttribute("f-origin", b[k].origin), Ge.setAttribute("f-family", b[k].fFamily), Ge.type = "text/css", Ge.innerText = "@font-face {font-family: " + b[k].fFamily + "; font-style: normal; src: url('" + b[k].fPath + "');}", B.appendChild(Ge);
            }
          } else if (b[k].fOrigin === "g" || b[k].origin === 1) {
            for (Me = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), Ie = 0; Ie < Me.length; Ie += 1)
              Me[Ie].href.indexOf(b[k].fPath) !== -1 && (ye = !1);
            if (ye) {
              var qe = m("link");
              qe.setAttribute("f-forigin", b[k].fOrigin), qe.setAttribute("f-origin", b[k].origin), qe.type = "text/css", qe.rel = "stylesheet", qe.href = b[k].fPath, document.body.appendChild(qe);
            }
          } else if (b[k].fOrigin === "t" || b[k].origin === 2) {
            for (Me = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), Ie = 0; Ie < Me.length; Ie += 1)
              b[k].fPath === Me[Ie].src && (ye = !1);
            if (ye) {
              var xt = m("link");
              xt.setAttribute("f-forigin", b[k].fOrigin), xt.setAttribute("f-origin", b[k].origin), xt.setAttribute("rel", "stylesheet"), xt.setAttribute("href", b[k].fPath), B.appendChild(xt);
            }
          }
          b[k].helper = H(b[k], B), b[k].cache = {}, this.fonts.push(b[k]);
        }
        q === 0 ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
      function O($) {
        if ($) {
          this.chars || (this.chars = []);
          var B, b = $.length, k, J = this.chars.length, q;
          for (B = 0; B < b; B += 1) {
            for (k = 0, q = !1; k < J; )
              this.chars[k].style === $[B].style && this.chars[k].fFamily === $[B].fFamily && this.chars[k].ch === $[B].ch && (q = !0), k += 1;
            q || (this.chars.push($[B]), J += 1);
          }
        }
      }
      function T($, B, b) {
        for (var k = 0, J = this.chars.length; k < J; ) {
          if (this.chars[k].ch === $ && this.chars[k].style === B && this.chars[k].fFamily === b)
            return this.chars[k];
          k += 1;
        }
        return (typeof $ == "string" && $.charCodeAt(0) !== 13 || !$) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", $, B, b)), l;
      }
      function C($, B, b) {
        var k = this.getFontByName(B), J = $;
        if (!k.cache[J]) {
          var q = k.helper;
          if ($ === " ") {
            var ye = q.measureText("|" + $ + "|"), Me = q.measureText("||");
            k.cache[J] = (ye - Me) / 100;
          } else
            k.cache[J] = q.measureText($) / 100;
        }
        return k.cache[J] * b;
      }
      function P($) {
        for (var B = 0, b = this.fonts.length; B < b; ) {
          if (this.fonts[B].fName === $)
            return this.fonts[B];
          B += 1;
        }
        return this.fonts[0];
      }
      function F($) {
        var B = 0, b = $.charCodeAt(0);
        if (b >= 55296 && b <= 56319) {
          var k = $.charCodeAt(1);
          k >= 56320 && k <= 57343 && (B = (b - 55296) * 1024 + k - 56320 + 65536);
        }
        return B;
      }
      function G($, B) {
        var b = $.toString(16) + B.toString(16);
        return Z.indexOf(b) !== -1;
      }
      function X($) {
        return $ === x;
      }
      function ee($) {
        return $ === M;
      }
      function ae($) {
        var B = F($);
        return B >= A && B <= z;
      }
      function Te($) {
        return ae($.substr(0, 2)) && ae($.substr(2, 2));
      }
      function Ce($) {
        return u.indexOf($) !== -1;
      }
      function he($, B) {
        var b = F($.substr(B, 2));
        if (b !== f)
          return !1;
        var k = 0;
        for (B += 2; k < 5; ) {
          if (b = F($.substr(B, 2)), b < h || b > w)
            return !1;
          k += 1, B += 2;
        }
        return F($.substr(B, 2)) === g;
      }
      function Ae() {
        this.isLoaded = !0;
      }
      var xe = function() {
        this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
      };
      xe.isModifier = G, xe.isZeroWidthJoiner = X, xe.isFlagEmoji = Te, xe.isRegionalCode = ae, xe.isCombinedCharacter = Ce, xe.isRegionalFlag = he, xe.isVariationSelector = ee, xe.BLACK_FLAG_CODE_POINT = f;
      var oe = {
        addChars: O,
        addFonts: U,
        getCharData: T,
        getFontByName: P,
        measureText: C,
        checkLoadedFonts: j,
        setIsLoaded: Ae
      };
      return xe.prototype = oe, xe;
    }();
    function Qu(s) {
      this.animationData = s;
    }
    Qu.prototype.getProp = function(s) {
      return this.animationData.slots && this.animationData.slots[s.sid] ? Object.assign(s, this.animationData.slots[s.sid].p) : s;
    };
    function hm(s) {
      return new Qu(s);
    }
    function ao() {
    }
    ao.prototype = {
      initRenderable: function() {
        this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
      },
      addRenderableComponent: function(l) {
        this.renderableComponents.indexOf(l) === -1 && this.renderableComponents.push(l);
      },
      removeRenderableComponent: function(l) {
        this.renderableComponents.indexOf(l) !== -1 && this.renderableComponents.splice(this.renderableComponents.indexOf(l), 1);
      },
      prepareRenderableFrame: function(l) {
        this.checkLayerLimits(l);
      },
      checkTransparency: function() {
        this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
      },
      /**
         * @function
         * Initializes frame related properties.
         *
         * @param {number} num
         * current frame number in Layer's time
         *
         */
      checkLayerLimits: function(l) {
        this.data.ip - this.data.st <= l && this.data.op - this.data.st > l ? this.isInRange !== !0 && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : this.isInRange !== !1 && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
      },
      renderRenderable: function() {
        var l, u = this.renderableComponents.length;
        for (l = 0; l < u; l += 1)
          this.renderableComponents[l].renderFrame(this._isFirstFrame);
      },
      sourceRectAtTime: function() {
        return {
          top: 0,
          left: 0,
          width: 100,
          height: 100
        };
      },
      getLayerSize: function() {
        return this.data.ty === 5 ? {
          w: this.data.textData.width,
          h: this.data.textData.height
        } : {
          w: this.data.width,
          h: this.data.height
        };
      }
    };
    var Ja = /* @__PURE__ */ function() {
      var s = {
        0: "source-over",
        1: "multiply",
        2: "screen",
        3: "overlay",
        4: "darken",
        5: "lighten",
        6: "color-dodge",
        7: "color-burn",
        8: "hard-light",
        9: "soft-light",
        10: "difference",
        11: "exclusion",
        12: "hue",
        13: "saturation",
        14: "color",
        15: "luminosity"
      };
      return function(l) {
        return s[l] || "";
      };
    }();
    function gm(s, l, u) {
      this.p = me.getProp(l, s.v, 0, 0, u);
    }
    function mm(s, l, u) {
      this.p = me.getProp(l, s.v, 0, 0, u);
    }
    function vm(s, l, u) {
      this.p = me.getProp(l, s.v, 1, 0, u);
    }
    function _m(s, l, u) {
      this.p = me.getProp(l, s.v, 1, 0, u);
    }
    function ym(s, l, u) {
      this.p = me.getProp(l, s.v, 0, 0, u);
    }
    function bm(s, l, u) {
      this.p = me.getProp(l, s.v, 0, 0, u);
    }
    function wm(s, l, u) {
      this.p = me.getProp(l, s.v, 0, 0, u);
    }
    function xm() {
      this.p = {};
    }
    function Xu(s, l) {
      var u = s.ef || [];
      this.effectElements = [];
      var f, g = u.length, h;
      for (f = 0; f < g; f += 1)
        h = new cs(u[f], l), this.effectElements.push(h);
    }
    function cs(s, l) {
      this.init(s, l);
    }
    v([At], cs), cs.prototype.getValue = cs.prototype.iterateDynamicProperties, cs.prototype.init = function(s, l) {
      this.data = s, this.effectElements = [], this.initDynamicPropertyContainer(l);
      var u, f = this.data.ef.length, g, h = this.data.ef;
      for (u = 0; u < f; u += 1) {
        switch (g = null, h[u].ty) {
          case 0:
            g = new gm(h[u], l, this);
            break;
          case 1:
            g = new mm(h[u], l, this);
            break;
          case 2:
            g = new vm(h[u], l, this);
            break;
          case 3:
            g = new _m(h[u], l, this);
            break;
          case 4:
          case 7:
            g = new wm(h[u], l, this);
            break;
          case 10:
            g = new ym(h[u], l, this);
            break;
          case 11:
            g = new bm(h[u], l, this);
            break;
          case 5:
            g = new Xu(h[u], l);
            break;
          default:
            g = new xm(h[u]);
            break;
        }
        g && this.effectElements.push(g);
      }
    };
    function gn() {
    }
    gn.prototype = {
      checkMasks: function() {
        if (!this.data.hasMask)
          return !1;
        for (var l = 0, u = this.data.masksProperties.length; l < u; ) {
          if (this.data.masksProperties[l].mode !== "n" && this.data.masksProperties[l].cl !== !1)
            return !0;
          l += 1;
        }
        return !1;
      },
      initExpressions: function() {
      },
      setBlendMode: function() {
        var l = Ja(this.data.bm), u = this.baseElement || this.layerElement;
        u.style["mix-blend-mode"] = l;
      },
      initBaseData: function(l, u, f) {
        this.globalData = u, this.comp = f, this.data = l, this.layerId = ue(), this.data.sr || (this.data.sr = 1), this.effectsManager = new Xu(this.data, this, this.dynamicProperties);
      },
      getType: function() {
        return this.type;
      },
      sourceRectAtTime: function() {
      }
    };
    function mn() {
    }
    mn.prototype = {
      /**
         * @function
         * Initializes frame related properties.
         *
         */
      initFrame: function() {
        this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
      },
      /**
         * @function
         * Calculates all dynamic values
         *
         * @param {number} num
         * current frame number in Layer's time
         * @param {boolean} isVisible
         * if layers is currently in range
         *
         */
      prepareProperties: function(l, u) {
        var f, g = this.dynamicProperties.length;
        for (f = 0; f < g; f += 1)
          (u || this._isParent && this.dynamicProperties[f].propType === "transform") && (this.dynamicProperties[f].getValue(), this.dynamicProperties[f]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
      },
      addDynamicProperty: function(l) {
        this.dynamicProperties.indexOf(l) === -1 && this.dynamicProperties.push(l);
      }
    };
    function vn(s, l, u) {
      this.initFrame(), this.initRenderable(), this.assetData = l.getAssetData(s.refId), this.footageData = l.imageLoader.getAsset(this.assetData), this.initBaseData(s, l, u);
    }
    vn.prototype.prepareFrame = function() {
    }, v([ao, gn, mn], vn), vn.prototype.getBaseElement = function() {
      return null;
    }, vn.prototype.renderFrame = function() {
    }, vn.prototype.destroy = function() {
    }, vn.prototype.initExpressions = function() {
    }, vn.prototype.getFootageData = function() {
      return this.footageData;
    };
    function Xt(s, l, u) {
      this.initFrame(), this.initRenderable(), this.assetData = l.getAssetData(s.refId), this.initBaseData(s, l, u), this._isPlaying = !1, this._canPlay = !1;
      var f = this.globalData.getAssetsPath(this.assetData);
      this.audio = this.globalData.audioController.createAudio(f), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = s.tm ? me.getProp(this, s.tm, 0, l.frameRate, this) : {
        _placeholder: !0
      }, this.lv = me.getProp(this, s.au && s.au.lv ? s.au.lv : {
        k: [100]
      }, 1, 0.01, this);
    }
    Xt.prototype.prepareFrame = function(s) {
      if (this.prepareRenderableFrame(s, !0), this.prepareProperties(s, !0), this.tm._placeholder)
        this._currentTime = s / this.data.sr;
      else {
        var l = this.tm.v;
        this._currentTime = l;
      }
      this._volume = this.lv.v[0];
      var u = this._volume * this._volumeMultiplier;
      this._previousVolume !== u && (this._previousVolume = u, this.audio.volume(u));
    }, v([ao, gn, mn], Xt), Xt.prototype.renderFrame = function() {
      this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
    }, Xt.prototype.show = function() {
    }, Xt.prototype.hide = function() {
      this.audio.pause(), this._isPlaying = !1;
    }, Xt.prototype.pause = function() {
      this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
    }, Xt.prototype.resume = function() {
      this._canPlay = !0;
    }, Xt.prototype.setRate = function(s) {
      this.audio.rate(s);
    }, Xt.prototype.volume = function(s) {
      this._volumeMultiplier = s, this._previousVolume = s * this._volume, this.audio.volume(this._previousVolume);
    }, Xt.prototype.getBaseElement = function() {
      return null;
    }, Xt.prototype.destroy = function() {
    }, Xt.prototype.sourceRectAtTime = function() {
    }, Xt.prototype.initExpressions = function() {
    };
    function Yt() {
    }
    Yt.prototype.checkLayers = function(s) {
      var l, u = this.layers.length, f;
      for (this.completeLayers = !0, l = u - 1; l >= 0; l -= 1)
        this.elements[l] || (f = this.layers[l], f.ip - f.st <= s - this.layers[l].st && f.op - f.st > s - this.layers[l].st && this.buildItem(l)), this.completeLayers = this.elements[l] ? this.completeLayers : !1;
      this.checkPendingElements();
    }, Yt.prototype.createItem = function(s) {
      switch (s.ty) {
        case 2:
          return this.createImage(s);
        case 0:
          return this.createComp(s);
        case 1:
          return this.createSolid(s);
        case 3:
          return this.createNull(s);
        case 4:
          return this.createShape(s);
        case 5:
          return this.createText(s);
        case 6:
          return this.createAudio(s);
        case 13:
          return this.createCamera(s);
        case 15:
          return this.createFootage(s);
        default:
          return this.createNull(s);
      }
    }, Yt.prototype.createCamera = function() {
      throw new Error("You're using a 3d camera. Try the html renderer.");
    }, Yt.prototype.createAudio = function(s) {
      return new Xt(s, this.globalData, this);
    }, Yt.prototype.createFootage = function(s) {
      return new vn(s, this.globalData, this);
    }, Yt.prototype.buildAllItems = function() {
      var s, l = this.layers.length;
      for (s = 0; s < l; s += 1)
        this.buildItem(s);
      this.checkPendingElements();
    }, Yt.prototype.includeLayers = function(s) {
      this.completeLayers = !1;
      var l, u = s.length, f, g = this.layers.length;
      for (l = 0; l < u; l += 1)
        for (f = 0; f < g; ) {
          if (this.layers[f].id === s[l].id) {
            this.layers[f] = s[l];
            break;
          }
          f += 1;
        }
    }, Yt.prototype.setProjectInterface = function(s) {
      this.globalData.projectInterface = s;
    }, Yt.prototype.initItems = function() {
      this.globalData.progressiveLoad || this.buildAllItems();
    }, Yt.prototype.buildElementParenting = function(s, l, u) {
      for (var f = this.elements, g = this.layers, h = 0, w = g.length; h < w; )
        g[h].ind == l && (!f[h] || f[h] === !0 ? (this.buildItem(h), this.addPendingElement(s)) : (u.push(f[h]), f[h].setAsParent(), g[h].parent !== void 0 ? this.buildElementParenting(s, g[h].parent, u) : s.setHierarchy(u))), h += 1;
    }, Yt.prototype.addPendingElement = function(s) {
      this.pendingElements.push(s);
    }, Yt.prototype.searchExtraCompositions = function(s) {
      var l, u = s.length;
      for (l = 0; l < u; l += 1)
        if (s[l].xt) {
          var f = this.createComp(s[l]);
          f.initExpressions(), this.globalData.projectInterface.registerComposition(f);
        }
    }, Yt.prototype.getElementById = function(s) {
      var l, u = this.elements.length;
      for (l = 0; l < u; l += 1)
        if (this.elements[l].data.ind === s)
          return this.elements[l];
      return null;
    }, Yt.prototype.getElementByPath = function(s) {
      var l = s.shift(), u;
      if (typeof l == "number")
        u = this.elements[l];
      else {
        var f, g = this.elements.length;
        for (f = 0; f < g; f += 1)
          if (this.elements[f].data.nm === l) {
            u = this.elements[f];
            break;
          }
      }
      return s.length === 0 ? u : u.getElementByPath(s);
    }, Yt.prototype.setupGlobalData = function(s, l) {
      this.globalData.fontManager = new Xn(), this.globalData.slotManager = hm(s), this.globalData.fontManager.addChars(s.chars), this.globalData.fontManager.addFonts(s.fonts, l), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = s.fr, this.globalData.nm = s.nm, this.globalData.compSize = {
        w: s.w,
        h: s.h
      };
    };
    var Sm = {
      TRANSFORM_EFFECT: "transformEFfect"
    };
    function Mi() {
    }
    Mi.prototype = {
      initTransform: function() {
        var l = new Vt();
        this.finalTransform = {
          mProp: this.data.ks ? Ka.getTransformProperty(this, this.data.ks, this) : {
            o: 0
          },
          _matMdf: !1,
          _localMatMdf: !1,
          _opMdf: !1,
          mat: l,
          localMat: l,
          localOpacity: 1
        }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
      },
      renderTransform: function() {
        if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
          var l, u = this.finalTransform.mat, f = 0, g = this.hierarchy.length;
          if (!this.finalTransform._matMdf)
            for (; f < g; ) {
              if (this.hierarchy[f].finalTransform.mProp._mdf) {
                this.finalTransform._matMdf = !0;
                break;
              }
              f += 1;
            }
          if (this.finalTransform._matMdf)
            for (l = this.finalTransform.mProp.v.props, u.cloneFromProps(l), f = 0; f < g; f += 1)
              u.multiply(this.hierarchy[f].finalTransform.mProp.v);
        }
        this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
      },
      renderLocalTransform: function() {
        if (this.localTransforms) {
          var l = 0, u = this.localTransforms.length;
          if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf)
            for (; l < u; )
              this.localTransforms[l]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[l]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), l += 1;
          if (this.finalTransform._localMatMdf) {
            var f = this.finalTransform.localMat;
            for (this.localTransforms[0].matrix.clone(f), l = 1; l < u; l += 1) {
              var g = this.localTransforms[l].matrix;
              f.multiply(g);
            }
            f.multiply(this.finalTransform.mat);
          }
          if (this.finalTransform._opMdf) {
            var h = this.finalTransform.localOpacity;
            for (l = 0; l < u; l += 1)
              h *= this.localTransforms[l].opacity * 0.01;
            this.finalTransform.localOpacity = h;
          }
        }
      },
      searchEffectTransforms: function() {
        if (this.renderableEffectsManager) {
          var l = this.renderableEffectsManager.getEffects(Sm.TRANSFORM_EFFECT);
          if (l.length) {
            this.localTransforms = [], this.finalTransform.localMat = new Vt();
            var u = 0, f = l.length;
            for (u = 0; u < f; u += 1)
              this.localTransforms.push(l[u]);
          }
        }
      },
      globalToLocal: function(l) {
        var u = [];
        u.push(this.finalTransform);
        for (var f = !0, g = this.comp; f; )
          g.finalTransform ? (g.data.hasMask && u.splice(0, 0, g.finalTransform), g = g.comp) : f = !1;
        var h, w = u.length, M;
        for (h = 0; h < w; h += 1)
          M = u[h].mat.applyToPointArray(0, 0, 0), l = [l[0] - M[0], l[1] - M[1], 0];
        return l;
      },
      mHelper: new Vt()
    };
    function Zn(s, l, u) {
      this.data = s, this.element = l, this.globalData = u, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
      var f = this.globalData.defs, g, h = this.masksProperties ? this.masksProperties.length : 0;
      this.viewData = E(h), this.solidPath = "";
      var w, M = this.masksProperties, x = 0, A = [], z, Z, D = ue(), V, j, H, U, O = "clipPath", T = "clip-path";
      for (g = 0; g < h; g += 1)
        if ((M[g].mode !== "a" && M[g].mode !== "n" || M[g].inv || M[g].o.k !== 100 || M[g].o.x) && (O = "mask", T = "mask"), (M[g].mode === "s" || M[g].mode === "i") && x === 0 ? (V = ve("rect"), V.setAttribute("fill", "#ffffff"), V.setAttribute("width", this.element.comp.data.w || 0), V.setAttribute("height", this.element.comp.data.h || 0), A.push(V)) : V = null, w = ve("path"), M[g].mode === "n")
          this.viewData[g] = {
            op: me.getProp(this.element, M[g].o, 0, 0.01, this.element),
            prop: ro.getShapeProp(this.element, M[g], 3),
            elem: w,
            lastPath: ""
          }, f.appendChild(w);
        else {
          x += 1, w.setAttribute("fill", M[g].mode === "s" ? "#000000" : "#ffffff"), w.setAttribute("clip-rule", "nonzero");
          var C;
          if (M[g].x.k !== 0 ? (O = "mask", T = "mask", U = me.getProp(this.element, M[g].x, 0, null, this.element), C = ue(), j = ve("filter"), j.setAttribute("id", C), H = ve("feMorphology"), H.setAttribute("operator", "erode"), H.setAttribute("in", "SourceGraphic"), H.setAttribute("radius", "0"), j.appendChild(H), f.appendChild(j), w.setAttribute("stroke", M[g].mode === "s" ? "#000000" : "#ffffff")) : (H = null, U = null), this.storedData[g] = {
            elem: w,
            x: U,
            expan: H,
            lastPath: "",
            lastOperator: "",
            filterId: C,
            lastRadius: 0
          }, M[g].mode === "i") {
            Z = A.length;
            var P = ve("g");
            for (z = 0; z < Z; z += 1)
              P.appendChild(A[z]);
            var F = ve("mask");
            F.setAttribute("mask-type", "alpha"), F.setAttribute("id", D + "_" + x), F.appendChild(w), f.appendChild(F), P.setAttribute("mask", "url(" + p() + "#" + D + "_" + x + ")"), A.length = 0, A.push(P);
          } else
            A.push(w);
          M[g].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[g] = {
            elem: w,
            lastPath: "",
            op: me.getProp(this.element, M[g].o, 0, 0.01, this.element),
            prop: ro.getShapeProp(this.element, M[g], 3),
            invRect: V
          }, this.viewData[g].prop.k || this.drawPath(M[g], this.viewData[g].prop.v, this.viewData[g]);
        }
      for (this.maskElement = ve(O), h = A.length, g = 0; g < h; g += 1)
        this.maskElement.appendChild(A[g]);
      x > 0 && (this.maskElement.setAttribute("id", D), this.element.maskedElement.setAttribute(T, "url(" + p() + "#" + D + ")"), f.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
    }
    Zn.prototype.getMaskProperty = function(s) {
      return this.viewData[s].prop;
    }, Zn.prototype.renderFrame = function(s) {
      var l = this.element.finalTransform.mat, u, f = this.masksProperties.length;
      for (u = 0; u < f; u += 1)
        if ((this.viewData[u].prop._mdf || s) && this.drawPath(this.masksProperties[u], this.viewData[u].prop.v, this.viewData[u]), (this.viewData[u].op._mdf || s) && this.viewData[u].elem.setAttribute("fill-opacity", this.viewData[u].op.v), this.masksProperties[u].mode !== "n" && (this.viewData[u].invRect && (this.element.finalTransform.mProp._mdf || s) && this.viewData[u].invRect.setAttribute("transform", l.getInverseMatrix().to2dCSS()), this.storedData[u].x && (this.storedData[u].x._mdf || s))) {
          var g = this.storedData[u].expan;
          this.storedData[u].x.v < 0 ? (this.storedData[u].lastOperator !== "erode" && (this.storedData[u].lastOperator = "erode", this.storedData[u].elem.setAttribute("filter", "url(" + p() + "#" + this.storedData[u].filterId + ")")), g.setAttribute("radius", -this.storedData[u].x.v)) : (this.storedData[u].lastOperator !== "dilate" && (this.storedData[u].lastOperator = "dilate", this.storedData[u].elem.setAttribute("filter", null)), this.storedData[u].elem.setAttribute("stroke-width", this.storedData[u].x.v * 2));
        }
    }, Zn.prototype.getMaskelement = function() {
      return this.maskElement;
    }, Zn.prototype.createLayerSolidPath = function() {
      var s = "M0,0 ";
      return s += " h" + this.globalData.compSize.w, s += " v" + this.globalData.compSize.h, s += " h-" + this.globalData.compSize.w, s += " v-" + this.globalData.compSize.h + " ", s;
    }, Zn.prototype.drawPath = function(s, l, u) {
      var f = " M" + l.v[0][0] + "," + l.v[0][1], g, h;
      for (h = l._length, g = 1; g < h; g += 1)
        f += " C" + l.o[g - 1][0] + "," + l.o[g - 1][1] + " " + l.i[g][0] + "," + l.i[g][1] + " " + l.v[g][0] + "," + l.v[g][1];
      if (l.c && h > 1 && (f += " C" + l.o[g - 1][0] + "," + l.o[g - 1][1] + " " + l.i[0][0] + "," + l.i[0][1] + " " + l.v[0][0] + "," + l.v[0][1]), u.lastPath !== f) {
        var w = "";
        u.elem && (l.c && (w = s.inv ? this.solidPath + f : f), u.elem.setAttribute("d", w)), u.lastPath = f;
      }
    }, Zn.prototype.destroy = function() {
      this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
    };
    var us = function() {
      var s = {};
      s.createFilter = l, s.createAlphaToLuminanceFilter = u;
      function l(f, g) {
        var h = ve("filter");
        return h.setAttribute("id", f), g !== !0 && (h.setAttribute("filterUnits", "objectBoundingBox"), h.setAttribute("x", "0%"), h.setAttribute("y", "0%"), h.setAttribute("width", "100%"), h.setAttribute("height", "100%")), h;
      }
      function u() {
        var f = ve("feColorMatrix");
        return f.setAttribute("type", "matrix"), f.setAttribute("color-interpolation-filters", "sRGB"), f.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), f;
      }
      return s;
    }(), Zu = function() {
      var s = {
        maskType: !0,
        svgLumaHidden: !0,
        offscreenCanvas: typeof OffscreenCanvas < "u"
      };
      return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (s.maskType = !1), /firefox/i.test(navigator.userAgent) && (s.svgLumaHidden = !1), s;
    }(), el = {}, Ju = "filter_result_";
    function tl(s) {
      var l, u = "SourceGraphic", f = s.data.ef ? s.data.ef.length : 0, g = ue(), h = us.createFilter(g, !0), w = 0;
      this.filters = [];
      var M;
      for (l = 0; l < f; l += 1) {
        M = null;
        var x = s.data.ef[l].ty;
        if (el[x]) {
          var A = el[x].effect;
          M = new A(h, s.effectsManager.effectElements[l], s, Ju + w, u), u = Ju + w, el[x].countsAsEffect && (w += 1);
        }
        M && this.filters.push(M);
      }
      w && (s.globalData.defs.appendChild(h), s.layerElement.setAttribute("filter", "url(" + p() + "#" + g + ")")), this.filters.length && s.addRenderableComponent(this);
    }
    tl.prototype.renderFrame = function(s) {
      var l, u = this.filters.length;
      for (l = 0; l < u; l += 1)
        this.filters[l].renderFrame(s);
    }, tl.prototype.getEffects = function(s) {
      var l, u = this.filters.length, f = [];
      for (l = 0; l < u; l += 1)
        this.filters[l].type === s && f.push(this.filters[l]);
      return f;
    };
    function ds() {
    }
    ds.prototype = {
      initRendererElement: function() {
        this.layerElement = ve("g");
      },
      createContainerElements: function() {
        this.matteElement = ve("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
        var l = null;
        if (this.data.td) {
          this.matteMasks = {};
          var u = ve("g");
          u.setAttribute("id", this.layerId), u.appendChild(this.layerElement), l = u, this.globalData.defs.appendChild(u);
        } else
          this.data.tt ? (this.matteElement.appendChild(this.layerElement), l = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
        if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), this.data.ty === 0 && !this.data.hd) {
          var f = ve("clipPath"), g = ve("path");
          g.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
          var h = ue();
          if (f.setAttribute("id", h), f.appendChild(g), this.globalData.defs.appendChild(f), this.checkMasks()) {
            var w = ve("g");
            w.setAttribute("clip-path", "url(" + p() + "#" + h + ")"), w.appendChild(this.layerElement), this.transformedElement = w, l ? l.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
          } else
            this.layerElement.setAttribute("clip-path", "url(" + p() + "#" + h + ")");
        }
        this.data.bm !== 0 && this.setBlendMode();
      },
      renderElement: function() {
        this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
      },
      destroyBaseElement: function() {
        this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
      },
      getBaseElement: function() {
        return this.data.hd ? null : this.baseElement;
      },
      createRenderableComponents: function() {
        this.maskManager = new Zn(this.data, this, this.globalData), this.renderableEffectsManager = new tl(this), this.searchEffectTransforms();
      },
      getMatte: function(l) {
        if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[l]) {
          var u = this.layerId + "_" + l, f, g, h, w;
          if (l === 1 || l === 3) {
            var M = ve("mask");
            M.setAttribute("id", u), M.setAttribute("mask-type", l === 3 ? "luminance" : "alpha"), h = ve("use"), h.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), M.appendChild(h), this.globalData.defs.appendChild(M), !Zu.maskType && l === 1 && (M.setAttribute("mask-type", "luminance"), f = ue(), g = us.createFilter(f), this.globalData.defs.appendChild(g), g.appendChild(us.createAlphaToLuminanceFilter()), w = ve("g"), w.appendChild(h), M.appendChild(w), w.setAttribute("filter", "url(" + p() + "#" + f + ")"));
          } else if (l === 2) {
            var x = ve("mask");
            x.setAttribute("id", u), x.setAttribute("mask-type", "alpha");
            var A = ve("g");
            x.appendChild(A), f = ue(), g = us.createFilter(f);
            var z = ve("feComponentTransfer");
            z.setAttribute("in", "SourceGraphic"), g.appendChild(z);
            var Z = ve("feFuncA");
            Z.setAttribute("type", "table"), Z.setAttribute("tableValues", "1.0 0.0"), z.appendChild(Z), this.globalData.defs.appendChild(g);
            var D = ve("rect");
            D.setAttribute("width", this.comp.data.w), D.setAttribute("height", this.comp.data.h), D.setAttribute("x", "0"), D.setAttribute("y", "0"), D.setAttribute("fill", "#ffffff"), D.setAttribute("opacity", "0"), A.setAttribute("filter", "url(" + p() + "#" + f + ")"), A.appendChild(D), h = ve("use"), h.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), A.appendChild(h), Zu.maskType || (x.setAttribute("mask-type", "luminance"), g.appendChild(us.createAlphaToLuminanceFilter()), w = ve("g"), A.appendChild(D), w.appendChild(this.layerElement), A.appendChild(w)), this.globalData.defs.appendChild(x);
          }
          this.matteMasks[l] = u;
        }
        return this.matteMasks[l];
      },
      setMatte: function(l) {
        this.matteElement && this.matteElement.setAttribute("mask", "url(" + p() + "#" + l + ")");
      }
    };
    function $i() {
    }
    $i.prototype = {
      /**
         * @function
         * Initializes hierarchy properties
         *
         */
      initHierarchy: function() {
        this.hierarchy = [], this._isParent = !1, this.checkParenting();
      },
      /**
         * @function
         * Sets layer's hierarchy.
         * @param {array} hierarch
         * layer's parent list
         *
         */
      setHierarchy: function(l) {
        this.hierarchy = l;
      },
      /**
         * @function
         * Sets layer as parent.
         *
         */
      setAsParent: function() {
        this._isParent = !0;
      },
      /**
         * @function
         * Searches layer's parenting chain
         *
         */
      checkParenting: function() {
        this.data.parent !== void 0 && this.comp.buildElementParenting(this, this.data.parent, []);
      }
    };
    function fs() {
    }
    (function() {
      var s = {
        initElement: function(u, f, g) {
          this.initFrame(), this.initBaseData(u, f, g), this.initTransform(u, f, g), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
        },
        hide: function() {
          if (!this.hidden && (!this.isInRange || this.isTransparent)) {
            var u = this.baseElement || this.layerElement;
            u.style.display = "none", this.hidden = !0;
          }
        },
        show: function() {
          if (this.isInRange && !this.isTransparent) {
            if (!this.data.hd) {
              var u = this.baseElement || this.layerElement;
              u.style.display = "block";
            }
            this.hidden = !1, this._isFirstFrame = !0;
          }
        },
        renderFrame: function() {
          this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
        },
        renderInnerContent: function() {
        },
        prepareFrame: function(u) {
          this._mdf = !1, this.prepareRenderableFrame(u), this.prepareProperties(u, this.isInRange), this.checkTransparency();
        },
        destroy: function() {
          this.innerElem = null, this.destroyBaseElement();
        }
      };
      v([ao, y(s)], fs);
    })();
    function ps(s, l, u) {
      this.assetData = l.getAssetData(s.refId), this.assetData && this.assetData.sid && (this.assetData = l.slotManager.getProp(this.assetData)), this.initElement(s, l, u), this.sourceRect = {
        top: 0,
        left: 0,
        width: this.assetData.w,
        height: this.assetData.h
      };
    }
    v([gn, Mi, ds, $i, mn, fs], ps), ps.prototype.createContent = function() {
      var s = this.globalData.getAssetsPath(this.assetData);
      this.innerElem = ve("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", s), this.layerElement.appendChild(this.innerElem);
    }, ps.prototype.sourceRectAtTime = function() {
      return this.sourceRect;
    };
    function km(s, l) {
      this.elem = s, this.pos = l;
    }
    function ed() {
    }
    ed.prototype = {
      addShapeToModifiers: function(l) {
        var u, f = this.shapeModifiers.length;
        for (u = 0; u < f; u += 1)
          this.shapeModifiers[u].addShape(l);
      },
      isShapeInAnimatedModifiers: function(l) {
        for (var u = 0, f = this.shapeModifiers.length; u < f; )
          if (this.shapeModifiers[u].isAnimatedWithShape(l))
            return !0;
        return !1;
      },
      renderModifiers: function() {
        if (this.shapeModifiers.length) {
          var l, u = this.shapes.length;
          for (l = 0; l < u; l += 1)
            this.shapes[l].sh.reset();
          u = this.shapeModifiers.length;
          var f;
          for (l = u - 1; l >= 0 && (f = this.shapeModifiers[l].processShapes(this._isFirstFrame), !f); l -= 1)
            ;
        }
      },
      searchProcessedElement: function(l) {
        for (var u = this.processedElements, f = 0, g = u.length; f < g; ) {
          if (u[f].elem === l)
            return u[f].pos;
          f += 1;
        }
        return 0;
      },
      addProcessedElement: function(l, u) {
        for (var f = this.processedElements, g = f.length; g; )
          if (g -= 1, f[g].elem === l) {
            f[g].pos = u;
            return;
          }
        f.push(new km(l, u));
      },
      prepareFrame: function(l) {
        this.prepareRenderableFrame(l), this.prepareProperties(l, this.isInRange);
      }
    };
    var td = {
      1: "butt",
      2: "round",
      3: "square"
    }, rd = {
      1: "miter",
      2: "round",
      3: "bevel"
    };
    function nd(s, l, u) {
      this.caches = [], this.styles = [], this.transformers = s, this.lStr = "", this.sh = u, this.lvl = l, this._isAnimated = !!u.k;
      for (var f = 0, g = s.length; f < g; ) {
        if (s[f].mProps.dynamicProperties.length) {
          this._isAnimated = !0;
          break;
        }
        f += 1;
      }
    }
    nd.prototype.setAsAnimated = function() {
      this._isAnimated = !0;
    };
    function id(s, l) {
      this.data = s, this.type = s.ty, this.d = "", this.lvl = l, this._mdf = !1, this.closed = s.hd === !0, this.pElem = ve("path"), this.msElem = null;
    }
    id.prototype.reset = function() {
      this.d = "", this._mdf = !1;
    };
    function lo(s, l, u, f) {
      this.elem = s, this.frameId = -1, this.dataProps = E(l.length), this.renderer = u, this.k = !1, this.dashStr = "", this.dashArray = S("float32", l.length ? l.length - 1 : 0), this.dashoffset = S("float32", 1), this.initDynamicPropertyContainer(f);
      var g, h = l.length || 0, w;
      for (g = 0; g < h; g += 1)
        w = me.getProp(s, l[g].v, 0, 0, this), this.k = w.k || this.k, this.dataProps[g] = {
          n: l[g].n,
          p: w
        };
      this.k || this.getValue(!0), this._isAnimated = this.k;
    }
    lo.prototype.getValue = function(s) {
      if (!(this.elem.globalData.frameId === this.frameId && !s) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || s, this._mdf)) {
        var l = 0, u = this.dataProps.length;
        for (this.renderer === "svg" && (this.dashStr = ""), l = 0; l < u; l += 1)
          this.dataProps[l].n !== "o" ? this.renderer === "svg" ? this.dashStr += " " + this.dataProps[l].p.v : this.dashArray[l] = this.dataProps[l].p.v : this.dashoffset[0] = this.dataProps[l].p.v;
      }
    }, v([At], lo);
    function sd(s, l, u) {
      this.initDynamicPropertyContainer(s), this.getValue = this.iterateDynamicProperties, this.o = me.getProp(s, l.o, 0, 0.01, this), this.w = me.getProp(s, l.w, 0, null, this), this.d = new lo(s, l.d || {}, "svg", this), this.c = me.getProp(s, l.c, 1, 255, this), this.style = u, this._isAnimated = !!this._isAnimated;
    }
    v([At], sd);
    function od(s, l, u) {
      this.initDynamicPropertyContainer(s), this.getValue = this.iterateDynamicProperties, this.o = me.getProp(s, l.o, 0, 0.01, this), this.c = me.getProp(s, l.c, 1, 255, this), this.style = u;
    }
    v([At], od);
    function ad(s, l, u) {
      this.initDynamicPropertyContainer(s), this.getValue = this.iterateDynamicProperties, this.style = u;
    }
    v([At], ad);
    function hs(s, l, u) {
      this.data = l, this.c = S("uint8c", l.p * 4);
      var f = l.k.k[0].s ? l.k.k[0].s.length - l.p * 4 : l.k.k.length - l.p * 4;
      this.o = S("float32", f), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = f, this.initDynamicPropertyContainer(u), this.prop = me.getProp(s, l.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
    }
    hs.prototype.comparePoints = function(s, l) {
      for (var u = 0, f = this.o.length / 2, g; u < f; ) {
        if (g = Math.abs(s[u * 4] - s[l * 4 + u * 2]), g > 0.01)
          return !1;
        u += 1;
      }
      return !0;
    }, hs.prototype.checkCollapsable = function() {
      if (this.o.length / 2 !== this.c.length / 4)
        return !1;
      if (this.data.k.k[0].s)
        for (var s = 0, l = this.data.k.k.length; s < l; ) {
          if (!this.comparePoints(this.data.k.k[s].s, this.data.p))
            return !1;
          s += 1;
        }
      else if (!this.comparePoints(this.data.k.k, this.data.p))
        return !1;
      return !0;
    }, hs.prototype.getValue = function(s) {
      if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || s) {
        var l, u = this.data.p * 4, f, g;
        for (l = 0; l < u; l += 1)
          f = l % 4 === 0 ? 100 : 255, g = Math.round(this.prop.v[l] * f), this.c[l] !== g && (this.c[l] = g, this._cmdf = !s);
        if (this.o.length)
          for (u = this.prop.v.length, l = this.data.p * 4; l < u; l += 1)
            f = l % 2 === 0 ? 100 : 1, g = l % 2 === 0 ? Math.round(this.prop.v[l] * 100) : this.prop.v[l], this.o[l - this.data.p * 4] !== g && (this.o[l - this.data.p * 4] = g, this._omdf = !s);
        this._mdf = !s;
      }
    }, v([At], hs);
    function Ti(s, l, u) {
      this.initDynamicPropertyContainer(s), this.getValue = this.iterateDynamicProperties, this.initGradientData(s, l, u);
    }
    Ti.prototype.initGradientData = function(s, l, u) {
      this.o = me.getProp(s, l.o, 0, 0.01, this), this.s = me.getProp(s, l.s, 1, null, this), this.e = me.getProp(s, l.e, 1, null, this), this.h = me.getProp(s, l.h || {
        k: 0
      }, 0, 0.01, this), this.a = me.getProp(s, l.a || {
        k: 0
      }, 0, de, this), this.g = new hs(s, l.g, this), this.style = u, this.stops = [], this.setGradientData(u.pElem, l), this.setGradientOpacity(l, u), this._isAnimated = !!this._isAnimated;
    }, Ti.prototype.setGradientData = function(s, l) {
      var u = ue(), f = ve(l.t === 1 ? "linearGradient" : "radialGradient");
      f.setAttribute("id", u), f.setAttribute("spreadMethod", "pad"), f.setAttribute("gradientUnits", "userSpaceOnUse");
      var g = [], h, w, M;
      for (M = l.g.p * 4, w = 0; w < M; w += 4)
        h = ve("stop"), f.appendChild(h), g.push(h);
      s.setAttribute(l.ty === "gf" ? "fill" : "stroke", "url(" + p() + "#" + u + ")"), this.gf = f, this.cst = g;
    }, Ti.prototype.setGradientOpacity = function(s, l) {
      if (this.g._hasOpacity && !this.g._collapsable) {
        var u, f, g, h = ve("mask"), w = ve("path");
        h.appendChild(w);
        var M = ue(), x = ue();
        h.setAttribute("id", x);
        var A = ve(s.t === 1 ? "linearGradient" : "radialGradient");
        A.setAttribute("id", M), A.setAttribute("spreadMethod", "pad"), A.setAttribute("gradientUnits", "userSpaceOnUse"), g = s.g.k.k[0].s ? s.g.k.k[0].s.length : s.g.k.k.length;
        var z = this.stops;
        for (f = s.g.p * 4; f < g; f += 2)
          u = ve("stop"), u.setAttribute("stop-color", "rgb(255,255,255)"), A.appendChild(u), z.push(u);
        w.setAttribute(s.ty === "gf" ? "fill" : "stroke", "url(" + p() + "#" + M + ")"), s.ty === "gs" && (w.setAttribute("stroke-linecap", td[s.lc || 2]), w.setAttribute("stroke-linejoin", rd[s.lj || 2]), s.lj === 1 && w.setAttribute("stroke-miterlimit", s.ml)), this.of = A, this.ms = h, this.ost = z, this.maskId = x, l.msElem = w;
      }
    }, v([At], Ti);
    function ld(s, l, u) {
      this.initDynamicPropertyContainer(s), this.getValue = this.iterateDynamicProperties, this.w = me.getProp(s, l.w, 0, null, this), this.d = new lo(s, l.d || {}, "svg", this), this.initGradientData(s, l, u), this._isAnimated = !!this._isAnimated;
    }
    v([Ti, At], ld);
    function Cm() {
      this.it = [], this.prevViewData = [], this.gr = ve("g");
    }
    function Dm(s, l, u) {
      this.transform = {
        mProps: s,
        op: l,
        container: u
      }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
    }
    var cd = function(l, u, f, g) {
      if (u === 0)
        return "";
      var h = l.o, w = l.i, M = l.v, x, A = " M" + g.applyToPointStringified(M[0][0], M[0][1]);
      for (x = 1; x < u; x += 1)
        A += " C" + g.applyToPointStringified(h[x - 1][0], h[x - 1][1]) + " " + g.applyToPointStringified(w[x][0], w[x][1]) + " " + g.applyToPointStringified(M[x][0], M[x][1]);
      return f && u && (A += " C" + g.applyToPointStringified(h[x - 1][0], h[x - 1][1]) + " " + g.applyToPointStringified(w[0][0], w[0][1]) + " " + g.applyToPointStringified(M[0][0], M[0][1]), A += "z"), A;
    }, Em = function() {
      var s = new Vt(), l = new Vt(), u = {
        createRenderFunction: f
      };
      function f(Z) {
        switch (Z.ty) {
          case "fl":
            return M;
          case "gf":
            return A;
          case "gs":
            return x;
          case "st":
            return z;
          case "sh":
          case "el":
          case "rc":
          case "sr":
            return w;
          case "tr":
            return g;
          case "no":
            return h;
          default:
            return null;
        }
      }
      function g(Z, D, V) {
        (V || D.transform.op._mdf) && D.transform.container.setAttribute("opacity", D.transform.op.v), (V || D.transform.mProps._mdf) && D.transform.container.setAttribute("transform", D.transform.mProps.v.to2dCSS());
      }
      function h() {
      }
      function w(Z, D, V) {
        var j, H, U, O, T, C, P = D.styles.length, F = D.lvl, G, X, ee, ae;
        for (C = 0; C < P; C += 1) {
          if (O = D.sh._mdf || V, D.styles[C].lvl < F) {
            for (X = l.reset(), ee = F - D.styles[C].lvl, ae = D.transformers.length - 1; !O && ee > 0; )
              O = D.transformers[ae].mProps._mdf || O, ee -= 1, ae -= 1;
            if (O)
              for (ee = F - D.styles[C].lvl, ae = D.transformers.length - 1; ee > 0; )
                X.multiply(D.transformers[ae].mProps.v), ee -= 1, ae -= 1;
          } else
            X = s;
          if (G = D.sh.paths, H = G._length, O) {
            for (U = "", j = 0; j < H; j += 1)
              T = G.shapes[j], T && T._length && (U += cd(T, T._length, T.c, X));
            D.caches[C] = U;
          } else
            U = D.caches[C];
          D.styles[C].d += Z.hd === !0 ? "" : U, D.styles[C]._mdf = O || D.styles[C]._mdf;
        }
      }
      function M(Z, D, V) {
        var j = D.style;
        (D.c._mdf || V) && j.pElem.setAttribute("fill", "rgb(" + ne(D.c.v[0]) + "," + ne(D.c.v[1]) + "," + ne(D.c.v[2]) + ")"), (D.o._mdf || V) && j.pElem.setAttribute("fill-opacity", D.o.v);
      }
      function x(Z, D, V) {
        A(Z, D, V), z(Z, D, V);
      }
      function A(Z, D, V) {
        var j = D.gf, H = D.g._hasOpacity, U = D.s.v, O = D.e.v;
        if (D.o._mdf || V) {
          var T = Z.ty === "gf" ? "fill-opacity" : "stroke-opacity";
          D.style.pElem.setAttribute(T, D.o.v);
        }
        if (D.s._mdf || V) {
          var C = Z.t === 1 ? "x1" : "cx", P = C === "x1" ? "y1" : "cy";
          j.setAttribute(C, U[0]), j.setAttribute(P, U[1]), H && !D.g._collapsable && (D.of.setAttribute(C, U[0]), D.of.setAttribute(P, U[1]));
        }
        var F, G, X, ee;
        if (D.g._cmdf || V) {
          F = D.cst;
          var ae = D.g.c;
          for (X = F.length, G = 0; G < X; G += 1)
            ee = F[G], ee.setAttribute("offset", ae[G * 4] + "%"), ee.setAttribute("stop-color", "rgb(" + ae[G * 4 + 1] + "," + ae[G * 4 + 2] + "," + ae[G * 4 + 3] + ")");
        }
        if (H && (D.g._omdf || V)) {
          var Te = D.g.o;
          for (D.g._collapsable ? F = D.cst : F = D.ost, X = F.length, G = 0; G < X; G += 1)
            ee = F[G], D.g._collapsable || ee.setAttribute("offset", Te[G * 2] + "%"), ee.setAttribute("stop-opacity", Te[G * 2 + 1]);
        }
        if (Z.t === 1)
          (D.e._mdf || V) && (j.setAttribute("x2", O[0]), j.setAttribute("y2", O[1]), H && !D.g._collapsable && (D.of.setAttribute("x2", O[0]), D.of.setAttribute("y2", O[1])));
        else {
          var Ce;
          if ((D.s._mdf || D.e._mdf || V) && (Ce = Math.sqrt(Math.pow(U[0] - O[0], 2) + Math.pow(U[1] - O[1], 2)), j.setAttribute("r", Ce), H && !D.g._collapsable && D.of.setAttribute("r", Ce)), D.e._mdf || D.h._mdf || D.a._mdf || V) {
            Ce || (Ce = Math.sqrt(Math.pow(U[0] - O[0], 2) + Math.pow(U[1] - O[1], 2)));
            var he = Math.atan2(O[1] - U[1], O[0] - U[0]), Ae = D.h.v;
            Ae >= 1 ? Ae = 0.99 : Ae <= -1 && (Ae = -0.99);
            var xe = Ce * Ae, oe = Math.cos(he + D.a.v) * xe + U[0], $ = Math.sin(he + D.a.v) * xe + U[1];
            j.setAttribute("fx", oe), j.setAttribute("fy", $), H && !D.g._collapsable && (D.of.setAttribute("fx", oe), D.of.setAttribute("fy", $));
          }
        }
      }
      function z(Z, D, V) {
        var j = D.style, H = D.d;
        H && (H._mdf || V) && H.dashStr && (j.pElem.setAttribute("stroke-dasharray", H.dashStr), j.pElem.setAttribute("stroke-dashoffset", H.dashoffset[0])), D.c && (D.c._mdf || V) && j.pElem.setAttribute("stroke", "rgb(" + ne(D.c.v[0]) + "," + ne(D.c.v[1]) + "," + ne(D.c.v[2]) + ")"), (D.o._mdf || V) && j.pElem.setAttribute("stroke-opacity", D.o.v), (D.w._mdf || V) && (j.pElem.setAttribute("stroke-width", D.w.v), j.msElem && j.msElem.setAttribute("stroke-width", D.w.v));
      }
      return u;
    }();
    function yt(s, l, u) {
      this.shapes = [], this.shapesData = s.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(s, l, u), this.prevViewData = [];
    }
    v([gn, Mi, ds, ed, $i, mn, fs], yt), yt.prototype.initSecondaryElement = function() {
    }, yt.prototype.identityMatrix = new Vt(), yt.prototype.buildExpressionInterface = function() {
    }, yt.prototype.createContent = function() {
      this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
    }, yt.prototype.filterUniqueShapes = function() {
      var s, l = this.shapes.length, u, f, g = this.stylesList.length, h, w = [], M = !1;
      for (f = 0; f < g; f += 1) {
        for (h = this.stylesList[f], M = !1, w.length = 0, s = 0; s < l; s += 1)
          u = this.shapes[s], u.styles.indexOf(h) !== -1 && (w.push(u), M = u._isAnimated || M);
        w.length > 1 && M && this.setShapesAsAnimated(w);
      }
    }, yt.prototype.setShapesAsAnimated = function(s) {
      var l, u = s.length;
      for (l = 0; l < u; l += 1)
        s[l].setAsAnimated();
    }, yt.prototype.createStyleElement = function(s, l) {
      var u, f = new id(s, l), g = f.pElem;
      if (s.ty === "st")
        u = new sd(this, s, f);
      else if (s.ty === "fl")
        u = new od(this, s, f);
      else if (s.ty === "gf" || s.ty === "gs") {
        var h = s.ty === "gf" ? Ti : ld;
        u = new h(this, s, f), this.globalData.defs.appendChild(u.gf), u.maskId && (this.globalData.defs.appendChild(u.ms), this.globalData.defs.appendChild(u.of), g.setAttribute("mask", "url(" + p() + "#" + u.maskId + ")"));
      } else
        s.ty === "no" && (u = new ad(this, s, f));
      return (s.ty === "st" || s.ty === "gs") && (g.setAttribute("stroke-linecap", td[s.lc || 2]), g.setAttribute("stroke-linejoin", rd[s.lj || 2]), g.setAttribute("fill-opacity", "0"), s.lj === 1 && g.setAttribute("stroke-miterlimit", s.ml)), s.r === 2 && g.setAttribute("fill-rule", "evenodd"), s.ln && g.setAttribute("id", s.ln), s.cl && g.setAttribute("class", s.cl), s.bm && (g.style["mix-blend-mode"] = Ja(s.bm)), this.stylesList.push(f), this.addToAnimatedContents(s, u), u;
    }, yt.prototype.createGroupElement = function(s) {
      var l = new Cm();
      return s.ln && l.gr.setAttribute("id", s.ln), s.cl && l.gr.setAttribute("class", s.cl), s.bm && (l.gr.style["mix-blend-mode"] = Ja(s.bm)), l;
    }, yt.prototype.createTransformElement = function(s, l) {
      var u = Ka.getTransformProperty(this, s, this), f = new Dm(u, u.o, l);
      return this.addToAnimatedContents(s, f), f;
    }, yt.prototype.createShapeElement = function(s, l, u) {
      var f = 4;
      s.ty === "rc" ? f = 5 : s.ty === "el" ? f = 6 : s.ty === "sr" && (f = 7);
      var g = ro.getShapeProp(this, s, f, this), h = new nd(l, u, g);
      return this.shapes.push(h), this.addShapeToModifiers(h), this.addToAnimatedContents(s, h), h;
    }, yt.prototype.addToAnimatedContents = function(s, l) {
      for (var u = 0, f = this.animatedContents.length; u < f; ) {
        if (this.animatedContents[u].element === l)
          return;
        u += 1;
      }
      this.animatedContents.push({
        fn: Em.createRenderFunction(s),
        element: l,
        data: s
      });
    }, yt.prototype.setElementStyles = function(s) {
      var l = s.styles, u, f = this.stylesList.length;
      for (u = 0; u < f; u += 1)
        this.stylesList[u].closed || l.push(this.stylesList[u]);
    }, yt.prototype.reloadShapes = function() {
      this._isFirstFrame = !0;
      var s, l = this.itemsData.length;
      for (s = 0; s < l; s += 1)
        this.prevViewData[s] = this.itemsData[s];
      for (this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), l = this.dynamicProperties.length, s = 0; s < l; s += 1)
        this.dynamicProperties[s].getValue();
      this.renderModifiers();
    }, yt.prototype.searchShapes = function(s, l, u, f, g, h, w) {
      var M = [].concat(h), x, A = s.length - 1, z, Z, D = [], V = [], j, H, U;
      for (x = A; x >= 0; x -= 1) {
        if (U = this.searchProcessedElement(s[x]), U ? l[x] = u[U - 1] : s[x]._render = w, s[x].ty === "fl" || s[x].ty === "st" || s[x].ty === "gf" || s[x].ty === "gs" || s[x].ty === "no")
          U ? l[x].style.closed = !1 : l[x] = this.createStyleElement(s[x], g), s[x]._render && l[x].style.pElem.parentNode !== f && f.appendChild(l[x].style.pElem), D.push(l[x].style);
        else if (s[x].ty === "gr") {
          if (!U)
            l[x] = this.createGroupElement(s[x]);
          else
            for (Z = l[x].it.length, z = 0; z < Z; z += 1)
              l[x].prevViewData[z] = l[x].it[z];
          this.searchShapes(s[x].it, l[x].it, l[x].prevViewData, l[x].gr, g + 1, M, w), s[x]._render && l[x].gr.parentNode !== f && f.appendChild(l[x].gr);
        } else
          s[x].ty === "tr" ? (U || (l[x] = this.createTransformElement(s[x], f)), j = l[x].transform, M.push(j)) : s[x].ty === "sh" || s[x].ty === "rc" || s[x].ty === "el" || s[x].ty === "sr" ? (U || (l[x] = this.createShapeElement(s[x], M, g)), this.setElementStyles(l[x])) : s[x].ty === "tm" || s[x].ty === "rd" || s[x].ty === "ms" || s[x].ty === "pb" || s[x].ty === "zz" || s[x].ty === "op" ? (U ? (H = l[x], H.closed = !1) : (H = pn.getModifier(s[x].ty), H.init(this, s[x]), l[x] = H, this.shapeModifiers.push(H)), V.push(H)) : s[x].ty === "rp" && (U ? (H = l[x], H.closed = !0) : (H = pn.getModifier(s[x].ty), l[x] = H, H.init(this, s, x, l), this.shapeModifiers.push(H), w = !1), V.push(H));
        this.addProcessedElement(s[x], x + 1);
      }
      for (A = D.length, x = 0; x < A; x += 1)
        D[x].closed = !0;
      for (A = V.length, x = 0; x < A; x += 1)
        V[x].closed = !0;
    }, yt.prototype.renderInnerContent = function() {
      this.renderModifiers();
      var s, l = this.stylesList.length;
      for (s = 0; s < l; s += 1)
        this.stylesList[s].reset();
      for (this.renderShape(), s = 0; s < l; s += 1)
        (this.stylesList[s]._mdf || this._isFirstFrame) && (this.stylesList[s].msElem && (this.stylesList[s].msElem.setAttribute("d", this.stylesList[s].d), this.stylesList[s].d = "M0 0" + this.stylesList[s].d), this.stylesList[s].pElem.setAttribute("d", this.stylesList[s].d || "M0 0"));
    }, yt.prototype.renderShape = function() {
      var s, l = this.animatedContents.length, u;
      for (s = 0; s < l; s += 1)
        u = this.animatedContents[s], (this._isFirstFrame || u.element._isAnimated) && u.data !== !0 && u.fn(u.data, u.element, this._isFirstFrame);
    }, yt.prototype.destroy = function() {
      this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
    };
    function rl(s, l, u, f, g, h) {
      this.o = s, this.sw = l, this.sc = u, this.fc = f, this.m = g, this.p = h, this._mdf = {
        o: !0,
        sw: !!l,
        sc: !!u,
        fc: !!f,
        m: !0,
        p: !0
      };
    }
    rl.prototype.update = function(s, l, u, f, g, h) {
      this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
      var w = !1;
      return this.o !== s && (this.o = s, this._mdf.o = !0, w = !0), this.sw !== l && (this.sw = l, this._mdf.sw = !0, w = !0), this.sc !== u && (this.sc = u, this._mdf.sc = !0, w = !0), this.fc !== f && (this.fc = f, this._mdf.fc = !0, w = !0), this.m !== g && (this.m = g, this._mdf.m = !0, w = !0), h.length && (this.p[0] !== h[0] || this.p[1] !== h[1] || this.p[4] !== h[4] || this.p[5] !== h[5] || this.p[12] !== h[12] || this.p[13] !== h[13]) && (this.p = h, this._mdf.p = !0, w = !0), w;
    };
    function qt(s, l) {
      this._frameId = o, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, l.d && l.d.sid && (l.d = s.globalData.slotManager.getProp(l.d)), this.data = l, this.elem = s, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
        ascent: 0,
        boxWidth: this.defaultBoxWidth,
        f: "",
        fStyle: "",
        fWeight: "",
        fc: "",
        j: "",
        justifyOffset: "",
        l: [],
        lh: 0,
        lineWidths: [],
        ls: "",
        of: "",
        s: "",
        sc: "",
        sw: 0,
        t: 0,
        tr: 0,
        sz: 0,
        ps: null,
        fillColorAnim: !1,
        strokeColorAnim: !1,
        strokeWidthAnim: !1,
        yOffset: 0,
        finalSize: 0,
        finalText: [],
        finalLineHeight: 0,
        __complete: !1
      }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
    }
    qt.prototype.defaultBoxWidth = [0, 0], qt.prototype.copyData = function(s, l) {
      for (var u in l)
        Object.prototype.hasOwnProperty.call(l, u) && (s[u] = l[u]);
      return s;
    }, qt.prototype.setCurrentData = function(s) {
      s.__complete || this.completeTextData(s), this.currentData = s, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
    }, qt.prototype.searchProperty = function() {
      return this.searchKeyframes();
    }, qt.prototype.searchKeyframes = function() {
      return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
    }, qt.prototype.addEffect = function(s) {
      this.effectsSequence.push(s), this.elem.addDynamicProperty(this);
    }, qt.prototype.getValue = function(s) {
      if (!((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !s)) {
        this.currentData.t = this.data.d.k[this.keysIndex].s.t;
        var l = this.currentData, u = this.keysIndex;
        if (this.lock) {
          this.setCurrentData(this.currentData);
          return;
        }
        this.lock = !0, this._mdf = !1;
        var f, g = this.effectsSequence.length, h = s || this.data.d.k[this.keysIndex].s;
        for (f = 0; f < g; f += 1)
          u !== this.keysIndex ? h = this.effectsSequence[f](h, h.t) : h = this.effectsSequence[f](this.currentData, h.t);
        l !== h && this.setCurrentData(h), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
      }
    }, qt.prototype.getKeyframeValue = function() {
      for (var s = this.data.d.k, l = this.elem.comp.renderedFrame, u = 0, f = s.length; u <= f - 1 && !(u === f - 1 || s[u + 1].t > l); )
        u += 1;
      return this.keysIndex !== u && (this.keysIndex = u), this.data.d.k[this.keysIndex].s;
    }, qt.prototype.buildFinalText = function(s) {
      for (var l = [], u = 0, f = s.length, g, h, w = !1, M = !1, x = ""; u < f; )
        w = M, M = !1, g = s.charCodeAt(u), x = s.charAt(u), Xn.isCombinedCharacter(g) ? w = !0 : g >= 55296 && g <= 56319 ? Xn.isRegionalFlag(s, u) ? x = s.substr(u, 14) : (h = s.charCodeAt(u + 1), h >= 56320 && h <= 57343 && (Xn.isModifier(g, h) ? (x = s.substr(u, 2), w = !0) : Xn.isFlagEmoji(s.substr(u, 4)) ? x = s.substr(u, 4) : x = s.substr(u, 2))) : g > 56319 ? (h = s.charCodeAt(u + 1), Xn.isVariationSelector(g) && (w = !0)) : Xn.isZeroWidthJoiner(g) && (w = !0, M = !0), w ? (l[l.length - 1] += x, w = !1) : l.push(x), u += x.length;
      return l;
    }, qt.prototype.completeTextData = function(s) {
      s.__complete = !0;
      var l = this.elem.globalData.fontManager, u = this.data, f = [], g, h, w, M = 0, x, A = u.m.g, z = 0, Z = 0, D = 0, V = [], j = 0, H = 0, U, O, T = l.getFontByName(s.f), C, P = 0, F = Uu(T);
      s.fWeight = F.weight, s.fStyle = F.style, s.finalSize = s.s, s.finalText = this.buildFinalText(s.t), h = s.finalText.length, s.finalLineHeight = s.lh;
      var G = s.tr / 1e3 * s.finalSize, X;
      if (s.sz)
        for (var ee = !0, ae = s.sz[0], Te = s.sz[1], Ce, he; ee; ) {
          he = this.buildFinalText(s.t), Ce = 0, j = 0, h = he.length, G = s.tr / 1e3 * s.finalSize;
          var Ae = -1;
          for (g = 0; g < h; g += 1)
            X = he[g].charCodeAt(0), w = !1, he[g] === " " ? Ae = g : (X === 13 || X === 3) && (j = 0, w = !0, Ce += s.finalLineHeight || s.finalSize * 1.2), l.chars ? (C = l.getCharData(he[g], T.fStyle, T.fFamily), P = w ? 0 : C.w * s.finalSize / 100) : P = l.measureText(he[g], s.f, s.finalSize), j + P > ae && he[g] !== " " ? (Ae === -1 ? h += 1 : g = Ae, Ce += s.finalLineHeight || s.finalSize * 1.2, he.splice(g, Ae === g ? 1 : 0, "\r"), Ae = -1, j = 0) : (j += P, j += G);
          Ce += T.ascent * s.finalSize / 100, this.canResize && s.finalSize > this.minimumFontSize && Te < Ce ? (s.finalSize -= 1, s.finalLineHeight = s.finalSize * s.lh / s.s) : (s.finalText = he, h = s.finalText.length, ee = !1);
        }
      j = -G, P = 0;
      var xe = 0, oe;
      for (g = 0; g < h; g += 1)
        if (w = !1, oe = s.finalText[g], X = oe.charCodeAt(0), X === 13 || X === 3 ? (xe = 0, V.push(j), H = j > H ? j : H, j = -2 * G, x = "", w = !0, D += 1) : x = oe, l.chars ? (C = l.getCharData(oe, T.fStyle, l.getFontByName(s.f).fFamily), P = w ? 0 : C.w * s.finalSize / 100) : P = l.measureText(x, s.f, s.finalSize), oe === " " ? xe += P + G : (j += P + G + xe, xe = 0), f.push({
          l: P,
          an: P,
          add: z,
          n: w,
          anIndexes: [],
          val: x,
          line: D,
          animatorJustifyOffset: 0
        }), A == 2) {
          if (z += P, x === "" || x === " " || g === h - 1) {
            for ((x === "" || x === " ") && (z -= P); Z <= g; )
              f[Z].an = z, f[Z].ind = M, f[Z].extra = P, Z += 1;
            M += 1, z = 0;
          }
        } else if (A == 3) {
          if (z += P, x === "" || g === h - 1) {
            for (x === "" && (z -= P); Z <= g; )
              f[Z].an = z, f[Z].ind = M, f[Z].extra = P, Z += 1;
            z = 0, M += 1;
          }
        } else
          f[M].ind = M, f[M].extra = 0, M += 1;
      if (s.l = f, H = j > H ? j : H, V.push(j), s.sz)
        s.boxWidth = s.sz[0], s.justifyOffset = 0;
      else
        switch (s.boxWidth = H, s.j) {
          case 1:
            s.justifyOffset = -s.boxWidth;
            break;
          case 2:
            s.justifyOffset = -s.boxWidth / 2;
            break;
          default:
            s.justifyOffset = 0;
        }
      s.lineWidths = V;
      var $ = u.a, B, b;
      O = $.length;
      var k, J, q = [];
      for (U = 0; U < O; U += 1) {
        for (B = $[U], B.a.sc && (s.strokeColorAnim = !0), B.a.sw && (s.strokeWidthAnim = !0), (B.a.fc || B.a.fh || B.a.fs || B.a.fb) && (s.fillColorAnim = !0), J = 0, k = B.s.b, g = 0; g < h; g += 1)
          b = f[g], b.anIndexes[U] = J, (k == 1 && b.val !== "" || k == 2 && b.val !== "" && b.val !== " " || k == 3 && (b.n || b.val == " " || g == h - 1) || k == 4 && (b.n || g == h - 1)) && (B.s.rn === 1 && q.push(J), J += 1);
        u.a[U].s.totalChars = J;
        var ye = -1, Me;
        if (B.s.rn === 1)
          for (g = 0; g < h; g += 1)
            b = f[g], ye != b.anIndexes[U] && (ye = b.anIndexes[U], Me = q.splice(Math.floor(Math.random() * q.length), 1)[0]), b.anIndexes[U] = Me;
      }
      s.yOffset = s.finalLineHeight || s.finalSize * 1.2, s.ls = s.ls || 0, s.ascent = T.ascent * s.finalSize / 100;
    }, qt.prototype.updateDocumentData = function(s, l) {
      l = l === void 0 ? this.keysIndex : l;
      var u = this.copyData({}, this.data.d.k[l].s);
      u = this.copyData(u, s), this.data.d.k[l].s = u, this.recalculate(l), this.setCurrentData(u), this.elem.addDynamicProperty(this);
    }, qt.prototype.recalculate = function(s) {
      var l = this.data.d.k[s].s;
      l.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(l);
    }, qt.prototype.canResizeFont = function(s) {
      this.canResize = s, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    }, qt.prototype.setMinimumFontSize = function(s) {
      this.minimumFontSize = Math.floor(s) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
    };
    var Pm = function() {
      var s = Math.max, l = Math.min, u = Math.floor;
      function f(h, w) {
        this._currentTextLength = -1, this.k = !1, this.data = w, this.elem = h, this.comp = h.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(h), this.s = me.getProp(h, w.s || {
          k: 0
        }, 0, 0, this), "e" in w ? this.e = me.getProp(h, w.e, 0, 0, this) : this.e = {
          v: 100
        }, this.o = me.getProp(h, w.o || {
          k: 0
        }, 0, 0, this), this.xe = me.getProp(h, w.xe || {
          k: 0
        }, 0, 0, this), this.ne = me.getProp(h, w.ne || {
          k: 0
        }, 0, 0, this), this.sm = me.getProp(h, w.sm || {
          k: 100
        }, 0, 0, this), this.a = me.getProp(h, w.a, 0, 0.01, this), this.dynamicProperties.length || this.getValue();
      }
      f.prototype = {
        getMult: function(w) {
          this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
          var M = 0, x = 0, A = 1, z = 1;
          this.ne.v > 0 ? M = this.ne.v / 100 : x = -this.ne.v / 100, this.xe.v > 0 ? A = 1 - this.xe.v / 100 : z = 1 + this.xe.v / 100;
          var Z = ns.getBezierEasing(M, x, A, z).get, D = 0, V = this.finalS, j = this.finalE, H = this.data.sh;
          if (H === 2)
            j === V ? D = w >= j ? 1 : 0 : D = s(0, l(0.5 / (j - V) + (w - V) / (j - V), 1)), D = Z(D);
          else if (H === 3)
            j === V ? D = w >= j ? 0 : 1 : D = 1 - s(0, l(0.5 / (j - V) + (w - V) / (j - V), 1)), D = Z(D);
          else if (H === 4)
            j === V ? D = 0 : (D = s(0, l(0.5 / (j - V) + (w - V) / (j - V), 1)), D < 0.5 ? D *= 2 : D = 1 - 2 * (D - 0.5)), D = Z(D);
          else if (H === 5) {
            if (j === V)
              D = 0;
            else {
              var U = j - V;
              w = l(s(0, w + 0.5 - V), j - V);
              var O = -U / 2 + w, T = U / 2;
              D = Math.sqrt(1 - O * O / (T * T));
            }
            D = Z(D);
          } else
            H === 6 ? (j === V ? D = 0 : (w = l(s(0, w + 0.5 - V), j - V), D = (1 + Math.cos(Math.PI + Math.PI * 2 * w / (j - V))) / 2), D = Z(D)) : (w >= u(V) && (w - V < 0 ? D = s(0, l(l(j, 1) - (V - w), 1)) : D = s(0, l(j - w, 1))), D = Z(D));
          if (this.sm.v !== 100) {
            var C = this.sm.v * 0.01;
            C === 0 && (C = 1e-8);
            var P = 0.5 - C * 0.5;
            D < P ? D = 0 : (D = (D - P) / C, D > 1 && (D = 1));
          }
          return D * this.a.v;
        },
        getValue: function(w) {
          this.iterateDynamicProperties(), this._mdf = w || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, w && this.data.r === 2 && (this.e.v = this._currentTextLength);
          var M = this.data.r === 2 ? 1 : 100 / this.data.totalChars, x = this.o.v / M, A = this.s.v / M + x, z = this.e.v / M + x;
          if (A > z) {
            var Z = A;
            A = z, z = Z;
          }
          this.finalS = A, this.finalE = z;
        }
      }, v([At], f);
      function g(h, w, M) {
        return new f(h, w);
      }
      return {
        getTextSelectorProp: g
      };
    }();
    function Mm(s, l, u) {
      var f = {
        propType: !1
      }, g = me.getProp, h = l.a;
      this.a = {
        r: h.r ? g(s, h.r, 0, de, u) : f,
        rx: h.rx ? g(s, h.rx, 0, de, u) : f,
        ry: h.ry ? g(s, h.ry, 0, de, u) : f,
        sk: h.sk ? g(s, h.sk, 0, de, u) : f,
        sa: h.sa ? g(s, h.sa, 0, de, u) : f,
        s: h.s ? g(s, h.s, 1, 0.01, u) : f,
        a: h.a ? g(s, h.a, 1, 0, u) : f,
        o: h.o ? g(s, h.o, 0, 0.01, u) : f,
        p: h.p ? g(s, h.p, 1, 0, u) : f,
        sw: h.sw ? g(s, h.sw, 0, 0, u) : f,
        sc: h.sc ? g(s, h.sc, 1, 0, u) : f,
        fc: h.fc ? g(s, h.fc, 1, 0, u) : f,
        fh: h.fh ? g(s, h.fh, 0, 0, u) : f,
        fs: h.fs ? g(s, h.fs, 0, 0.01, u) : f,
        fb: h.fb ? g(s, h.fb, 0, 0.01, u) : f,
        t: h.t ? g(s, h.t, 0, 0, u) : f
      }, this.s = Pm.getTextSelectorProp(s, l.s, u), this.s.t = l.s.t;
    }
    function Jn(s, l, u) {
      this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = s, this._renderType = l, this._elem = u, this._animatorsData = E(this._textData.a.length), this._pathData = {}, this._moreOptions = {
        alignment: {}
      }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(u);
    }
    Jn.prototype.searchProperties = function() {
      var s, l = this._textData.a.length, u, f = me.getProp;
      for (s = 0; s < l; s += 1)
        u = this._textData.a[s], this._animatorsData[s] = new Mm(this._elem, u, this);
      this._textData.p && "m" in this._textData.p ? (this._pathData = {
        a: f(this._elem, this._textData.p.a, 0, 0, this),
        f: f(this._elem, this._textData.p.f, 0, 0, this),
        l: f(this._elem, this._textData.p.l, 0, 0, this),
        r: f(this._elem, this._textData.p.r, 0, 0, this),
        p: f(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = f(this._elem, this._textData.m.a, 1, 0, this);
    }, Jn.prototype.getMeasures = function(s, l) {
      if (this.lettersChangedFlag = l, !(!this._mdf && !this._isFirstFrame && !l && (!this._hasMaskedPath || !this._pathData.m._mdf))) {
        this._isFirstFrame = !1;
        var u = this._moreOptions.alignment.v, f = this._animatorsData, g = this._textData, h = this.mHelper, w = this._renderType, M = this.renderedLetters.length, x, A, z, Z, D = s.l, V, j, H, U, O, T, C, P, F, G, X, ee, ae, Te, Ce;
        if (this._hasMaskedPath) {
          if (Ce = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
            var he = Ce.v;
            this._pathData.r.v && (he = he.reverse()), V = {
              tLength: 0,
              segments: []
            }, Z = he._length - 1;
            var Ae;
            for (ee = 0, z = 0; z < Z; z += 1)
              Ae = $r.buildBezierData(he.v[z], he.v[z + 1], [he.o[z][0] - he.v[z][0], he.o[z][1] - he.v[z][1]], [he.i[z + 1][0] - he.v[z + 1][0], he.i[z + 1][1] - he.v[z + 1][1]]), V.tLength += Ae.segmentLength, V.segments.push(Ae), ee += Ae.segmentLength;
            z = Z, Ce.v.c && (Ae = $r.buildBezierData(he.v[z], he.v[0], [he.o[z][0] - he.v[z][0], he.o[z][1] - he.v[z][1]], [he.i[0][0] - he.v[0][0], he.i[0][1] - he.v[0][1]]), V.tLength += Ae.segmentLength, V.segments.push(Ae), ee += Ae.segmentLength), this._pathData.pi = V;
          }
          if (V = this._pathData.pi, j = this._pathData.f.v, C = 0, T = 1, U = 0, O = !0, G = V.segments, j < 0 && Ce.v.c)
            for (V.tLength < Math.abs(j) && (j = -Math.abs(j) % V.tLength), C = G.length - 1, F = G[C].points, T = F.length - 1; j < 0; )
              j += F[T].partialLength, T -= 1, T < 0 && (C -= 1, F = G[C].points, T = F.length - 1);
          F = G[C].points, P = F[T - 1], H = F[T], X = H.partialLength;
        }
        Z = D.length, x = 0, A = 0;
        var xe = s.finalSize * 1.2 * 0.714, oe = !0, $, B, b, k, J;
        k = f.length;
        var q, ye = -1, Me, Ie, Ge, qe = j, xt = C, Zt = T, Ir = -1, Jt, Ft, or, it, Se, qr, yn, Kr, Rr = "", Ur = this.defaultPropsArray, Qr;
        if (s.j === 2 || s.j === 1) {
          var er = 0, bn = 0, wn = s.j === 2 ? -0.5 : -1, br = 0, xn = !0;
          for (z = 0; z < Z; z += 1)
            if (D[z].n) {
              for (er && (er += bn); br < z; )
                D[br].animatorJustifyOffset = er, br += 1;
              er = 0, xn = !0;
            } else {
              for (b = 0; b < k; b += 1)
                $ = f[b].a, $.t.propType && (xn && s.j === 2 && (bn += $.t.v * wn), B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), q.length ? er += $.t.v * q[0] * wn : er += $.t.v * q * wn);
              xn = !1;
            }
          for (er && (er += bn); br < z; )
            D[br].animatorJustifyOffset = er, br += 1;
        }
        for (z = 0; z < Z; z += 1) {
          if (h.reset(), Jt = 1, D[z].n)
            x = 0, A += s.yOffset, A += oe ? 1 : 0, j = qe, oe = !1, this._hasMaskedPath && (C = xt, T = Zt, F = G[C].points, P = F[T - 1], H = F[T], X = H.partialLength, U = 0), Rr = "", Kr = "", qr = "", Qr = "", Ur = this.defaultPropsArray;
          else {
            if (this._hasMaskedPath) {
              if (Ir !== D[z].line) {
                switch (s.j) {
                  case 1:
                    j += ee - s.lineWidths[D[z].line];
                    break;
                  case 2:
                    j += (ee - s.lineWidths[D[z].line]) / 2;
                    break;
                }
                Ir = D[z].line;
              }
              ye !== D[z].ind && (D[ye] && (j += D[ye].extra), j += D[z].an / 2, ye = D[z].ind), j += u[0] * D[z].an * 5e-3;
              var wr = 0;
              for (b = 0; b < k; b += 1)
                $ = f[b].a, $.p.propType && (B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), q.length ? wr += $.p.v[0] * q[0] : wr += $.p.v[0] * q), $.a.propType && (B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), q.length ? wr += $.a.v[0] * q[0] : wr += $.a.v[0] * q);
              for (O = !0, this._pathData.a.v && (j = D[0].an * 0.5 + (ee - this._pathData.f.v - D[0].an * 0.5 - D[D.length - 1].an * 0.5) * ye / (Z - 1), j += this._pathData.f.v); O; )
                U + X >= j + wr || !F ? (ae = (j + wr - U) / H.partialLength, Ie = P.point[0] + (H.point[0] - P.point[0]) * ae, Ge = P.point[1] + (H.point[1] - P.point[1]) * ae, h.translate(-u[0] * D[z].an * 5e-3, -(u[1] * xe) * 0.01), O = !1) : F && (U += H.partialLength, T += 1, T >= F.length && (T = 0, C += 1, G[C] ? F = G[C].points : Ce.v.c ? (T = 0, C = 0, F = G[C].points) : (U -= H.partialLength, F = null)), F && (P = H, H = F[T], X = H.partialLength));
              Me = D[z].an / 2 - D[z].add, h.translate(-Me, 0, 0);
            } else
              Me = D[z].an / 2 - D[z].add, h.translate(-Me, 0, 0), h.translate(-u[0] * D[z].an * 5e-3, -u[1] * xe * 0.01, 0);
            for (b = 0; b < k; b += 1)
              $ = f[b].a, $.t.propType && (B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), (x !== 0 || s.j !== 0) && (this._hasMaskedPath ? q.length ? j += $.t.v * q[0] : j += $.t.v * q : q.length ? x += $.t.v * q[0] : x += $.t.v * q));
            for (s.strokeWidthAnim && (or = s.sw || 0), s.strokeColorAnim && (s.sc ? Ft = [s.sc[0], s.sc[1], s.sc[2]] : Ft = [0, 0, 0]), s.fillColorAnim && s.fc && (it = [s.fc[0], s.fc[1], s.fc[2]]), b = 0; b < k; b += 1)
              $ = f[b].a, $.a.propType && (B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), q.length ? h.translate(-$.a.v[0] * q[0], -$.a.v[1] * q[1], $.a.v[2] * q[2]) : h.translate(-$.a.v[0] * q, -$.a.v[1] * q, $.a.v[2] * q));
            for (b = 0; b < k; b += 1)
              $ = f[b].a, $.s.propType && (B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), q.length ? h.scale(1 + ($.s.v[0] - 1) * q[0], 1 + ($.s.v[1] - 1) * q[1], 1) : h.scale(1 + ($.s.v[0] - 1) * q, 1 + ($.s.v[1] - 1) * q, 1));
            for (b = 0; b < k; b += 1) {
              if ($ = f[b].a, B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), $.sk.propType && (q.length ? h.skewFromAxis(-$.sk.v * q[0], $.sa.v * q[1]) : h.skewFromAxis(-$.sk.v * q, $.sa.v * q)), $.r.propType && (q.length ? h.rotateZ(-$.r.v * q[2]) : h.rotateZ(-$.r.v * q)), $.ry.propType && (q.length ? h.rotateY($.ry.v * q[1]) : h.rotateY($.ry.v * q)), $.rx.propType && (q.length ? h.rotateX($.rx.v * q[0]) : h.rotateX($.rx.v * q)), $.o.propType && (q.length ? Jt += ($.o.v * q[0] - Jt) * q[0] : Jt += ($.o.v * q - Jt) * q), s.strokeWidthAnim && $.sw.propType && (q.length ? or += $.sw.v * q[0] : or += $.sw.v * q), s.strokeColorAnim && $.sc.propType)
                for (Se = 0; Se < 3; Se += 1)
                  q.length ? Ft[Se] += ($.sc.v[Se] - Ft[Se]) * q[0] : Ft[Se] += ($.sc.v[Se] - Ft[Se]) * q;
              if (s.fillColorAnim && s.fc) {
                if ($.fc.propType)
                  for (Se = 0; Se < 3; Se += 1)
                    q.length ? it[Se] += ($.fc.v[Se] - it[Se]) * q[0] : it[Se] += ($.fc.v[Se] - it[Se]) * q;
                $.fh.propType && (q.length ? it = Be(it, $.fh.v * q[0]) : it = Be(it, $.fh.v * q)), $.fs.propType && (q.length ? it = Re(it, $.fs.v * q[0]) : it = Re(it, $.fs.v * q)), $.fb.propType && (q.length ? it = Ee(it, $.fb.v * q[0]) : it = Ee(it, $.fb.v * q));
              }
            }
            for (b = 0; b < k; b += 1)
              $ = f[b].a, $.p.propType && (B = f[b].s, q = B.getMult(D[z].anIndexes[b], g.a[b].s.totalChars), this._hasMaskedPath ? q.length ? h.translate(0, $.p.v[1] * q[0], -$.p.v[2] * q[1]) : h.translate(0, $.p.v[1] * q, -$.p.v[2] * q) : q.length ? h.translate($.p.v[0] * q[0], $.p.v[1] * q[1], -$.p.v[2] * q[2]) : h.translate($.p.v[0] * q, $.p.v[1] * q, -$.p.v[2] * q));
            if (s.strokeWidthAnim && (qr = or < 0 ? 0 : or), s.strokeColorAnim && (yn = "rgb(" + Math.round(Ft[0] * 255) + "," + Math.round(Ft[1] * 255) + "," + Math.round(Ft[2] * 255) + ")"), s.fillColorAnim && s.fc && (Kr = "rgb(" + Math.round(it[0] * 255) + "," + Math.round(it[1] * 255) + "," + Math.round(it[2] * 255) + ")"), this._hasMaskedPath) {
              if (h.translate(0, -s.ls), h.translate(0, u[1] * xe * 0.01 + A, 0), this._pathData.p.v) {
                Te = (H.point[1] - P.point[1]) / (H.point[0] - P.point[0]);
                var ei = Math.atan(Te) * 180 / Math.PI;
                H.point[0] < P.point[0] && (ei += 180), h.rotate(-ei * Math.PI / 180);
              }
              h.translate(Ie, Ge, 0), j -= u[0] * D[z].an * 5e-3, D[z + 1] && ye !== D[z + 1].ind && (j += D[z].an / 2, j += s.tr * 1e-3 * s.finalSize);
            } else {
              switch (h.translate(x, A, 0), s.ps && h.translate(s.ps[0], s.ps[1] + s.ascent, 0), s.j) {
                case 1:
                  h.translate(D[z].animatorJustifyOffset + s.justifyOffset + (s.boxWidth - s.lineWidths[D[z].line]), 0, 0);
                  break;
                case 2:
                  h.translate(D[z].animatorJustifyOffset + s.justifyOffset + (s.boxWidth - s.lineWidths[D[z].line]) / 2, 0, 0);
                  break;
              }
              h.translate(0, -s.ls), h.translate(Me, 0, 0), h.translate(u[0] * D[z].an * 5e-3, u[1] * xe * 0.01, 0), x += D[z].l + s.tr * 1e-3 * s.finalSize;
            }
            w === "html" ? Rr = h.toCSS() : w === "svg" ? Rr = h.to2dCSS() : Ur = [h.props[0], h.props[1], h.props[2], h.props[3], h.props[4], h.props[5], h.props[6], h.props[7], h.props[8], h.props[9], h.props[10], h.props[11], h.props[12], h.props[13], h.props[14], h.props[15]], Qr = Jt;
          }
          M <= z ? (J = new rl(Qr, qr, yn, Kr, Rr, Ur), this.renderedLetters.push(J), M += 1, this.lettersChangedFlag = !0) : (J = this.renderedLetters[z], this.lettersChangedFlag = J.update(Qr, qr, yn, Kr, Rr, Ur) || this.lettersChangedFlag);
        }
      }
    }, Jn.prototype.getValue = function() {
      this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
    }, Jn.prototype.mHelper = new Vt(), Jn.prototype.defaultPropsArray = [], v([At], Jn);
    function gr() {
    }
    gr.prototype.initElement = function(s, l, u) {
      this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(s, l, u), this.textProperty = new qt(this, s.t, this.dynamicProperties), this.textAnimator = new Jn(s.t, this.renderType, this), this.initTransform(s, l, u), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
    }, gr.prototype.prepareFrame = function(s) {
      this._mdf = !1, this.prepareRenderableFrame(s), this.prepareProperties(s, this.isInRange);
    }, gr.prototype.createPathShape = function(s, l) {
      var u, f = l.length, g, h = "";
      for (u = 0; u < f; u += 1)
        l[u].ty === "sh" && (g = l[u].ks.k, h += cd(g, g.i.length, !0, s));
      return h;
    }, gr.prototype.updateDocumentData = function(s, l) {
      this.textProperty.updateDocumentData(s, l);
    }, gr.prototype.canResizeFont = function(s) {
      this.textProperty.canResizeFont(s);
    }, gr.prototype.setMinimumFontSize = function(s) {
      this.textProperty.setMinimumFontSize(s);
    }, gr.prototype.applyTextPropertiesToMatrix = function(s, l, u, f, g) {
      switch (s.ps && l.translate(s.ps[0], s.ps[1] + s.ascent, 0), l.translate(0, -s.ls, 0), s.j) {
        case 1:
          l.translate(s.justifyOffset + (s.boxWidth - s.lineWidths[u]), 0, 0);
          break;
        case 2:
          l.translate(s.justifyOffset + (s.boxWidth - s.lineWidths[u]) / 2, 0, 0);
          break;
      }
      l.translate(f, g, 0);
    }, gr.prototype.buildColor = function(s) {
      return "rgb(" + Math.round(s[0] * 255) + "," + Math.round(s[1] * 255) + "," + Math.round(s[2] * 255) + ")";
    }, gr.prototype.emptyProp = new rl(), gr.prototype.destroy = function() {
    }, gr.prototype.validateText = function() {
      (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
    };
    var $m = {
      shapes: []
    };
    function jr(s, l, u) {
      this.textSpans = [], this.renderType = "svg", this.initElement(s, l, u);
    }
    v([gn, Mi, ds, $i, mn, fs, gr], jr), jr.prototype.createContent = function() {
      this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = ve("text"));
    }, jr.prototype.buildTextContents = function(s) {
      for (var l = 0, u = s.length, f = [], g = ""; l < u; )
        s[l] === "\r" || s[l] === "" ? (f.push(g), g = "") : g += s[l], l += 1;
      return f.push(g), f;
    }, jr.prototype.buildShapeData = function(s, l) {
      if (s.shapes && s.shapes.length) {
        var u = s.shapes[0];
        if (u.it) {
          var f = u.it[u.it.length - 1];
          f.s && (f.s.k[0] = l, f.s.k[1] = l);
        }
      }
      return s;
    }, jr.prototype.buildNewText = function() {
      this.addDynamicProperty(this);
      var s, l, u = this.textProperty.currentData;
      this.renderedLetters = E(u ? u.l.length : 0), u.fc ? this.layerElement.setAttribute("fill", this.buildColor(u.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), u.sc && (this.layerElement.setAttribute("stroke", this.buildColor(u.sc)), this.layerElement.setAttribute("stroke-width", u.sw)), this.layerElement.setAttribute("font-size", u.finalSize);
      var f = this.globalData.fontManager.getFontByName(u.f);
      if (f.fClass)
        this.layerElement.setAttribute("class", f.fClass);
      else {
        this.layerElement.setAttribute("font-family", f.fFamily);
        var g = u.fWeight, h = u.fStyle;
        this.layerElement.setAttribute("font-style", h), this.layerElement.setAttribute("font-weight", g);
      }
      this.layerElement.setAttribute("aria-label", u.t);
      var w = u.l || [], M = !!this.globalData.fontManager.chars;
      l = w.length;
      var x, A = this.mHelper, z = "", Z = this.data.singleShape, D = 0, V = 0, j = !0, H = u.tr * 1e-3 * u.finalSize;
      if (Z && !M && !u.sz) {
        var U = this.textContainer, O = "start";
        switch (u.j) {
          case 1:
            O = "end";
            break;
          case 2:
            O = "middle";
            break;
          default:
            O = "start";
            break;
        }
        U.setAttribute("text-anchor", O), U.setAttribute("letter-spacing", H);
        var T = this.buildTextContents(u.finalText);
        for (l = T.length, V = u.ps ? u.ps[1] + u.ascent : 0, s = 0; s < l; s += 1)
          x = this.textSpans[s].span || ve("tspan"), x.textContent = T[s], x.setAttribute("x", 0), x.setAttribute("y", V), x.style.display = "inherit", U.appendChild(x), this.textSpans[s] || (this.textSpans[s] = {
            span: null,
            glyph: null
          }), this.textSpans[s].span = x, V += u.finalLineHeight;
        this.layerElement.appendChild(U);
      } else {
        var C = this.textSpans.length, P;
        for (s = 0; s < l; s += 1) {
          if (this.textSpans[s] || (this.textSpans[s] = {
            span: null,
            childSpan: null,
            glyph: null
          }), !M || !Z || s === 0) {
            if (x = C > s ? this.textSpans[s].span : ve(M ? "g" : "text"), C <= s) {
              if (x.setAttribute("stroke-linecap", "butt"), x.setAttribute("stroke-linejoin", "round"), x.setAttribute("stroke-miterlimit", "4"), this.textSpans[s].span = x, M) {
                var F = ve("g");
                x.appendChild(F), this.textSpans[s].childSpan = F;
              }
              this.textSpans[s].span = x, this.layerElement.appendChild(x);
            }
            x.style.display = "inherit";
          }
          if (A.reset(), Z && (w[s].n && (D = -H, V += u.yOffset, V += j ? 1 : 0, j = !1), this.applyTextPropertiesToMatrix(u, A, w[s].line, D, V), D += w[s].l || 0, D += H), M) {
            P = this.globalData.fontManager.getCharData(u.finalText[s], f.fStyle, this.globalData.fontManager.getFontByName(u.f).fFamily);
            var G;
            if (P.t === 1)
              G = new gs(P.data, this.globalData, this);
            else {
              var X = $m;
              P.data && P.data.shapes && (X = this.buildShapeData(P.data, u.finalSize)), G = new yt(X, this.globalData, this);
            }
            if (this.textSpans[s].glyph) {
              var ee = this.textSpans[s].glyph;
              this.textSpans[s].childSpan.removeChild(ee.layerElement), ee.destroy();
            }
            this.textSpans[s].glyph = G, G._debug = !0, G.prepareFrame(0), G.renderFrame(), this.textSpans[s].childSpan.appendChild(G.layerElement), P.t === 1 && this.textSpans[s].childSpan.setAttribute("transform", "scale(" + u.finalSize / 100 + "," + u.finalSize / 100 + ")");
          } else
            Z && x.setAttribute("transform", "translate(" + A.props[12] + "," + A.props[13] + ")"), x.textContent = w[s].val, x.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
        }
        Z && x && x.setAttribute("d", z);
      }
      for (; s < this.textSpans.length; )
        this.textSpans[s].span.style.display = "none", s += 1;
      this._sizeChanged = !0;
    }, jr.prototype.sourceRectAtTime = function() {
      if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
        this._sizeChanged = !1;
        var s = this.layerElement.getBBox();
        this.bbox = {
          top: s.y,
          left: s.x,
          width: s.width,
          height: s.height
        };
      }
      return this.bbox;
    }, jr.prototype.getValue = function() {
      var s, l = this.textSpans.length, u;
      for (this.renderedFrame = this.comp.renderedFrame, s = 0; s < l; s += 1)
        u = this.textSpans[s].glyph, u && (u.prepareFrame(this.comp.renderedFrame - this.data.st), u._mdf && (this._mdf = !0));
    }, jr.prototype.renderInnerContent = function() {
      if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
        this._sizeChanged = !0;
        var s, l, u = this.textAnimator.renderedLetters, f = this.textProperty.currentData.l;
        l = f.length;
        var g, h, w;
        for (s = 0; s < l; s += 1)
          f[s].n || (g = u[s], h = this.textSpans[s].span, w = this.textSpans[s].glyph, w && w.renderFrame(), g._mdf.m && h.setAttribute("transform", g.m), g._mdf.o && h.setAttribute("opacity", g.o), g._mdf.sw && h.setAttribute("stroke-width", g.sw), g._mdf.sc && h.setAttribute("stroke", g.sc), g._mdf.fc && h.setAttribute("fill", g.fc));
      }
    };
    function nl(s, l, u) {
      this.initElement(s, l, u);
    }
    v([ps], nl), nl.prototype.createContent = function() {
      var s = ve("rect");
      s.setAttribute("width", this.data.sw), s.setAttribute("height", this.data.sh), s.setAttribute("fill", this.data.sc), this.layerElement.appendChild(s);
    };
    function _n(s, l, u) {
      this.initFrame(), this.initBaseData(s, l, u), this.initFrame(), this.initTransform(s, l, u), this.initHierarchy();
    }
    _n.prototype.prepareFrame = function(s) {
      this.prepareProperties(s, !0);
    }, _n.prototype.renderFrame = function() {
    }, _n.prototype.getBaseElement = function() {
      return null;
    }, _n.prototype.destroy = function() {
    }, _n.prototype.sourceRectAtTime = function() {
    }, _n.prototype.hide = function() {
    }, v([gn, Mi, $i, mn], _n);
    function Ct() {
    }
    v([Yt], Ct), Ct.prototype.createNull = function(s) {
      return new _n(s, this.globalData, this);
    }, Ct.prototype.createShape = function(s) {
      return new yt(s, this.globalData, this);
    }, Ct.prototype.createText = function(s) {
      return new jr(s, this.globalData, this);
    }, Ct.prototype.createImage = function(s) {
      return new ps(s, this.globalData, this);
    }, Ct.prototype.createSolid = function(s) {
      return new nl(s, this.globalData, this);
    }, Ct.prototype.configAnimation = function(s) {
      this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + s.w + " " + s.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", s.w), this.svgElement.setAttribute("height", s.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), this.renderConfig.focusable !== void 0 && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
      var l = this.globalData.defs;
      this.setupGlobalData(s, l), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = s;
      var u = ve("clipPath"), f = ve("rect");
      f.setAttribute("width", s.w), f.setAttribute("height", s.h), f.setAttribute("x", 0), f.setAttribute("y", 0);
      var g = ue();
      u.setAttribute("id", g), u.appendChild(f), this.layerElement.setAttribute("clip-path", "url(" + p() + "#" + g + ")"), l.appendChild(u), this.layers = s.layers, this.elements = E(s.layers.length);
    }, Ct.prototype.destroy = function() {
      this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
      var s, l = this.layers ? this.layers.length : 0;
      for (s = 0; s < l; s += 1)
        this.elements[s] && this.elements[s].destroy && this.elements[s].destroy();
      this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
    }, Ct.prototype.updateContainerSize = function() {
    }, Ct.prototype.findIndexByInd = function(s) {
      var l = 0, u = this.layers.length;
      for (l = 0; l < u; l += 1)
        if (this.layers[l].ind === s)
          return l;
      return -1;
    }, Ct.prototype.buildItem = function(s) {
      var l = this.elements;
      if (!(l[s] || this.layers[s].ty === 99)) {
        l[s] = !0;
        var u = this.createItem(this.layers[s]);
        if (l[s] = u, ut() && (this.layers[s].ty === 0 && this.globalData.projectInterface.registerComposition(u), u.initExpressions()), this.appendElementInPos(u, s), this.layers[s].tt) {
          var f = "tp" in this.layers[s] ? this.findIndexByInd(this.layers[s].tp) : s - 1;
          if (f === -1)
            return;
          if (!this.elements[f] || this.elements[f] === !0)
            this.buildItem(f), this.addPendingElement(u);
          else {
            var g = l[f], h = g.getMatte(this.layers[s].tt);
            u.setMatte(h);
          }
        }
      }
    }, Ct.prototype.checkPendingElements = function() {
      for (; this.pendingElements.length; ) {
        var s = this.pendingElements.pop();
        if (s.checkParenting(), s.data.tt)
          for (var l = 0, u = this.elements.length; l < u; ) {
            if (this.elements[l] === s) {
              var f = "tp" in s.data ? this.findIndexByInd(s.data.tp) : l - 1, g = this.elements[f], h = g.getMatte(this.layers[l].tt);
              s.setMatte(h);
              break;
            }
            l += 1;
          }
      }
    }, Ct.prototype.renderFrame = function(s) {
      if (!(this.renderedFrame === s || this.destroyed)) {
        s === null ? s = this.renderedFrame : this.renderedFrame = s, this.globalData.frameNum = s, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = s, this.globalData._mdf = !1;
        var l, u = this.layers.length;
        for (this.completeLayers || this.checkLayers(s), l = u - 1; l >= 0; l -= 1)
          (this.completeLayers || this.elements[l]) && this.elements[l].prepareFrame(s - this.layers[l].st);
        if (this.globalData._mdf)
          for (l = 0; l < u; l += 1)
            (this.completeLayers || this.elements[l]) && this.elements[l].renderFrame();
      }
    }, Ct.prototype.appendElementInPos = function(s, l) {
      var u = s.getBaseElement();
      if (u) {
        for (var f = 0, g; f < l; )
          this.elements[f] && this.elements[f] !== !0 && this.elements[f].getBaseElement() && (g = this.elements[f].getBaseElement()), f += 1;
        g ? this.layerElement.insertBefore(u, g) : this.layerElement.appendChild(u);
      }
    }, Ct.prototype.hide = function() {
      this.layerElement.style.display = "none";
    }, Ct.prototype.show = function() {
      this.layerElement.style.display = "block";
    };
    function Gr() {
    }
    v([gn, Mi, $i, mn, fs], Gr), Gr.prototype.initElement = function(s, l, u) {
      this.initFrame(), this.initBaseData(s, l, u), this.initTransform(s, l, u), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), (this.data.xt || !l.progressiveLoad) && this.buildAllItems(), this.hide();
    }, Gr.prototype.prepareFrame = function(s) {
      if (this._mdf = !1, this.prepareRenderableFrame(s), this.prepareProperties(s, this.isInRange), !(!this.isInRange && !this.data.xt)) {
        if (this.tm._placeholder)
          this.renderedFrame = s / this.data.sr;
        else {
          var l = this.tm.v;
          l === this.data.op && (l = this.data.op - 1), this.renderedFrame = l;
        }
        var u, f = this.elements.length;
        for (this.completeLayers || this.checkLayers(this.renderedFrame), u = f - 1; u >= 0; u -= 1)
          (this.completeLayers || this.elements[u]) && (this.elements[u].prepareFrame(this.renderedFrame - this.layers[u].st), this.elements[u]._mdf && (this._mdf = !0));
      }
    }, Gr.prototype.renderInnerContent = function() {
      var s, l = this.layers.length;
      for (s = 0; s < l; s += 1)
        (this.completeLayers || this.elements[s]) && this.elements[s].renderFrame();
    }, Gr.prototype.setElements = function(s) {
      this.elements = s;
    }, Gr.prototype.getElements = function() {
      return this.elements;
    }, Gr.prototype.destroyElements = function() {
      var s, l = this.layers.length;
      for (s = 0; s < l; s += 1)
        this.elements[s] && this.elements[s].destroy();
    }, Gr.prototype.destroy = function() {
      this.destroyElements(), this.destroyBaseElement();
    };
    function gs(s, l, u) {
      this.layers = s.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? E(this.layers.length) : [], this.initElement(s, l, u), this.tm = s.tm ? me.getProp(this, s.tm, 0, l.frameRate, this) : {
        _placeholder: !0
      };
    }
    v([Ct, Gr, ds], gs), gs.prototype.createComp = function(s) {
      return new gs(s, this.globalData, this);
    };
    function il(s, l) {
      this.animationItem = s, this.layers = null, this.renderedFrame = -1, this.svgElement = ve("svg");
      var u = "";
      if (l && l.title) {
        var f = ve("title"), g = ue();
        f.setAttribute("id", g), f.textContent = l.title, this.svgElement.appendChild(f), u += g;
      }
      if (l && l.description) {
        var h = ve("desc"), w = ue();
        h.setAttribute("id", w), h.textContent = l.description, this.svgElement.appendChild(h), u += " " + w;
      }
      u && this.svgElement.setAttribute("aria-labelledby", u);
      var M = ve("defs");
      this.svgElement.appendChild(M);
      var x = ve("g");
      this.svgElement.appendChild(x), this.layerElement = x, this.renderConfig = {
        preserveAspectRatio: l && l.preserveAspectRatio || "xMidYMid meet",
        imagePreserveAspectRatio: l && l.imagePreserveAspectRatio || "xMidYMid slice",
        contentVisibility: l && l.contentVisibility || "visible",
        progressiveLoad: l && l.progressiveLoad || !1,
        hideOnTransparent: !(l && l.hideOnTransparent === !1),
        viewBoxOnly: l && l.viewBoxOnly || !1,
        viewBoxSize: l && l.viewBoxSize || !1,
        className: l && l.className || "",
        id: l && l.id || "",
        focusable: l && l.focusable,
        filterSize: {
          width: l && l.filterSize && l.filterSize.width || "100%",
          height: l && l.filterSize && l.filterSize.height || "100%",
          x: l && l.filterSize && l.filterSize.x || "0%",
          y: l && l.filterSize && l.filterSize.y || "0%"
        },
        width: l && l.width,
        height: l && l.height,
        runExpressions: !l || l.runExpressions === void 0 || l.runExpressions
      }, this.globalData = {
        _mdf: !1,
        frameNum: -1,
        defs: M,
        renderConfig: this.renderConfig
      }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
    }
    return v([Ct], il), il.prototype.createComp = function(s) {
      return new gs(s, this.globalData, this);
    }, Vg("svg", il), pn.registerModifier("tm", yr), pn.registerModifier("pb", is), pn.registerModifier("rp", Tr), pn.registerModifier("rd", ss), pn.registerModifier("zz", as), pn.registerModifier("op", ls), Ze;
  });
})(hc, hc.exports);
var rE = hc.exports;
const nE = /* @__PURE__ */ up(rE), iE = W.div`
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
  > svg {
    display: block; /* Lottie SVG will have line-height otherwise */
    height: 100%;
    width: 100%;
  }
`, sE = {
  contain: "xMidYMid meet",
  cover: "xMidYMid slice",
  fill: "none"
};
function bI({
  accessibilityLabel: e,
  ccMargin: n,
  className: t,
  objectFit: r,
  style: i,
  "data-testid": o,
  ...a
}) {
  const c = We(null), d = We(null);
  return ct(() => {
    var p;
    if (d.current) {
      const m = (p = a.rendererSettings) == null ? void 0 : p.preserveAspectRatio;
      c.current = nE.loadAnimation({
        container: d.current,
        renderer: "svg",
        rendererSettings: {
          title: e,
          viewBoxOnly: !0,
          // if user wants to get granular with preserveAspectRatio, they can pass it in rendererSettings
          preserveAspectRatio: m || sE[r ?? "contain"]
        },
        ...a
      });
    }
    return () => {
      var m;
      return (m = c.current) == null ? void 0 : m.destroy();
    };
  }, [e, r, a]), /* @__PURE__ */ L(
    iE,
    {
      $ccMargin: n,
      className: t,
      style: i,
      "data-testid": o,
      ref: d
    }
  );
}
var oE = Object.defineProperty, aE = (e, n, t) => n in e ? oE(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Ml = (e, n, t) => (aE(e, typeof n != "symbol" ? n + "" : n, t), t);
let lE = class {
  constructor() {
    Ml(this, "current", this.detect()), Ml(this, "handoffState", "pending"), Ml(this, "currentId", 0);
  }
  set(n) {
    this.current !== n && (this.handoffState = "pending", this.currentId = 0, this.current = n);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, an = new lE(), Qt = (e, n) => {
  an.isServer ? ct(e, n) : Pc(e, n);
};
function Ya(e) {
  let n = We(e);
  return Qt(() => {
    n.current = e;
  }, [e]), n;
}
let tt = function(e) {
  let n = Ya(e);
  return K.useCallback((...t) => n.current(...t), [n]);
};
function Ha(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((n) => setTimeout(() => {
    throw n;
  }));
}
function Yn() {
  let e = [], n = { addEventListener(t, r, i, o) {
    return t.addEventListener(r, i, o), n.add(() => t.removeEventListener(r, i, o));
  }, requestAnimationFrame(...t) {
    let r = requestAnimationFrame(...t);
    return n.add(() => cancelAnimationFrame(r));
  }, nextFrame(...t) {
    return n.requestAnimationFrame(() => n.requestAnimationFrame(...t));
  }, setTimeout(...t) {
    let r = setTimeout(...t);
    return n.add(() => clearTimeout(r));
  }, microTask(...t) {
    let r = { current: !0 };
    return Ha(() => {
      r.current && t[0]();
    }), n.add(() => {
      r.current = !1;
    });
  }, style(t, r, i) {
    let o = t.style.getPropertyValue(r);
    return Object.assign(t.style, { [r]: i }), this.add(() => {
      Object.assign(t.style, { [r]: o });
    });
  }, group(t) {
    let r = Yn();
    return t(r), this.add(() => r.dispose());
  }, add(t) {
    return e.push(t), () => {
      let r = e.indexOf(t);
      if (r >= 0)
        for (let i of e.splice(r, 1))
          i();
    };
  }, dispose() {
    for (let t of e.splice(0))
      t();
  } };
  return n;
}
function hu() {
  let [e] = lr(Yn);
  return ct(() => () => e.dispose(), [e]), e;
}
function cE() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in se ? ((n) => n.useSyncExternalStore)(se)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Ba() {
  let e = cE(), [n, t] = se.useState(an.isHandoffComplete);
  return n && an.isHandoffComplete === !1 && t(!1), se.useEffect(() => {
    n !== !0 && t(!0);
  }, [n]), se.useEffect(() => an.handoff(), []), e ? !1 : n;
}
var Bf;
let fn = (Bf = K.useId) != null ? Bf : function() {
  let e = Ba(), [n, t] = K.useState(e ? () => an.nextId() : null);
  return Qt(() => {
    n === null && t(an.nextId());
  }, [n]), n != null ? "" + n : void 0;
};
function Hr(e, n, ...t) {
  if (e in n) {
    let i = n[e];
    return typeof i == "function" ? i(...t) : i;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(n).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, Hr), r;
}
function Wa(e) {
  return an.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let gc = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var en = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(en || {}), sg = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(sg || {}), uE = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(uE || {});
function og(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(gc)).sort((n, t) => Math.sign((n.tabIndex || Number.MAX_SAFE_INTEGER) - (t.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var gu = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(gu || {});
function mu(e, n = 0) {
  var t;
  return e === ((t = Wa(e)) == null ? void 0 : t.body) ? !1 : Hr(n, { 0() {
    return e.matches(gc);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(gc))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
function ag(e) {
  let n = Wa(e);
  Yn().nextFrame(() => {
    n && !mu(n.activeElement, 0) && Fn(e);
  });
}
var dE = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(dE || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Fn(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let fE = ["textarea", "input"].join(",");
function pE(e) {
  var n, t;
  return (t = (n = e == null ? void 0 : e.matches) == null ? void 0 : n.call(e, fE)) != null ? t : !1;
}
function lg(e, n = (t) => t) {
  return e.slice().sort((t, r) => {
    let i = n(t), o = n(r);
    if (i === null || o === null)
      return 0;
    let a = i.compareDocumentPosition(o);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function hE(e, n) {
  return Rs(og(), n, { relativeTo: e });
}
function Rs(e, n, { sorted: t = !0, relativeTo: r = null, skipElements: i = [] } = {}) {
  let o = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, a = Array.isArray(e) ? t ? lg(e) : e : og(e);
  i.length > 0 && a.length > 1 && (a = a.filter((_) => !i.includes(_))), r = r ?? o.activeElement;
  let c = (() => {
    if (n & 5)
      return 1;
    if (n & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), d = (() => {
    if (n & 1)
      return 0;
    if (n & 2)
      return Math.max(0, a.indexOf(r)) - 1;
    if (n & 4)
      return Math.max(0, a.indexOf(r)) + 1;
    if (n & 8)
      return a.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), p = n & 32 ? { preventScroll: !0 } : {}, m = 0, v = a.length, y;
  do {
    if (m >= v || m + v <= 0)
      return 0;
    let _ = d + m;
    if (n & 16)
      _ = (_ + v) % v;
    else {
      if (_ < 0)
        return 3;
      if (_ >= v)
        return 1;
    }
    y = a[_], y == null || y.focus(p), m += c;
  } while (y !== o.activeElement);
  return n & 6 && pE(y) && y.select(), 2;
}
function cg() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function gE() {
  return /Android/gi.test(window.navigator.userAgent);
}
function mE() {
  return cg() || gE();
}
function Po(e, n, t) {
  let r = Ya(n);
  ct(() => {
    function i(o) {
      r.current(o);
    }
    return document.addEventListener(e, i, t), () => document.removeEventListener(e, i, t);
  }, [e, t]);
}
function ug(e, n, t) {
  let r = Ya(n);
  ct(() => {
    function i(o) {
      r.current(o);
    }
    return window.addEventListener(e, i, t), () => window.removeEventListener(e, i, t);
  }, [e, t]);
}
function dg(e, n, t = !0) {
  let r = We(!1);
  ct(() => {
    requestAnimationFrame(() => {
      r.current = t;
    });
  }, [t]);
  function i(a, c) {
    if (!r.current || a.defaultPrevented)
      return;
    let d = c(a);
    if (d === null || !d.getRootNode().contains(d) || !d.isConnected)
      return;
    let p = function m(v) {
      return typeof v == "function" ? m(v()) : Array.isArray(v) || v instanceof Set ? v : [v];
    }(e);
    for (let m of p) {
      if (m === null)
        continue;
      let v = m instanceof HTMLElement ? m : m.current;
      if (v != null && v.contains(d) || a.composed && a.composedPath().includes(v))
        return;
    }
    return !mu(d, gu.Loose) && d.tabIndex !== -1 && a.preventDefault(), n(a, d);
  }
  let o = We(null);
  Po("pointerdown", (a) => {
    var c, d;
    r.current && (o.current = ((d = (c = a.composedPath) == null ? void 0 : c.call(a)) == null ? void 0 : d[0]) || a.target);
  }, !0), Po("mousedown", (a) => {
    var c, d;
    r.current && (o.current = ((d = (c = a.composedPath) == null ? void 0 : c.call(a)) == null ? void 0 : d[0]) || a.target);
  }, !0), Po("click", (a) => {
    mE() || o.current && (i(a, () => o.current), o.current = null);
  }, !0), Po("touchend", (a) => i(a, () => a.target instanceof HTMLElement ? a.target : null), !0), ug("blur", (a) => i(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function es(...e) {
  return jt(() => Wa(...e), [...e]);
}
function Wf(e) {
  var n;
  if (e.type)
    return e.type;
  let t = (n = e.as) != null ? n : "button";
  if (typeof t == "string" && t.toLowerCase() === "button")
    return "button";
}
function vE(e, n) {
  let [t, r] = lr(() => Wf(e));
  return Qt(() => {
    r(Wf(e));
  }, [e.type, e.as]), Qt(() => {
    t || n.current && n.current instanceof HTMLButtonElement && !n.current.hasAttribute("type") && r("button");
  }, [t, n]), t;
}
let fg = Symbol();
function _E(e, n = !0) {
  return Object.assign(e, { [fg]: n });
}
function pr(...e) {
  let n = We(e);
  ct(() => {
    n.current = e;
  }, [e]);
  let t = tt((r) => {
    for (let i of n.current)
      i != null && (typeof i == "function" ? i(r) : i.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[fg])) ? void 0 : t;
}
function jf(e) {
  return [e.screenX, e.screenY];
}
function yE() {
  let e = We([-1, -1]);
  return { wasMoved(n) {
    let t = jf(n);
    return e.current[0] === t[0] && e.current[1] === t[1] ? !1 : (e.current = t, !0);
  }, update(n) {
    e.current = jf(n);
  } };
}
function bE({ container: e, accept: n, walk: t, enabled: r = !0 }) {
  let i = We(n), o = We(t);
  ct(() => {
    i.current = n, o.current = t;
  }, [n, t]), Qt(() => {
    if (!e || !r)
      return;
    let a = Wa(e);
    if (!a)
      return;
    let c = i.current, d = o.current, p = Object.assign((v) => c(v), { acceptNode: c }), m = a.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, p, !1);
    for (; m.nextNode(); )
      d(m.currentNode);
  }, [e, r, i, o]);
}
function vu(e, n) {
  let t = We([]), r = tt(e);
  ct(() => {
    let i = [...t.current];
    for (let [o, a] of n.entries())
      if (t.current[o] !== a) {
        let c = r(n, i);
        return t.current = n, c;
      }
  }, [r, ...n]);
}
function Gf(...e) {
  return Array.from(new Set(e.flatMap((n) => typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}
var Bs = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Bs || {}), wE = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(wE || {});
function ir({ ourProps: e, theirProps: n, slot: t, defaultTag: r, features: i, visible: o = !0, name: a, mergeRefs: c }) {
  c = c ?? xE;
  let d = pg(n, e);
  if (o)
    return Mo(d, t, r, a, c);
  let p = i ?? 0;
  if (p & 2) {
    let { static: m = !1, ...v } = d;
    if (m)
      return Mo(v, t, r, a, c);
  }
  if (p & 1) {
    let { unmount: m = !0, ...v } = d;
    return Hr(m ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Mo({ ...v, hidden: !0, style: { display: "none" } }, t, r, a, c);
    } });
  }
  return Mo(d, t, r, a, c);
}
function Mo(e, n = {}, t, r, i) {
  let { as: o = t, children: a, refName: c = "ref", ...d } = $l(e, ["unmount", "static"]), p = e.ref !== void 0 ? { [c]: e.ref } : {}, m = typeof a == "function" ? a(n) : a;
  "className" in d && d.className && typeof d.className == "function" && (d.className = d.className(n));
  let v = {};
  if (n) {
    let y = !1, _ = [];
    for (let [S, E] of Object.entries(n))
      typeof E == "boolean" && (y = !0), E === !0 && _.push(S);
    y && (v["data-headlessui-state"] = _.join(" "));
  }
  if (o === rn && Object.keys(qf(d)).length > 0) {
    if (!ba(m) || Array.isArray(m) && m.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(d).map((E) => `  - ${E}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((E) => `  - ${E}`).join(`
`)].join(`
`));
    let y = m.props, _ = typeof (y == null ? void 0 : y.className) == "function" ? (...E) => Gf(y == null ? void 0 : y.className(...E), d.className) : Gf(y == null ? void 0 : y.className, d.className), S = _ ? { className: _ } : {};
    return Mc(m, Object.assign({}, pg(m.props, qf($l(d, ["ref"]))), v, p, { ref: i(m.ref, p.ref) }, S));
  }
  return Ec(o, Object.assign({}, $l(d, ["ref"]), o !== rn && p, o !== rn && v), m);
}
function xE(...e) {
  return e.every((n) => n == null) ? void 0 : (n) => {
    for (let t of e)
      t != null && (typeof t == "function" ? t(n) : t.current = n);
  };
}
function pg(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let n = {}, t = {};
  for (let r of e)
    for (let i in r)
      i.startsWith("on") && typeof r[i] == "function" ? (t[i] != null || (t[i] = []), t[i].push(r[i])) : n[i] = r[i];
  if (n.disabled || n["aria-disabled"])
    return Object.assign(n, Object.fromEntries(Object.keys(t).map((r) => [r, void 0])));
  for (let r in t)
    Object.assign(n, { [r](i, ...o) {
      let a = t[r];
      for (let c of a) {
        if ((i instanceof Event || (i == null ? void 0 : i.nativeEvent) instanceof Event) && i.defaultPrevented)
          return;
        c(i, ...o);
      }
    } });
  return n;
}
function sr(e) {
  var n;
  return Object.assign(Wn(e), { displayName: (n = e.displayName) != null ? n : e.name });
}
function qf(e) {
  let n = Object.assign({}, e);
  for (let t in n)
    n[t] === void 0 && delete n[t];
  return n;
}
function $l(e, n = []) {
  let t = Object.assign({}, e);
  for (let r of n)
    r in t && delete t[r];
  return t;
}
let SE = "div";
var ma = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(ma || {});
function kE(e, n) {
  var t;
  let { features: r = 1, ...i } = e, o = { ref: n, "aria-hidden": (r & 2) === 2 ? !0 : (t = i["aria-hidden"]) != null ? t : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
  return ir({ ourProps: o, theirProps: i, slot: {}, defaultTag: SE, name: "Hidden" });
}
let mc = sr(kE), _u = jn(null);
_u.displayName = "OpenClosedContext";
var tn = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(tn || {});
function hg() {
  return Er(_u);
}
function CE({ value: e, children: n }) {
  return K.createElement(_u.Provider, { value: e }, n);
}
function DE(e) {
  function n() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", n));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", n), n());
}
let En = [];
DE(() => {
  function e(n) {
    n.target instanceof HTMLElement && n.target !== document.body && En[0] !== n.target && (En.unshift(n.target), En = En.filter((t) => t != null && t.isConnected), En.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function gg(e) {
  let n = e.parentElement, t = null;
  for (; n && !(n instanceof HTMLFieldSetElement); )
    n instanceof HTMLLegendElement && (t = n), n = n.parentElement;
  let r = (n == null ? void 0 : n.getAttribute("disabled")) === "";
  return r && EE(t) ? !1 : r;
}
function EE(e) {
  if (!e)
    return !1;
  let n = e.previousElementSibling;
  for (; n !== null; ) {
    if (n instanceof HTMLLegendElement)
      return !1;
    n = n.previousElementSibling;
  }
  return !0;
}
function PE(e) {
  throw new Error("Unexpected object: " + e);
}
var Sr = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(Sr || {});
function ME(e, n) {
  let t = n.resolveItems();
  if (t.length <= 0)
    return null;
  let r = n.resolveActiveIndex(), i = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let o = 0; o < t.length; ++o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 1: {
      for (let o = i - 1; o >= 0; --o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 2: {
      for (let o = i + 1; o < t.length; ++o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 3: {
      for (let o = t.length - 1; o >= 0; --o)
        if (!n.resolveDisabled(t[o], o, t))
          return o;
      return r;
    }
    case 4: {
      for (let o = 0; o < t.length; ++o)
        if (n.resolveId(t[o], o, t) === e.id)
          return o;
      return r;
    }
    case 5:
      return null;
    default:
      PE(e);
  }
}
var Dt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Dt || {});
function mg(e, n, t, r) {
  let i = Ya(t);
  ct(() => {
    e = e ?? window;
    function o(a) {
      i.current(a);
    }
    return e.addEventListener(n, o, r), () => e.removeEventListener(n, o, r);
  }, [e, n, r]);
}
function vg() {
  let e = We(!1);
  return Qt(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function _g(e) {
  let n = tt(e), t = We(!1);
  ct(() => (t.current = !1, () => {
    t.current = !0, Ha(() => {
      t.current && n();
    });
  }), [n]);
}
var Ps = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Ps || {});
function $E() {
  let e = We(0);
  return ug("keydown", (n) => {
    n.key === "Tab" && (e.current = n.shiftKey ? 1 : 0);
  }, !0), e;
}
function yg(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let n = /* @__PURE__ */ new Set();
  for (let t of e.current)
    t.current instanceof HTMLElement && n.add(t.current);
  return n;
}
let TE = "div";
var bg = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(bg || {});
function IE(e, n) {
  let t = We(null), r = pr(t, n), { initialFocus: i, containers: o, features: a = 30, ...c } = e;
  Ba() || (a = 1);
  let d = es(t);
  FE({ ownerDocument: d }, !!(a & 16));
  let p = OE({ ownerDocument: d, container: t, initialFocus: i }, !!(a & 2));
  LE({ ownerDocument: d, container: t, containers: o, previousActiveElement: p }, !!(a & 8));
  let m = $E(), v = tt((E) => {
    let Y = t.current;
    Y && ((N) => N())(() => {
      Hr(m.current, { [Ps.Forwards]: () => {
        Rs(Y, en.First, { skipElements: [E.relatedTarget] });
      }, [Ps.Backwards]: () => {
        Rs(Y, en.Last, { skipElements: [E.relatedTarget] });
      } });
    });
  }), y = hu(), _ = We(!1), S = { ref: r, onKeyDown(E) {
    E.key == "Tab" && (_.current = !0, y.requestAnimationFrame(() => {
      _.current = !1;
    }));
  }, onBlur(E) {
    let Y = yg(o);
    t.current instanceof HTMLElement && Y.add(t.current);
    let N = E.relatedTarget;
    N instanceof HTMLElement && N.dataset.headlessuiFocusGuard !== "true" && (wg(Y, N) || (_.current ? Rs(t.current, Hr(m.current, { [Ps.Forwards]: () => en.Next, [Ps.Backwards]: () => en.Previous }) | en.WrapAround, { relativeTo: E.target }) : E.target instanceof HTMLElement && Fn(E.target)));
  } };
  return K.createElement(K.Fragment, null, !!(a & 4) && K.createElement(mc, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: v, features: ma.Focusable }), ir({ ourProps: S, theirProps: c, defaultTag: TE, name: "FocusTrap" }), !!(a & 4) && K.createElement(mc, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: v, features: ma.Focusable }));
}
let RE = sr(IE), bs = Object.assign(RE, { features: bg });
function AE(e = !0) {
  let n = We(En.slice());
  return vu(([t], [r]) => {
    r === !0 && t === !1 && Ha(() => {
      n.current.splice(0);
    }), r === !1 && t === !0 && (n.current = En.slice());
  }, [e, En, n]), tt(() => {
    var t;
    return (t = n.current.find((r) => r != null && r.isConnected)) != null ? t : null;
  });
}
function FE({ ownerDocument: e }, n) {
  let t = AE(n);
  vu(() => {
    n || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && Fn(t());
  }, [n]), _g(() => {
    n && Fn(t());
  });
}
function OE({ ownerDocument: e, container: n, initialFocus: t }, r) {
  let i = We(null), o = vg();
  return vu(() => {
    if (!r)
      return;
    let a = n.current;
    a && Ha(() => {
      if (!o.current)
        return;
      let c = e == null ? void 0 : e.activeElement;
      if (t != null && t.current) {
        if ((t == null ? void 0 : t.current) === c) {
          i.current = c;
          return;
        }
      } else if (a.contains(c)) {
        i.current = c;
        return;
      }
      t != null && t.current ? Fn(t.current) : Rs(a, en.First) === sg.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), i.current = e == null ? void 0 : e.activeElement;
    });
  }, [r]), i;
}
function LE({ ownerDocument: e, container: n, containers: t, previousActiveElement: r }, i) {
  let o = vg();
  mg(e == null ? void 0 : e.defaultView, "focus", (a) => {
    if (!i || !o.current)
      return;
    let c = yg(t);
    n.current instanceof HTMLElement && c.add(n.current);
    let d = r.current;
    if (!d)
      return;
    let p = a.target;
    p && p instanceof HTMLElement ? wg(c, p) ? (r.current = p, Fn(p)) : (a.preventDefault(), a.stopPropagation(), Fn(d)) : Fn(r.current);
  }, !0);
}
function wg(e, n) {
  for (let t of e)
    if (t.contains(n))
      return !0;
  return !1;
}
let xg = jn(!1);
function NE() {
  return Er(xg);
}
function vc(e) {
  return K.createElement(xg.Provider, { value: e.force }, e.children);
}
function zE(e) {
  let n = NE(), t = Er(Sg), r = es(e), [i, o] = lr(() => {
    if (!n && t !== null || an.isServer)
      return null;
    let a = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (a)
      return a;
    if (r === null)
      return null;
    let c = r.createElement("div");
    return c.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(c);
  });
  return ct(() => {
    i !== null && (r != null && r.body.contains(i) || r == null || r.body.appendChild(i));
  }, [i, r]), ct(() => {
    n || t !== null && o(t.current);
  }, [t, o, n]), i;
}
let VE = rn;
function YE(e, n) {
  let t = e, r = We(null), i = pr(_E((m) => {
    r.current = m;
  }), n), o = es(r), a = zE(r), [c] = lr(() => {
    var m;
    return an.isServer ? null : (m = o == null ? void 0 : o.createElement("div")) != null ? m : null;
  }), d = Er(_c), p = Ba();
  return Qt(() => {
    !a || !c || a.contains(c) || (c.setAttribute("data-headlessui-portal", ""), a.appendChild(c));
  }, [a, c]), Qt(() => {
    if (c && d)
      return d.register(c);
  }, [d, c]), _g(() => {
    var m;
    !a || !c || (c instanceof Node && a.contains(c) && a.removeChild(c), a.childNodes.length <= 0 && ((m = a.parentElement) == null || m.removeChild(a)));
  }), p ? !a || !c ? null : cp(ir({ ourProps: { ref: i }, theirProps: t, defaultTag: VE, name: "Portal" }), c) : null;
}
let HE = rn, Sg = jn(null);
function BE(e, n) {
  let { target: t, ...r } = e, i = { ref: pr(n) };
  return K.createElement(Sg.Provider, { value: t }, ir({ ourProps: i, theirProps: r, defaultTag: HE, name: "Popover.Group" }));
}
let _c = jn(null);
function WE() {
  let e = Er(_c), n = We([]), t = tt((o) => (n.current.push(o), e && e.register(o), () => r(o))), r = tt((o) => {
    let a = n.current.indexOf(o);
    a !== -1 && n.current.splice(a, 1), e && e.unregister(o);
  }), i = jt(() => ({ register: t, unregister: r, portals: n }), [t, r, n]);
  return [n, jt(() => function({ children: o }) {
    return K.createElement(_c.Provider, { value: i }, o);
  }, [i])];
}
let jE = sr(YE), GE = sr(BE), yc = Object.assign(jE, { Group: GE });
function qE(e, n) {
  return e === n && (e !== 0 || 1 / e === 1 / n) || e !== e && n !== n;
}
const KE = typeof Object.is == "function" ? Object.is : qE, { useState: UE, useEffect: QE, useLayoutEffect: XE, useDebugValue: ZE } = se;
function JE(e, n, t) {
  const r = n(), [{ inst: i }, o] = UE({ inst: { value: r, getSnapshot: n } });
  return XE(() => {
    i.value = r, i.getSnapshot = n, Tl(i) && o({ inst: i });
  }, [e, r, n]), QE(() => (Tl(i) && o({ inst: i }), e(() => {
    Tl(i) && o({ inst: i });
  })), [e]), ZE(r), r;
}
function Tl(e) {
  const n = e.getSnapshot, t = e.value;
  try {
    const r = n();
    return !KE(t, r);
  } catch {
    return !0;
  }
}
function eP(e, n, t) {
  return n();
}
const tP = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", rP = !tP, nP = rP ? eP : JE, iP = "useSyncExternalStore" in se ? ((e) => e.useSyncExternalStore)(se) : nP;
function sP(e) {
  return iP(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function oP(e, n) {
  let t = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return t;
  }, subscribe(i) {
    return r.add(i), () => r.delete(i);
  }, dispatch(i, ...o) {
    let a = n[i].call(t, ...o);
    a && (t = a, r.forEach((c) => c()));
  } };
}
function aP() {
  let e;
  return { before({ doc: n }) {
    var t;
    let r = n.documentElement;
    e = ((t = n.defaultView) != null ? t : window).innerWidth - r.clientWidth;
  }, after({ doc: n, d: t }) {
    let r = n.documentElement, i = r.clientWidth - r.offsetWidth, o = e - i;
    t.style(r, "paddingRight", `${o}px`);
  } };
}
function lP() {
  return cg() ? { before({ doc: e, d: n, meta: t }) {
    function r(i) {
      return t.containers.flatMap((o) => o()).some((o) => o.contains(i));
    }
    n.microTask(() => {
      var i;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let c = Yn();
        c.style(e.documentElement, "scrollBehavior", "auto"), n.add(() => n.microTask(() => c.dispose()));
      }
      let o = (i = window.scrollY) != null ? i : window.pageYOffset, a = null;
      n.addEventListener(e, "click", (c) => {
        if (c.target instanceof HTMLElement)
          try {
            let d = c.target.closest("a");
            if (!d)
              return;
            let { hash: p } = new URL(d.href), m = e.querySelector(p);
            m && !r(m) && (a = m);
          } catch {
          }
      }, !0), n.addEventListener(e, "touchstart", (c) => {
        if (c.target instanceof HTMLElement)
          if (r(c.target)) {
            let d = c.target;
            for (; d.parentElement && r(d.parentElement); )
              d = d.parentElement;
            n.style(d, "overscrollBehavior", "contain");
          } else
            n.style(c.target, "touchAction", "none");
      }), n.addEventListener(e, "touchmove", (c) => {
        if (c.target instanceof HTMLElement)
          if (r(c.target)) {
            let d = c.target;
            for (; d.parentElement && d.dataset.headlessuiPortal !== "" && !(d.scrollHeight > d.clientHeight || d.scrollWidth > d.clientWidth); )
              d = d.parentElement;
            d.dataset.headlessuiPortal === "" && c.preventDefault();
          } else
            c.preventDefault();
      }, { passive: !1 }), n.add(() => {
        var c;
        let d = (c = window.scrollY) != null ? c : window.pageYOffset;
        o !== d && window.scrollTo(0, o), a && a.isConnected && (a.scrollIntoView({ block: "nearest" }), a = null);
      });
    });
  } } : {};
}
function cP() {
  return { before({ doc: e, d: n }) {
    n.style(e.documentElement, "overflow", "hidden");
  } };
}
function uP(e) {
  let n = {};
  for (let t of e)
    Object.assign(n, t(n));
  return n;
}
let li = oP(() => /* @__PURE__ */ new Map(), { PUSH(e, n) {
  var t;
  let r = (t = this.get(e)) != null ? t : { doc: e, count: 0, d: Yn(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(n), this.set(e, r), this;
}, POP(e, n) {
  let t = this.get(e);
  return t && (t.count--, t.meta.delete(n)), this;
}, SCROLL_PREVENT({ doc: e, d: n, meta: t }) {
  let r = { doc: e, d: n, meta: uP(t) }, i = [lP(), aP(), cP()];
  i.forEach(({ before: o }) => o == null ? void 0 : o(r)), i.forEach(({ after: o }) => o == null ? void 0 : o(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
li.subscribe(() => {
  let e = li.getSnapshot(), n = /* @__PURE__ */ new Map();
  for (let [t] of e)
    n.set(t, t.documentElement.style.overflow);
  for (let t of e.values()) {
    let r = n.get(t.doc) === "hidden", i = t.count !== 0;
    (i && !r || !i && r) && li.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t), t.count === 0 && li.dispatch("TEARDOWN", t);
  }
});
function dP(e, n, t) {
  let r = sP(li), i = e ? r.get(e) : void 0, o = i ? i.count > 0 : !1;
  return Qt(() => {
    if (!(!e || !n))
      return li.dispatch("PUSH", e, t), () => li.dispatch("POP", e, t);
  }, [n, e]), o;
}
let Il = /* @__PURE__ */ new Map(), ws = /* @__PURE__ */ new Map();
function Kf(e, n = !0) {
  Qt(() => {
    var t;
    if (!n)
      return;
    let r = typeof e == "function" ? e() : e.current;
    if (!r)
      return;
    function i() {
      var a;
      if (!r)
        return;
      let c = (a = ws.get(r)) != null ? a : 1;
      if (c === 1 ? ws.delete(r) : ws.set(r, c - 1), c !== 1)
        return;
      let d = Il.get(r);
      d && (d["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", d["aria-hidden"]), r.inert = d.inert, Il.delete(r));
    }
    let o = (t = ws.get(r)) != null ? t : 0;
    return ws.set(r, o + 1), o !== 0 || (Il.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0), i;
  }, [e, n]);
}
function fP({ defaultContainers: e = [], portals: n, mainTreeNodeRef: t } = {}) {
  var r;
  let i = We((r = t == null ? void 0 : t.current) != null ? r : null), o = es(i), a = tt(() => {
    var c, d, p;
    let m = [];
    for (let v of e)
      v !== null && (v instanceof HTMLElement ? m.push(v) : "current" in v && v.current instanceof HTMLElement && m.push(v.current));
    if (n != null && n.current)
      for (let v of n.current)
        m.push(v);
    for (let v of (c = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) != null ? c : [])
      v !== document.body && v !== document.head && v instanceof HTMLElement && v.id !== "headlessui-portal-root" && (v.contains(i.current) || v.contains((p = (d = i.current) == null ? void 0 : d.getRootNode()) == null ? void 0 : p.host) || m.some((y) => v.contains(y)) || m.push(v));
    return m;
  });
  return { resolveContainers: a, contains: tt((c) => a().some((d) => d.contains(c))), mainTreeNodeRef: i, MainTreeNode: jt(() => function() {
    return t != null ? null : K.createElement(mc, { features: ma.Hidden, ref: i });
  }, [i, t]) };
}
let yu = jn(() => {
});
yu.displayName = "StackContext";
var bc = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(bc || {});
function pP() {
  return Er(yu);
}
function hP({ children: e, onUpdate: n, type: t, element: r, enabled: i }) {
  let o = pP(), a = tt((...c) => {
    n == null || n(...c), o(...c);
  });
  return Qt(() => {
    let c = i === void 0 || i === !0;
    return c && a(0, t, r), () => {
      c && a(1, t, r);
    };
  }, [a, t, r, i]), K.createElement(yu.Provider, { value: a }, e);
}
let kg = jn(null);
function Cg() {
  let e = Er(kg);
  if (e === null) {
    let n = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(n, Cg), n;
  }
  return e;
}
function gP() {
  let [e, n] = lr([]);
  return [e.length > 0 ? e.join(" ") : void 0, jt(() => function(t) {
    let r = tt((o) => (n((a) => [...a, o]), () => n((a) => {
      let c = a.slice(), d = c.indexOf(o);
      return d !== -1 && c.splice(d, 1), c;
    }))), i = jt(() => ({ register: r, slot: t.slot, name: t.name, props: t.props }), [r, t.slot, t.name, t.props]);
    return K.createElement(kg.Provider, { value: i }, t.children);
  }, [n])];
}
let mP = "p";
function vP(e, n) {
  let t = fn(), { id: r = `headlessui-description-${t}`, ...i } = e, o = Cg(), a = pr(n);
  Qt(() => o.register(r), [r, o.register]);
  let c = { ref: a, ...o.props, id: r };
  return ir({ ourProps: c, theirProps: i, slot: o.slot || {}, defaultTag: mP, name: o.name || "Description" });
}
let _P = sr(vP), yP = Object.assign(_P, {});
var bP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(bP || {}), wP = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(wP || {});
let xP = { 0(e, n) {
  return e.titleId === n.id ? e : { ...e, titleId: n.id };
} }, va = jn(null);
va.displayName = "DialogContext";
function Xs(e) {
  let n = Er(va);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, Xs), t;
  }
  return n;
}
function SP(e, n, t = () => [document.body]) {
  dP(e, n, (r) => {
    var i;
    return { containers: [...(i = r.containers) != null ? i : [], t] };
  });
}
function kP(e, n) {
  return Hr(n.type, xP, e, n);
}
let CP = "div", DP = Bs.RenderStrategy | Bs.Static;
function EP(e, n) {
  let t = fn(), { id: r = `headlessui-dialog-${t}`, open: i, onClose: o, initialFocus: a, role: c = "dialog", __demoMode: d = !1, ...p } = e, [m, v] = lr(0), y = We(!1);
  c = function() {
    return c === "dialog" || c === "alertdialog" ? c : (y.current || (y.current = !0, console.warn(`Invalid role [${c}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let _ = hg();
  i === void 0 && _ !== null && (i = (_ & tn.Open) === tn.Open);
  let S = We(null), E = pr(S, n), Y = es(S), N = e.hasOwnProperty("open") || _ !== null, I = e.hasOwnProperty("onClose");
  if (!N && !I)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!N)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!I)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof i != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${i}`);
  if (typeof o != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${o}`);
  let Q = i ? 0 : 1, [te, ie] = lp(kP, { titleId: null, descriptionId: null, panelRef: Wo() }), ne = tt(() => o(!1)), re = tt((ve) => ie({ type: 0, id: ve })), ce = Ba() ? d ? !1 : Q === 0 : !1, de = m > 1, ge = Er(va) !== null, [$e, Le] = WE(), ze = { get current() {
    var ve;
    return (ve = te.panelRef.current) != null ? ve : S.current;
  } }, { resolveContainers: ke, mainTreeNodeRef: fe, MainTreeNode: De } = fP({ portals: $e, defaultContainers: [ze] }), _e = de ? "parent" : "leaf", ue = _ !== null ? (_ & tn.Closing) === tn.Closing : !1, Ve = ge || ue ? !1 : ce, Ne = dd(() => {
    var ve, dt;
    return (dt = Array.from((ve = Y == null ? void 0 : Y.querySelectorAll("body > *")) != null ? ve : []).find((St) => St.id === "headlessui-portal-root" ? !1 : St.contains(fe.current) && St instanceof HTMLElement)) != null ? dt : null;
  }, [fe]);
  Kf(Ne, Ve);
  let Re = de ? !0 : ce, Ee = dd(() => {
    var ve, dt;
    return (dt = Array.from((ve = Y == null ? void 0 : Y.querySelectorAll("[data-headlessui-portal]")) != null ? ve : []).find((St) => St.contains(fe.current) && St instanceof HTMLElement)) != null ? dt : null;
  }, [fe]);
  Kf(Ee, Re), dg(ke, ne, !(!ce || de));
  let je = !(de || Q !== 0);
  mg(Y == null ? void 0 : Y.defaultView, "keydown", (ve) => {
    je && (ve.defaultPrevented || ve.key === Dt.Escape && (ve.preventDefault(), ve.stopPropagation(), ne()));
  }), SP(Y, !(ue || Q !== 0 || ge), ke), ct(() => {
    if (Q !== 0 || !S.current)
      return;
    let ve = new ResizeObserver((dt) => {
      for (let St of dt) {
        let ki = St.target.getBoundingClientRect();
        ki.x === 0 && ki.y === 0 && ki.width === 0 && ki.height === 0 && ne();
      }
    });
    return ve.observe(S.current), () => ve.disconnect();
  }, [Q, S, ne]);
  let [nt, ut] = gP(), wt = jt(() => [{ dialogState: Q, close: ne, setTitleId: re }, te], [Q, te, ne, re]), Rt = jt(() => ({ open: Q === 0 }), [Q]), Mr = { ref: E, id: r, role: c, "aria-modal": Q === 0 ? !0 : void 0, "aria-labelledby": te.titleId, "aria-describedby": nt };
  return K.createElement(hP, { type: "Dialog", enabled: Q === 0, element: S, onUpdate: tt((ve, dt) => {
    dt === "Dialog" && Hr(ve, { [bc.Add]: () => v((St) => St + 1), [bc.Remove]: () => v((St) => St - 1) });
  }) }, K.createElement(vc, { force: !0 }, K.createElement(yc, null, K.createElement(va.Provider, { value: wt }, K.createElement(yc.Group, { target: S }, K.createElement(vc, { force: !1 }, K.createElement(ut, { slot: Rt, name: "Dialog.Description" }, K.createElement(bs, { initialFocus: a, containers: ke, features: ce ? Hr(_e, { parent: bs.features.RestoreFocus, leaf: bs.features.All & ~bs.features.FocusLock }) : bs.features.None }, K.createElement(Le, null, ir({ ourProps: Mr, theirProps: p, slot: Rt, defaultTag: CP, features: DP, visible: Q === 0, name: "Dialog" }))))))))), K.createElement(De, null));
}
let PP = "div";
function MP(e, n) {
  let t = fn(), { id: r = `headlessui-dialog-overlay-${t}`, ...i } = e, [{ dialogState: o, close: a }] = Xs("Dialog.Overlay"), c = pr(n), d = tt((m) => {
    if (m.target === m.currentTarget) {
      if (gg(m.currentTarget))
        return m.preventDefault();
      m.preventDefault(), m.stopPropagation(), a();
    }
  }), p = jt(() => ({ open: o === 0 }), [o]);
  return ir({ ourProps: { ref: c, id: r, "aria-hidden": !0, onClick: d }, theirProps: i, slot: p, defaultTag: PP, name: "Dialog.Overlay" });
}
let $P = "div";
function TP(e, n) {
  let t = fn(), { id: r = `headlessui-dialog-backdrop-${t}`, ...i } = e, [{ dialogState: o }, a] = Xs("Dialog.Backdrop"), c = pr(n);
  ct(() => {
    if (a.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [a.panelRef]);
  let d = jt(() => ({ open: o === 0 }), [o]);
  return K.createElement(vc, { force: !0 }, K.createElement(yc, null, ir({ ourProps: { ref: c, id: r, "aria-hidden": !0 }, theirProps: i, slot: d, defaultTag: $P, name: "Dialog.Backdrop" })));
}
let IP = "div";
function RP(e, n) {
  let t = fn(), { id: r = `headlessui-dialog-panel-${t}`, ...i } = e, [{ dialogState: o }, a] = Xs("Dialog.Panel"), c = pr(n, a.panelRef), d = jt(() => ({ open: o === 0 }), [o]), p = tt((m) => {
    m.stopPropagation();
  });
  return ir({ ourProps: { ref: c, id: r, onClick: p }, theirProps: i, slot: d, defaultTag: IP, name: "Dialog.Panel" });
}
let AP = "h2";
function FP(e, n) {
  let t = fn(), { id: r = `headlessui-dialog-title-${t}`, ...i } = e, [{ dialogState: o, setTitleId: a }] = Xs("Dialog.Title"), c = pr(n);
  ct(() => (a(r), () => a(null)), [r, a]);
  let d = jt(() => ({ open: o === 0 }), [o]);
  return ir({ ourProps: { ref: c, id: r }, theirProps: i, slot: d, defaultTag: AP, name: "Dialog.Title" });
}
let OP = sr(EP), LP = sr(TP), NP = sr(RP), zP = sr(MP), VP = sr(FP), bu = Object.assign(OP, { Backdrop: LP, Panel: NP, Overlay: zP, Title: VP, Description: yP }), Uf = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Qf(e) {
  var n, t;
  let r = (n = e.innerText) != null ? n : "", i = e.cloneNode(!0);
  if (!(i instanceof HTMLElement))
    return r;
  let o = !1;
  for (let c of i.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    c.remove(), o = !0;
  let a = o ? (t = i.innerText) != null ? t : "" : r;
  return Uf.test(a) && (a = a.replace(Uf, "")), a;
}
function YP(e) {
  let n = e.getAttribute("aria-label");
  if (typeof n == "string")
    return n.trim();
  let t = e.getAttribute("aria-labelledby");
  if (t) {
    let r = t.split(" ").map((i) => {
      let o = document.getElementById(i);
      if (o) {
        let a = o.getAttribute("aria-label");
        return typeof a == "string" ? a.trim() : Qf(o).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0)
      return r.join(", ");
  }
  return Qf(e).trim();
}
function HP(e) {
  let n = We(""), t = We("");
  return tt(() => {
    let r = e.current;
    if (!r)
      return "";
    let i = r.innerText;
    if (n.current === i)
      return t.current;
    let o = YP(r).trim().toLowerCase();
    return n.current = i, t.current = o, o;
  });
}
var BP = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(BP || {}), WP = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(WP || {}), jP = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e))(jP || {});
function Rl(e, n = (t) => t) {
  let t = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, r = lg(n(e.items.slice()), (o) => o.dataRef.current.domRef.current), i = t ? r.indexOf(t) : null;
  return i === -1 && (i = null), { items: r, activeItemIndex: i };
}
let GP = { 1(e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, 0(e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, 2: (e, n) => {
  var t;
  let r = Rl(e), i = ME(n, { resolveItems: () => r.items, resolveActiveIndex: () => r.activeItemIndex, resolveId: (o) => o.id, resolveDisabled: (o) => o.dataRef.current.disabled });
  return { ...e, ...r, searchQuery: "", activeItemIndex: i, activationTrigger: (t = n.trigger) != null ? t : 1 };
}, 3: (e, n) => {
  let t = e.searchQuery !== "" ? 0 : 1, r = e.searchQuery + n.value.toLowerCase(), i = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + t).concat(e.items.slice(0, e.activeItemIndex + t)) : e.items).find((a) => {
    var c;
    return ((c = a.dataRef.current.textValue) == null ? void 0 : c.startsWith(r)) && !a.dataRef.current.disabled;
  }), o = i ? e.items.indexOf(i) : -1;
  return o === -1 || o === e.activeItemIndex ? { ...e, searchQuery: r } : { ...e, searchQuery: r, activeItemIndex: o, activationTrigger: 1 };
}, 4(e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, 5: (e, n) => {
  let t = Rl(e, (r) => [...r, { id: n.id, dataRef: n.dataRef }]);
  return { ...e, ...t };
}, 6: (e, n) => {
  let t = Rl(e, (r) => {
    let i = r.findIndex((o) => o.id === n.id);
    return i !== -1 && r.splice(i, 1), r;
  });
  return { ...e, ...t, activationTrigger: 1 };
} }, wu = jn(null);
wu.displayName = "MenuContext";
function ja(e) {
  let n = Er(wu);
  if (n === null) {
    let t = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(t, ja), t;
  }
  return n;
}
function qP(e, n) {
  return Hr(n.type, GP, e, n);
}
let KP = rn;
function UP(e, n) {
  let { __demoMode: t = !1, ...r } = e, i = lp(qP, { __demoMode: t, menuState: t ? 0 : 1, buttonRef: Wo(), itemsRef: Wo(), items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: o, itemsRef: a, buttonRef: c }, d] = i, p = pr(n);
  dg([c, a], (_, S) => {
    var E;
    d({ type: 1 }), mu(S, gu.Loose) || (_.preventDefault(), (E = c.current) == null || E.focus());
  }, o === 0);
  let m = tt(() => {
    d({ type: 1 });
  }), v = jt(() => ({ open: o === 0, close: m }), [o, m]), y = { ref: p };
  return K.createElement(wu.Provider, { value: i }, K.createElement(CE, { value: Hr(o, { 0: tn.Open, 1: tn.Closed }) }, ir({ ourProps: y, theirProps: r, slot: v, defaultTag: KP, name: "Menu" })));
}
let QP = "button";
function XP(e, n) {
  var t;
  let r = fn(), { id: i = `headlessui-menu-button-${r}`, ...o } = e, [a, c] = ja("Menu.Button"), d = pr(a.buttonRef, n), p = hu(), m = tt((E) => {
    switch (E.key) {
      case Dt.Space:
      case Dt.Enter:
      case Dt.ArrowDown:
        E.preventDefault(), E.stopPropagation(), c({ type: 0 }), p.nextFrame(() => c({ type: 2, focus: Sr.First }));
        break;
      case Dt.ArrowUp:
        E.preventDefault(), E.stopPropagation(), c({ type: 0 }), p.nextFrame(() => c({ type: 2, focus: Sr.Last }));
        break;
    }
  }), v = tt((E) => {
    switch (E.key) {
      case Dt.Space:
        E.preventDefault();
        break;
    }
  }), y = tt((E) => {
    if (gg(E.currentTarget))
      return E.preventDefault();
    e.disabled || (a.menuState === 0 ? (c({ type: 1 }), p.nextFrame(() => {
      var Y;
      return (Y = a.buttonRef.current) == null ? void 0 : Y.focus({ preventScroll: !0 });
    })) : (E.preventDefault(), c({ type: 0 })));
  }), _ = jt(() => ({ open: a.menuState === 0 }), [a]), S = { ref: d, id: i, type: vE(e, a.buttonRef), "aria-haspopup": "menu", "aria-controls": (t = a.itemsRef.current) == null ? void 0 : t.id, "aria-expanded": a.menuState === 0, onKeyDown: m, onKeyUp: v, onClick: y };
  return ir({ ourProps: S, theirProps: o, slot: _, defaultTag: QP, name: "Menu.Button" });
}
let ZP = "div", JP = Bs.RenderStrategy | Bs.Static;
function eM(e, n) {
  var t, r;
  let i = fn(), { id: o = `headlessui-menu-items-${i}`, ...a } = e, [c, d] = ja("Menu.Items"), p = pr(c.itemsRef, n), m = es(c.itemsRef), v = hu(), y = hg(), _ = y !== null ? (y & tn.Open) === tn.Open : c.menuState === 0;
  ct(() => {
    let I = c.itemsRef.current;
    I && c.menuState === 0 && I !== (m == null ? void 0 : m.activeElement) && I.focus({ preventScroll: !0 });
  }, [c.menuState, c.itemsRef, m]), bE({ container: c.itemsRef.current, enabled: c.menuState === 0, accept(I) {
    return I.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : I.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(I) {
    I.setAttribute("role", "none");
  } });
  let S = tt((I) => {
    var Q, te;
    switch (v.dispose(), I.key) {
      case Dt.Space:
        if (c.searchQuery !== "")
          return I.preventDefault(), I.stopPropagation(), d({ type: 3, value: I.key });
      case Dt.Enter:
        if (I.preventDefault(), I.stopPropagation(), d({ type: 1 }), c.activeItemIndex !== null) {
          let { dataRef: ie } = c.items[c.activeItemIndex];
          (te = (Q = ie.current) == null ? void 0 : Q.domRef.current) == null || te.click();
        }
        ag(c.buttonRef.current);
        break;
      case Dt.ArrowDown:
        return I.preventDefault(), I.stopPropagation(), d({ type: 2, focus: Sr.Next });
      case Dt.ArrowUp:
        return I.preventDefault(), I.stopPropagation(), d({ type: 2, focus: Sr.Previous });
      case Dt.Home:
      case Dt.PageUp:
        return I.preventDefault(), I.stopPropagation(), d({ type: 2, focus: Sr.First });
      case Dt.End:
      case Dt.PageDown:
        return I.preventDefault(), I.stopPropagation(), d({ type: 2, focus: Sr.Last });
      case Dt.Escape:
        I.preventDefault(), I.stopPropagation(), d({ type: 1 }), Yn().nextFrame(() => {
          var ie;
          return (ie = c.buttonRef.current) == null ? void 0 : ie.focus({ preventScroll: !0 });
        });
        break;
      case Dt.Tab:
        I.preventDefault(), I.stopPropagation(), d({ type: 1 }), Yn().nextFrame(() => {
          hE(c.buttonRef.current, I.shiftKey ? en.Previous : en.Next);
        });
        break;
      default:
        I.key.length === 1 && (d({ type: 3, value: I.key }), v.setTimeout(() => d({ type: 4 }), 350));
        break;
    }
  }), E = tt((I) => {
    switch (I.key) {
      case Dt.Space:
        I.preventDefault();
        break;
    }
  }), Y = jt(() => ({ open: c.menuState === 0 }), [c]), N = { "aria-activedescendant": c.activeItemIndex === null || (t = c.items[c.activeItemIndex]) == null ? void 0 : t.id, "aria-labelledby": (r = c.buttonRef.current) == null ? void 0 : r.id, id: o, onKeyDown: S, onKeyUp: E, role: "menu", tabIndex: 0, ref: p };
  return ir({ ourProps: N, theirProps: a, slot: Y, defaultTag: ZP, features: JP, visible: _, name: "Menu.Items" });
}
let tM = rn;
function rM(e, n) {
  let t = fn(), { id: r = `headlessui-menu-item-${t}`, disabled: i = !1, ...o } = e, [a, c] = ja("Menu.Item"), d = a.activeItemIndex !== null ? a.items[a.activeItemIndex].id === r : !1, p = We(null), m = pr(n, p);
  Qt(() => {
    if (a.__demoMode || a.menuState !== 0 || !d || a.activationTrigger === 0)
      return;
    let ie = Yn();
    return ie.requestAnimationFrame(() => {
      var ne, re;
      (re = (ne = p.current) == null ? void 0 : ne.scrollIntoView) == null || re.call(ne, { block: "nearest" });
    }), ie.dispose;
  }, [a.__demoMode, p, d, a.menuState, a.activationTrigger, a.activeItemIndex]);
  let v = HP(p), y = We({ disabled: i, domRef: p, get textValue() {
    return v();
  } });
  Qt(() => {
    y.current.disabled = i;
  }, [y, i]), Qt(() => (c({ type: 5, id: r, dataRef: y }), () => c({ type: 6, id: r })), [y, r]);
  let _ = tt(() => {
    c({ type: 1 });
  }), S = tt((ie) => {
    if (i)
      return ie.preventDefault();
    c({ type: 1 }), ag(a.buttonRef.current);
  }), E = tt(() => {
    if (i)
      return c({ type: 2, focus: Sr.Nothing });
    c({ type: 2, focus: Sr.Specific, id: r });
  }), Y = yE(), N = tt((ie) => Y.update(ie)), I = tt((ie) => {
    Y.wasMoved(ie) && (i || d || c({ type: 2, focus: Sr.Specific, id: r, trigger: 0 }));
  }), Q = tt((ie) => {
    Y.wasMoved(ie) && (i || d && c({ type: 2, focus: Sr.Nothing }));
  }), te = jt(() => ({ active: d, disabled: i, close: _ }), [d, i, _]);
  return ir({ ourProps: { id: r, ref: m, role: "menuitem", tabIndex: i === !0 ? void 0 : -1, "aria-disabled": i === !0 ? !0 : void 0, disabled: void 0, onClick: S, onFocus: E, onPointerEnter: N, onMouseEnter: N, onPointerMove: I, onMouseMove: I, onPointerLeave: Q, onMouseLeave: Q }, theirProps: o, slot: te, defaultTag: tM, name: "Menu.Item" });
}
let nM = sr(UP), iM = sr(XP), sM = sr(eM), oM = sr(rM), As = Object.assign(nM, { Button: iM, Items: sM, Item: oM });
const aM = Br`
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`, lM = W.div`
  background-color: var(--cc_color_background_1);
  padding: var(--cc_size_spacing_s);
  border-radius: var(--cc_size_border_radius_l);
  box-shadow: 0 var(--cc_size_depth_3_y) var(--cc_size_depth_3_blur)
    var(--cc_color_depth_3);
  min-width: 148px;
  max-width: 100%;
  outline: none;

  /* animation */
  opacity: 0;
  transform: ${(e) => Nc({ placement: e.$placement, offset: pt.size_spacing_m })};
  animation: ${aM} ${mt.duration.fast} forwards
    ${mt.easeOut};
  @media (prefers-reduced-motion) {
    animation: none;
    opacity: 1;
    transform: none;
  }

  .dark-environment & {
    background-color: var(--cc_color_background_2);
  }
`, cM = W(As.Items)`
  border-radius: var(--cc_size_border_radius_l);
  &:focus-visible {
    ${Pt("normal").focusStyles}
    outline-offset: var(--cc_size_spacing_xs);
  }
`, xI = ({
  triggerButton: e,
  children: n,
  tooltip: t,
  mountNodeId: r,
  placement: i = "bottom-end",
  ...o
}) => {
  const { refs: a, floatingStyles: c, context: d } = Us({
    whileElementsMounted: Ta,
    placement: i,
    middleware: [
      $a(pt.size_spacing_s),
      Ia(),
      Kc({
        limiter: ib()
      })
    ]
  });
  return /* @__PURE__ */ L(As, { children: ({ open: p }) => /* @__PURE__ */ pe(Bn, { children: [
    t ? /* @__PURE__ */ L(hh, { title: t, ref: a.setReference, delay: 2e3, children: /* @__PURE__ */ L(As.Button, { as: rn, children: e }) }) : /* @__PURE__ */ L(As.Button, { as: rn, ref: a.setReference, children: e }),
    p && /* @__PURE__ */ L(Aa, { id: r || void 0, children: /* @__PURE__ */ L(cM, { ref: a.setFloating, style: c, children: /* @__PURE__ */ L(lM, { ...o, $placement: d.placement, children: n }) }) })
  ] }) });
}, uM = W.h3`
  all: initial;
  display: block;
  ${dr}
  color: var(--cc_color_text_nonessential);
  font-size: var(--cc_size_text_xs);
  text-transform: uppercase;
  font-weight: 600;
  margin: calc(var(--cc_size_spacing_s) * 1.25) var(--cc_size_spacing_s)
    calc(var(--cc_size_spacing_s) * 0.75);
`;
function SI({ ...e }) {
  return /* @__PURE__ */ L(uM, { ...e, "aria-hidden": "true" });
}
const dM = W.button`
  ${Gn}
  ${dr}
  width: 100%;
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_s);
  padding: var(--cc_size_spacing_s);
  text-align: start;
  font-size: var(--cc_size_text_s);
  font-weight: 400;
  background-color: ${({ $active: e }) => e ? "var(--cc_color_button_background_subtle)" : "transparent"};
  color: var(--cc_color_link_secondary);
  border-radius: var(--cc_size_border_radius_l);
  ${(e) => e.disabled ? _r : null}
`, fM = W.i`
  font-size: var(--cc_size_text_m);
  line-height: 1;
`, pM = W.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`, hM = W.span`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  gap: var(--cc_size_spacing_s);
`, gM = W.span`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;
function kI({
  children: e,
  iconName: n,
  contentAfter: t,
  href: r,
  disabled: i,
  ...o
}) {
  return /* @__PURE__ */ L(As.Item, { disabled: i, children: ({ active: a, disabled: c }) => /* @__PURE__ */ pe(
    dM,
    {
      as: r ? "a" : "button",
      href: r,
      $active: a,
      disabled: c,
      ...o,
      children: [
        /* @__PURE__ */ pe(hM, { children: [
          n ? /* @__PURE__ */ L(
            fM,
            {
              className: `mdi mdi-${n}`,
              role: "presentation"
            }
          ) : null,
          /* @__PURE__ */ L(pM, { children: e })
        ] }),
        t ? /* @__PURE__ */ L(gM, { children: t }) : null
      ]
    }
  ) });
}
const mM = le`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`, vM = W(iu)`
  margin-top: var(--cc_size_spacing_xl);
  align-self: center;
`, Xf = W.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--cc_size_spacing_s);
  padding: var(--cc_size_spacing_m);
  background-color: ${({ color: e }) => {
  switch (e) {
    case "success":
      return "var(--cc_color_utility_success_alpha_20)";
    case "warning":
      return "var(--cc_color_utility_caution_alpha_20)";
    case "danger":
      return "var(--cc_color_utility_destroy_alpha_20)";
    default:
      return "var(--cc_color_background_2)";
  }
}};
  border-radius: var(--cc_size_border_radius_l);
  min-height: 125px;
`, _M = W.span`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cc_size_spacing_xs);
`, yM = W.i`
  font-size: var(--cc_size_text_m);
  color: var(--cc_color_text_nonessential);
`, bM = W(Nt)`
  ${mM}
  line-height: 1.2;
  min-width: 1px;
`, wM = W.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  margin: auto 0 0;
`, xM = W.li`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_xs);
`, Dg = W.i`
  font-size: 18px;
  color: ${({ color: e }) => {
  switch (e) {
    case "success":
      return "var(--cc_color_utility_success_darken_10)";
    case "warning":
      return "var(--cc_color_utility_caution_darken_15)";
    case "danger":
      return "var(--cc_color_utility_destroy)";
    default:
      return "var(--cc_color_text_subtle)";
  }
}};
`, SM = W.div`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_xs);
`, kM = W.div`
  display: flex;
  gap: var(--cc_size_spacing_xs);
  position: relative;
  bottom: 1px;
`, Zf = ({
  icon: e,
  text: n,
  color: t
}) => /* @__PURE__ */ pe(xM, { children: [
  e ? /* @__PURE__ */ L(
    Dg,
    {
      className: `mdi mdi-${e}`,
      "aria-hidden": !0,
      color: t
    }
  ) : null,
  /* @__PURE__ */ L(Nt, { as: "span", size: "xs", color: "subtle", children: n })
] }), CM = ({
  comparisonText: e,
  comparisonType: n,
  comparisonValue: t,
  comparisonAccessibilityLabel: r
}) => {
  let i, o;
  switch (n) {
    case "positive":
    case "positive-down":
      o = "success";
      break;
    case "negative":
    case "negative-up":
      o = "danger";
      break;
    default:
      o = "default";
      break;
  }
  switch (n) {
    case "positive":
    case "negative-up":
      i = "arrow-up-bold";
      break;
    case "negative":
    case "positive-down":
      i = "arrow-down-bold";
      break;
    default:
      i = "equal";
      break;
  }
  return /* @__PURE__ */ pe(Bn, { children: [
    /* @__PURE__ */ pe(SM, { "aria-hidden": !0, children: [
      /* @__PURE__ */ L(
        Dg,
        {
          className: `mdi mdi-${i}`,
          "aria-hidden": !0,
          color: o
        }
      ),
      /* @__PURE__ */ pe(kM, { children: [
        /* @__PURE__ */ L(Nt, { as: "span", size: "xs", weight: 600, color: "subtle", children: t }),
        /* @__PURE__ */ L(Nt, { as: "span", size: "xs", color: "subtle", children: e })
      ] })
    ] }),
    /* @__PURE__ */ L(ln, { children: r })
  ] });
};
function CI({
  count: e,
  title: n,
  iconName: t,
  color: r,
  primaryMetadata: i,
  primaryMetadataIconName: o,
  secondaryMetadata: a,
  secondaryMetadataIconName: c,
  comparisonType: d,
  comparisonValue: p,
  comparisonText: m,
  comparisonAccessibilityLabel: v,
  isLoading: y,
  loadingAccessibilityLabel: _,
  "data-testid": S
}) {
  return y ? /* @__PURE__ */ L(Xf, { color: r, "data-testid": S, children: /* @__PURE__ */ L(
    vM,
    {
      accessibilityLabel: _ ?? "Loading…"
    }
  ) }) : /* @__PURE__ */ pe(Xf, { color: r, "data-testid": S, children: [
    /* @__PURE__ */ pe(_M, { children: [
      /* @__PURE__ */ L(yM, { className: `mdi mdi-${t}`, "aria-hidden": !0 }),
      /* @__PURE__ */ L(bM, { size: "xs", weight: "600", family: "heading", color: "subtle", children: n })
    ] }),
    /* @__PURE__ */ L(Nt, { as: "h3", weight: "700", size: "xxl", ccMargin: "none none s", children: e }),
    i || a ? /* @__PURE__ */ pe(wM, { children: [
      i && /* @__PURE__ */ L(
        Zf,
        {
          icon: o,
          text: i,
          color: r
        }
      ),
      a && /* @__PURE__ */ L(
        Zf,
        {
          icon: c,
          text: a,
          color: r
        }
      )
    ] }) : null,
    d && p !== null && m ? /* @__PURE__ */ L(
      CM,
      {
        comparisonType: d,
        comparisonValue: p,
        comparisonText: m,
        comparisonAccessibilityLabel: v
      }
    ) : null
  ] });
}
const xu = "calc(var(--cc_size_spacing_m) * 1.25) var(--cc_size_spacing_l)", DM = W(bu.Title)`
  all: initial;
  min-width: 0;
`, EM = Br`
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`, PM = (e) => {
  const n = "calc(100% - var(--cc_size_spacing_xl))", t = le`
    max-width: ${n};
    max-height: ${n};
  `;
  switch (e) {
    case "small":
      return le`
        width: ${n};
        ${t}
        @container (min-width: 600px) {
          width: 600px;
        }
      `;
    case "medium":
      return le`
        width: ${n};
        ${t}
        @container (min-width: 900px) {
          width: 900px;
          ${t}
        }
      `;
    default:
      return `
        width: ${n};
        height: ${n};
        ${t}
      `;
  }
}, MM = W(bu.Panel)`
  position: relative;
  display: grid;
  grid-template-rows:
    ${(e) => e.$noHeader ? null : "auto"} minmax(100px, 1fr)
    ${(e) => e.$noFooter ? null : "auto"};
  ${(e) => PM(e.$size)}
  border-radius: var(--cc_size_border_radius_l);
  opacity: 0;
  transform: translate3d(0, var(--cc_size_spacing_m), 0);
  animation: ${EM} 0.3s forwards ease-out;
  animation-delay: 0.1s;
  box-shadow: 0 var(--cc_size_depth_3_y) var(--cc_size_depth_3_blur)
    var(--cc_color_depth_3);
  background: var(--cc_color_background_1);
  min-height: 200px;
`, $M = Br`
  to {
    opacity: 1;
  }
`, TM = W.div`
  position: absolute;
  inset: 0;
  background: var(--cc_color_background_backdrop);
  opacity: 0;
  animation: ${$M} 0.2s forwards;
  @media (prefers-reduced-motion) {
    animation: none;
    opacity: 1;
    transform: none;
  }
`, IM = W.header`
  all: initial;
  display: grid;
  gap: var(--cc_size_spacing_l);
  align-items: center;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: ${xu};
  border-block-end: 1px solid var(--cc_color_border_default);
  border-radius: var(--cc_size_border_radius_l) var(--cc_size_border_radius_l) 0
    0;
`, RM = W.div`
  display: grid;
`, AM = W.div`
  padding: ${xu};
  overflow-y: auto;
`, FM = W.footer`
  all: initial;
  position: relative;
  display: grid;
  gap: var(--cc_size_spacing_s);
  align-items: center;
  padding: ${xu};
  background: var(--cc_color_background_2);
  border-radius: 0 0 var(--cc_size_border_radius_l)
    var(--cc_size_border_radius_l);

  @container (min-width: 500px) {
    grid-template-columns: minmax(0, 1fr) auto;
  }
`, OM = W.div`
  min-width: 0;
`, LM = W.div`
  flex-shrink: 0;
  display: flex;
  gap: var(--cc_size_spacing_s);
`, NM = ({
  dataTestIdCloseButton: e,
  headerComponent: n,
  headerContentAfter: t,
  headerStyle: r,
  title: i,
  onClose: o
}) => n === null ? null : n || /* @__PURE__ */ pe(IM, { style: r, children: [
  /* @__PURE__ */ pe(RM, { children: [
    /* @__PURE__ */ L(DM, { as: "h2", children: /* @__PURE__ */ L(Nt, { as: "span", size: "xl", family: "heading", weight: 800, children: i }) }),
    t || null
  ] }),
  /* @__PURE__ */ L(
    sa,
    {
      iconName: "close",
      onClick: o,
      accessibilityLabel: "Close modal",
      "data-testid": e
    }
  )
] }), zM = ({
  footerComponent: e,
  footerActions: n,
  footerContentBefore: t,
  footerStyle: r
}) => e === null ? null : e || /* @__PURE__ */ pe(FM, { style: r, children: [
  /* @__PURE__ */ L(OM, { children: t }),
  n ? /* @__PURE__ */ L(LM, { children: n }) : null
] });
function DI({
  isOpen: e,
  onClose: n,
  as: t,
  children: r,
  "data-testid__close-button": i = "slab__modal-close-button",
  bodyStyle: o,
  containerStyle: a,
  headerStyle: c,
  footerStyle: d,
  headerComponent: p,
  headerContentAfter: m,
  footerComponent: v,
  footerActions: y,
  footerContentBefore: _,
  size: S = "medium",
  title: E,
  ...Y
}) {
  return (
    // inline styles below because styled-components doesn't support containerType yet and also breaks the Headless UI Dialog `as` prop
    /* @__PURE__ */ L(
      bu,
      {
        "aria-label": p || p === null ? E : "",
        open: e,
        onClose: n,
        as: t,
        style: {
          position: "fixed",
          zIndex: 900,
          inset: 0
        },
        ...Y,
        children: /* @__PURE__ */ pe(
          "div",
          {
            style: {
              containerType: "inline-size",
              width: "100%",
              height: "100%",
              display: "grid",
              placeItems: "center",
              overflow: "hidden"
            },
            children: [
              /* @__PURE__ */ L(TM, {}),
              /* @__PURE__ */ pe(
                MM,
                {
                  $size: S,
                  $noHeader: p === null,
                  $noFooter: v === null,
                  style: a,
                  children: [
                    NM({
                      headerComponent: p,
                      title: E,
                      onClose: n,
                      headerStyle: c,
                      headerContentAfter: m,
                      dataTestIdCloseButton: i
                    }),
                    /* @__PURE__ */ L(AM, { style: o, children: r }),
                    zM({
                      footerComponent: v,
                      footerActions: y,
                      footerContentBefore: _,
                      footerStyle: d
                    })
                  ]
                }
              )
            ]
          }
        )
      }
    )
  );
}
const VM = W.dialog`
  border: none;
  &::backdrop {
    background: ${pt.color_background_backdrop};
  }
`, YM = (e, n) => {
  const t = n.getBoundingClientRect();
  return !(e.clientX > t.left && e.clientX < t.right && e.clientY > t.top && e.clientY < t.bottom);
}, EI = ({
  isOpen: e,
  onClose: n,
  children: t,
  ...r
}) => {
  const i = We(null);
  return ct(() => {
    var o, a;
    e ? (o = i.current) == null || o.showModal() : (a = i.current) == null || a.close();
  }, [e]), /* @__PURE__ */ L(
    VM,
    {
      ...r,
      ref: i,
      onCancel: n,
      onClose: n,
      onClick: (o) => i.current && YM(o, i.current) && n(),
      children: t
    }
  );
}, ot = {
  add_on: "add_on",
  assigned: "assigned",
  caution: "caution",
  destroy: "destroy",
  info: "info",
  success: "success",
  upgrade: "upgrade"
}, hi = {
  small: "small",
  medium: "medium",
  large: "large"
}, HM = (e) => {
  switch (e) {
    case ot.add_on:
      return "var(--cc_color_brand_add_on_alpha_10)";
    case ot.assigned:
      return "var(--cc_color_utility_assigned_alpha_10)";
    case ot.caution:
      return "var(--cc_color_utility_caution_alpha_20)";
    case ot.destroy:
      return "var(--cc_color_utility_destroy_alpha_10)";
    case ot.info:
      return "var(--cc_color_background_3_alpha_80)";
    case ot.success:
      return "var(--cc_color_utility_success_alpha_10)";
    case ot.upgrade:
      return "var(--cc_color_brand_upgrade_alpha_10)";
    default:
      return "var(--cc_color_background_3_alpha_80)";
  }
}, BM = (e) => {
  switch (e) {
    case ot.add_on:
      return "var(--cc_color_brand_add_on)";
    case ot.assigned:
      return "var(--cc_color_utility_assigned)";
    case ot.caution:
      return "var(--cc_color_utility_caution)";
    case ot.destroy:
      return "var(--cc_color_utility_destroy)";
    case ot.info:
      return "var(--cc_color_utility_info_alpha_80)";
    case ot.success:
      return "var(--cc_color_utility_success)";
    case ot.upgrade:
      return "var(--cc_color_brand_upgrade)";
    default:
      return "var(--cc_color_utility_info_alpha_80)";
  }
}, WM = (e) => {
  switch (e) {
    case ot.add_on:
      return "var(--cc_color_background_1)";
    case ot.assigned:
      return "var(--cc_color_background_1)";
    case ot.caution:
      return pt.color_text_default_le;
    case ot.destroy:
      return "var(--cc_color_background_1)";
    case ot.info:
      return pt.color_text_default_de;
    case ot.success:
      return "var(--cc_color_background_1)";
    case ot.upgrade:
      return "var(--cc_color_brand_secondary)";
    default:
      return pt.color_text_default_de;
  }
}, jM = (e, n) => {
  switch (n) {
    case "add_on":
      return e || "information-outline";
    case "assigned":
      return e || "account-check";
    case "success":
      return e || "check";
    case "caution":
      return e || "alert-circle-outline";
    case "destroy":
      return e || "alert-circle-outline";
    case "upgrade":
      return e || "lightning-bolt";
    default:
      return e || "information-outline";
  }
}, GM = (e) => {
  switch (e) {
    case "small":
      return "6px 8px";
    case "medium":
      return "calc(var(--cc_size_spacing_s) + 2px) var(--cc_size_spacing_m) calc(var(--cc_size_spacing_s) + 2px)";
    case "large":
      return "var(--cc_size_spacing_m) var(--cc_size_spacing_l) var(--cc_size_spacing_m) var(--cc_size_spacing_m)";
  }
}, Jf = (e) => {
  switch (e) {
    case "small":
      return 24;
    case "medium":
      return 28;
    case "large":
      return 34;
  }
}, qM = (e) => {
  switch (e) {
    case "small":
      return "var(--cc_size_text_xs)";
    case "medium":
      return "calc(var(--cc_size_text_s) - 1px)";
    case "large":
      return "var(--cc_size_text_s)";
  }
}, KM = (e) => {
  switch (e) {
    case "small":
      return 16;
    case "medium":
      return 18;
    case "large":
      return 22;
  }
}, UM = W.div`
  display: flex;
  flex-wrap: wrap;
  align-items: ${({ $contentAlign: e = "center" }) => e};
  gap: ${({ size: e = hi.medium }) => e === "small" ? "calc(var(--cc_size_spacing_s) + 2px)" : "var(--cc_size_spacing_m)"};
  padding: ${({ size: e = hi.medium }) => GM(e)};
  background-color: ${({ $color: e = ot.info }) => HM(e)};
  border-radius: var(--cc_size_border_radius_l);
  color: var(--cc_color_text_subtle);
  font-size: ${({ size: e = hi.medium }) => qM(e)};
  font-family: system-ui, sans-serif;
  line-height: 1.3;

  /* if ccMargin is specified in props, convert spacing tokens to CSS variables */
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
`, QM = W.span`
  flex: 1;
`, ep = W.span`
  flex-shrink: 0;
`, XM = W.span`
  flex-shrink: 0;
  display: grid;
  place-items: center;
  width: ${({ size: e = hi.medium }) => Jf(e)}px;
  height: ${({ size: e = hi.medium }) => Jf(e)}px;
  background-color: ${({ color: e = ot.info }) => BM(e)};
  border-radius: var(--cc_size_border_radius_l);
`, ZM = W.i`
  font-size: ${({ size: e = hi.medium }) => KM(e)}px;
  color: ${({ color: e = ot.info }) => WM(e)};
`;
function PI({
  children: e,
  ccMargin: n,
  color: t = ot.info,
  contentBefore: r,
  contentAfter: i,
  contentAlign: o = "center",
  iconName: a = "",
  hideIcon: c,
  size: d = hi.medium,
  testId: p,
  ...m
}) {
  return /* @__PURE__ */ pe(
    UM,
    {
      $color: t,
      $ccMargin: n,
      size: d,
      $contentAlign: o,
      "data-testid": p,
      ...m,
      children: [
        !c && !r ? /* @__PURE__ */ L(XM, { color: t, size: d, children: /* @__PURE__ */ L(
          ZM,
          {
            className: `mdi mdi-${jM(a, t)}`,
            "aria-hidden": "true",
            size: d,
            color: t,
            "data-testid": "icon"
          }
        ) }) : null,
        r ? /* @__PURE__ */ L(ep, { children: r }) : null,
        /* @__PURE__ */ L(QM, { children: e }),
        i ? /* @__PURE__ */ L(ep, { children: i }) : null
      ]
    }
  );
}
const JM = W.header`
  all: initial;
  display: block;
  ${(e) => e.$hasBottomBorder ? le`
          padding-block-end: var(--cc_size_spacing_m);
          border-block-end: var(--cc_size_border_width_s) solid
            var(--cc_color_border_default);
        ` : null}
`, e$ = W(Hw)`
  margin-block-end: var(--cc_size_spacing_s);
`, t$ = W.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--cc_size_spacing_m);
`, r$ = W.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  row-gap: var(--cc_size_spacing_m);
  column-gap: var(--cc_size_spacing_l);
  width: fit-content;
  flex: 1;
`, n$ = W.div`
  display: flex;
  flex: none;
  align-items: flex-end;
  gap: var(--cc_size_spacing_s);
`, i$ = W.div`
  display: flex;
  flex: none;
  align-items: flex-end;
  gap: var(--cc_size_spacing_s);
`;
function MI({
  backAction: e,
  contentAfter: n,
  contentAfterHeading: t,
  hasBottomBorder: r = !1,
  testId: i,
  heading: o,
  ...a
}) {
  return /* @__PURE__ */ pe(
    JM,
    {
      $hasBottomBorder: r,
      "data-testid": i,
      ...a,
      children: [
        e ? /* @__PURE__ */ L(
          e$,
          {
            ...e,
            "data-testid": e["data-testid"],
            color: "subtle",
            icon: {
              name: "chevron-left",
              position: "before"
            },
            children: e.label
          }
        ) : null,
        /* @__PURE__ */ pe(t$, { children: [
          /* @__PURE__ */ pe(r$, { children: [
            /* @__PURE__ */ L(Nt, { as: "h1", size: "xxl", children: o }),
            t ? /* @__PURE__ */ L(i$, { children: t }) : null
          ] }),
          n ? /* @__PURE__ */ L(n$, { children: n }) : null
        ] })
      ]
    }
  );
}
const s$ = W.div`
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
`, o$ = Br`
  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`, a$ = W.div`
  all: initial;
  box-sizing: border-box;
  display: block;
  background-color: var(--cc_color_background_1);
  padding: var(--cc_size_spacing_m);
  overflow-y: auto;
  border-radius: var(--cc_size_border_radius_l);
  box-shadow: 0 0 var(--cc_size_depth_2_blur) var(--cc_color_depth_2);

  /* animation */
  opacity: 0;
  transform: ${(e) => Nc({ placement: e.$placement, offset: pt.size_spacing_m })};
  animation: ${o$} ${mt.duration.medium} forwards
    ${mt.easeOut};
  @media (prefers-reduced-motion) {
    animation: none;
    opacity: 1;
    transform: none;
  }
`;
function $I({
  as: e,
  children: n,
  isOpen: t,
  onOpenChange: r,
  mountNodeId: i,
  placement: o,
  triggerButton: a,
  ...c
}) {
  const { refs: d, floatingStyles: p, context: m } = Us({
    open: t,
    onOpenChange: r,
    placement: o || "bottom",
    whileElementsMounted: Ta,
    middleware: [
      $a(pt.size_spacing_s),
      Ia({
        fallbackAxisSideDirection: "start"
      }),
      Kc()
    ]
  }), v = ph(m), y = Jc(m), _ = tu(m, { role: "dialog" }), { getReferenceProps: S, getFloatingProps: E } = eu([
    v,
    y,
    _
  ]), Y = a;
  return ba(Y) ? /* @__PURE__ */ pe(Bn, { children: [
    K.cloneElement(
      Y,
      {
        type: "button",
        ref: d.setReference,
        ...S()
      }
    ),
    /* @__PURE__ */ L(Aa, { id: i || void 0, children: t && /* @__PURE__ */ L(fh, { context: m, modal: !0, children: /* @__PURE__ */ L(
      s$,
      {
        ref: d.setFloating,
        style: p,
        ...E(),
        children: /* @__PURE__ */ L(a$, { as: e, $placement: m.placement, ...c, children: n })
      }
    ) }) })
  ] }) : null;
}
const l$ = W.div`
  position: relative;
`, c$ = W.label`
  ${(e) => e.$hideLabel ? fr : le`
          all: initial;
          display: block;
          ${Lt}
          color: var(--cc_color_text_subtle);
          font-size: ${e.$size === "medium" ? "var(--cc_size_text_s)" : "var(--cc_size_text_xs)"};
          margin-block-end: var(--cc_size_spacing_s);
        `}
`, tp = le`
  border: none;
  background-color: var(--cc_color_background_3);
  border-radius: var(--cc_size_border_radius_pill);
`, rp = (e, n) => le`
  background-color: ${zc(e)};
  border-radius: var(--cc_size_border_radius_pill) 0 0
    var(--cc_size_border_radius_pill);
  border-radius: ${n ? "var(--cc_size_border_radius_pill)" : "var(--cc_size_border_radius_pill) 0 0 var(--cc_size_border_radius_pill)"};
`, u$ = W.progress`
  display: block;
  width: 100%;
  min-width: 124px;
  appearance: none;
  ${tp}
  height: ${(e) => e.$size === "medium" ? "var(--cc_size_spacing_s)" : "calc(var(--cc_size_spacing_s) * 0.75)"};

  /* webkit */
  &::-webkit-progress-bar {
    ${tp}
  }
  &::-webkit-progress-value {
    ${(e) => rp(e.$color, e.$isCompleted)}
  }
  &::-moz-progress-bar {
    ${(e) => rp(e.$color, e.$isCompleted)}
  }
`;
function TI({
  hideLabel: e = !1,
  labelStyle: n,
  size: t = "small",
  ...r
}) {
  const i = () => r.value && r.max ? r.value >= r.max : !1;
  return /* @__PURE__ */ pe(l$, { children: [
    /* @__PURE__ */ L(
      c$,
      {
        htmlFor: r.id,
        $size: t,
        $hideLabel: e,
        style: n,
        children: r.label
      }
    ),
    /* @__PURE__ */ L(
      u$,
      {
        $size: t,
        $color: r.color || "secondary",
        $isCompleted: i(),
        ...r
      }
    )
  ] });
}
const Ws = {
  small: {
    diameter: 24,
    strokeWidth: 3,
    iconSize: "var(--cc_size_text_xs)"
  },
  medium: {
    diameter: 48,
    strokeWidth: 4,
    iconSize: "var(--cc_size_text_m)"
  },
  large: {
    diameter: 60,
    strokeWidth: 6,
    iconSize: "var(--cc_size_text_l)"
  }
}, d$ = W.div`
  position: relative;
  width: ${(e) => Ws[e.$size || "medium"].diameter}px;
  height: ${(e) => Ws[e.$size || "medium"].diameter}px;
  display: grid;
  place-items: center;

  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}
`, Eg = le`
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`, f$ = W.output`
  ${Eg}
`, p$ = W.svg`
  transform: rotate(-90deg);
`, h$ = W.circle`
  fill: none;
  stroke: var(--cc_color_background_3);
  transition: stroke-dashoffset 0.3s ease-out;
`, g$ = W.circle`
  fill: none;
  stroke: blue;
`, m$ = W(Nt)`
  text-align: center;
`, v$ = W.span`
  ${Eg}
`, _$ = W.i`
  font-size: ${(e) => Ws[e.$size || "small"].iconSize};
  color: ${(e) => zc(e.$color)};
`;
function II({
  formatValue: e,
  size: n = "medium",
  shouldShowCompleteIcon: t = !1,
  ccMargin: r,
  ...i
}) {
  const { label: o, color: a, style: c, className: d, ...p } = i, m = Ws[n].diameter, v = Ws[n].strokeWidth, y = m / 2 - v / 2, _ = 2 * Math.PI * y, S = i.value >= i.max, E = e ? e({ value: i.value, max: i.max }) : i.value;
  return /* @__PURE__ */ pe(
    d$,
    {
      $size: n,
      $ccMargin: r,
      style: c,
      className: d,
      children: [
        /* @__PURE__ */ L(ln, { children: /* @__PURE__ */ L("progress", { "aria-label": o, ...p }) }),
        /* @__PURE__ */ pe(
          p$,
          {
            viewBox: `0 0 ${m} ${m}`,
            role: "presentation",
            $size: n,
            children: [
              /* @__PURE__ */ L(
                h$,
                {
                  cx: m / 2,
                  cy: m / 2,
                  r: y,
                  style: { strokeWidth: v }
                }
              ),
              /* @__PURE__ */ L(
                g$,
                {
                  cx: m / 2,
                  cy: m / 2,
                  r: y,
                  style: {
                    strokeWidth: v,
                    strokeDasharray: _,
                    strokeDashoffset: _ - (S ? i.max : i.value) / i.max * _,
                    stroke: zc(a)
                  }
                }
              )
            ]
          }
        ),
        n === "small" || t ? /* @__PURE__ */ L(ln, { children: /* @__PURE__ */ L("output", { htmlFor: i.id, children: E }) }) : /* @__PURE__ */ L(f$, { htmlFor: i.id, children: /* @__PURE__ */ L(
          m$,
          {
            forwardedAs: "span",
            color: "subtle",
            family: "heading",
            size: n === "large" ? "s" : "xs",
            children: E
          }
        ) }),
        t ? /* @__PURE__ */ L(v$, { children: /* @__PURE__ */ L(
          _$,
          {
            className: "mdi mdi-check-bold",
            role: "presentation",
            $size: n,
            $color: a
          }
        ) }) : null
      ]
    }
  );
}
const y$ = W.svg`
  display: block;
  fill: ${({ $isSelected: e }) => e ? "var(--cc_color_utility_caution)" : "var(--cc_color_text_nonessential)"};
  scale: 0.85;
`, b$ = "M7.19883 0.531328C7.49309 -0.177109 8.49343 -0.177109 8.78769 0.531328L10.3376 4.26322C10.4627 4.56437 10.756 4.76055 11.0812 4.76055H15.1571C15.9066 4.76055 16.2819 5.66958 15.7519 6.20123L12.4554 9.50846C12.2485 9.716 12.1701 10.0197 12.2504 10.3019L13.5577 14.8923C13.7785 15.6674 12.917 16.2983 12.2484 15.8512L8.4401 13.304C8.16951 13.1231 7.81701 13.1231 7.54642 13.3041L3.74443 15.847C3.07373 16.2955 2.20941 15.6626 2.43086 14.885L3.73609 10.3019C3.81646 10.0197 3.73801 9.716 3.53115 9.50846L0.250883 6.21757C-0.285057 5.67989 0.0945176 4.76055 0.852458 4.76055H4.90533C5.23053 4.76055 5.52383 4.56437 5.64891 4.26322L7.19883 0.531328Z", w$ = "M11.2886 10.5756C11.1094 9.94587 11.2839 9.26718 11.7471 8.8025L14.7792 5.76055H11.0812C10.3504 5.76055 9.69353 5.31978 9.41407 4.64664L7.99326 1.22569L6.57243 4.64678C6.29292 5.31976 5.63613 5.76055 4.90533 5.76055H1.20727L4.2394 8.8025C4.70243 9.26704 4.87728 9.94575 4.69785 10.5758L3.49102 14.8134L6.99037 12.473C7.59746 12.0668 8.38895 12.0668 8.99598 12.4728L12.4955 14.8134L11.2886 10.5756ZM12.2484 15.8512L8.4401 13.304C8.16951 13.1231 7.81701 13.1231 7.54642 13.3041L3.74443 15.847C3.07373 16.2955 2.2094 15.6626 2.43086 14.885L3.73609 10.3019C3.81646 10.0197 3.73801 9.716 3.53115 9.50846L0.250883 6.21757C-0.285057 5.67989 0.0945176 4.76055 0.852458 4.76055H4.90533C5.23053 4.76055 5.52383 4.56437 5.64891 4.26322L7.19883 0.531328C7.49309 -0.177109 8.49343 -0.177109 8.78769 0.531328L10.3376 4.26322C10.4627 4.56437 10.756 4.76055 11.0812 4.76055H15.1571C15.9066 4.76055 16.2819 5.66958 15.7519 6.20123L12.4554 9.50846C12.2485 9.716 12.1701 10.0197 12.2504 10.3019L13.5577 14.8923C13.7785 15.6674 12.917 16.2983 12.2484 15.8512ZM15.0437 5.49527C15.0436 5.49532 15.0437 5.49522 15.0437 5.49527Z";
function x$({ isSelected: e = !1 }) {
  return /* @__PURE__ */ L(y$, { viewBox: "0 0 16 16", "aria-hidden": "true", $isSelected: e, children: /* @__PURE__ */ L(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: e ? b$ : w$
    }
  ) });
}
const _a = {
  xsmall: "xs",
  small: "s",
  medium: "m",
  large: "l"
}, S$ = W.div`
  all: initial;
  display: flex;
  align-items: center;
`, k$ = W.legend`
  all: initial;
  ${fr}
`, C$ = W.div`
  width: ${(e) => `var(--cc_size_avatar_${_a[e.$size || "small"]})`};
  height: ${(e) => `var(--cc_size_avatar_${_a[e.$size || "small"]})`};
`, D$ = W.label`
  all: initial;
  position: relative;
  cursor: pointer;
  width: ${(e) => `var(--cc_size_avatar_${_a[e.$size || "small"]})`};
  height: ${(e) => `var(--cc_size_avatar_${_a[e.$size || "small"]})`};
  transition: scale 0.3s ease-out;

  &:active {
    scale: 1.5;
    z-index: 1;
  }

  &:has(input:focus-visible) {
    border-radius: var(--cc_size_border_radius_m);
    outline-color: var(--cc_color_border_input_active);
    ${ui}
  }

  &:has(input[aria-disabled='true']) {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }
`, E$ = W.input`
  all: initial;
  ${fr}
`, P$ = (e, n, t) => e > 0 && e >= n || e === 0 && n <= t;
function RI({
  accessibilityLabel: e,
  className: n,
  "data-testid": t,
  disabled: r = !1,
  max: i,
  selectedValue: o,
  onChange: a,
  onHover: c,
  readOnly: d = !1,
  size: p = "small",
  style: m
}) {
  const [v, y] = lr(0), _ = Am(), S = (Y) => {
    y(Y), c == null || c(Y);
  }, E = () => {
    y(0), c == null || c(0);
  };
  return /* @__PURE__ */ pe(
    S$,
    {
      "data-testid": t || void 0,
      as: d ? "div" : "fieldset",
      "aria-disabled": !d && r ? !0 : void 0,
      style: m,
      className: n,
      children: [
        !d && /* @__PURE__ */ L(k$, { children: e }),
        Array.from({ length: i }, (Y, N) => N + 1).map((Y) => {
          const N = o === Y, I = /* @__PURE__ */ pe(Bn, { children: [
            /* @__PURE__ */ L(ln, { children: Y }),
            /* @__PURE__ */ L(
              x$,
              {
                isSelected: P$(v, Y, o)
              }
            )
          ] });
          return d ? /* @__PURE__ */ L(C$, { $size: p, children: I }, Y) : /* @__PURE__ */ pe(
            D$,
            {
              onMouseEnter: () => S(Y),
              onMouseLeave: E,
              $size: p,
              children: [
                /* @__PURE__ */ L(
                  E$,
                  {
                    type: "radio",
                    "data-testid": t ? `${t}-${Y}` : void 0,
                    name: _,
                    value: Y,
                    checked: N,
                    disabled: r && !N ? r : !1,
                    "aria-disabled": r ? "true" : void 0,
                    onChange: !d && a ? () => a(Y) : void 0
                  }
                ),
                I
              ]
            },
            Y
          );
        })
      ]
    }
  );
}
const M$ = (e, n) => e ? fr : n === "group" ? le`
      flex: 1;
      min-width: 1px;
    ` : null, ya = pt.size_avatar_s, $$ = W.div`
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_s);
`, T$ = W.label`
  all: initial;
  ${(e) => M$(e.$hideLabel, e.$layout)}
`, I$ = W.span`
  ${Lt}
  flex: 1;
  min-width: 1px;
  font-size: var(--cc_size_text_s);
  color: var(--cc_color_text_default);
  user-select: none;
`, Pg = W.span`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  height: ${ya}px;
  width: ${ya}px;
  border-radius: 100%;
  transition: transform 0.2s ease-out;
  transform: translateX(${(e) => e.$isPressed ? "100%" : "0"});
  &::after {
    content: '';
    position: absolute;
    inset: var(--cc_size_spacing_xxs);
    border-radius: 100%;
    transition: all 0.2s;
    background-color: var(--cc_color_button_text_secondary);
  }
`, R$ = W.span`
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  place-items: center;
  padding: 0 var(--cc_size_spacing_xs);
`, np = W.i`
  font-size: var(--cc_size_text_xs);
  transition: all 0.2s;
  transition-delay: 0.1s;
  color: ${(e) => e.$isPressed ? "var(--cc_color_button_text_secondary)" : "var(--cc_color_button_text_subtle)"};
`, A$ = W.button`
  all: initial; /* reset browser styles */
  ${Gn} /* add our shared CoCam button styles */
  flex-shrink: 0;
  width: ${ya * 2}px;
  height: ${ya}px;
  border-radius: var(--cc_size_border_radius_pill);
  position: relative;
  transition: background-color 0.2s ease-out;

  &:active ${Pg}::after {
    transform: scale(0.75);
  }
  &:focus-visible {
    outline-offset: var(--cc_size_spacing_xs);
  }
  ${(e) => e.disabled ? _r : null}
  ${(e) => e.$isPressed ? le`
          background-color: ${e.$status !== "normal" ? Pt(e.$status).accentColor : "var(--cc_color_button_background_secondary)"};
        ` : le`
          background-color: var(--cc_color_button_background_subtle);
        `}
`, AI = ({
  hideLabel: e,
  label: n,
  layout: t = "default",
  onClick: r,
  pressed: i,
  ...o
}) => {
  const { status: a = "normal", className: c, message: d, style: p, ...m } = o, v = /* @__PURE__ */ L(
    T$,
    {
      id: `${o.id}-label`,
      $hideLabel: e,
      $layout: t,
      htmlFor: t === "default" ? o.id : "",
      children: /* @__PURE__ */ L(I$, { children: n })
    }
  );
  return /* @__PURE__ */ L(
    qn,
    {
      inputId: o.id,
      message: d,
      className: c,
      status: a,
      style: p,
      children: /* @__PURE__ */ pe($$, { $layout: t, children: [
        t === "group" ? v : null,
        /* @__PURE__ */ pe(
          A$,
          {
            "aria-labelledby": `${o.id}-label`,
            "aria-describedby": d ? `${o.id}-message` : "",
            "aria-invalid": a === "error",
            $isPressed: i,
            $status: a,
            onClick: r,
            "aria-pressed": i,
            ...m,
            children: [
              /* @__PURE__ */ pe(R$, { children: [
                /* @__PURE__ */ L(
                  np,
                  {
                    "aria-hidden": "true",
                    className: "mdi mdi-check-bold",
                    $isPressed: i,
                    style: { opacity: i ? 1 : 0 }
                  }
                ),
                /* @__PURE__ */ L(
                  np,
                  {
                    "aria-hidden": "true",
                    className: "mdi mdi-close-thick",
                    $isPressed: i,
                    style: { opacity: i ? 0 : 1 }
                  }
                )
              ] }),
              /* @__PURE__ */ L(Pg, { $isPressed: i, "aria-hidden": "true" })
            ]
          }
        ),
        t === "default" ? v : null
      ] })
    }
  );
};
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Mn(e, n) {
  return typeof e == "function" ? e(n) : e;
}
function ur(e, n) {
  return (t) => {
    n.setState((r) => ({
      ...r,
      [e]: Mn(t, r[e])
    }));
  };
}
function Ga(e) {
  return e instanceof Function;
}
function F$(e) {
  return Array.isArray(e) && e.every((n) => typeof n == "number");
}
function O$(e, n) {
  const t = [], r = (i) => {
    i.forEach((o) => {
      t.push(o);
      const a = n(o);
      a != null && a.length && r(a);
    });
  };
  return r(e), t;
}
function Fe(e, n, t) {
  let r = [], i;
  return (o) => {
    let a;
    t.key && t.debug && (a = Date.now());
    const c = e(o);
    if (!(c.length !== r.length || c.some((m, v) => r[v] !== m)))
      return i;
    r = c;
    let p;
    if (t.key && t.debug && (p = Date.now()), i = n(...c), t == null || t.onChange == null || t.onChange(i), t.key && t.debug && t != null && t.debug()) {
      const m = Math.round((Date.now() - a) * 100) / 100, v = Math.round((Date.now() - p) * 100) / 100, y = v / 16, _ = (S, E) => {
        for (S = String(S); S.length < E; )
          S = " " + S;
        return S;
      };
      console.info(`%c⏱ ${_(v, 5)} /${_(m, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * y, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return i;
  };
}
function Oe(e, n, t, r) {
  return {
    debug: () => {
      var i;
      return (i = e == null ? void 0 : e.debugAll) != null ? i : e[n];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: r
  };
}
function L$(e, n, t, r) {
  const i = () => {
    var a;
    return (a = o.getValue()) != null ? a : e.options.renderFallbackValue;
  }, o = {
    id: `${n.id}_${t.id}`,
    row: n,
    column: t,
    getValue: () => n.getValue(r),
    renderValue: i,
    getContext: Fe(() => [e, t, n, o], (a, c, d, p) => ({
      table: a,
      column: c,
      row: d,
      cell: p,
      getValue: p.getValue,
      renderValue: p.renderValue
    }), Oe(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((a) => {
    a.createCell == null || a.createCell(o, t, n, e);
  }, {}), o;
}
function N$(e, n, t, r) {
  var i, o;
  const c = {
    ...e._getDefaultColumnDef(),
    ...n
  }, d = c.accessorKey;
  let p = (i = (o = c.id) != null ? o : d ? d.replace(".", "_") : void 0) != null ? i : typeof c.header == "string" ? c.header : void 0, m;
  if (c.accessorFn ? m = c.accessorFn : d && (d.includes(".") ? m = (y) => {
    let _ = y;
    for (const E of d.split(".")) {
      var S;
      _ = (S = _) == null ? void 0 : S[E], process.env.NODE_ENV !== "production" && _ === void 0 && console.warn(`"${E}" in deeply nested key "${d}" returned undefined.`);
    }
    return _;
  } : m = (y) => y[c.accessorKey]), !p)
    throw process.env.NODE_ENV !== "production" ? new Error(c.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let v = {
    id: `${String(p)}`,
    accessorFn: m,
    parent: r,
    depth: t,
    columnDef: c,
    columns: [],
    getFlatColumns: Fe(() => [!0], () => {
      var y;
      return [v, ...(y = v.columns) == null ? void 0 : y.flatMap((_) => _.getFlatColumns())];
    }, Oe(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: Fe(() => [e._getOrderColumnsFn()], (y) => {
      var _;
      if ((_ = v.columns) != null && _.length) {
        let S = v.columns.flatMap((E) => E.getLeafColumns());
        return y(S);
      }
      return [v];
    }, Oe(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const y of e._features)
    y.createColumn == null || y.createColumn(v, e);
  return v;
}
const Ht = "debugHeaders";
function ip(e, n, t) {
  var r;
  let o = {
    id: (r = t.id) != null ? r : n.id,
    column: n,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const a = [], c = (d) => {
        d.subHeaders && d.subHeaders.length && d.subHeaders.map(c), a.push(d);
      };
      return c(o), a;
    },
    getContext: () => ({
      table: e,
      header: o,
      column: n
    })
  };
  return e._features.forEach((a) => {
    a.createHeader == null || a.createHeader(o, e);
  }), o;
}
const z$ = {
  createTable: (e) => {
    e.getHeaderGroups = Fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, r, i) => {
      var o, a;
      const c = (o = r == null ? void 0 : r.map((v) => t.find((y) => y.id === v)).filter(Boolean)) != null ? o : [], d = (a = i == null ? void 0 : i.map((v) => t.find((y) => y.id === v)).filter(Boolean)) != null ? a : [], p = t.filter((v) => !(r != null && r.includes(v.id)) && !(i != null && i.includes(v.id)));
      return $o(n, [...c, ...p, ...d], e);
    }, Oe(e.options, Ht, "getHeaderGroups")), e.getCenterHeaderGroups = Fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, r, i) => (t = t.filter((o) => !(r != null && r.includes(o.id)) && !(i != null && i.includes(o.id))), $o(n, t, e, "center")), Oe(e.options, Ht, "getCenterHeaderGroups")), e.getLeftHeaderGroups = Fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (n, t, r) => {
      var i;
      const o = (i = r == null ? void 0 : r.map((a) => t.find((c) => c.id === a)).filter(Boolean)) != null ? i : [];
      return $o(n, o, e, "left");
    }, Oe(e.options, Ht, "getLeftHeaderGroups")), e.getRightHeaderGroups = Fe(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (n, t, r) => {
      var i;
      const o = (i = r == null ? void 0 : r.map((a) => t.find((c) => c.id === a)).filter(Boolean)) != null ? i : [];
      return $o(n, o, e, "right");
    }, Oe(e.options, Ht, "getRightHeaderGroups")), e.getFooterGroups = Fe(() => [e.getHeaderGroups()], (n) => [...n].reverse(), Oe(e.options, Ht, "getFooterGroups")), e.getLeftFooterGroups = Fe(() => [e.getLeftHeaderGroups()], (n) => [...n].reverse(), Oe(e.options, Ht, "getLeftFooterGroups")), e.getCenterFooterGroups = Fe(() => [e.getCenterHeaderGroups()], (n) => [...n].reverse(), Oe(e.options, Ht, "getCenterFooterGroups")), e.getRightFooterGroups = Fe(() => [e.getRightHeaderGroups()], (n) => [...n].reverse(), Oe(e.options, Ht, "getRightFooterGroups")), e.getFlatHeaders = Fe(() => [e.getHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Oe(e.options, Ht, "getFlatHeaders")), e.getLeftFlatHeaders = Fe(() => [e.getLeftHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Oe(e.options, Ht, "getLeftFlatHeaders")), e.getCenterFlatHeaders = Fe(() => [e.getCenterHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Oe(e.options, Ht, "getCenterFlatHeaders")), e.getRightFlatHeaders = Fe(() => [e.getRightHeaderGroups()], (n) => n.map((t) => t.headers).flat(), Oe(e.options, Ht, "getRightFlatHeaders")), e.getCenterLeafHeaders = Fe(() => [e.getCenterFlatHeaders()], (n) => n.filter((t) => {
      var r;
      return !((r = t.subHeaders) != null && r.length);
    }), Oe(e.options, Ht, "getCenterLeafHeaders")), e.getLeftLeafHeaders = Fe(() => [e.getLeftFlatHeaders()], (n) => n.filter((t) => {
      var r;
      return !((r = t.subHeaders) != null && r.length);
    }), Oe(e.options, Ht, "getLeftLeafHeaders")), e.getRightLeafHeaders = Fe(() => [e.getRightFlatHeaders()], (n) => n.filter((t) => {
      var r;
      return !((r = t.subHeaders) != null && r.length);
    }), Oe(e.options, Ht, "getRightLeafHeaders")), e.getLeafHeaders = Fe(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (n, t, r) => {
      var i, o, a, c, d, p;
      return [...(i = (o = n[0]) == null ? void 0 : o.headers) != null ? i : [], ...(a = (c = t[0]) == null ? void 0 : c.headers) != null ? a : [], ...(d = (p = r[0]) == null ? void 0 : p.headers) != null ? d : []].map((m) => m.getLeafHeaders()).flat();
    }, Oe(e.options, Ht, "getLeafHeaders"));
  }
};
function $o(e, n, t, r) {
  var i, o;
  let a = 0;
  const c = function(y, _) {
    _ === void 0 && (_ = 1), a = Math.max(a, _), y.filter((S) => S.getIsVisible()).forEach((S) => {
      var E;
      (E = S.columns) != null && E.length && c(S.columns, _ + 1);
    }, 0);
  };
  c(e);
  let d = [];
  const p = (y, _) => {
    const S = {
      depth: _,
      id: [r, `${_}`].filter(Boolean).join("_"),
      headers: []
    }, E = [];
    y.forEach((Y) => {
      const N = [...E].reverse()[0], I = Y.column.depth === S.depth;
      let Q, te = !1;
      if (I && Y.column.parent ? Q = Y.column.parent : (Q = Y.column, te = !0), N && (N == null ? void 0 : N.column) === Q)
        N.subHeaders.push(Y);
      else {
        const ie = ip(t, Q, {
          id: [r, _, Q.id, Y == null ? void 0 : Y.id].filter(Boolean).join("_"),
          isPlaceholder: te,
          placeholderId: te ? `${E.filter((ne) => ne.column === Q).length}` : void 0,
          depth: _,
          index: E.length
        });
        ie.subHeaders.push(Y), E.push(ie);
      }
      S.headers.push(Y), Y.headerGroup = S;
    }), d.push(S), _ > 0 && p(E, _ - 1);
  }, m = n.map((y, _) => ip(t, y, {
    depth: a,
    index: _
  }));
  p(m, a - 1), d.reverse();
  const v = (y) => y.filter((S) => S.column.getIsVisible()).map((S) => {
    let E = 0, Y = 0, N = [0];
    S.subHeaders && S.subHeaders.length ? (N = [], v(S.subHeaders).forEach((Q) => {
      let {
        colSpan: te,
        rowSpan: ie
      } = Q;
      E += te, N.push(ie);
    })) : E = 1;
    const I = Math.min(...N);
    return Y = Y + I, S.colSpan = E, S.rowSpan = Y, {
      colSpan: E,
      rowSpan: Y
    };
  });
  return v((i = (o = d[0]) == null ? void 0 : o.headers) != null ? i : []), d;
}
const V$ = (e, n, t, r, i, o, a) => {
  let c = {
    id: n,
    index: r,
    original: t,
    depth: i,
    parentId: a,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (d) => {
      if (c._valuesCache.hasOwnProperty(d))
        return c._valuesCache[d];
      const p = e.getColumn(d);
      if (p != null && p.accessorFn)
        return c._valuesCache[d] = p.accessorFn(c.original, r), c._valuesCache[d];
    },
    getUniqueValues: (d) => {
      if (c._uniqueValuesCache.hasOwnProperty(d))
        return c._uniqueValuesCache[d];
      const p = e.getColumn(d);
      if (p != null && p.accessorFn)
        return p.columnDef.getUniqueValues ? (c._uniqueValuesCache[d] = p.columnDef.getUniqueValues(c.original, r), c._uniqueValuesCache[d]) : (c._uniqueValuesCache[d] = [c.getValue(d)], c._uniqueValuesCache[d]);
    },
    renderValue: (d) => {
      var p;
      return (p = c.getValue(d)) != null ? p : e.options.renderFallbackValue;
    },
    subRows: o ?? [],
    getLeafRows: () => O$(c.subRows, (d) => d.subRows),
    getParentRow: () => c.parentId ? e.getRow(c.parentId, !0) : void 0,
    getParentRows: () => {
      let d = [], p = c;
      for (; ; ) {
        const m = p.getParentRow();
        if (!m)
          break;
        d.push(m), p = m;
      }
      return d.reverse();
    },
    getAllCells: Fe(() => [e.getAllLeafColumns()], (d) => d.map((p) => L$(e, c, p, p.id)), Oe(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: Fe(() => [c.getAllCells()], (d) => d.reduce((p, m) => (p[m.column.id] = m, p), {}), Oe(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let d = 0; d < e._features.length; d++) {
    const p = e._features[d];
    p == null || p.createRow == null || p.createRow(c, e);
  }
  return c;
}, Y$ = {
  createColumn: (e, n) => {
    e._getFacetedRowModel = n.options.getFacetedRowModel && n.options.getFacetedRowModel(n, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : n.getPreFilteredRowModel(), e._getFacetedUniqueValues = n.options.getFacetedUniqueValues && n.options.getFacetedUniqueValues(n, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = n.options.getFacetedMinMaxValues && n.options.getFacetedMinMaxValues(n, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Mg = (e, n, t) => {
  var r;
  const i = t.toLowerCase();
  return !!(!((r = e.getValue(n)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
Mg.autoRemove = (e) => Cr(e);
const $g = (e, n, t) => {
  var r;
  return !!(!((r = e.getValue(n)) == null || (r = r.toString()) == null) && r.includes(t));
};
$g.autoRemove = (e) => Cr(e);
const Tg = (e, n, t) => {
  var r;
  return ((r = e.getValue(n)) == null || (r = r.toString()) == null ? void 0 : r.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
Tg.autoRemove = (e) => Cr(e);
const Ig = (e, n, t) => {
  var r;
  return (r = e.getValue(n)) == null ? void 0 : r.includes(t);
};
Ig.autoRemove = (e) => Cr(e) || !(e != null && e.length);
const Rg = (e, n, t) => !t.some((r) => {
  var i;
  return !((i = e.getValue(n)) != null && i.includes(r));
});
Rg.autoRemove = (e) => Cr(e) || !(e != null && e.length);
const Ag = (e, n, t) => t.some((r) => {
  var i;
  return (i = e.getValue(n)) == null ? void 0 : i.includes(r);
});
Ag.autoRemove = (e) => Cr(e) || !(e != null && e.length);
const Fg = (e, n, t) => e.getValue(n) === t;
Fg.autoRemove = (e) => Cr(e);
const Og = (e, n, t) => e.getValue(n) == t;
Og.autoRemove = (e) => Cr(e);
const Su = (e, n, t) => {
  let [r, i] = t;
  const o = e.getValue(n);
  return o >= r && o <= i;
};
Su.resolveFilterValue = (e) => {
  let [n, t] = e, r = typeof n != "number" ? parseFloat(n) : n, i = typeof t != "number" ? parseFloat(t) : t, o = n === null || Number.isNaN(r) ? -1 / 0 : r, a = t === null || Number.isNaN(i) ? 1 / 0 : i;
  if (o > a) {
    const c = o;
    o = a, a = c;
  }
  return [o, a];
};
Su.autoRemove = (e) => Cr(e) || Cr(e[0]) && Cr(e[1]);
const Zr = {
  includesString: Mg,
  includesStringSensitive: $g,
  equalsString: Tg,
  arrIncludes: Ig,
  arrIncludesAll: Rg,
  arrIncludesSome: Ag,
  equals: Fg,
  weakEquals: Og,
  inNumberRange: Su
};
function Cr(e) {
  return e == null || e === "";
}
const H$ = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: ur("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, n) => {
    e.getAutoFilterFn = () => {
      const t = n.getCoreRowModel().flatRows[0], r = t == null ? void 0 : t.getValue(e.id);
      return typeof r == "string" ? Zr.includesString : typeof r == "number" ? Zr.inNumberRange : typeof r == "boolean" || r !== null && typeof r == "object" ? Zr.equals : Array.isArray(r) ? Zr.arrIncludes : Zr.weakEquals;
    }, e.getFilterFn = () => {
      var t, r;
      return Ga(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (r = n.options.filterFns) == null ? void 0 : r[e.columnDef.filterFn]) != null ? t : Zr[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, r, i;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((r = n.options.enableColumnFilters) != null ? r : !0) && ((i = n.options.enableFilters) != null ? i : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = n.getState().columnFilters) == null || (t = t.find((r) => r.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, r;
      return (t = (r = n.getState().columnFilters) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      n.setColumnFilters((r) => {
        const i = e.getFilterFn(), o = r == null ? void 0 : r.find((m) => m.id === e.id), a = Mn(t, o ? o.value : void 0);
        if (sp(i, a, e)) {
          var c;
          return (c = r == null ? void 0 : r.filter((m) => m.id !== e.id)) != null ? c : [];
        }
        const d = {
          id: e.id,
          value: a
        };
        if (o) {
          var p;
          return (p = r == null ? void 0 : r.map((m) => m.id === e.id ? d : m)) != null ? p : [];
        }
        return r != null && r.length ? [...r, d] : [d];
      });
    };
  },
  createRow: (e, n) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (n) => {
      const t = e.getAllLeafColumns(), r = (i) => {
        var o;
        return (o = Mn(n, i)) == null ? void 0 : o.filter((a) => {
          const c = t.find((d) => d.id === a.id);
          if (c) {
            const d = c.getFilterFn();
            if (sp(d, a.value, c))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(r);
    }, e.resetColumnFilters = (n) => {
      var t, r;
      e.setColumnFilters(n ? [] : (t = (r = e.initialState) == null ? void 0 : r.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function sp(e, n, t) {
  return (e && e.autoRemove ? e.autoRemove(n, t) : !1) || typeof n > "u" || typeof n == "string" && !n;
}
const B$ = (e, n, t) => t.reduce((r, i) => {
  const o = i.getValue(e);
  return r + (typeof o == "number" ? o : 0);
}, 0), W$ = (e, n, t) => {
  let r;
  return t.forEach((i) => {
    const o = i.getValue(e);
    o != null && (r > o || r === void 0 && o >= o) && (r = o);
  }), r;
}, j$ = (e, n, t) => {
  let r;
  return t.forEach((i) => {
    const o = i.getValue(e);
    o != null && (r < o || r === void 0 && o >= o) && (r = o);
  }), r;
}, G$ = (e, n, t) => {
  let r, i;
  return t.forEach((o) => {
    const a = o.getValue(e);
    a != null && (r === void 0 ? a >= a && (r = i = a) : (r > a && (r = a), i < a && (i = a)));
  }), [r, i];
}, q$ = (e, n) => {
  let t = 0, r = 0;
  if (n.forEach((i) => {
    let o = i.getValue(e);
    o != null && (o = +o) >= o && (++t, r += o);
  }), t)
    return r / t;
}, K$ = (e, n) => {
  if (!n.length)
    return;
  const t = n.map((o) => o.getValue(e));
  if (!F$(t))
    return;
  if (t.length === 1)
    return t[0];
  const r = Math.floor(t.length / 2), i = t.sort((o, a) => o - a);
  return t.length % 2 !== 0 ? i[r] : (i[r - 1] + i[r]) / 2;
}, U$ = (e, n) => Array.from(new Set(n.map((t) => t.getValue(e))).values()), Q$ = (e, n) => new Set(n.map((t) => t.getValue(e))).size, X$ = (e, n) => n.length, Al = {
  sum: B$,
  min: W$,
  max: j$,
  extent: G$,
  mean: q$,
  median: K$,
  unique: U$,
  uniqueCount: Q$,
  count: X$
}, Z$ = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var n, t;
      return (n = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? n : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: ur("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, n) => {
    e.toggleGrouping = () => {
      n.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((r) => r !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, r;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((r = n.options.enableGrouping) != null ? r : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = n.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = n.getCoreRowModel().flatRows[0], r = t == null ? void 0 : t.getValue(e.id);
      if (typeof r == "number")
        return Al.sum;
      if (Object.prototype.toString.call(r) === "[object Date]")
        return Al.extent;
    }, e.getAggregationFn = () => {
      var t, r;
      if (!e)
        throw new Error();
      return Ga(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (r = n.options.aggregationFns) == null ? void 0 : r[e.columnDef.aggregationFn]) != null ? t : Al[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (n) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(n), e.resetGrouping = (n) => {
      var t, r;
      e.setGrouping(n ? [] : (t = (r = e.initialState) == null ? void 0 : r.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, n) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const r = n.getColumn(t);
      return r != null && r.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = r.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, n, t, r) => {
    e.getIsGrouped = () => n.getIsGrouped() && n.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && n.getIsGrouped(), e.getIsAggregated = () => {
      var i;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((i = t.subRows) != null && i.length);
    };
  }
};
function J$(e, n, t) {
  if (!(n != null && n.length) || !t)
    return e;
  const r = e.filter((o) => !n.includes(o.id));
  return t === "remove" ? r : [...n.map((o) => e.find((a) => a.id === o)).filter(Boolean), ...r];
}
const eT = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: ur("columnOrder", e)
  }),
  createColumn: (e, n) => {
    e.getIndex = Fe((t) => [Fs(n, t)], (t) => t.findIndex((r) => r.id === e.id), Oe(n.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var r;
      return ((r = Fs(n, t)[0]) == null ? void 0 : r.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var r;
      const i = Fs(n, t);
      return ((r = i[i.length - 1]) == null ? void 0 : r.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (n) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(n), e.resetColumnOrder = (n) => {
      var t;
      e.setColumnOrder(n ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = Fe(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (n, t, r) => (i) => {
      let o = [];
      if (!(n != null && n.length))
        o = i;
      else {
        const a = [...n], c = [...i];
        for (; c.length && a.length; ) {
          const d = a.shift(), p = c.findIndex((m) => m.id === d);
          p > -1 && o.push(c.splice(p, 1)[0]);
        }
        o = [...o, ...c];
      }
      return J$(o, t, r);
    }, Oe(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Fl = () => ({
  left: [],
  right: []
}), tT = {
  getInitialState: (e) => ({
    columnPinning: Fl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: ur("columnPinning", e)
  }),
  createColumn: (e, n) => {
    e.pin = (t) => {
      const r = e.getLeafColumns().map((i) => i.id).filter(Boolean);
      n.setColumnPinning((i) => {
        var o, a;
        if (t === "right") {
          var c, d;
          return {
            left: ((c = i == null ? void 0 : i.left) != null ? c : []).filter((v) => !(r != null && r.includes(v))),
            right: [...((d = i == null ? void 0 : i.right) != null ? d : []).filter((v) => !(r != null && r.includes(v))), ...r]
          };
        }
        if (t === "left") {
          var p, m;
          return {
            left: [...((p = i == null ? void 0 : i.left) != null ? p : []).filter((v) => !(r != null && r.includes(v))), ...r],
            right: ((m = i == null ? void 0 : i.right) != null ? m : []).filter((v) => !(r != null && r.includes(v)))
          };
        }
        return {
          left: ((o = i == null ? void 0 : i.left) != null ? o : []).filter((v) => !(r != null && r.includes(v))),
          right: ((a = i == null ? void 0 : i.right) != null ? a : []).filter((v) => !(r != null && r.includes(v)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((r) => {
      var i, o, a;
      return ((i = r.columnDef.enablePinning) != null ? i : !0) && ((o = (a = n.options.enableColumnPinning) != null ? a : n.options.enablePinning) != null ? o : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((c) => c.id), {
        left: r,
        right: i
      } = n.getState().columnPinning, o = t.some((c) => r == null ? void 0 : r.includes(c)), a = t.some((c) => i == null ? void 0 : i.includes(c));
      return o ? "left" : a ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, r;
      const i = e.getIsPinned();
      return i ? (t = (r = n.getState().columnPinning) == null || (r = r[i]) == null ? void 0 : r.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, n) => {
    e.getCenterVisibleCells = Fe(() => [e._getAllVisibleCells(), n.getState().columnPinning.left, n.getState().columnPinning.right], (t, r, i) => {
      const o = [...r ?? [], ...i ?? []];
      return t.filter((a) => !o.includes(a.column.id));
    }, Oe(n.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = Fe(() => [e._getAllVisibleCells(), n.getState().columnPinning.left], (t, r) => (r ?? []).map((o) => t.find((a) => a.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "left"
    })), Oe(n.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = Fe(() => [e._getAllVisibleCells(), n.getState().columnPinning.right], (t, r) => (r ?? []).map((o) => t.find((a) => a.column.id === o)).filter(Boolean).map((o) => ({
      ...o,
      position: "right"
    })), Oe(n.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (n) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(n), e.resetColumnPinning = (n) => {
      var t, r;
      return e.setColumnPinning(n ? Fl() : (t = (r = e.initialState) == null ? void 0 : r.columnPinning) != null ? t : Fl());
    }, e.getIsSomeColumnsPinned = (n) => {
      var t;
      const r = e.getState().columnPinning;
      if (!n) {
        var i, o;
        return !!((i = r.left) != null && i.length || (o = r.right) != null && o.length);
      }
      return !!((t = r[n]) != null && t.length);
    }, e.getLeftLeafColumns = Fe(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (n, t) => (t ?? []).map((r) => n.find((i) => i.id === r)).filter(Boolean), Oe(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = Fe(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (n, t) => (t ?? []).map((r) => n.find((i) => i.id === r)).filter(Boolean), Oe(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = Fe(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, t, r) => {
      const i = [...t ?? [], ...r ?? []];
      return n.filter((o) => !i.includes(o.id));
    }, Oe(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, To = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Ol = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), rT = {
  getDefaultColumnDef: () => To,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: Ol(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: ur("columnSizing", e),
    onColumnSizingInfoChange: ur("columnSizingInfo", e)
  }),
  createColumn: (e, n) => {
    e.getSize = () => {
      var t, r, i;
      const o = n.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : To.minSize, (r = o ?? e.columnDef.size) != null ? r : To.size), (i = e.columnDef.maxSize) != null ? i : To.maxSize);
    }, e.getStart = Fe((t) => [t, Fs(n, t), n.getState().columnSizing], (t, r) => r.slice(0, e.getIndex(t)).reduce((i, o) => i + o.getSize(), 0), Oe(n.options, "debugColumns", "getStart")), e.getAfter = Fe((t) => [t, Fs(n, t), n.getState().columnSizing], (t, r) => r.slice(e.getIndex(t) + 1).reduce((i, o) => i + o.getSize(), 0), Oe(n.options, "debugColumns", "getAfter")), e.resetSize = () => {
      n.setColumnSizing((t) => {
        let {
          [e.id]: r,
          ...i
        } = t;
        return i;
      });
    }, e.getCanResize = () => {
      var t, r;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((r = n.options.enableColumnResizing) != null ? r : !0);
    }, e.getIsResizing = () => n.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, n) => {
    e.getSize = () => {
      let t = 0;
      const r = (i) => {
        if (i.subHeaders.length)
          i.subHeaders.forEach(r);
        else {
          var o;
          t += (o = i.column.getSize()) != null ? o : 0;
        }
      };
      return r(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const r = n.getColumn(e.column.id), i = r == null ? void 0 : r.getCanResize();
      return (o) => {
        if (!r || !i || (o.persist == null || o.persist(), Ll(o) && o.touches && o.touches.length > 1))
          return;
        const a = e.getSize(), c = e ? e.getLeafHeaders().map((N) => [N.column.id, N.column.getSize()]) : [[r.id, r.getSize()]], d = Ll(o) ? Math.round(o.touches[0].clientX) : o.clientX, p = {}, m = (N, I) => {
          typeof I == "number" && (n.setColumnSizingInfo((Q) => {
            var te, ie;
            const ne = n.options.columnResizeDirection === "rtl" ? -1 : 1, re = (I - ((te = Q == null ? void 0 : Q.startOffset) != null ? te : 0)) * ne, ce = Math.max(re / ((ie = Q == null ? void 0 : Q.startSize) != null ? ie : 0), -0.999999);
            return Q.columnSizingStart.forEach((de) => {
              let [ge, $e] = de;
              p[ge] = Math.round(Math.max($e + $e * ce, 0) * 100) / 100;
            }), {
              ...Q,
              deltaOffset: re,
              deltaPercentage: ce
            };
          }), (n.options.columnResizeMode === "onChange" || N === "end") && n.setColumnSizing((Q) => ({
            ...Q,
            ...p
          })));
        }, v = (N) => m("move", N), y = (N) => {
          m("end", N), n.setColumnSizingInfo((I) => ({
            ...I,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, _ = t || typeof document < "u" ? document : null, S = {
          moveHandler: (N) => v(N.clientX),
          upHandler: (N) => {
            _ == null || _.removeEventListener("mousemove", S.moveHandler), _ == null || _.removeEventListener("mouseup", S.upHandler), y(N.clientX);
          }
        }, E = {
          moveHandler: (N) => (N.cancelable && (N.preventDefault(), N.stopPropagation()), v(N.touches[0].clientX), !1),
          upHandler: (N) => {
            var I;
            _ == null || _.removeEventListener("touchmove", E.moveHandler), _ == null || _.removeEventListener("touchend", E.upHandler), N.cancelable && (N.preventDefault(), N.stopPropagation()), y((I = N.touches[0]) == null ? void 0 : I.clientX);
          }
        }, Y = nT() ? {
          passive: !1
        } : !1;
        Ll(o) ? (_ == null || _.addEventListener("touchmove", E.moveHandler, Y), _ == null || _.addEventListener("touchend", E.upHandler, Y)) : (_ == null || _.addEventListener("mousemove", S.moveHandler, Y), _ == null || _.addEventListener("mouseup", S.upHandler, Y)), n.setColumnSizingInfo((N) => ({
          ...N,
          startOffset: d,
          startSize: a,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: c,
          isResizingColumn: r.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (n) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(n), e.setColumnSizingInfo = (n) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(n), e.resetColumnSizing = (n) => {
      var t;
      e.setColumnSizing(n ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (n) => {
      var t;
      e.setColumnSizingInfo(n ? Ol() : (t = e.initialState.columnSizingInfo) != null ? t : Ol());
    }, e.getTotalSize = () => {
      var n, t;
      return (n = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? n : 0;
    }, e.getLeftTotalSize = () => {
      var n, t;
      return (n = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? n : 0;
    }, e.getCenterTotalSize = () => {
      var n, t;
      return (n = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? n : 0;
    }, e.getRightTotalSize = () => {
      var n, t;
      return (n = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((r, i) => r + i.getSize(), 0)) != null ? n : 0;
    };
  }
};
let Io = null;
function nT() {
  if (typeof Io == "boolean")
    return Io;
  let e = !1;
  try {
    const n = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, n), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return Io = e, Io;
}
function Ll(e) {
  return e.type === "touchstart";
}
const iT = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: ur("columnVisibility", e)
  }),
  createColumn: (e, n) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && n.setColumnVisibility((r) => ({
        ...r,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, r;
      const i = e.columns;
      return (t = i.length ? i.some((o) => o.getIsVisible()) : (r = n.getState().columnVisibility) == null ? void 0 : r[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, r;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((r = n.options.enableHiding) != null ? r : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, n) => {
    e._getAllVisibleCells = Fe(() => [e.getAllCells(), n.getState().columnVisibility], (t) => t.filter((r) => r.column.getIsVisible()), Oe(n.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = Fe(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, r, i) => [...t, ...r, ...i], Oe(n.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const n = (t, r) => Fe(() => [r(), r().filter((i) => i.getIsVisible()).map((i) => i.id).join("_")], (i) => i.filter((o) => o.getIsVisible == null ? void 0 : o.getIsVisible()), Oe(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = n("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = n("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = n("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = n("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = n("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var r;
      e.setColumnVisibility(t ? {} : (r = e.initialState.columnVisibility) != null ? r : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var r;
      t = (r = t) != null ? r : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((i, o) => ({
        ...i,
        [o.id]: t || !(o.getCanHide != null && o.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var r;
      e.toggleAllColumnsVisible((r = t.target) == null ? void 0 : r.checked);
    };
  }
};
function Fs(e, n) {
  return n ? n === "center" ? e.getCenterVisibleLeafColumns() : n === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const sT = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, oT = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: ur("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (n) => {
      var t;
      const r = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[n.id]) == null ? void 0 : t.getValue();
      return typeof r == "string" || typeof r == "number";
    }
  }),
  createColumn: (e, n) => {
    e.getCanGlobalFilter = () => {
      var t, r, i, o;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((r = n.options.enableGlobalFilter) != null ? r : !0) && ((i = n.options.enableFilters) != null ? i : !0) && ((o = n.options.getColumnCanGlobalFilter == null ? void 0 : n.options.getColumnCanGlobalFilter(e)) != null ? o : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Zr.includesString, e.getGlobalFilterFn = () => {
      var n, t;
      const {
        globalFilterFn: r
      } = e.options;
      return Ga(r) ? r : r === "auto" ? e.getGlobalAutoFilterFn() : (n = (t = e.options.filterFns) == null ? void 0 : t[r]) != null ? n : Zr[r];
    }, e.setGlobalFilter = (n) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(n);
    }, e.resetGlobalFilter = (n) => {
      e.setGlobalFilter(n ? void 0 : e.initialState.globalFilter);
    };
  }
}, aT = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: ur("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetExpanded = () => {
      var r, i;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetExpanded) != null ? r : !e.options.manualExpanding) {
        if (t)
          return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (r) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(r), e.toggleAllRowsExpanded = (r) => {
      r ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (r) => {
      var i, o;
      e.setExpanded(r ? {} : (i = (o = e.initialState) == null ? void 0 : o.expanded) != null ? i : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((r) => r.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (r) => {
      r.persist == null || r.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const r = e.getState().expanded;
      return r === !0 || Object.values(r).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const r = e.getState().expanded;
      return typeof r == "boolean" ? r === !0 : !(!Object.keys(r).length || e.getRowModel().flatRows.some((i) => !i.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let r = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((o) => {
        const a = o.split(".");
        r = Math.max(r, a.length);
      }), r;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, n) => {
    e.toggleExpanded = (t) => {
      n.setExpanded((r) => {
        var i;
        const o = r === !0 ? !0 : !!(r != null && r[e.id]);
        let a = {};
        if (r === !0 ? Object.keys(n.getRowModel().rowsById).forEach((c) => {
          a[c] = !0;
        }) : a = r, t = (i = t) != null ? i : !o, !o && t)
          return {
            ...a,
            [e.id]: !0
          };
        if (o && !t) {
          const {
            [e.id]: c,
            ...d
          } = a;
          return d;
        }
        return r;
      });
    }, e.getIsExpanded = () => {
      var t;
      const r = n.getState().expanded;
      return !!((t = n.options.getIsRowExpanded == null ? void 0 : n.options.getIsRowExpanded(e)) != null ? t : r === !0 || r != null && r[e.id]);
    }, e.getCanExpand = () => {
      var t, r, i;
      return (t = n.options.getRowCanExpand == null ? void 0 : n.options.getRowCanExpand(e)) != null ? t : ((r = n.options.enableExpanding) != null ? r : !0) && !!((i = e.subRows) != null && i.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, r = e;
      for (; t && r.parentId; )
        r = n.getRow(r.parentId, !0), t = r.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, wc = 0, xc = 10, Nl = () => ({
  pageIndex: wc,
  pageSize: xc
}), lT = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Nl(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: ur("pagination", e)
  }),
  createTable: (e) => {
    let n = !1, t = !1;
    e._autoResetPageIndex = () => {
      var r, i;
      if (!n) {
        e._queue(() => {
          n = !0;
        });
        return;
      }
      if ((r = (i = e.options.autoResetAll) != null ? i : e.options.autoResetPageIndex) != null ? r : !e.options.manualPagination) {
        if (t)
          return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (r) => {
      const i = (o) => Mn(r, o);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(i);
    }, e.resetPagination = (r) => {
      var i;
      e.setPagination(r ? Nl() : (i = e.initialState.pagination) != null ? i : Nl());
    }, e.setPageIndex = (r) => {
      e.setPagination((i) => {
        let o = Mn(r, i.pageIndex);
        const a = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return o = Math.max(0, Math.min(o, a)), {
          ...i,
          pageIndex: o
        };
      });
    }, e.resetPageIndex = (r) => {
      var i, o;
      e.setPageIndex(r ? wc : (i = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageIndex) != null ? i : wc);
    }, e.resetPageSize = (r) => {
      var i, o;
      e.setPageSize(r ? xc : (i = (o = e.initialState) == null || (o = o.pagination) == null ? void 0 : o.pageSize) != null ? i : xc);
    }, e.setPageSize = (r) => {
      e.setPagination((i) => {
        const o = Math.max(1, Mn(r, i.pageSize)), a = i.pageSize * i.pageIndex, c = Math.floor(a / o);
        return {
          ...i,
          pageIndex: c,
          pageSize: o
        };
      });
    }, e.setPageCount = (r) => e.setPagination((i) => {
      var o;
      let a = Mn(r, (o = e.options.pageCount) != null ? o : -1);
      return typeof a == "number" && (a = Math.max(-1, a)), {
        ...i,
        pageCount: a
      };
    }), e.getPageOptions = Fe(() => [e.getPageCount()], (r) => {
      let i = [];
      return r && r > 0 && (i = [...new Array(r)].fill(null).map((o, a) => a)), i;
    }, Oe(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: r
      } = e.getState().pagination, i = e.getPageCount();
      return i === -1 ? !0 : i === 0 ? !1 : r < i - 1;
    }, e.previousPage = () => e.setPageIndex((r) => r - 1), e.nextPage = () => e.setPageIndex((r) => r + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var r;
      return (r = e.options.pageCount) != null ? r : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var r;
      return (r = e.options.rowCount) != null ? r : e.getPrePaginationRowModel().rows.length;
    };
  }
}, zl = () => ({
  top: [],
  bottom: []
}), cT = {
  getInitialState: (e) => ({
    rowPinning: zl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: ur("rowPinning", e)
  }),
  createRow: (e, n) => {
    e.pin = (t, r, i) => {
      const o = r ? e.getLeafRows().map((d) => {
        let {
          id: p
        } = d;
        return p;
      }) : [], a = i ? e.getParentRows().map((d) => {
        let {
          id: p
        } = d;
        return p;
      }) : [], c = /* @__PURE__ */ new Set([...a, e.id, ...o]);
      n.setRowPinning((d) => {
        var p, m;
        if (t === "bottom") {
          var v, y;
          return {
            top: ((v = d == null ? void 0 : d.top) != null ? v : []).filter((E) => !(c != null && c.has(E))),
            bottom: [...((y = d == null ? void 0 : d.bottom) != null ? y : []).filter((E) => !(c != null && c.has(E))), ...Array.from(c)]
          };
        }
        if (t === "top") {
          var _, S;
          return {
            top: [...((_ = d == null ? void 0 : d.top) != null ? _ : []).filter((E) => !(c != null && c.has(E))), ...Array.from(c)],
            bottom: ((S = d == null ? void 0 : d.bottom) != null ? S : []).filter((E) => !(c != null && c.has(E)))
          };
        }
        return {
          top: ((p = d == null ? void 0 : d.top) != null ? p : []).filter((E) => !(c != null && c.has(E))),
          bottom: ((m = d == null ? void 0 : d.bottom) != null ? m : []).filter((E) => !(c != null && c.has(E)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: r,
        enablePinning: i
      } = n.options;
      return typeof r == "function" ? r(e) : (t = r ?? i) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: r,
        bottom: i
      } = n.getState().rowPinning, o = t.some((c) => r == null ? void 0 : r.includes(c)), a = t.some((c) => i == null ? void 0 : i.includes(c));
      return o ? "top" : a ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, r;
      const i = e.getIsPinned();
      if (!i)
        return -1;
      const o = (t = n._getPinnedRows(i)) == null ? void 0 : t.map((a) => {
        let {
          id: c
        } = a;
        return c;
      });
      return (r = o == null ? void 0 : o.indexOf(e.id)) != null ? r : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (n) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(n), e.resetRowPinning = (n) => {
      var t, r;
      return e.setRowPinning(n ? zl() : (t = (r = e.initialState) == null ? void 0 : r.rowPinning) != null ? t : zl());
    }, e.getIsSomeRowsPinned = (n) => {
      var t;
      const r = e.getState().rowPinning;
      if (!n) {
        var i, o;
        return !!((i = r.top) != null && i.length || (o = r.bottom) != null && o.length);
      }
      return !!((t = r[n]) != null && t.length);
    }, e._getPinnedRows = Fe((n) => [e.getRowModel().rows, e.getState().rowPinning[n], n], (n, t, r) => {
      var i;
      return ((i = e.options.keepPinnedRows) == null || i ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((a) => {
          const c = e.getRow(a, !0);
          return c.getIsAllParentsExpanded() ? c : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((a) => n.find((c) => c.id === a))
      )).filter(Boolean).map((a) => ({
        ...a,
        position: r
      }));
    }, Oe(e.options, "debugRows", "_getPinnedRows")), e.getTopRows = () => e._getPinnedRows("top"), e.getBottomRows = () => e._getPinnedRows("bottom"), e.getCenterRows = Fe(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (n, t, r) => {
      const i = /* @__PURE__ */ new Set([...t ?? [], ...r ?? []]);
      return n.filter((o) => !i.has(o.id));
    }, Oe(e.options, "debugRows", "getCenterRows"));
  }
}, uT = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: ur("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (n) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(n), e.resetRowSelection = (n) => {
      var t;
      return e.setRowSelection(n ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (n) => {
      e.setRowSelection((t) => {
        n = typeof n < "u" ? n : !e.getIsAllRowsSelected();
        const r = {
          ...t
        }, i = e.getPreGroupedRowModel().flatRows;
        return n ? i.forEach((o) => {
          o.getCanSelect() && (r[o.id] = !0);
        }) : i.forEach((o) => {
          delete r[o.id];
        }), r;
      });
    }, e.toggleAllPageRowsSelected = (n) => e.setRowSelection((t) => {
      const r = typeof n < "u" ? n : !e.getIsAllPageRowsSelected(), i = {
        ...t
      };
      return e.getRowModel().rows.forEach((o) => {
        Sc(i, o.id, r, !0, e);
      }), i;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = Fe(() => [e.getState().rowSelection, e.getCoreRowModel()], (n, t) => Object.keys(n).length ? Vl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Oe(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = Fe(() => [e.getState().rowSelection, e.getFilteredRowModel()], (n, t) => Object.keys(n).length ? Vl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Oe(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = Fe(() => [e.getState().rowSelection, e.getSortedRowModel()], (n, t) => Object.keys(n).length ? Vl(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, Oe(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const n = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let r = !!(n.length && Object.keys(t).length);
      return r && n.some((i) => i.getCanSelect() && !t[i.id]) && (r = !1), r;
    }, e.getIsAllPageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows.filter((i) => i.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let r = !!n.length;
      return r && n.some((i) => !t[i.id]) && (r = !1), r;
    }, e.getIsSomeRowsSelected = () => {
      var n;
      const t = Object.keys((n = e.getState().rowSelection) != null ? n : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const n = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : n.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (n) => {
      e.toggleAllRowsSelected(n.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (n) => {
      e.toggleAllPageRowsSelected(n.target.checked);
    };
  },
  createRow: (e, n) => {
    e.toggleSelected = (t, r) => {
      const i = e.getIsSelected();
      n.setRowSelection((o) => {
        var a;
        if (t = typeof t < "u" ? t : !i, e.getCanSelect() && i === t)
          return o;
        const c = {
          ...o
        };
        return Sc(c, e.id, t, (a = r == null ? void 0 : r.selectChildren) != null ? a : !0, n), c;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return ku(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return kc(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = n.getState();
      return kc(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof n.options.enableRowSelection == "function" ? n.options.enableRowSelection(e) : (t = n.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof n.options.enableSubRowSelection == "function" ? n.options.enableSubRowSelection(e) : (t = n.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof n.options.enableMultiRowSelection == "function" ? n.options.enableMultiRowSelection(e) : (t = n.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (r) => {
        var i;
        t && e.toggleSelected((i = r.target) == null ? void 0 : i.checked);
      };
    };
  }
}, Sc = (e, n, t, r, i) => {
  var o;
  const a = i.getRow(n, !0);
  t ? (a.getCanMultiSelect() || Object.keys(e).forEach((c) => delete e[c]), a.getCanSelect() && (e[n] = !0)) : delete e[n], r && (o = a.subRows) != null && o.length && a.getCanSelectSubRows() && a.subRows.forEach((c) => Sc(e, c.id, t, r, i));
};
function Vl(e, n) {
  const t = e.getState().rowSelection, r = [], i = {}, o = function(a, c) {
    return a.map((d) => {
      var p;
      const m = ku(d, t);
      if (m && (r.push(d), i[d.id] = d), (p = d.subRows) != null && p.length && (d = {
        ...d,
        subRows: o(d.subRows)
      }), m)
        return d;
    }).filter(Boolean);
  };
  return {
    rows: o(n.rows),
    flatRows: r,
    rowsById: i
  };
}
function ku(e, n) {
  var t;
  return (t = n[e.id]) != null ? t : !1;
}
function kc(e, n, t) {
  var r;
  if (!((r = e.subRows) != null && r.length))
    return !1;
  let i = !0, o = !1;
  return e.subRows.forEach((a) => {
    if (!(o && !i) && (a.getCanSelect() && (ku(a, n) ? o = !0 : i = !1), a.subRows && a.subRows.length)) {
      const c = kc(a, n);
      c === "all" ? o = !0 : (c === "some" && (o = !0), i = !1);
    }
  }), i ? "all" : o ? "some" : !1;
}
const Cc = /([0-9]+)/gm, dT = (e, n, t) => Lg(Hn(e.getValue(t)).toLowerCase(), Hn(n.getValue(t)).toLowerCase()), fT = (e, n, t) => Lg(Hn(e.getValue(t)), Hn(n.getValue(t))), pT = (e, n, t) => Cu(Hn(e.getValue(t)).toLowerCase(), Hn(n.getValue(t)).toLowerCase()), hT = (e, n, t) => Cu(Hn(e.getValue(t)), Hn(n.getValue(t))), gT = (e, n, t) => {
  const r = e.getValue(t), i = n.getValue(t);
  return r > i ? 1 : r < i ? -1 : 0;
}, mT = (e, n, t) => Cu(e.getValue(t), n.getValue(t));
function Cu(e, n) {
  return e === n ? 0 : e > n ? 1 : -1;
}
function Hn(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function Lg(e, n) {
  const t = e.split(Cc).filter(Boolean), r = n.split(Cc).filter(Boolean);
  for (; t.length && r.length; ) {
    const i = t.shift(), o = r.shift(), a = parseInt(i, 10), c = parseInt(o, 10), d = [a, c].sort();
    if (isNaN(d[0])) {
      if (i > o)
        return 1;
      if (o > i)
        return -1;
      continue;
    }
    if (isNaN(d[1]))
      return isNaN(a) ? -1 : 1;
    if (a > c)
      return 1;
    if (c > a)
      return -1;
  }
  return t.length - r.length;
}
const xs = {
  alphanumeric: dT,
  alphanumericCaseSensitive: fT,
  text: pT,
  textCaseSensitive: hT,
  datetime: gT,
  basic: mT
}, vT = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: ur("sorting", e),
    isMultiSortEvent: (n) => n.shiftKey
  }),
  createColumn: (e, n) => {
    e.getAutoSortingFn = () => {
      const t = n.getFilteredRowModel().flatRows.slice(10);
      let r = !1;
      for (const i of t) {
        const o = i == null ? void 0 : i.getValue(e.id);
        if (Object.prototype.toString.call(o) === "[object Date]")
          return xs.datetime;
        if (typeof o == "string" && (r = !0, o.split(Cc).length > 1))
          return xs.alphanumeric;
      }
      return r ? xs.text : xs.basic;
    }, e.getAutoSortDir = () => {
      const t = n.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, r;
      if (!e)
        throw new Error();
      return Ga(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (r = n.options.sortingFns) == null ? void 0 : r[e.columnDef.sortingFn]) != null ? t : xs[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, r) => {
      const i = e.getNextSortingOrder(), o = typeof t < "u" && t !== null;
      n.setSorting((a) => {
        const c = a == null ? void 0 : a.find((_) => _.id === e.id), d = a == null ? void 0 : a.findIndex((_) => _.id === e.id);
        let p = [], m, v = o ? t : i === "desc";
        if (a != null && a.length && e.getCanMultiSort() && r ? c ? m = "toggle" : m = "add" : a != null && a.length && d !== a.length - 1 ? m = "replace" : c ? m = "toggle" : m = "replace", m === "toggle" && (o || i || (m = "remove")), m === "add") {
          var y;
          p = [...a, {
            id: e.id,
            desc: v
          }], p.splice(0, p.length - ((y = n.options.maxMultiSortColCount) != null ? y : Number.MAX_SAFE_INTEGER));
        } else
          m === "toggle" ? p = a.map((_) => _.id === e.id ? {
            ..._,
            desc: v
          } : _) : m === "remove" ? p = a.filter((_) => _.id !== e.id) : p = [{
            id: e.id,
            desc: v
          }];
        return p;
      });
    }, e.getFirstSortDir = () => {
      var t, r;
      return ((t = (r = e.columnDef.sortDescFirst) != null ? r : n.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var r, i;
      const o = e.getFirstSortDir(), a = e.getIsSorted();
      return a ? a !== o && ((r = n.options.enableSortingRemoval) == null || r) && // If enableSortRemove, enable in general
      (!(t && (i = n.options.enableMultiRemove) != null) || i) ? !1 : a === "desc" ? "asc" : "desc" : o;
    }, e.getCanSort = () => {
      var t, r;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((r = n.options.enableSorting) != null ? r : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, r;
      return (t = (r = e.columnDef.enableMultiSort) != null ? r : n.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const r = (t = n.getState().sorting) == null ? void 0 : t.find((i) => i.id === e.id);
      return r ? r.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, r;
      return (t = (r = n.getState().sorting) == null ? void 0 : r.findIndex((i) => i.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      n.setSorting((t) => t != null && t.length ? t.filter((r) => r.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (r) => {
        t && (r.persist == null || r.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? n.options.isMultiSortEvent == null ? void 0 : n.options.isMultiSortEvent(r) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (n) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(n), e.resetSorting = (n) => {
      var t, r;
      e.setSorting(n ? [] : (t = (r = e.initialState) == null ? void 0 : r.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, _T = [
  z$,
  iT,
  eT,
  tT,
  Y$,
  H$,
  sT,
  //depends on ColumnFaceting
  oT,
  //depends on ColumnFiltering
  vT,
  Z$,
  //depends on RowSorting
  aT,
  lT,
  cT,
  uT,
  rT
];
function yT(e) {
  var n, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const r = [..._T, ...(n = e._features) != null ? n : []];
  let i = {
    _features: r
  };
  const o = i._features.reduce((y, _) => Object.assign(y, _.getDefaultOptions == null ? void 0 : _.getDefaultOptions(i)), {}), a = (y) => i.options.mergeOptions ? i.options.mergeOptions(o, y) : {
    ...o,
    ...y
  };
  let d = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  i._features.forEach((y) => {
    var _;
    d = (_ = y.getInitialState == null ? void 0 : y.getInitialState(d)) != null ? _ : d;
  });
  const p = [];
  let m = !1;
  const v = {
    _features: r,
    options: {
      ...o,
      ...e
    },
    initialState: d,
    _queue: (y) => {
      p.push(y), m || (m = !0, Promise.resolve().then(() => {
        for (; p.length; )
          p.shift()();
        m = !1;
      }).catch((_) => setTimeout(() => {
        throw _;
      })));
    },
    reset: () => {
      i.setState(i.initialState);
    },
    setOptions: (y) => {
      const _ = Mn(y, i.options);
      i.options = a(_);
    },
    getState: () => i.options.state,
    setState: (y) => {
      i.options.onStateChange == null || i.options.onStateChange(y);
    },
    _getRowId: (y, _, S) => {
      var E;
      return (E = i.options.getRowId == null ? void 0 : i.options.getRowId(y, _, S)) != null ? E : `${S ? [S.id, _].join(".") : _}`;
    },
    getCoreRowModel: () => (i._getCoreRowModel || (i._getCoreRowModel = i.options.getCoreRowModel(i)), i._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => i.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (y, _) => {
      let S = (_ ? i.getPrePaginationRowModel() : i.getRowModel()).rowsById[y];
      if (!S && (S = i.getCoreRowModel().rowsById[y], !S))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${y}`) : new Error();
      return S;
    },
    _getDefaultColumnDef: Fe(() => [i.options.defaultColumn], (y) => {
      var _;
      return y = (_ = y) != null ? _ : {}, {
        header: (S) => {
          const E = S.header.column.columnDef;
          return E.accessorKey ? E.accessorKey : E.accessorFn ? E.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (S) => {
          var E, Y;
          return (E = (Y = S.renderValue()) == null || Y.toString == null ? void 0 : Y.toString()) != null ? E : null;
        },
        ...i._features.reduce((S, E) => Object.assign(S, E.getDefaultColumnDef == null ? void 0 : E.getDefaultColumnDef()), {}),
        ...y
      };
    }, Oe(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => i.options.columns,
    getAllColumns: Fe(() => [i._getColumnDefs()], (y) => {
      const _ = function(S, E, Y) {
        return Y === void 0 && (Y = 0), S.map((N) => {
          const I = N$(i, N, Y, E), Q = N;
          return I.columns = Q.columns ? _(Q.columns, I, Y + 1) : [], I;
        });
      };
      return _(y);
    }, Oe(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: Fe(() => [i.getAllColumns()], (y) => y.flatMap((_) => _.getFlatColumns()), Oe(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: Fe(() => [i.getAllFlatColumns()], (y) => y.reduce((_, S) => (_[S.id] = S, _), {}), Oe(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: Fe(() => [i.getAllColumns(), i._getOrderColumnsFn()], (y, _) => {
      let S = y.flatMap((E) => E.getLeafColumns());
      return _(S);
    }, Oe(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (y) => {
      const _ = i._getAllFlatColumnsById()[y];
      return process.env.NODE_ENV !== "production" && !_ && console.error(`[Table] Column with id '${y}' does not exist.`), _;
    }
  };
  Object.assign(i, v);
  for (let y = 0; y < i._features.length; y++) {
    const _ = i._features[y];
    _ == null || _.createTable == null || _.createTable(i);
  }
  return i;
}
function bT() {
  return (e) => Fe(() => [e.options.data], (n) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, r = function(i, o, a) {
      o === void 0 && (o = 0);
      const c = [];
      for (let p = 0; p < i.length; p++) {
        const m = V$(e, e._getRowId(i[p], p, a), i[p], p, o, void 0, a == null ? void 0 : a.id);
        if (t.flatRows.push(m), t.rowsById[m.id] = m, c.push(m), e.options.getSubRows) {
          var d;
          m.originalSubRows = e.options.getSubRows(i[p], p), (d = m.originalSubRows) != null && d.length && (m.subRows = r(m.originalSubRows, o + 1, m));
        }
      }
      return c;
    };
    return t.rows = r(n), t;
  }, Oe(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function wT(e) {
  const n = [], t = (r) => {
    var i;
    n.push(r), (i = r.subRows) != null && i.length && r.getIsExpanded() && r.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: n,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function xT(e) {
  return (n) => Fe(() => [n.getState().pagination, n.getPrePaginationRowModel(), n.options.paginateExpandedRows ? void 0 : n.getState().expanded], (t, r) => {
    if (!r.rows.length)
      return r;
    const {
      pageSize: i,
      pageIndex: o
    } = t;
    let {
      rows: a,
      flatRows: c,
      rowsById: d
    } = r;
    const p = i * o, m = p + i;
    a = a.slice(p, m);
    let v;
    n.options.paginateExpandedRows ? v = {
      rows: a,
      flatRows: c,
      rowsById: d
    } : v = wT({
      rows: a,
      flatRows: c,
      rowsById: d
    }), v.flatRows = [];
    const y = (_) => {
      v.flatRows.push(_), _.subRows.length && _.subRows.forEach(y);
    };
    return v.rows.forEach(y), v;
  }, Oe(n.options, "debugTable", "getPaginationRowModel"));
}
function ST() {
  return (e) => Fe(() => [e.getState().sorting, e.getPreSortedRowModel()], (n, t) => {
    if (!t.rows.length || !(n != null && n.length))
      return t;
    const r = e.getState().sorting, i = [], o = r.filter((d) => {
      var p;
      return (p = e.getColumn(d.id)) == null ? void 0 : p.getCanSort();
    }), a = {};
    o.forEach((d) => {
      const p = e.getColumn(d.id);
      p && (a[d.id] = {
        sortUndefined: p.columnDef.sortUndefined,
        invertSorting: p.columnDef.invertSorting,
        sortingFn: p.getSortingFn()
      });
    });
    const c = (d) => {
      const p = d.map((m) => ({
        ...m
      }));
      return p.sort((m, v) => {
        for (let _ = 0; _ < o.length; _ += 1) {
          var y;
          const S = o[_], E = a[S.id], Y = (y = S == null ? void 0 : S.desc) != null ? y : !1;
          let N = 0;
          if (E.sortUndefined) {
            const I = m.getValue(S.id), Q = v.getValue(S.id), te = I === void 0, ie = Q === void 0;
            (te || ie) && (N = te && ie ? 0 : te ? E.sortUndefined : -E.sortUndefined);
          }
          if (N === 0 && (N = E.sortingFn(m, v, S.id)), N !== 0)
            return Y && (N *= -1), E.invertSorting && (N *= -1), N;
        }
        return m.index - v.index;
      }), p.forEach((m) => {
        var v;
        i.push(m), (v = m.subRows) != null && v.length && (m.subRows = c(m.subRows));
      }), p;
    };
    return {
      rows: c(t.rows),
      flatRows: i,
      rowsById: t.rowsById
    };
  }, Oe(e.options, "debugTable", "getSortedRowModel", () => e._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Dc(e, n) {
  return e ? kT(e) ? /* @__PURE__ */ se.createElement(e, n) : e : null;
}
function kT(e) {
  return CT(e) || typeof e == "function" || DT(e);
}
function CT(e) {
  return typeof e == "function" && (() => {
    const n = Object.getPrototypeOf(e);
    return n.prototype && n.prototype.isReactComponent;
  })();
}
function DT(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function ET(e) {
  const n = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = se.useState(() => ({
    current: yT(n)
  })), [r, i] = se.useState(() => t.current.initialState);
  return t.current.setOptions((o) => ({
    ...o,
    ...e,
    state: {
      ...r,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (a) => {
      i(a), e.onStateChange == null || e.onStateChange(a);
    }
  })), t.current;
}
const PT = W.button`
  ${Gn}
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_xs);
  font-size: var(--cc_size_text_s);
  font-weight: 600;
  text-align: start;
  color: ${(e) => e.$isInactive ? "var(--cc_color_link_subtle)" : "var(--cc_color_link_secondary)"};
`, MT = W.span`
  flex: 1;
`, $T = W.i`
  flex-shrink: 0;
  font-size: var(--cc_size_text_m);
`, TT = ({
  header: e
}) => {
  const n = e.column.getIsSorted() || "false", t = {
    asc: "arrow-up-thin",
    desc: "arrow-down-thin",
    false: "swap-vertical"
  };
  return /* @__PURE__ */ pe(
    PT,
    {
      onClick: e.column.getToggleSortingHandler(),
      $isInactive: n === "false",
      children: [
        /* @__PURE__ */ L(MT, { children: e.isPlaceholder ? null : Dc(e.column.columnDef.header, e.getContext()) }),
        /* @__PURE__ */ L(
          $T,
          {
            role: "presentation",
            className: `mdi mdi-${t[n]}`
          }
        )
      ]
    }
  );
}, IT = (e) => e === "fill" ? "minmax(100px, 1fr)" : typeof e == "number" ? `${e}px` : e, RT = W.table`
  all: unset;
  display: block;
  min-width: 100%;
  max-width: fit-content;
  overflow-x: auto;
  white-space: nowrap;

  /* if ccMargin is specified in props, convert spacing tokens to CSS variables */
  ${(e) => e.$ccMargin ? le`
          margin: ${Pr(e.$ccMargin)};
        ` : null}

  thead,
  tbody,
  th,
  tr,
  td {
    all: unset;
  }

  thead tr,
  tbody tr {
    min-width: 100%;
    display: grid;
    ${(e) => {
  var t;
  const n = (t = e.$columnSizes) == null ? void 0 : t.map((r) => IT(r)).join(" ");
  return le`
        grid-template-columns: ${n};
      `;
}}
  }

  th {
    ${dr};
    color: var(--cc_color_text_subtle);
    font-weight: 700;
    font-size: var(--cc_size_text_s);
    text-align: start;
    padding: var(--cc_size_spacing_s) var(--cc_size_spacing_m);
    border-block-end: var(--cc_size_border_width_m) solid
      var(--cc_color_border_default);
    align-content: end;
  }

  ${(e) => e.$enableStickyHeaders ? le`
          thead th {
            position: sticky;
            top: 0;
            z-index: 1;
            background: var(--cc_color_background_1);
          }
        ` : null}

  td {
    ${Lt}
    color: var(--cc_color_text_subtle);
    font-size: var(--cc_size_text_s);
    padding: var(--cc_size_spacing_m);
    border-block-end: var(--cc_size_border_width_s) solid
      var(--cc_color_border_default);
    align-content: center;
  }

  tr:hover > td {
    background: var(--cc_color_background_2);
  }
`, AT = (e) => e ? e != null && e.desc ? "descending" : "ascending" : "none", FI = ({
  defaultSortedColumns: e,
  defaultData: n,
  ccMargin: t,
  columns: r,
  columnSizes: i,
  enableSortingRemoval: o = !1,
  enableStickyHeaders: a = !1,
  manualPagination: c = !1,
  pageCount: d = -1,
  onSortingChange: p,
  ...m
}) => {
  const [v, y] = lr(() => [...n]), [_, S] = lr([]), Y = ET({
    columns: r,
    data: v,
    state: {
      sorting: _
    },
    onSortingChange: (N) => {
      p && p(N), S(N);
    },
    getCoreRowModel: bT(),
    getPaginationRowModel: xT(),
    getSortedRowModel: ST(),
    enableSortingRemoval: o,
    manualPagination: c,
    pageCount: d
    // etc...
  });
  return ct(() => {
    e && Y.setSorting(() => e);
  }, [e, Y]), ct(() => {
    y([...n]);
  }, [n]), /* @__PURE__ */ pe(
    RT,
    {
      $ccMargin: t,
      $enableStickyHeaders: a,
      $columnSizes: i,
      ...m,
      children: [
        /* @__PURE__ */ L("thead", { children: Y.getHeaderGroups().map((N) => /* @__PURE__ */ L("tr", { children: N.headers.map((I) => {
          const Q = _[I.column.getSortIndex()], te = AT(Q);
          return /* @__PURE__ */ L("th", { "aria-sort": te, scope: "col", children: I.column.getCanSort() ? /* @__PURE__ */ L(TT, { header: I }) : Dc(
            I.column.columnDef.header,
            I.getContext()
          ) }, I.id);
        }) }, N.id)) }),
        /* @__PURE__ */ L("tbody", { children: Y.getRowModel().rows.map((N) => /* @__PURE__ */ L("tr", { children: N.getVisibleCells().map((I) => /* @__PURE__ */ L("td", { children: Dc(I.column.columnDef.cell, I.getContext()) }, I.id)) }, N.id)) })
      ]
    }
  );
}, xi = {
  small: {
    fontSize: "var(--cc_size_text_xs)",
    statusSize: 20,
    iconSize: 18
  },
  medium: {
    fontSize: "var(--cc_size_text_s)",
    statusSize: 24,
    iconSize: 22
  }
}, FT = W.div`
  display: flex;
  align-items: center;
  gap: calc(var(--cc_size_spacing_xs) * 1.25);
  min-width: 1px;
`, op = W.span`
  width: ${(e) => xi[e.$size || "small"].statusSize}px;
  height: ${(e) => xi[e.$size || "small"].statusSize}px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
`, OT = W.span`
  ${Lt}
  color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_text_subtle)"};
  font-size: ${(e) => xi[e.$size || "small"].fontSize};
  line-height: ${(e) => xi[e.$size || "small"].statusSize}px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 1px;
`, LT = Br`
  50% {
    transform: scale(1.125);
    }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`, NT = W.i`
  font-size: ${(e) => xi[e.$size || "small"].iconSize}px;
  color: ${(e) => e.$status === "error" ? "var(--cc_color_utility_destroy)" : "var(--cc_color_utility_success_darken_10)"};

  transform: scale(0.5);
  opacity: 0;
  animation-name: ${LT};
  animation-duration: ${mt.duration.medium};
  animation-fill-mode: forwards;
  animation-timing-function: ${mt.easeOut};
`;
function OI({
  children: e,
  avatar: n,
  size: t = "small",
  status: r = "none",
  ...i
}) {
  return /* @__PURE__ */ pe(FT, { ...i, children: [
    n ? /* @__PURE__ */ L(
      ru,
      {
        size: xi[t].iconSize,
        tooltip: { shouldShow: !0, placement: "top" },
        ...n
      }
    ) : null,
    /* @__PURE__ */ L(OT, { $size: t, $status: r, children: e }),
    r === "saving" ? /* @__PURE__ */ L(op, { $size: t, children: /* @__PURE__ */ L(
      iu,
      {
        accessibilityLabel: "Saving",
        size: xi[t || "small"].iconSize - 2
      }
    ) }) : null,
    r === "success" || r === "error" ? /* @__PURE__ */ L(op, { $size: t, children: /* @__PURE__ */ L(
      NT,
      {
        className: `mdi mdi-${r === "error" ? "alert-circle-outline" : "cloud-check-variant-outline"}`,
        "aria-hidden": "true",
        $status: r,
        $size: t
      }
    ) }) : null
  ] });
}
const $n = {
  caution: "caution",
  destroy: "destroy",
  info: "info",
  success: "success"
}, zT = (e, n) => {
  switch (n) {
    case "caution":
      return e || "alert-outline";
    case "destroy":
      return e || "alert-circle-outline";
    case "info":
      return e || "information-outline";
    case "success":
      return e || "check";
    default:
      return e || "information-outline";
  }
}, VT = (e) => {
  switch (e) {
    case $n.caution:
      return "var(--cc_color_utility_caution)";
    case $n.destroy:
      return "var(--cc_color_utility_destroy)";
    case $n.info:
      return "var(--cc_color_utility_info)";
    case $n.success:
      return "var(--cc_color_utility_success)";
    default:
      return "var(--cc_color_utility_info)";
  }
}, YT = (e) => {
  switch (e) {
    case $n.info:
      return pt.color_text_default_de;
    default:
      return pt.color_text_default_le;
  }
}, HT = W.div`
  width: 360px;
  border-radius: var(--cc_size_border_radius_l);
  color: var(--cc_color_text_default);
  box-shadow: 0 var(--cc_size_depth_3_y) var(--cc_size_depth_3_blur)
    var(--cc_color_depth_3);
`, BT = W.div`
  position: relative;
  padding: var(--cc_size_spacing_m);
  display: flex;
  align-items: ${(e) => e.$action || e.$title ? "start" : "center"};
  gap: var(--cc_size_spacing_m);
  background: var(--cc_color_background_3);
  border-radius: var(--cc_size_border_radius_l);
`, WT = W.div`
  flex: 1;
  min-width: 1px;
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: var(--cc_size_spacing_xxs);
  padding-inline-end: var(--cc_size_spacing_l);
`, jT = W.div`
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: var(--cc_size_avatar_m);
  height: var(--cc_size_avatar_m);
  background: var(--cc_color_utility_success);
  border-radius: var(--cc_size_border_radius_l);
  background-color: ${({ color: e = $n.success }) => VT(e)};
`, GT = W.i`
  font-size: 20px;
  color: ${({ color: e = $n.success }) => YT(e)};
`, qT = W(Ns)`
  margin-block-start: var(--cc_size_spacing_s);
`, KT = W(sa)`
  position: absolute;
  top: 6px; /* magic number to account for icon padding */
  right: 6px;
  display: block;
`;
function LI({
  action: e,
  closeAction: n,
  color: t = $n.success,
  iconName: r = "",
  message: i,
  title: o,
  testId: a
}) {
  var c, d;
  return /* @__PURE__ */ L(HT, { "data-testId": a, children: /* @__PURE__ */ pe(BT, { $action: e, $title: o, className: "dark-environment", children: [
    /* @__PURE__ */ L(jT, { color: t, children: /* @__PURE__ */ L(
      GT,
      {
        color: t,
        className: `mdi mdi-${zT(r, t)}`
      }
    ) }),
    /* @__PURE__ */ pe(WT, { children: [
      o ? /* @__PURE__ */ L(Nt, { as: "h4", family: "heading", size: "m", weight: 600, children: o }) : null,
      /* @__PURE__ */ L(Nt, { as: "p", children: i }),
      e ? /* @__PURE__ */ L(
        qT,
        {
          ...e,
          "data-testid": e["data-testid"],
          color: "secondary",
          design: "outline",
          size: "small",
          icon: {
            name: (c = e.icon) == null ? void 0 : c.name,
            position: (d = e.icon) == null ? void 0 : d.position
          },
          children: e.label
        }
      ) : null
    ] }),
    n ? /* @__PURE__ */ L(
      KT,
      {
        ...n,
        "data-testid": n["data-testid"],
        accessibilityLabel: n.accessibilityLabel,
        iconName: "close",
        color: "subtle"
      }
    ) : null
  ] }) });
}
export {
  JT as AssetThumbnail,
  ru as Avatar,
  eI as AvatarGroup,
  tI as Badge,
  Vw as Billboard,
  Ns as Button,
  Hw as ButtonCondensed,
  rI as ButtonFilter,
  bh as ButtonIcon,
  sa as ButtonIconCondensed,
  nI as Card,
  iI as ChipFilter,
  sI as ChipToggle,
  oI as Comment,
  aI as Drawer,
  $x as Fieldset,
  lI as Grid,
  cI as HorizontalRule,
  Dx as InputCheckbox,
  uI as InputCheckboxGroup,
  dI as InputDate,
  fI as InputFile,
  pI as InputPassword,
  YD as InputRadio,
  hI as InputRadioGroup,
  gI as InputRange,
  mI as InputSelectHTML,
  OD as InputText,
  vI as InputTextArea,
  _I as Label,
  yI as Link,
  bI as Lottie,
  xI as Menu,
  SI as MenuHeading,
  kI as MenuItem,
  CI as Metric,
  DI as Modal,
  EI as ModalBase,
  PI as Notice,
  MI as PageHeader,
  $I as Popover,
  TI as ProgressBar,
  II as ProgressCircle,
  RI as Rating,
  ln as ScreenReaderContent,
  iu as Spinner,
  AI as Switch,
  FI as Table,
  Nt as Text,
  OI as TimeStamp,
  LI as Toast,
  hh as Tooltip
};
